/* eslint-disable max-len */

export const Learnsets: {[k: string]: ModdedLearnsetData} = {
	bulbasaur: {
		learnset: {
			amnesia: ["8E"],
			attract: ["8M"],
			bulletseed: ["8M"],
			charm: ["8E"],
			curse: ["8E"],
			cut: ["8M"],
			doubleedge: ["8L33"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M"],
			grassknot: ["8M"],
			grassyterrain: ["8E"],
			growl: ["8L1"],
			growth: ["8L6"],
			ingrain: ["8E"],
			leafstorm: ["8E"],
			leechseed: ["8L9"],
			lightscreen: ["8M"],
			magicalleaf: ["8E"],
			naturepower: ["8E"],
			petaldance: ["8E"],
			poisonpowder: ["8L15"],
			powerwhip: ["8E"],
			protect: ["8M"],
			razorleaf: ["8L12"],
			rest: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			seedbomb: ["8L18"],
			skullbash: ["8E"],
			sleeppowder: ["8L15"],
			sleeptalk: ["8M"],
			sludge: ["8E"],
			sludgebomb: ["8M"],
			solarbeam: ["8M", "8L36"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L24"],
			swordsdance: ["8M"],
			synthesis: ["8L27"],
			tackle: ["8L1"],
			takedown: ["8L21"],
			toxic: ["8M"],
			vinewhip: ["8L3"],
			workup: ["8M"],
			worryseed: ["8L30"],
		},
	},
	ivysaur: {
		learnset: {
			attract: ["8M"],
			bulletseed: ["8M"],
			cut: ["8M"],
			doubleedge: ["8L45"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			growth: ["8L1"],
			leechseed: ["8L9"],
			lightscreen: ["8M"],
			poisonpowder: ["8L15"],
			protect: ["8M"],
			razorleaf: ["8L12"],
			rest: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			seedbomb: ["8L20"],
			sleeppowder: ["8L15"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M", "8L50"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L30"],
			swordsdance: ["8M"],
			synthesis: ["8L35"],
			tackle: ["8L1"],
			takedown: ["8L25"],
			toxic: ["8M"],
			vinewhip: ["8L1"],
			workup: ["8M"],
			worryseed: ["8L40"],
		},
	},
	venusaur: {
		learnset: {
			attract: ["8M"],
			bulldoze: ["8M"],
			bulletseed: ["8M"],
			cut: ["8M"],
			doubleedge: ["8L51"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			flash: ["8M"],
			frenzyplant: ["8T"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			growth: ["8L1"],
			hyperbeam: ["8M"],
			leechseed: ["8L9"],
			lightscreen: ["8M"],
			petalblizzard: ["8L1"],
			petaldance: ["8L1"],
			poisonpowder: ["8L15"],
			protect: ["8M"],
			razorleaf: ["8L12"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			seedbomb: ["8L20"],
			sleeppowder: ["8L15"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M", "8L58"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L30"],
			swordsdance: ["8M"],
			synthesis: ["8L37"],
			tackle: ["8L1"],
			takedown: ["8L25"],
			toxic: ["8M"],
			vinewhip: ["8L1"],
			workup: ["8M"],
			worryseed: ["8L44"],
		},
	},
	charmander: {
		learnset: {
			aerialace: ["8M"],
			aircutter: ["8E"],
			ancientpower: ["8E"],
			attract: ["8M"],
			beatup: ["8E"],
			bellydrum: ["8E"],
			bite: ["8E"],
			brickbreak: ["8M"],
			counter: ["8E"],
			crunch: ["8E"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonbreath: ["8L12"],
			dragonclaw: ["8M"],
			dragondance: ["8E"],
			dragonpulse: ["8M"],
			dragonrush: ["8E"],
			dragontail: ["8E"],
			ember: ["8L4"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fireblast: ["8M"],
			firefang: ["8L17"],
			firespin: ["8L32"],
			flamethrower: ["8M", "8L24"],
			flareblitz: ["8L40", "8E"],
			fling: ["8M"],
			focuspunch: ["8M"],
			growl: ["8L1"],
			inferno: ["8L36"],
			irontail: ["8M"],
			metalclaw: ["8E"],
			outrage: ["8E"],
			overheat: ["8M"],
			protect: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scaryface: ["8L28"],
			scratch: ["8L1"],
			shadowclaw: ["8M"],
			slash: ["8L20"],
			sleeptalk: ["8M"],
			smokescreen: ["8L8"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			willowisp: ["8M"],
			wingattack: ["8E"],
			workup: ["8M"],
		},
	},
	charmeleon: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			brickbreak: ["8M"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonbreath: ["8L12"],
			dragonclaw: ["8M"],
			dragonpulse: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fireblast: ["8M"],
			firefang: ["8L19"],
			firespin: ["8L42"],
			flamethrower: ["8M", "8L30"],
			flareblitz: ["8L54"],
			fling: ["8M"],
			focuspunch: ["8M"],
			growl: ["8L1"],
			inferno: ["8L48"],
			irontail: ["8M"],
			overheat: ["8M"],
			protect: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scaryface: ["8L37"],
			scratch: ["8L1"],
			shadowclaw: ["8M"],
			slash: ["8L24"],
			sleeptalk: ["8M"],
			smokescreen: ["8L1"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			willowisp: ["8M"],
			workup: ["8M"],
		},
	},
	charizard: {
		learnset: {
			aerialace: ["8M"],
			airslash: ["8L1"],
			attract: ["8M"],
			blastburn: ["8T"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonbreath: ["8L12"],
			dragonclaw: ["8M", "8L1"],
			dragonpulse: ["8M"],
			earthquake: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fireblast: ["8M"],
			firefang: ["8L19"],
			firespin: ["8L46"],
			flamethrower: ["8M", "8L30"],
			flareblitz: ["8L62"],
			fling: ["8M"],
			fly: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			heatwave: ["8L1"],
			hyperbeam: ["8M"],
			inferno: ["8L54"],
			irontail: ["8M"],
			overheat: ["8M"],
			protect: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			roost: ["8M"],
			scaryface: ["8L39"],
			scratch: ["8L1"],
			shadowclaw: ["8M"],
			slash: ["8L24"],
			sleeptalk: ["8M"],
			smokescreen: ["8L1"],
			solarbeam: ["8M"],
			steelwing: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			willowisp: ["8M"],
			workup: ["8M"],
		},
	},
	squirtle: {
		learnset: {
			aquajet: ["8E"],
			aquaring: ["8E"],
			aquatail: ["8L24"],
			attract: ["8M"],
			aurasphere: ["8E"],
			bite: ["8L12"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonpulse: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8E"],
			falseswipe: ["8M"],
			flail: ["8E"],
			fling: ["8M"],
			focuspunch: ["8M"],
			gyroball: ["8M"],
			hail: ["8M"],
			haze: ["8E"],
			hydropump: ["8L33"],
			icebeam: ["8M"],
			irondefense: ["8L30"],
			irontail: ["8M"],
			lifedew: ["8E"],
			mirrorcoat: ["8E"],
			mist: ["8E"],
			muddywater: ["8E"],
			protect: ["8M", "8L18"],
			raindance: ["8M", "8L21"],
			rapidspin: ["8L9"],
			rest: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			shellsmash: ["8L27"],
			skullbash: ["8L36"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			waterfall: ["8M"],
			watergun: ["8L3"],
			waterpulse: ["8M", "8L15"],
			waterspout: ["8E"],
			withdraw: ["8L6"],
			workup: ["8M"],
			yawn: ["8E"],
		},
	},
	wartortle: {
		learnset: {
			aquatail: ["8L30"],
			attract: ["8M"],
			bite: ["8L12"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonpulse: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			gyroball: ["8M"],
			hail: ["8M"],
			hydropump: ["8L45"],
			icebeam: ["8M"],
			irondefense: ["8L40"],
			irontail: ["8M"],
			protect: ["8M", "8L20"],
			raindance: ["8M", "8L25"],
			rapidspin: ["8L9"],
			rest: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			shellsmash: ["8L35"],
			skullbash: ["8L50"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L15"],
			withdraw: ["8L1"],
			workup: ["8M"],
		},
	},
	blastoise: {
		learnset: {
			aquatail: ["8L30"],
			attract: ["8M"],
			avalanche: ["8M"],
			bite: ["8L12"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M"],
			bulldoze: ["8M"],
			darkpulse: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonpulse: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			flashcannon: ["8M", "8L1"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			gyroball: ["8M"],
			hail: ["8M"],
			hydrocannon: ["8T"],
			hydropump: ["8L49"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irondefense: ["8L42"],
			irontail: ["8M"],
			protect: ["8M", "8L20"],
			raindance: ["8M", "8L25"],
			rapidspin: ["8L9"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			shellsmash: ["8L35"],
			skullbash: ["8L56"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L15"],
			withdraw: ["8L1"],
			workup: ["8M"],
		},
	},
	caterpie: {
		learnset: {
			bugbite: ["8L9"],
			stringshot: ["8L1"],
			tackle: ["8L1"],
		},
	},
	metapod: {
		learnset: {
			harden: ["8L1"],
		},
	},
	butterfree: {
		learnset: {
			aerialace: ["8M"],
			airslash: ["8L24"],
			attract: ["8M"],
			bugbite: ["8L1"],
			bugbuzz: ["8M", "8L32"],
			confusion: ["8L8"],
			defog: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			gust: ["8L1"],
			harden: ["8L1"],
			hyperbeam: ["8M"],
			poisonpowder: ["8L12"],
			protect: ["8M"],
			psybeam: ["8L16"],
			psychic: ["8M"],
			psychup: ["8M"],
			quiverdance: ["8L44"],
			ragepowder: ["8L40"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M"],
			safeguard: ["8M", "8L28"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeppowder: ["8L12"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stringshot: ["8L1"],
			stunspore: ["8L12"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L4"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailwind: ["8L36"],
			thief: ["8M"],
			uturn: ["8M"],
			whirlwind: ["8L20"],
		},
	},
	weedle: {
		learnset: {
			bugbite: ["8L9"],
			poisonsting: ["8L1"],
			stringshot: ["8L1"],
		},
	},
	kakuna: {
		learnset: {
			harden: ["8L1"],
		},
	},
	beedrill: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L38"],
			assurance: ["8L26"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bugbite: ["8L1"],
			cut: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			endeavor: ["8L41"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fellstinger: ["8L44"],
			flash: ["8M"],
			focusenergy: ["8L20"],
			furyattack: ["8L1"],
			furycutter: ["8L11"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			harden: ["8L1"],
			hyperbeam: ["8M"],
			laserfocus: ["8L14"],
			payback: ["8M"],
			pinmissile: ["8L32"],
			poisonjab: ["8M", "8L35"],
			poisonsting: ["8L17", "8L1"],
			protect: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			roost: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			stringshot: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			thief: ["8M"],
			toxicspikes: ["8L29"],
			uturn: ["8M"],
			venoshock: ["8L23"],
			xscissor: ["8M"],
		},
	},
	pidgey: {
		learnset: {
			aerialace: ["8M", "8L45"],
			agility: ["8L29"],
			aircutter: ["8E"],
			airslash: ["8L49", "8E"],
			attract: ["8M"],
			bravebird: ["8E"],
			defog: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			featherdance: ["8L25"],
			fly: ["8M"],
			gust: ["8L9"],
			hurricane: ["8L53"],
			pluck: ["8M"],
			protect: ["8M"],
			quickattack: ["8L13"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M", "8L37"],
			sandattack: ["8L5"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailwind: ["8L41"],
			thief: ["8M"],
			twister: ["8L21"],
			uproar: ["8E"],
			uturn: ["8M"],
			whirlwind: ["8L17"],
			wingattack: ["8L33"],
			workup: ["8M"],
		},
	},
	pidgeotto: {
		learnset: {
			aerialace: ["8M", "8L52"],
			agility: ["8L32"],
			airslash: ["8L57"],
			attract: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			featherdance: ["8L27"],
			fly: ["8M"],
			gust: ["8L9", "8L1"],
			hurricane: ["8L62"],
			pluck: ["8M"],
			protect: ["8M"],
			quickattack: ["8L13"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M", "8L42"],
			sandattack: ["8L5", "8L1"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailwind: ["8L47"],
			thief: ["8M"],
			twister: ["8L22"],
			uturn: ["8M"],
			whirlwind: ["8L17"],
			wingattack: ["8L37"],
			workup: ["8M"],
		},
	},
	pidgeot: {
		learnset: {
			aerialace: ["8M", "8L56"],
			agility: ["8L32"],
			airslash: ["8L62"],
			attract: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			featherdance: ["8L27"],
			fly: ["8M"],
			gigaimpact: ["8M"],
			gust: ["8L9", "8L1"],
			hurricane: ["8L68", "8L1"],
			hyperbeam: ["8M"],
			pluck: ["8M"],
			protect: ["8M"],
			quickattack: ["8L13", "8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M", "8L44"],
			sandattack: ["8L5", "8L1"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailwind: ["8L50"],
			thief: ["8M"],
			twister: ["8L22"],
			uturn: ["8M"],
			whirlwind: ["8L17"],
			wingattack: ["8L38"],
			workup: ["8M"],
		},
	},
	rattata: {
		learnset: {
			assurance: ["8L19"],
			attract: ["8M"],
			bite: ["8L10", "8E"],
			blizzard: ["8M"],
			chargebeam: ["8M"],
			counter: ["8E"],
			crunch: ["8L22"],
			cut: ["8M"],
			dig: ["8M"],
			doubleedge: ["8L31"],
			doubleteam: ["8M"],
			endeavor: ["8L34"],
			endure: ["8M"],
			facade: ["8M"],
			finalgambit: ["8E"],
			flamewheel: ["8E"],
			focusenergy: ["8L7"],
			furyswipes: ["8E"],
			grassknot: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			laserfocus: ["8L13"],
			lastresort: ["8E"],
			pluck: ["8M"],
			protect: ["8M"],
			quickattack: ["8L4"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8E"],
			reversal: ["8E"],
			rocksmash: ["8M"],
			screech: ["8E"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L25"],
			sunnyday: ["8M"],
			superfang: ["8L28"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			takedown: ["8L16"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			uproar: ["8E"],
			workup: ["8M"],
		},
	},
	raticate: {
		learnset: {
			assurance: ["8L19"],
			attract: ["8M"],
			bite: ["8L10"],
			blizzard: ["8M"],
			chargebeam: ["8M"],
			crunch: ["8L24"],
			cut: ["8M"],
			dig: ["8M"],
			doubleedge: ["8L39"],
			doubleteam: ["8M"],
			endeavor: ["8L44"],
			endure: ["8M"],
			facade: ["8M"],
			focusenergy: ["8L7", "8L1"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			laserfocus: ["8L13"],
			pluck: ["8M"],
			protect: ["8M"],
			quickattack: ["8L4", "8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			scaryface: ["8L1"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L29"],
			sunnyday: ["8M"],
			superfang: ["8L34"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L1"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			takedown: ["8L16"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			workup: ["8M"],
		},
	},
	spearow: {
		learnset: {
			aerialace: ["8M", "8L15"],
			agility: ["8L25"],
			assurance: ["8L8"],
			astonish: ["8E"],
			attract: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			drillpeck: ["8L36"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			featherdance: ["8E"],
			fly: ["8M"],
			focusenergy: ["8L29"],
			furyattack: ["8L11"],
			growl: ["8L1"],
			leer: ["8L4"],
			peck: ["8L1"],
			pluck: ["8M"],
			protect: ["8M"],
			quickattack: ["8E"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M", "8L32"],
			scaryface: ["8E"],
			skyattack: ["8E"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			takedown: ["8L22"],
			thief: ["8M"],
			triattack: ["8E"],
			uproar: ["8E"],
			uturn: ["8M"],
			whirlwind: ["8E"],
			wingattack: ["8L18"],
			workup: ["8M"],
		},
	},
	fearow: {
		learnset: {
			aerialace: ["8M", "8L15"],
			agility: ["8L27"],
			assurance: ["8L8"],
			attract: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			drillpeck: ["8L41"],
			drillrun: ["8L45", "8L1"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fly: ["8M"],
			focusenergy: ["8L32"],
			furyattack: ["8L11"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hyperbeam: ["8M"],
			leer: ["8L4", "8L1"],
			peck: ["8L1"],
			pluck: ["8M", "8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M", "8L36"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			takedown: ["8L23"],
			thief: ["8M"],
			uturn: ["8M"],
			wingattack: ["8L18"],
			workup: ["8M"],
		},
	},
	ekans: {
		learnset: {
			acid: ["8L20"],
			acidspray: ["8L28"],
			attract: ["8M"],
			beatup: ["8E"],
			belch: ["8L38"],
			bite: ["8L9"],
			bulldoze: ["8M"],
			coil: ["8L44"],
			darkpulse: ["8M"],
			dig: ["8M"],
			disable: ["8E"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			gastroacid: ["8L36"],
			gigadrain: ["8M"],
			glare: ["8L12"],
			gunkshot: ["8L49"],
			haze: ["8L41"],
			irontail: ["8M"],
			leer: ["8L1"],
			payback: ["8M"],
			poisonfang: ["8E"],
			poisonjab: ["8M"],
			poisonsting: ["8L4"],
			poisontail: ["8E"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocktomb: ["8M"],
			scaryface: ["8E"],
			screech: ["8L17"],
			slam: ["8E"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M", "8L33"],
			spite: ["8E"],
			spitup: ["8L25"],
			stockpile: ["8L25"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8E"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8L25"],
			switcheroo: ["8E"],
			thief: ["8M"],
			torment: ["8M"],
			wrap: ["8L1"],
		},
	},
	arbok: {
		learnset: {
			acid: ["8L20"],
			acidspray: ["8L32"],
			attract: ["8M"],
			belch: ["8L48"],
			bite: ["8L9", "8L1"],
			bulldoze: ["8M"],
			coil: ["8L56"],
			crunch: ["8L1"],
			darkpulse: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			firefang: ["8L1"],
			gastroacid: ["8L44"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			glare: ["8L12"],
			gunkshot: ["8L63"],
			haze: ["8L51"],
			hyperbeam: ["8M"],
			icefang: ["8L1"],
			irontail: ["8M"],
			leer: ["8L1"],
			payback: ["8M"],
			poisonjab: ["8M"],
			poisonsting: ["8L4", "8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocktomb: ["8M"],
			screech: ["8L17"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M", "8L39"],
			spitup: ["8L27"],
			stockpile: ["8L27"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8L27"],
			thief: ["8M"],
			thunderfang: ["8L1"],
			torment: ["8M"],
			wrap: ["8L1"],
		},
	},
	pikachu: {
		learnset: {
			agility: ["8L24"],
			attract: ["8M"],
			brickbreak: ["8M"],
			chargebeam: ["8M"],
			charm: ["8L1"],
			dig: ["8M"],
			discharge: ["8L32"],
			doubleteam: ["8M", "8L8"],
			electroball: ["8L12"],
			endure: ["8M"],
			facade: ["8M"],
			feint: ["8L16"],
			flash: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			irontail: ["8M"],
			lightscreen: ["8M", "8L40"],
			nastyplot: ["8M", "8L1"],
			nuzzle: ["8L1"],
			playnice: ["8L1"],
			protect: ["8M"],
			quickattack: ["8L1"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			shockwave: ["8M"],
			slam: ["8L28"],
			sleeptalk: ["8M"],
			spark: ["8L20"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8L1"],
			tailwhip: ["8L1"],
			thief: ["8M"],
			thunder: ["8M", "8L44"],
			thunderbolt: ["8M", "8L36"],
			thundershock: ["8L1"],
			thunderwave: ["8M", "8L4"],
			voltswitch: ["8M"],
		},
	},
	raichu: {
		learnset: {
			agility: ["8L1"],
			attract: ["8M"],
			brickbreak: ["8M"],
			chargebeam: ["8M"],
			charm: ["8L1"],
			dig: ["8M"],
			discharge: ["8L1"],
			doubleteam: ["8M", "8L1"],
			electroball: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			feint: ["8L1"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			lightscreen: ["8M", "8L1"],
			nastyplot: ["8M", "8L1"],
			nuzzle: ["8L1"],
			playnice: ["8L1"],
			protect: ["8M"],
			quickattack: ["8L1"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			shockwave: ["8M"],
			slam: ["8L1"],
			sleeptalk: ["8M"],
			spark: ["8L1"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8L1"],
			tailwhip: ["8L1"],
			thief: ["8M"],
			thunder: ["8M", "8L1"],
			thunderbolt: ["8M", "8L1"],
			thunderpunch: ["8L1"],
			thundershock: ["8L1"],
			thunderwave: ["8M", "8L1"],
			voltswitch: ["8M"],
		},
	},
	sandshrew: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L27"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M", "8L18"],
			counter: ["8E"],
			crushclaw: ["8E"],
			cut: ["8M"],
			defensecurl: ["8L1"],
			dig: ["8M", "8L33"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L45"],
			endure: ["8M"],
			facade: ["8M"],
			flail: ["8E"],
			fling: ["8M"],
			focuspunch: ["8M"],
			furycutter: ["8L12"],
			furyswipes: ["8L24"],
			gyroball: ["8M", "8L36"],
			honeclaws: ["8E"],
			irontail: ["8M"],
			metalclaw: ["8E"],
			mudshot: ["8E"],
			mudslap: ["8E"],
			nightslash: ["8E"],
			poisonjab: ["8M"],
			poisonsting: ["8L3"],
			protect: ["8M"],
			rapidspin: ["8L15", "8E"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L9"],
			safeguard: ["8M"],
			sandattack: ["8L6"],
			sandstorm: ["8M", "8L42"],
			scratch: ["8L1"],
			shadowclaw: ["8M"],
			slash: ["8L30"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L21"],
			swordsdance: ["8M", "8L39"],
			thief: ["8M"],
			workup: ["8M"],
			xscissor: ["8M"],
		},
	},
	sandslash: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L1"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M", "8L18"],
			crushclaw: ["8L1"],
			cut: ["8M"],
			defensecurl: ["8L1"],
			dig: ["8M", "8L41"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L61"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			furycutter: ["8L12"],
			furyswipes: ["8L26"],
			gigaimpact: ["8M"],
			gyroball: ["8M", "8L46"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			poisonjab: ["8M"],
			poisonsting: ["8L1"],
			protect: ["8M"],
			rapidspin: ["8L15"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L9"],
			safeguard: ["8M"],
			sandattack: ["8L1"],
			sandstorm: ["8M", "8L56"],
			sandtomb: ["8L31"],
			scratch: ["8L1"],
			shadowclaw: ["8M"],
			slash: ["8L36"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L21"],
			swordsdance: ["8M", "8L51"],
			thief: ["8M"],
			workup: ["8M"],
			xscissor: ["8M"],
		},
	},
	nidoranf: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			beatup: ["8E"],
			bite: ["8L30"],
			blizzard: ["8M"],
			charm: ["8E"],
			counter: ["8E"],
			crunch: ["8L50"],
			cut: ["8M"],
			dig: ["8M"],
			disable: ["8E"],
			doublekick: ["8L25"],
			doubleteam: ["8M"],
			earthpower: ["8L55"],
			endure: ["8M"],
			facade: ["8M"],
			flatter: ["8L45"],
			focusenergy: ["8E"],
			furyswipes: ["8L15"],
			growl: ["8L1"],
			helpinghand: ["8L35"],
			icebeam: ["8M"],
			irontail: ["8M"],
			poisonfang: ["8E"],
			poisonjab: ["8M"],
			poisonsting: ["8L1"],
			poisontail: ["8E"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			scratch: ["8L5"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			skullbash: ["8E"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8E"],
			swagger: ["8M"],
			tailwhip: ["8L10"],
			takedown: ["8E"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			toxic: ["8M", "8L40"],
			toxicspikes: ["8L20"],
			venomdrench: ["8E"],
			waterpulse: ["8M"],
		},
	},
	nidorina: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			bite: ["8L36"],
			blizzard: ["8M"],
			crunch: ["8L64"],
			cut: ["8M"],
			dig: ["8M"],
			doublekick: ["8L29"],
			doubleteam: ["8M"],
			earthpower: ["8L71"],
			endure: ["8M"],
			facade: ["8M"],
			flatter: ["8L57"],
			furyswipes: ["8L15"],
			growl: ["8L1"],
			helpinghand: ["8L43"],
			icebeam: ["8M"],
			irontail: ["8M"],
			poisonjab: ["8M"],
			poisonsting: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			scratch: ["8L1"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tailwhip: ["8L1"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			toxic: ["8M", "8L50"],
			toxicspikes: ["8L22"],
			waterpulse: ["8M"],
		},
	},
	nidoqueen: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			avalanche: ["8M"],
			bite: ["8L1"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			crunch: ["8L1"],
			cut: ["8M"],
			dig: ["8M"],
			doublekick: ["8L1"],
			doubleteam: ["8M"],
			dragonpulse: ["8M"],
			earthpower: ["8L1"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flatter: ["8L1"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			furyswipes: ["8L1"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			helpinghand: ["8L1"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			poisonjab: ["8M"],
			poisonsting: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			scratch: ["8L1"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			sludgewave: ["8L1"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			superpower: ["8L1"],
			surf: ["8M"],
			swagger: ["8M"],
			tailwhip: ["8L1"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			torment: ["8M"],
			toxic: ["8M", "8L1"],
			toxicspikes: ["8L1"],
			waterpulse: ["8M"],
		},
	},
	nidoranm: {
		learnset: {
			amnesia: ["8E"],
			attract: ["8M"],
			beatup: ["8E"],
			blizzard: ["8M"],
			confusion: ["8E"],
			counter: ["8E"],
			cut: ["8M"],
			dig: ["8M"],
			disable: ["8E"],
			doublekick: ["8L25"],
			doubleteam: ["8M"],
			earthpower: ["8L55"],
			endure: ["8M"],
			facade: ["8M"],
			flatter: ["8L45"],
			focusenergy: ["8L10"],
			furyattack: ["8L15"],
			headsmash: ["8E"],
			helpinghand: ["8L35"],
			hornattack: ["8L30"],
			horndrill: ["8E"],
			icebeam: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			peck: ["8L5"],
			poisonjab: ["8M", "8L50"],
			poisonsting: ["8L1"],
			poisontail: ["8E"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8E"],
			sunnyday: ["8M"],
			supersonic: ["8E"],
			swagger: ["8M"],
			takedown: ["8E"],
			thief: ["8M"],
			thrash: ["8E"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			toxic: ["8M", "8L40"],
			toxicspikes: ["8L20"],
			venomdrench: ["8E"],
			waterpulse: ["8M"],
		},
	},
	nidorino: {
		learnset: {
			attract: ["8M"],
			blizzard: ["8M"],
			cut: ["8M"],
			dig: ["8M"],
			doublekick: ["8L29"],
			doubleteam: ["8M"],
			earthpower: ["8L71"],
			endure: ["8M"],
			facade: ["8M"],
			flatter: ["8L57"],
			focusenergy: ["8L1"],
			furyattack: ["8L15"],
			helpinghand: ["8L43"],
			hornattack: ["8L36"],
			icebeam: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			peck: ["8L1"],
			poisonjab: ["8M", "8L64"],
			poisonsting: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			toxic: ["8M", "8L50"],
			toxicspikes: ["8L22"],
			waterpulse: ["8M"],
		},
	},
	nidoking: {
		learnset: {
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			cut: ["8M"],
			dig: ["8M"],
			doublekick: ["8L1"],
			doubleteam: ["8M"],
			dragonpulse: ["8M"],
			earthpower: ["8L1"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flatter: ["8L1"],
			fling: ["8M"],
			focusblast: ["8M"],
			focusenergy: ["8L1"],
			focuspunch: ["8M"],
			furyattack: ["8L1"],
			gigaimpact: ["8M"],
			helpinghand: ["8L1"],
			hornattack: ["8L1"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			megahorn: ["8L1"],
			peck: ["8L1"],
			poisonjab: ["8M", "8L1"],
			poisonsting: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			sludgewave: ["8L1"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			torment: ["8M"],
			toxic: ["8M", "8L1"],
			toxicspikes: ["8L1"],
			waterpulse: ["8M"],
		},
	},
	clefairy: {
		learnset: {
			afteryou: ["8L12"],
			attract: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			charm: ["8L1"],
			copycat: ["8L1"],
			cosmicpower: ["8L40"],
			dazzlinggleam: ["8M"],
			defensecurl: ["8L1"],
			dig: ["8M"],
			disarmingvoice: ["8L1"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			encore: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			followme: ["8L36"],
			grassknot: ["8M"],
			gravity: ["8L28"],
			growl: ["8L1"],
			healingwish: ["8L48"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lifedew: ["8L16"],
			lightscreen: ["8M"],
			meteormash: ["8L32"],
			metronome: ["8L20"],
			minimize: ["8L8"],
			moonblast: ["8L44"],
			moonlight: ["8L24"],
			pound: ["8L1"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sing: ["8L1"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			splash: ["8L1"],
			stealthrock: ["8M"],
			storedpower: ["8L4"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8L1"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	clefable: {
		learnset: {
			afteryou: ["8L1"],
			attract: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			charm: ["8L1"],
			copycat: ["8L1"],
			cosmicpower: ["8L1"],
			dazzlinggleam: ["8M"],
			defensecurl: ["8L1"],
			dig: ["8M"],
			disarmingvoice: ["8L1"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			encore: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			followme: ["8L1"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			gravity: ["8L1"],
			growl: ["8L1"],
			healingwish: ["8L1"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lifedew: ["8L1"],
			lightscreen: ["8M"],
			meteormash: ["8L1"],
			metronome: ["8L1"],
			minimize: ["8L1"],
			moonblast: ["8L1"],
			moonlight: ["8L1"],
			pound: ["8L1"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sing: ["8L1"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			splash: ["8L1"],
			stealthrock: ["8M"],
			storedpower: ["8L1"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8L1"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	vulpix: {
		learnset: {
			attract: ["8M"],
			babydolleyes: ["8E"],
			confuseray: ["8L20"],
			darkpulse: ["8M"],
			dig: ["8M"],
			disable: ["8L4", "8E"],
			doubleteam: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			energyball: ["8M"],
			extrasensory: ["8L28", "8E"],
			facade: ["8M"],
			fireblast: ["8M", "8L56"],
			firespin: ["8L40"],
			flail: ["8E"],
			flamecharge: ["8E"],
			flamethrower: ["8M", "8L32"],
			flareblitz: ["8E"],
			grudge: ["8L52"],
			heatwave: ["8E"],
			hex: ["8E"],
			howl: ["8E"],
			hypnosis: ["8E"],
			imprison: ["8L36"],
			incinerate: ["8L16"],
			inferno: ["8L48"],
			irontail: ["8M"],
			memento: ["8E"],
			overheat: ["8M"],
			payback: ["8M"],
			powerswap: ["8E"],
			protect: ["8M"],
			psychup: ["8M"],
			quickattack: ["8L8"],
			rest: ["8M"],
			roar: ["8M"],
			safeguard: ["8M", "8L44"],
			sleeptalk: ["8M"],
			spite: ["8L12", "8E"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tailwhip: ["8L1"],
			willowisp: ["8M", "8L24"],
		},
	},
	ninetales: {
		learnset: {
			attract: ["8M"],
			calmmind: ["8M"],
			confuseray: ["8L1"],
			darkpulse: ["8M"],
			dig: ["8M"],
			disable: ["8L1"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			energyball: ["8M"],
			extrasensory: ["8L1"],
			facade: ["8M"],
			fireblast: ["8M", "8L1"],
			firespin: ["8L1"],
			flamethrower: ["8M", "8L1"],
			gigaimpact: ["8M"],
			grudge: ["8L1"],
			hyperbeam: ["8M"],
			imprison: ["8L1"],
			incinerate: ["8L1"],
			inferno: ["8L1"],
			irontail: ["8M"],
			nastyplot: ["8M", "8L1"],
			overheat: ["8M"],
			payback: ["8M"],
			protect: ["8M"],
			psychup: ["8M"],
			quickattack: ["8L1"],
			rest: ["8M"],
			roar: ["8M"],
			safeguard: ["8M", "8L1"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			spite: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tailwhip: ["8L1"],
			willowisp: ["8M", "8L1"],
		},
	},
	jigglypuff: {
		learnset: {
			attract: ["8M"],
			blizzard: ["8M"],
			bodyslam: ["8L24"],
			brickbreak: ["8M"],
			chargebeam: ["8M"],
			charm: ["8L1"],
			copycat: ["8L1"],
			covet: ["8L8"],
			dazzlinggleam: ["8M"],
			defensecurl: ["8L1"],
			dig: ["8M"],
			disable: ["8L1"],
			disarmingvoice: ["8L1"],
			doubleedge: ["8L44"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			echoedvoice: ["8L4"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			grassknot: ["8M"],
			gyroball: ["8M", "8L32"],
			hypervoice: ["8L36"],
			icebeam: ["8M"],
			lightscreen: ["8M"],
			mimic: ["8L28"],
			playrough: ["8L40"],
			pound: ["8L1"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M", "8L20"],
			round: ["8L16"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sing: ["8L1"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			spitup: ["8L12"],
			stealthrock: ["8M"],
			stockpile: ["8L12"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8L12"],
			sweetkiss: ["8L1"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	wigglytuff: {
		learnset: {
			attract: ["8M"],
			blizzard: ["8M"],
			bodyslam: ["8L1"],
			brickbreak: ["8M"],
			chargebeam: ["8M"],
			charm: ["8L1"],
			copycat: ["8L1"],
			covet: ["8L1"],
			dazzlinggleam: ["8M"],
			defensecurl: ["8L1"],
			dig: ["8M"],
			disable: ["8L1"],
			disarmingvoice: ["8L1"],
			doubleedge: ["8L1"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			echoedvoice: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			gyroball: ["8M", "8L1"],
			hyperbeam: ["8M"],
			hypervoice: ["8L1"],
			icebeam: ["8M"],
			lightscreen: ["8M"],
			mimic: ["8L1"],
			playrough: ["8L1"],
			pound: ["8L1"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M", "8L1"],
			round: ["8L1"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sing: ["8L1"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			spitup: ["8L1"],
			stealthrock: ["8M"],
			stockpile: ["8L1"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8L1"],
			sweetkiss: ["8L1"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	zubat: {
		learnset: {
			absorb: ["8L1"],
			aerialace: ["8M"],
			aircutter: ["8L25"],
			airslash: ["8L50"],
			astonish: ["8L5"],
			attract: ["8M"],
			bite: ["8L30"],
			bravebird: ["8E"],
			confuseray: ["8L45"],
			curse: ["8E"],
			defog: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fly: ["8M"],
			gigadrain: ["8M"],
			gust: ["8E"],
			haze: ["8L35"],
			hypnosis: ["8E"],
			leechlife: ["8L55"],
			meanlook: ["8L10"],
			nastyplot: ["8M"],
			payback: ["8M"],
			pluck: ["8M"],
			poisonfang: ["8L15"],
			protect: ["8M"],
			quickattack: ["8E"],
			quickguard: ["8L20"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L1"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			torment: ["8M"],
			uturn: ["8M"],
			venomdrench: ["8E"],
			venoshock: ["8L40"],
			whirlwind: ["8E"],
			wingattack: ["8E"],
			zenheadbutt: ["8E"],
		},
	},
	golbat: {
		learnset: {
			absorb: ["8L1"],
			aerialace: ["8M"],
			aircutter: ["8L27"],
			airslash: ["8L62"],
			astonish: ["8L1"],
			attract: ["8M"],
			bite: ["8L34"],
			confuseray: ["8L55"],
			defog: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fly: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			haze: ["8L41"],
			hyperbeam: ["8M"],
			leechlife: ["8L69"],
			meanlook: ["8L1"],
			nastyplot: ["8M"],
			payback: ["8M"],
			pluck: ["8M"],
			poisonfang: ["8L15"],
			protect: ["8M"],
			quickguard: ["8L20"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M"],
			screech: ["8L1"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L1"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			torment: ["8M"],
			uturn: ["8M"],
			venoshock: ["8L48"],
		},
	},
	oddish: {
		learnset: {
			absorb: ["8L1"],
			acid: ["8L4"],
			afteryou: ["8E"],
			attract: ["8M"],
			bulletseed: ["8M"],
			charm: ["8E"],
			cut: ["8M"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flail: ["8E"],
			flash: ["8M"],
			gigadrain: ["8M", "8L20"],
			grassknot: ["8M"],
			grassyterrain: ["8L32"],
			growth: ["8L1"],
			ingrain: ["8E"],
			leechseed: ["8E"],
			megadrain: ["8L12"],
			moonblast: ["8L28"],
			moonlight: ["8L36"],
			naturepower: ["8E"],
			petaldance: ["8L40"],
			poisonpowder: ["8L14"],
			protect: ["8M"],
			razorleaf: ["8E"],
			rest: ["8M"],
			sleeppowder: ["8L18"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			strengthsap: ["8E"],
			stunspore: ["8L16"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L8"],
			swordsdance: ["8M"],
			synthesis: ["8E"],
			teeterdance: ["8E"],
			tickle: ["8E"],
			toxic: ["8M", "8L24"],
		},
	},
	gloom: {
		learnset: {
			absorb: ["8L1"],
			acid: ["8L1"],
			attract: ["8M"],
			bulletseed: ["8M"],
			cut: ["8M"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			gigadrain: ["8M", "8L20"],
			grassknot: ["8M"],
			grassyterrain: ["8L38"],
			growth: ["8L1"],
			megadrain: ["8L12"],
			moonblast: ["8L32"],
			moonlight: ["8L44"],
			petaldance: ["8L50"],
			poisonpowder: ["8L14"],
			protect: ["8M"],
			rest: ["8M"],
			sleeppowder: ["8L18"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			stunspore: ["8L16"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L1"],
			swordsdance: ["8M"],
			toxic: ["8M", "8L26"],
		},
	},
	vileplume: {
		learnset: {
			absorb: ["8L1"],
			acid: ["8L1"],
			aromatherapy: ["8L1"],
			attract: ["8M"],
			bulletseed: ["8M"],
			cut: ["8M"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			gigadrain: ["8M", "8L1"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			grassyterrain: ["8L1"],
			growth: ["8L1"],
			hyperbeam: ["8M"],
			megadrain: ["8L1"],
			moonblast: ["8L1"],
			moonlight: ["8L1"],
			petalblizzard: ["8L1"],
			petaldance: ["8L1"],
			poisonpowder: ["8L1"],
			protect: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			sleeppowder: ["8L1"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			stunspore: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L1"],
			swordsdance: ["8M"],
			toxic: ["8M", "8L1"],
		},
	},
	paras: {
		learnset: {
			absorb: ["8L11"],
			aerialace: ["8M"],
			agility: ["8E"],
			aromatherapy: ["8L43"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bugbite: ["8E"],
			bulletseed: ["8M"],
			counter: ["8E"],
			crosspoison: ["8E"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fellstinger: ["8E"],
			flail: ["8E"],
			flash: ["8M"],
			furycutter: ["8L17"],
			gigadrain: ["8M", "8L38"],
			grassknot: ["8M"],
			grassyterrain: ["8E"],
			growth: ["8L33"],
			leechseed: ["8E"],
			lightscreen: ["8M"],
			metalclaw: ["8E"],
			poisonpowder: ["8L6"],
			protect: ["8M"],
			psybeam: ["8E"],
			ragepowder: ["8L49"],
			rest: ["8M"],
			rocksmash: ["8M"],
			scratch: ["8L1"],
			screech: ["8E"],
			slash: ["8L27"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			spore: ["8L22"],
			stunspore: ["8L6"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8E"],
			swordsdance: ["8M"],
			thief: ["8M"],
			wideguard: ["8E"],
			xscissor: ["8M", "8L54"],
		},
	},
	parasect: {
		learnset: {
			absorb: ["8L11", "8L1"],
			aerialace: ["8M"],
			aromatherapy: ["8L51"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulletseed: ["8M"],
			crosspoison: ["8L1"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			flash: ["8M"],
			furycutter: ["8L17"],
			gigadrain: ["8M", "8L44"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growth: ["8L37"],
			hyperbeam: ["8M"],
			lightscreen: ["8M"],
			poisonpowder: ["8L6", "8L1"],
			protect: ["8M"],
			ragepowder: ["8L59"],
			rest: ["8M"],
			rocksmash: ["8M"],
			scratch: ["8L1"],
			slash: ["8L29"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			spore: ["8L22"],
			stunspore: ["8L6", "8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			thief: ["8M"],
			xscissor: ["8M", "8L66"],
		},
	},
	venonat: {
		learnset: {
			agility: ["8E"],
			attract: ["8M"],
			batonpass: ["8E"],
			bugbite: ["8E"],
			confusion: ["8L11"],
			disable: ["8L1"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M"],
			leechlife: ["8L35"],
			megadrain: ["8L25"],
			morningsun: ["8E"],
			poisonfang: ["8L41"],
			poisonpowder: ["8L13"],
			protect: ["8M"],
			psybeam: ["8L17"],
			psychic: ["8M", "8L47"],
			ragepowder: ["8E"],
			rest: ["8M"],
			screech: ["8E"],
			skillswap: ["8M"],
			sleeppowder: ["8L29"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			strugglebug: ["8L1"],
			stunspore: ["8L23"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L5"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
			toxicspikes: ["8E"],
			zenheadbutt: ["8L37"],
		},
	},
	venomoth: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			bugbuzz: ["8M", "8L59", "8L1"],
			confusion: ["8L11"],
			defog: ["8M"],
			disable: ["8L1"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			gust: ["8L1"],
			hyperbeam: ["8M"],
			leechlife: ["8L37"],
			megadrain: ["8L25"],
			poisonfang: ["8L47"],
			poisonpowder: ["8L13"],
			protect: ["8M"],
			psybeam: ["8L17"],
			psychic: ["8M", "8L55"],
			quiverdance: ["8L63", "8L1"],
			rest: ["8M"],
			roost: ["8M"],
			skillswap: ["8M"],
			sleeppowder: ["8L29"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			strugglebug: ["8L1"],
			stunspore: ["8L23"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L5", "8L1"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
			uturn: ["8M"],
			whirlwind: ["8L1"],
			zenheadbutt: ["8L41"],
		},
	},
	diglett: {
		learnset: {
			aerialace: ["8M"],
			ancientpower: ["8E"],
			astonish: ["8L8", "8E"],
			attract: ["8M"],
			beatup: ["8E"],
			bulldoze: ["8M", "8L16"],
			cut: ["8M"],
			dig: ["8M", "8L32"],
			doubleteam: ["8M"],
			earthpower: ["8L36"],
			earthquake: ["8M", "8L40"],
			endure: ["8M"],
			facade: ["8M"],
			finalgambit: ["8E"],
			fissure: ["8L44"],
			growl: ["8L4"],
			headbutt: ["8E"],
			honeclaws: ["8E"],
			memento: ["8E"],
			mudslap: ["8L12"],
			protect: ["8M"],
			rest: ["8M"],
			reversal: ["8E"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandattack: ["8L1"],
			sandstorm: ["8M", "8L28"],
			scratch: ["8L1"],
			screech: ["8E"],
			shadowclaw: ["8M"],
			slash: ["8L24"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			stealthrock: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L20"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thief: ["8M"],
			uproar: ["8E"],
			workup: ["8M"],
		},
	},
	dugtrio: {
		learnset: {
			aerialace: ["8M"],
			astonish: ["8L1"],
			attract: ["8M"],
			bulldoze: ["8M", "8L16"],
			cut: ["8M"],
			dig: ["8M", "8L36"],
			doubleteam: ["8M"],
			earthpower: ["8L42"],
			earthquake: ["8M", "8L48"],
			endure: ["8M"],
			facade: ["8M"],
			fissure: ["8L54"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hyperbeam: ["8M"],
			mudslap: ["8L12"],
			nightslash: ["8L1"],
			protect: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandattack: ["8L1"],
			sandstorm: ["8M", "8L30"],
			sandtomb: ["8L1"],
			scratch: ["8L1"],
			shadowclaw: ["8M"],
			slash: ["8L24"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L20"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thief: ["8M"],
			triattack: ["8L1"],
			workup: ["8M"],
		},
	},
	meowth: {
		learnset: {
			aerialace: ["8M"],
			amnesia: ["8E"],
			assurance: ["8L24"],
			attract: ["8M"],
			bite: ["8L16"],
			charm: ["8E"],
			covet: ["8E"],
			cut: ["8M"],
			darkpulse: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8L1"],
			feint: ["8L4"],
			flail: ["8E"],
			flash: ["8M"],
			foulplay: ["8E"],
			furyswipes: ["8L29"],
			growl: ["8L1"],
			hypnosis: ["8E"],
			irontail: ["8M"],
			lastresort: ["8E"],
			nastyplot: ["8M", "8L40"],
			payback: ["8M"],
			payday: ["8L12"],
			playrough: ["8L44"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			scratch: ["8L8"],
			screech: ["8L32"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			slash: ["8L36"],
			sleeptalk: ["8M"],
			spite: ["8E"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tailwhip: ["8E"],
			taunt: ["8M", "8L20"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			torment: ["8M"],
			uturn: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	persian: {
		learnset: {
			aerialace: ["8M"],
			assurance: ["8L24"],
			attract: ["8M"],
			bite: ["8L16"],
			cut: ["8M"],
			darkpulse: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8L1"],
			feint: ["8L1"],
			flash: ["8M"],
			furyswipes: ["8L31"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			nastyplot: ["8M", "8L48"],
			payback: ["8M"],
			payday: ["8L12"],
			playrough: ["8L54"],
			powergem: ["8L1"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			scratch: ["8L1"],
			screech: ["8L36"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			slash: ["8L42"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			switcheroo: ["8L1"],
			taunt: ["8M", "8L20"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			torment: ["8M"],
			uturn: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	psyduck: {
		learnset: {
			aerialace: ["8M"],
			amnesia: ["8L34"],
			aquatail: ["8L24"],
			attract: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M"],
			calmmind: ["8M"],
			clearsmog: ["8E"],
			confuseray: ["8E"],
			confusion: ["8L6"],
			crosschop: ["8E"],
			dig: ["8M"],
			disable: ["8L15"],
			doubleteam: ["8M"],
			encore: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			furyswipes: ["8L9"],
			futuresight: ["8E"],
			hail: ["8M"],
			hydropump: ["8L36"],
			hypnosis: ["8E"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			protect: ["8M"],
			psybeam: ["8E"],
			psychic: ["8M"],
			psychup: ["8M", "8L30"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			scald: ["8M"],
			scratch: ["8L1"],
			screech: ["8L21"],
			shadowclaw: ["8M"],
			simplebeam: ["8E"],
			sleeptalk: ["8M"],
			soak: ["8L27"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tailwhip: ["8L1"],
			waterfall: ["8M"],
			watergun: ["8L3"],
			waterpulse: ["8M", "8L12"],
			wonderroom: ["8L39"],
			yawn: ["8E"],
			zenheadbutt: ["8L18"],
		},
	},
	golduck: {
		learnset: {
			aerialace: ["8M"],
			amnesia: ["8L36"],
			aquajet: ["8L1"],
			aquatail: ["8L24"],
			attract: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M"],
			calmmind: ["8M"],
			confusion: ["8L1"],
			dig: ["8M"],
			disable: ["8L15"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			furyswipes: ["8L9"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hydropump: ["8L40"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			lowsweep: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M", "8L30"],
			raindance: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rocksmash: ["8M"],
			scald: ["8M"],
			scratch: ["8L1"],
			screech: ["8L21"],
			shadowclaw: ["8M"],
			sleeptalk: ["8M"],
			soak: ["8L27"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tailwhip: ["8L1"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L12"],
			wonderroom: ["8L45"],
			zenheadbutt: ["8L18"],
		},
	},
	mankey: {
		learnset: {
			aerialace: ["8M"],
			assurance: ["8L26"],
			attract: ["8M"],
			beatup: ["8E"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			closecombat: ["8L36", "8E"],
			counter: ["8E"],
			covet: ["8L1"],
			crosschop: ["8L22"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			encore: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			finalgambit: ["8L50"],
			fling: ["8M"],
			focusblast: ["8M"],
			focusenergy: ["8L1"],
			focuspunch: ["8M"],
			furyswipes: ["8L5"],
			irontail: ["8M"],
			leer: ["8L1"],
			lowkick: ["8L1"],
			lowsweep: ["8M"],
			mudslap: ["8L8"],
			nightslash: ["8E"],
			outrage: ["8L47"],
			overheat: ["8M"],
			payback: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			retaliate: ["8L15"],
			revenge: ["8E"],
			reversal: ["8E"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scratch: ["8L1"],
			screech: ["8L40"],
			seismictoss: ["8L12"],
			skullbash: ["8L29"],
			sleeptalk: ["8M"],
			stompingtantrum: ["8L43"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M", "8L19"],
			taunt: ["8M"],
			thief: ["8M"],
			thrash: ["8L33"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			uturn: ["8M"],
			workup: ["8M"],
		},
	},
	primeape: {
		learnset: {
			aerialace: ["8M"],
			assurance: ["8L26"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			closecombat: ["8L39"],
			covet: ["8L1"],
			crosschop: ["8L22"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			finalgambit: ["8L57", "8L1"],
			fling: ["8M", "8L1"],
			focusblast: ["8M"],
			focusenergy: ["8L1"],
			focuspunch: ["8M"],
			furyswipes: ["8L5"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			lowkick: ["8L1"],
			lowsweep: ["8M"],
			mudslap: ["8L8"],
			outrage: ["8L53"],
			overheat: ["8M"],
			payback: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			retaliate: ["8L15"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scratch: ["8L1"],
			screech: ["8L44"],
			seismictoss: ["8L12"],
			skullbash: ["8L30"],
			sleeptalk: ["8M"],
			stompingtantrum: ["8L48"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M", "8L19"],
			taunt: ["8M"],
			thief: ["8M"],
			thrash: ["8L35"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			uturn: ["8M"],
			workup: ["8M"],
		},
	},
	growlithe: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L20"],
			attract: ["8M"],
			bite: ["8L8"],
			bodyslam: ["8E"],
			burnup: ["8E"],
			closecombat: ["8E"],
			covet: ["8E"],
			crunch: ["8L32", "8E"],
			dig: ["8M"],
			doubleedge: ["8E"],
			doublekick: ["8E"],
			doubleteam: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			firefang: ["8L24"],
			firespin: ["8E"],
			flamethrower: ["8M", "8L40"],
			flamewheel: ["8L12"],
			flareblitz: ["8L56", "8E"],
			heatwave: ["8E"],
			helpinghand: ["8L16"],
			howl: ["8L4", "8E"],
			irontail: ["8M"],
			leer: ["8L1"],
			morningsun: ["8E"],
			overheat: ["8M"],
			playrough: ["8L48"],
			protect: ["8M"],
			rest: ["8M"],
			retaliate: ["8L28"],
			reversal: ["8L52"],
			roar: ["8M", "8L44"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			takedown: ["8L36"],
			thief: ["8M"],
			thrash: ["8E"],
			willowisp: ["8M"],
		},
	},
	arcanine: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L1"],
			attract: ["8M"],
			bite: ["8L1"],
			bulldoze: ["8M"],
			burnup: ["8L1"],
			crunch: ["8L1"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonpulse: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			extremespeed: ["8L1"],
			facade: ["8M"],
			fireblast: ["8M"],
			firefang: ["8L1"],
			flamethrower: ["8M", "8L1"],
			flamewheel: ["8L1"],
			flareblitz: ["8L1"],
			gigaimpact: ["8M"],
			helpinghand: ["8L1"],
			howl: ["8L1"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			overheat: ["8M"],
			playrough: ["8L1"],
			protect: ["8M"],
			rest: ["8M"],
			retaliate: ["8L1"],
			reversal: ["8L1"],
			roar: ["8M", "8L1"],
			rockclimb: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			takedown: ["8L1"],
			thief: ["8M"],
			willowisp: ["8M"],
		},
	},
	poliwag: {
		learnset: {
			attract: ["8M"],
			bellydrum: ["8L48"],
			blizzard: ["8M"],
			bodyslam: ["8L30"],
			bubblebeam: ["8L18", "8E"],
			bulldoze: ["8M"],
			dig: ["8M"],
			doubleedge: ["8L54"],
			doubleteam: ["8M"],
			earthpower: ["8L36"],
			encore: ["8E"],
			endeavor: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			hail: ["8M"],
			haze: ["8E"],
			hydropump: ["8L42"],
			hypnosis: ["8L1"],
			icebeam: ["8M"],
			mindreader: ["8E"],
			mist: ["8E"],
			mudshot: ["8L12", "8E"],
			pound: ["8L6"],
			protect: ["8M"],
			psychic: ["8M"],
			raindance: ["8M", "8L24"],
			rest: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			splash: ["8E"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			thief: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
		},
	},
	poliwhirl: {
		learnset: {
			attract: ["8M"],
			bellydrum: ["8L56"],
			blizzard: ["8M"],
			bodyslam: ["8L32"],
			brickbreak: ["8M"],
			bubblebeam: ["8L18"],
			bulldoze: ["8M"],
			dig: ["8M"],
			doubleedge: ["8L66"],
			doubleteam: ["8M"],
			earthpower: ["8L40"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			hail: ["8M"],
			hydropump: ["8L48"],
			hypnosis: ["8L1"],
			icebeam: ["8M"],
			mudshot: ["8L1"],
			pound: ["8L1"],
			protect: ["8M"],
			psychic: ["8M"],
			raindance: ["8M", "8L24"],
			rest: ["8M"],
			rocksmash: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			thief: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
		},
	},
	poliwrath: {
		learnset: {
			attract: ["8M"],
			bellydrum: ["8L1"],
			blizzard: ["8M"],
			bodyslam: ["8L1"],
			brickbreak: ["8M"],
			bubblebeam: ["8L1"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			circlethrow: ["8L1"],
			dig: ["8M"],
			doubleedge: ["8L1"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dynamicpunch: ["8L1"],
			earthpower: ["8L1"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hydropump: ["8L1"],
			hyperbeam: ["8M"],
			hypnosis: ["8L1"],
			icebeam: ["8M"],
			lowsweep: ["8M"],
			mindreader: ["8L1"],
			mudshot: ["8L1"],
			payback: ["8M"],
			poisonjab: ["8M"],
			pound: ["8L1"],
			protect: ["8M"],
			psychic: ["8M"],
			raindance: ["8M", "8L1"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			submission: ["8L1"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			thief: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	abra: {
		learnset: {
			allyswitch: ["8E"],
			attract: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confusion: ["8E"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			encore: ["8E"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			firepunch: ["8E"],
			flash: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			grassknot: ["8M"],
			guardsplit: ["8E"],
			guardswap: ["8E"],
			icepunch: ["8E"],
			irontail: ["8M"],
			knockoff: ["8E"],
			lightscreen: ["8M"],
			magiccoat: ["8E"],
			powertrick: ["8E"],
			protect: ["8M"],
			psychic: ["8M"],
			psychoshift: ["8E"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			teleport: ["8L1"],
			thief: ["8M"],
			thunderpunch: ["8E"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
		},
	},
	kadabra: {
		learnset: {
			allyswitch: ["8L15"],
			attract: ["8M"],
			calmmind: ["8M", "8L50"],
			chargebeam: ["8M"],
			confusion: ["8L1"],
			dazzlinggleam: ["8M"],
			disable: ["8L1"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			futuresight: ["8L45"],
			grassknot: ["8M"],
			irontail: ["8M"],
			kinesis: ["8L1"],
			lightscreen: ["8M"],
			protect: ["8M"],
			psybeam: ["8L5"],
			psychic: ["8M", "8L35"],
			psychocut: ["8L20"],
			psychup: ["8M"],
			psyshock: ["8L30"],
			raindance: ["8M"],
			recover: ["8L25"],
			recycle: ["8M"],
			reflect: ["8M", "8L10"],
			rest: ["8M"],
			roleplay: ["8L40"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			teleport: ["8L1"],
			thief: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
		},
	},
	alakazam: {
		learnset: {
			allyswitch: ["8L15"],
			attract: ["8M"],
			calmmind: ["8M", "8L50"],
			chargebeam: ["8M"],
			confusion: ["8L1"],
			dazzlinggleam: ["8M"],
			disable: ["8L1"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			futuresight: ["8L45"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			kinesis: ["8L1"],
			lightscreen: ["8M"],
			nastyplot: ["8M"],
			protect: ["8M"],
			psybeam: ["8L5"],
			psychic: ["8M", "8L35"],
			psychocut: ["8L20"],
			psychup: ["8M"],
			psyshock: ["8L30"],
			raindance: ["8M"],
			recover: ["8L25"],
			recycle: ["8M"],
			reflect: ["8M", "8L10"],
			rest: ["8M"],
			roleplay: ["8L40"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			teleport: ["8L1"],
			thief: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
		},
	},
	machop: {
		learnset: {
			attract: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M", "8L36"],
			bulldoze: ["8M"],
			bulletpunch: ["8E"],
			closecombat: ["8E"],
			counter: ["8E"],
			crosschop: ["8L48"],
			dig: ["8M"],
			doubleedge: ["8L52"],
			doubleteam: ["8M"],
			dualchop: ["8L32"],
			dynamicpunch: ["8L44"],
			earthquake: ["8M"],
			encore: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			firepunch: ["8E"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focusenergy: ["8L4"],
			focuspunch: ["8M"],
			heavyslam: ["8E"],
			icepunch: ["8E"],
			knockoff: ["8L16", "8E"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			lowkick: ["8L1"],
			lowsweep: ["8M", "8L12"],
			payback: ["8M"],
			poisonjab: ["8M"],
			powertrick: ["8E"],
			protect: ["8M"],
			quickguard: ["8E"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8L8"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scaryface: ["8L20"],
			seismictoss: ["8L40"],
			sleeptalk: ["8M"],
			strength: ["8M", "8L29"],
			submission: ["8E"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thief: ["8M"],
			thunderpunch: ["8E"],
			tickle: ["8E"],
			vitalthrow: ["8L24"],
			workup: ["8M"],
		},
	},
	machoke: {
		learnset: {
			attract: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M", "8L42"],
			bulldoze: ["8M"],
			crosschop: ["8L60"],
			dig: ["8M"],
			doubleedge: ["8L66"],
			doubleteam: ["8M"],
			dualchop: ["8L36"],
			dynamicpunch: ["8L54"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focusenergy: ["8L1"],
			focuspunch: ["8M"],
			knockoff: ["8L16"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			lowkick: ["8L1"],
			lowsweep: ["8M", "8L12"],
			payback: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8L1"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scaryface: ["8L20"],
			seismictoss: ["8L48"],
			sleeptalk: ["8M"],
			strength: ["8M", "8L31"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thief: ["8M"],
			vitalthrow: ["8L24"],
			workup: ["8M"],
		},
	},
	machamp: {
		learnset: {
			attract: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M", "8L42"],
			bulldoze: ["8M"],
			crosschop: ["8L60"],
			dig: ["8M"],
			doubleedge: ["8L66"],
			doubleteam: ["8M"],
			dualchop: ["8L36"],
			dynamicpunch: ["8L54"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focusenergy: ["8L1"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M"],
			knockoff: ["8L16"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			lowkick: ["8L1"],
			lowsweep: ["8M", "8L12"],
			payback: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8L1"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scaryface: ["8L20"],
			seismictoss: ["8L48"],
			sleeptalk: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M", "8L31"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thief: ["8M"],
			vitalthrow: ["8L24"],
			wideguard: ["8L1"],
			workup: ["8M"],
		},
	},
	bellsprout: {
		learnset: {
			acid: ["8L23"],
			acidspray: ["8E"],
			attract: ["8M"],
			belch: ["8E"],
			bulletseed: ["8M"],
			clearsmog: ["8E"],
			cut: ["8M"],
			doubleteam: ["8M"],
			encore: ["8E"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gastroacid: ["8L35"],
			gigadrain: ["8M"],
			grassknot: ["8M"],
			growth: ["8L7"],
			ingrain: ["8E"],
			knockoff: ["8L27"],
			leechlife: ["8E"],
			magicalleaf: ["8E"],
			poisonjab: ["8M", "8L41"],
			poisonpowder: ["8L15"],
			powerwhip: ["8E"],
			protect: ["8M"],
			razorleaf: ["8L39"],
			reflect: ["8M"],
			rest: ["8M"],
			slam: ["8L47"],
			sleeppowder: ["8L13"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			strengthsap: ["8E"],
			stunspore: ["8L17"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L29"],
			swordsdance: ["8M"],
			synthesis: ["8E"],
			thief: ["8M"],
			tickle: ["8E"],
			vinewhip: ["8L1"],
			weatherball: ["8E"],
			worryseed: ["8E"],
			wrap: ["8L11"],
		},
	},
	weepinbell: {
		learnset: {
			acid: ["8L24"],
			attract: ["8M"],
			bulletseed: ["8M"],
			cut: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gastroacid: ["8L39"],
			gigadrain: ["8M"],
			grassknot: ["8M"],
			growth: ["8L7", "8L1"],
			knockoff: ["8L29"],
			poisonjab: ["8M", "8L47"],
			poisonpowder: ["8L15"],
			protect: ["8M"],
			razorleaf: ["8L44"],
			reflect: ["8M"],
			rest: ["8M"],
			slam: ["8L54"],
			sleeppowder: ["8L13"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			stunspore: ["8L17"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L32"],
			swordsdance: ["8M"],
			thief: ["8M"],
			vinewhip: ["8L1"],
			wrap: ["8L11", "8L1"],
		},
	},
	victreebel: {
		learnset: {
			acid: ["8L1"],
			attract: ["8M"],
			bulletseed: ["8M"],
			cut: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gastroacid: ["8L1"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growth: ["8L1"],
			hyperbeam: ["8M"],
			knockoff: ["8L1"],
			leafblade: ["8L44"],
			leafstorm: ["8L32"],
			leaftornado: ["8L1"],
			poisonjab: ["8M", "8L1"],
			poisonpowder: ["8L1"],
			protect: ["8M"],
			razorleaf: ["8L1"],
			reflect: ["8M"],
			rest: ["8M"],
			slam: ["8L1"],
			sleeppowder: ["8L1"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			spitup: ["8L1"],
			stockpile: ["8L1"],
			stunspore: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8L1"],
			sweetscent: ["8L1"],
			swordsdance: ["8M"],
			thief: ["8M"],
			vinewhip: ["8L1"],
			wrap: ["8L1"],
		},
	},
	tentacool: {
		learnset: {
			acid: ["8L4"],
			acidarmor: ["8L32"],
			acupressure: ["8E"],
			aquaring: ["8E"],
			attract: ["8M"],
			aurorabeam: ["8E"],
			blizzard: ["8M"],
			brine: ["8M"],
			bubblebeam: ["8L24"],
			confuseray: ["8E"],
			cut: ["8M"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			gigadrain: ["8M"],
			hail: ["8M"],
			haze: ["8E"],
			hex: ["8L28"],
			hydropump: ["8L48"],
			icebeam: ["8M"],
			knockoff: ["8E"],
			mirrorcoat: ["8E"],
			muddywater: ["8E"],
			payback: ["8M"],
			poisonjab: ["8M", "8L36"],
			poisonsting: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rapidspin: ["8E"],
			rest: ["8M"],
			safeguard: ["8M"],
			scald: ["8M"],
			screech: ["8L20"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			sludgewave: ["8L44"],
			substitute: ["8M"],
			supersonic: ["8L12"],
			surf: ["8M", "8L40"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			thief: ["8M"],
			tickle: ["8E"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L16"],
			wrap: ["8L8"],
		},
	},
	tentacruel: {
		learnset: {
			acid: ["8L1"],
			acidarmor: ["8L34"],
			attract: ["8M"],
			blizzard: ["8M"],
			brine: ["8M"],
			bubblebeam: ["8L24"],
			cut: ["8M"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hex: ["8L28"],
			hydropump: ["8L58"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			payback: ["8M"],
			poisonjab: ["8M", "8L40"],
			poisonsting: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			reflecttype: ["8L1"],
			rest: ["8M"],
			safeguard: ["8M"],
			scald: ["8M"],
			screech: ["8L20"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			sludgewave: ["8L52"],
			substitute: ["8M"],
			supersonic: ["8L12"],
			surf: ["8M", "8L46"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			thief: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L16"],
			wrap: ["8L1"],
		},
	},
	geodude: {
		learnset: {
			attract: ["8M"],
			autotomize: ["8E"],
			block: ["8E"],
			brickbreak: ["8M"],
			bulldoze: ["8M", "8L22"],
			curse: ["8E"],
			defensecurl: ["8L1"],
			dig: ["8M"],
			doubleedge: ["8L40"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L34"],
			endure: ["8M"],
			explosion: ["8M", "8L36"],
			facade: ["8M"],
			fireblast: ["8M"],
			flail: ["8E"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			gyroball: ["8M"],
			hammerarm: ["8E"],
			harden: ["8L12"],
			megapunch: ["8E"],
			protect: ["8M"],
			rest: ["8M"],
			rockblast: ["8L30"],
			rockclimb: ["8M"],
			rockpolish: ["8M", "8L6"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rockthrow: ["8L16"],
			rocktomb: ["8M"],
			rollout: ["8L10"],
			sandstorm: ["8M", "8L4"],
			selfdestruct: ["8L24"],
			sleeptalk: ["8M"],
			smackdown: ["8L18"],
			stealthrock: ["8M", "8L28"],
			stoneedge: ["8M", "8L42"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			wideguard: ["8E"],
		},
	},
	graveler: {
		learnset: {
			attract: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M", "8L22"],
			defensecurl: ["8L1"],
			dig: ["8M"],
			doubleedge: ["8L50"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L40"],
			endure: ["8M"],
			explosion: ["8M", "8L44"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			gyroball: ["8M"],
			harden: ["8L12"],
			protect: ["8M"],
			rest: ["8M"],
			rockblast: ["8L34"],
			rockclimb: ["8M"],
			rockpolish: ["8M", "8L6", "8L1"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rockthrow: ["8L16"],
			rocktomb: ["8M"],
			rollout: ["8L10"],
			sandstorm: ["8M", "8L4"],
			selfdestruct: ["8L24"],
			sleeptalk: ["8M"],
			smackdown: ["8L18"],
			stealthrock: ["8M", "8L30"],
			stoneedge: ["8M", "8L54"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
		},
	},
	golem: {
		learnset: {
			attract: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M", "8L22"],
			defensecurl: ["8L1"],
			dig: ["8M"],
			doubleedge: ["8L50"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L40"],
			endure: ["8M"],
			explosion: ["8M", "8L44"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			gyroball: ["8M"],
			harden: ["8L12"],
			heavyslam: ["8L60", "8L1"],
			hyperbeam: ["8M"],
			protect: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockblast: ["8L34"],
			rockclimb: ["8M"],
			rockpolish: ["8M", "8L6", "8L1"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rockthrow: ["8L16"],
			rocktomb: ["8M"],
			rollout: ["8L10"],
			sandstorm: ["8M", "8L4"],
			selfdestruct: ["8L24"],
			sleeptalk: ["8M"],
			smackdown: ["8L18"],
			stealthrock: ["8M", "8L30"],
			stoneedge: ["8M", "8L54"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
		},
	},
	ponyta: {
		learnset: {
			agility: ["8L20"],
			allyswitch: ["8E"],
			attract: ["8M"],
			charm: ["8E"],
			doubleedge: ["8E"],
			doublekick: ["8E"],
			doubleteam: ["8M"],
			ember: ["8L10"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M", "8L50"],
			firespin: ["8L35"],
			flamecharge: ["8L15"],
			flamethrower: ["8M"],
			flamewheel: ["8L25", "8E"],
			flareblitz: ["8L55"],
			growl: ["8L1"],
			highhorsepower: ["8E"],
			horndrill: ["8E"],
			hypnosis: ["8E"],
			inferno: ["8L45"],
			irontail: ["8M"],
			lowkick: ["8E"],
			morningsun: ["8E"],
			overheat: ["8M"],
			protect: ["8M"],
			rest: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stomp: ["8L30"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailwhip: ["8L5"],
			takedown: ["8L41"],
			thrash: ["8E"],
			willowisp: ["8M"],
		},
	},
	rapidash: {
		learnset: {
			agility: ["8L20"],
			attract: ["8M"],
			doubleteam: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M", "8L56"],
			firespin: ["8L35"],
			flamecharge: ["8L15"],
			flamethrower: ["8M"],
			flamewheel: ["8L25"],
			flareblitz: ["8L63"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hyperbeam: ["8M"],
			inferno: ["8L49"],
			irontail: ["8M"],
			megahorn: ["8L1"],
			overheat: ["8M"],
			poisonjab: ["8M", "8L1"],
			protect: ["8M"],
			quickattack: ["8L1"],
			rest: ["8M"],
			sleeptalk: ["8M"],
			smartstrike: ["8L1"],
			solarbeam: ["8M"],
			stomp: ["8L30"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			takedown: ["8L43"],
			willowisp: ["8M"],
		},
	},
	slowpoke: {
		learnset: {
			amnesia: ["8L27"],
			attract: ["8M"],
			belch: ["8E"],
			bellydrum: ["8E"],
			blizzard: ["8M"],
			block: ["8E"],
			brine: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			confusion: ["8L12"],
			curse: ["8L1"],
			dig: ["8M"],
			disable: ["8L15"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			futuresight: ["8E"],
			grassknot: ["8M"],
			growl: ["8L3"],
			hail: ["8M"],
			headbutt: ["8L21"],
			healpulse: ["8L45"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			protect: ["8M"],
			psychic: ["8M", "8L36"],
			psychup: ["8M", "8L39"],
			raindance: ["8M", "8L42"],
			recycle: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			scald: ["8M"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			slackoff: ["8L33"],
			sleeptalk: ["8M"],
			snore: ["8E"],
			stomp: ["8E"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M", "8L30"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thunderwave: ["8M"],
			trickroom: ["8M"],
			watergun: ["8L6"],
			waterpulse: ["8M", "8L18"],
			wonderroom: ["8E"],
			yawn: ["8L9"],
			zenheadbutt: ["8L24", "8E"],
		},
	},
	slowbro: {
		learnset: {
			aerialace: ["8M"],
			amnesia: ["8L27"],
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			confusion: ["8L12"],
			curse: ["8L1"],
			dig: ["8M"],
			disable: ["8L15"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			hail: ["8M"],
			headbutt: ["8L21"],
			healpulse: ["8L51"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			nastyplot: ["8M"],
			protect: ["8M"],
			psychic: ["8M", "8L36"],
			psychup: ["8M", "8L41"],
			raindance: ["8M", "8L46"],
			recycle: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			scald: ["8M"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			slackoff: ["8L33"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M", "8L30"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thunderwave: ["8M"],
			trickroom: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L18"],
			withdraw: ["8L1"],
			yawn: ["8L9"],
			zenheadbutt: ["8L24"],
		},
	},
	magnemite: {
		learnset: {
			chargebeam: ["8M"],
			discharge: ["8L36"],
			doubleteam: ["8M"],
			electroball: ["8L12"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			flashcannon: ["8M", "8L32"],
			gyroball: ["8M", "8L16"],
			lightscreen: ["8M", "8L44"],
			lockon: ["8L48"],
			magnetrise: ["8L28"],
			metalsound: ["8L40"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			screech: ["8L24"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			spark: ["8L20"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L4"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thundershock: ["8L1"],
			thunderwave: ["8M", "8L8"],
			voltswitch: ["8M"],
			zapcannon: ["8L52"],
		},
	},
	magneton: {
		learnset: {
			chargebeam: ["8M"],
			discharge: ["8L40"],
			doubleteam: ["8M"],
			electricterrain: ["8L1"],
			electroball: ["8L12"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			flashcannon: ["8M", "8L34"],
			gigaimpact: ["8M"],
			gyroball: ["8M", "8L16"],
			hyperbeam: ["8M"],
			lightscreen: ["8M", "8L52"],
			lockon: ["8L58"],
			magnetrise: ["8L28"],
			metalsound: ["8L46"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			screech: ["8L24"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			spark: ["8L20"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L1"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thundershock: ["8L1"],
			thunderwave: ["8M", "8L1"],
			triattack: ["8L1"],
			voltswitch: ["8M"],
			zapcannon: ["8L64"],
		},
	},
	farfetchd: {
		learnset: {
			aerialace: ["8M", "8L20"],
			agility: ["8L60"],
			aircutter: ["8L25"],
			airslash: ["8L50"],
			attract: ["8M"],
			bravebird: ["8L65"],
			covet: ["8E"],
			curse: ["8E"],
			cut: ["8M", "8L15"],
			defog: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M", "8L35"],
			featherdance: ["8E"],
			feint: ["8E"],
			finalgambit: ["8E"],
			flail: ["8E"],
			fly: ["8M"],
			furycutter: ["8L10"],
			gust: ["8E"],
			irontail: ["8M"],
			knockoff: ["8L30"],
			leafblade: ["8L55", "8E"],
			leer: ["8L5"],
			mudslap: ["8E"],
			nightslash: ["8E"],
			peck: ["8L1"],
			pluck: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			psychup: ["8M"],
			quickattack: ["8E"],
			rest: ["8M"],
			revenge: ["8E"],
			roost: ["8M"],
			sandattack: ["8L1"],
			simplebeam: ["8E"],
			skyattack: ["8E"],
			slash: ["8L40"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L45"],
			thief: ["8M"],
			uturn: ["8M"],
			workup: ["8M"],
		},
	},
	doduo: {
		learnset: {
			acupressure: ["8L33"],
			aerialace: ["8M"],
			agility: ["8L26"],
			assurance: ["8E"],
			attract: ["8M"],
			bravebird: ["8E"],
			doublehit: ["8L22"],
			doubleteam: ["8M"],
			drillpeck: ["8L43"],
			endeavor: ["8L47", "8E"],
			endure: ["8M"],
			facade: ["8M"],
			flail: ["8E"],
			fly: ["8M"],
			furyattack: ["8L12"],
			growl: ["8L1"],
			haze: ["8E"],
			leer: ["8L8"],
			lunge: ["8L40"],
			peck: ["8L1"],
			pluck: ["8M", "8L19"],
			protect: ["8M"],
			quickattack: ["8L5", "8E"],
			rest: ["8M"],
			roost: ["8M"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8E"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L36"],
			thief: ["8M"],
			thrash: ["8L50"],
			uproar: ["8L29"],
			wingattack: ["8L15"],
			workup: ["8M"],
		},
	},
	dodrio: {
		learnset: {
			acupressure: ["8L34"],
			aerialace: ["8M"],
			agility: ["8L26"],
			attract: ["8M"],
			doublehit: ["8L22"],
			doubleteam: ["8M"],
			drillpeck: ["8L47"],
			endeavor: ["8L52"],
			endure: ["8M"],
			facade: ["8M"],
			fly: ["8M"],
			furyattack: ["8L12"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hyperbeam: ["8M"],
			leer: ["8L8"],
			lunge: ["8L43"],
			payback: ["8M"],
			peck: ["8L1"],
			pluck: ["8M", "8L19"],
			protect: ["8M"],
			quickattack: ["8L5", "8L1"],
			rest: ["8M"],
			roost: ["8M"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L38"],
			taunt: ["8M"],
			thief: ["8M"],
			thrash: ["8L56"],
			torment: ["8M"],
			triattack: ["8L1"],
			uproar: ["8L29"],
			wingattack: ["8L15"],
			workup: ["8M"],
		},
	},
	seel: {
		learnset: {
			aquajet: ["8L31"],
			aquaring: ["8L23"],
			aquatail: ["8L43"],
			attract: ["8M"],
			aurorabeam: ["8L27"],
			belch: ["8E"],
			blizzard: ["8M"],
			brine: ["8M", "8L33"],
			disable: ["8E"],
			dive: ["8L41"],
			doubleteam: ["8M"],
			encore: ["8L13", "8E"],
			endure: ["8M"],
			entrainment: ["8E"],
			facade: ["8M"],
			fakeout: ["8E"],
			fling: ["8M"],
			growl: ["8L3"],
			hail: ["8M", "8L53"],
			headbutt: ["8L1"],
			horndrill: ["8E"],
			icebeam: ["8M", "8L47"],
			iceshard: ["8L17"],
			iciclespear: ["8E"],
			icywind: ["8L11"],
			irontail: ["8M"],
			lick: ["8E"],
			perishsong: ["8E"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L21"],
			safeguard: ["8M", "8L51"],
			slam: ["8E"],
			sleeptalk: ["8M"],
			spitup: ["8E"],
			stockpile: ["8E"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swallow: ["8E"],
			takedown: ["8L37"],
			thief: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L7"],
			waterpulse: ["8M"],
		},
	},
	dewgong: {
		learnset: {
			aquajet: ["8L31"],
			aquaring: ["8L23"],
			aquatail: ["8L49"],
			attract: ["8M"],
			aurorabeam: ["8L27"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brine: ["8M", "8L33"],
			bubblebeam: ["8L7", "8L1"],
			dive: ["8L45"],
			doubleteam: ["8M"],
			encore: ["8L13"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L3", "8L1"],
			hail: ["8M", "8L65"],
			headbutt: ["8L1"],
			hyperbeam: ["8M"],
			icebeam: ["8M", "8L55"],
			iceshard: ["8L17"],
			icywind: ["8L11", "8L1"],
			irontail: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L21"],
			safeguard: ["8M", "8L61"],
			sheercold: ["8L1"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			takedown: ["8L39"],
			thief: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
		},
	},
	grimer: {
		learnset: {
			acidarmor: ["8L43"],
			acidspray: ["8E"],
			attract: ["8M"],
			belch: ["8L46"],
			curse: ["8E"],
			dig: ["8M"],
			disable: ["8L12"],
			doubleteam: ["8M"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M", "8L26"],
			gigadrain: ["8M"],
			gunkshot: ["8L40"],
			harden: ["8L4"],
			haze: ["8E"],
			imprison: ["8E"],
			lick: ["8E"],
			meanlook: ["8E"],
			memento: ["8L48"],
			minimize: ["8L21"],
			mudslap: ["8L7"],
			payback: ["8M"],
			poisongas: ["8L1"],
			poisonjab: ["8M"],
			pound: ["8L1"],
			poweruppunch: ["8E"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocktomb: ["8M"],
			scaryface: ["8E"],
			screech: ["8L37"],
			shadowball: ["8M"],
			shadowpunch: ["8E"],
			shadowsneak: ["8E"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludge: ["8L15"],
			sludgebomb: ["8M", "8L29"],
			sludgewave: ["8L32"],
			smog: ["8L18"],
			spitup: ["8E"],
			stockpile: ["8E"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8E"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			torment: ["8M"],
		},
	},
	muk: {
		learnset: {
			acidarmor: ["8L46"],
			attract: ["8M"],
			belch: ["8L52"],
			brickbreak: ["8M"],
			darkpulse: ["8M"],
			dig: ["8M"],
			disable: ["8L12"],
			doubleteam: ["8M"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M", "8L26"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			gunkshot: ["8L40"],
			harden: ["8L4", "8L1"],
			hyperbeam: ["8M"],
			memento: ["8L57"],
			minimize: ["8L21"],
			mudslap: ["8L7", "8L1"],
			payback: ["8M"],
			poisongas: ["8L1"],
			poisonjab: ["8M"],
			pound: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			screech: ["8L37"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludge: ["8L15"],
			sludgebomb: ["8M", "8L29"],
			sludgewave: ["8L32"],
			smog: ["8L18"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			torment: ["8M"],
			venomdrench: ["8L1"],
		},
	},
	shellder: {
		learnset: {
			aquaring: ["8E"],
			attract: ["8M"],
			aurorabeam: ["8L24"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brine: ["8M"],
			bubblebeam: ["8E"],
			doubleteam: ["8M"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			hail: ["8M"],
			hydropump: ["8L48"],
			icebeam: ["8M", "8L40"],
			iceshard: ["8L8"],
			iciclespear: ["8E"],
			irondefense: ["8L36"],
			leer: ["8L12"],
			lifedew: ["8E"],
			mudshot: ["8E"],
			payback: ["8M"],
			protect: ["8M", "8L28"],
			raindance: ["8M"],
			rapidspin: ["8E"],
			razorshell: ["8L32"],
			rest: ["8M"],
			rockblast: ["8E"],
			screech: ["8E"],
			shellsmash: ["8L44"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			supersonic: ["8L20"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8E"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			whirlpool: ["8L16"],
			withdraw: ["8L4"],
		},
	},
	cloyster: {
		learnset: {
			attract: ["8M"],
			aurorabeam: ["8L1"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brine: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hydropump: ["8L1"],
			hyperbeam: ["8M"],
			icebeam: ["8M", "8L1"],
			iceshard: ["8L1"],
			iciclecrash: ["8L1"],
			iciclespear: ["8L1"],
			irondefense: ["8L1"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			payback: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M", "8L1"],
			raindance: ["8M"],
			razorshell: ["8L1"],
			rest: ["8M"],
			shellsmash: ["8L1"],
			sleeptalk: ["8M"],
			spikes: ["8L1"],
			substitute: ["8M"],
			supersonic: ["8L1"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			torment: ["8M"],
			toxicspikes: ["8L1"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			whirlpool: ["8L1"],
			withdraw: ["8L1"],
		},
	},
	gastly: {
		learnset: {
			astonish: ["8E"],
			attract: ["8M"],
			clearsmog: ["8E"],
			confuseray: ["8L1"],
			curse: ["8L20"],
			darkpulse: ["8M", "8L36"],
			dazzlinggleam: ["8M"],
			destinybond: ["8L44"],
			disable: ["8E"],
			doubleteam: ["8M"],
			dreameater: ["8M", "8L48"],
			endure: ["8M"],
			energyball: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			firepunch: ["8E"],
			gigadrain: ["8M"],
			grudge: ["8E"],
			haze: ["8E"],
			hex: ["8L24"],
			hypnosis: ["8L4"],
			icepunch: ["8E"],
			lick: ["8L1"],
			meanlook: ["8L8"],
			nightshade: ["8L28"],
			payback: ["8M", "8L12"],
			perishsong: ["8E"],
			poisonjab: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			reflecttype: ["8E"],
			rest: ["8M"],
			scaryface: ["8E"],
			shadowball: ["8M", "8L40"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			smog: ["8E"],
			spite: ["8L16"],
			substitute: ["8M"],
			suckerpunch: ["8L32"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			thunderbolt: ["8M"],
			thunderpunch: ["8E"],
			torment: ["8M"],
			toxic: ["8M"],
			trickroom: ["8M"],
			willowisp: ["8M"],
		},
	},
	haunter: {
		learnset: {
			attract: ["8M"],
			confuseray: ["8L1"],
			curse: ["8L20"],
			darkpulse: ["8M", "8L42"],
			dazzlinggleam: ["8M"],
			destinybond: ["8L54"],
			doubleteam: ["8M"],
			dreameater: ["8M", "8L60"],
			endure: ["8M"],
			energyball: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			gigadrain: ["8M"],
			hex: ["8L24"],
			hypnosis: ["8L1"],
			lick: ["8L1"],
			meanlook: ["8L1"],
			nightshade: ["8L30"],
			payback: ["8M", "8L12"],
			poisonjab: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			shadowball: ["8M", "8L48"],
			shadowclaw: ["8M"],
			shadowpunch: ["8L1"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			spite: ["8L16"],
			substitute: ["8M"],
			suckerpunch: ["8L36"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			thunderbolt: ["8M"],
			torment: ["8M"],
			toxic: ["8M"],
			trickroom: ["8M"],
			willowisp: ["8M"],
		},
	},
	gengar: {
		learnset: {
			attract: ["8M"],
			brickbreak: ["8M"],
			confuseray: ["8L1"],
			curse: ["8L20"],
			darkpulse: ["8M", "8L42"],
			dazzlinggleam: ["8M"],
			destinybond: ["8L54"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M", "8L60"],
			endure: ["8M"],
			energyball: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			hex: ["8L24"],
			hyperbeam: ["8M"],
			hypnosis: ["8L1"],
			lick: ["8L1"],
			meanlook: ["8L1"],
			nastyplot: ["8M"],
			nightshade: ["8L30"],
			payback: ["8M", "8L12"],
			perishsong: ["8L1"],
			poisonjab: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			reflecttype: ["8L1"],
			rest: ["8M"],
			rocksmash: ["8M"],
			shadowball: ["8M", "8L48"],
			shadowclaw: ["8M"],
			shadowpunch: ["8L1"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			spite: ["8L16"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L36"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			torment: ["8M"],
			toxic: ["8M"],
			trickroom: ["8M"],
			willowisp: ["8M"],
		},
	},
	onix: {
		learnset: {
			attract: ["8M"],
			bind: ["8L1"],
			block: ["8E"],
			bulldoze: ["8M"],
			curse: ["8L16"],
			defensecurl: ["8E"],
			dig: ["8M", "8L44"],
			doubleedge: ["8L56"],
			doubleteam: ["8M"],
			dragonbreath: ["8L12"],
			dragonpulse: ["8M"],
			dragontail: ["8E"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			flail: ["8E"],
			flashcannon: ["8M"],
			gyroball: ["8M"],
			harden: ["8L1"],
			headsmash: ["8E"],
			heavyslam: ["8E"],
			irontail: ["8M", "8L48"],
			payback: ["8M"],
			protect: ["8M"],
			psychup: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockblast: ["8E"],
			rockclimb: ["8M"],
			rockpolish: ["8M", "8L8"],
			rockslide: ["8M", "8L20"],
			rocksmash: ["8M"],
			rockthrow: ["8L1"],
			rocktomb: ["8M"],
			rollout: ["8E"],
			sandstorm: ["8M", "8L40"],
			sandtomb: ["8L28"],
			screech: ["8L24"],
			slam: ["8L36"],
			sleeptalk: ["8M"],
			smackdown: ["8L4"],
			stealthrock: ["8M", "8L32"],
			stoneedge: ["8M", "8L52"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			taunt: ["8M"],
			torment: ["8M"],
			wideguard: ["8E"],
		},
	},
	drowzee: {
		learnset: {
			attract: ["8M"],
			brickbreak: ["8M"],
			calmmind: ["8M"],
			confusion: ["8L9"],
			dazzlinggleam: ["8M"],
			disable: ["8L5"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			firepunch: ["8E"],
			flash: ["8M"],
			flatter: ["8E"],
			fling: ["8M"],
			focuspunch: ["8M"],
			futuresight: ["8L61"],
			grassknot: ["8M"],
			guardswap: ["8E"],
			headbutt: ["8L13"],
			hypnosis: ["8L21", "8L1", "8L37"],
			icepunch: ["8E"],
			lightscreen: ["8M"],
			lowsweep: ["8M"],
			mindreader: ["8L29"],
			nastyplot: ["8M", "8L53"],
			poisongas: ["8L17"],
			pound: ["8L1"],
			powersplit: ["8E"],
			protect: ["8M"],
			psybeam: ["8L25"],
			psychic: ["8M", "8L49"],
			psychocut: ["8E"],
			psychup: ["8M", "8L33"],
			psyshock: ["8L57"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			roleplay: ["8E"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M", "8L45"],
			taunt: ["8M"],
			thief: ["8M"],
			thunderpunch: ["8E"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
			zenheadbutt: ["8L41"],
		},
	},
	hypno: {
		learnset: {
			attract: ["8M"],
			brickbreak: ["8M"],
			calmmind: ["8M"],
			confusion: ["8L9", "8L1"],
			dazzlinggleam: ["8M"],
			disable: ["8L5", "8L1"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			futuresight: ["8L61", "8L1"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			headbutt: ["8L13"],
			hyperbeam: ["8M"],
			hypnosis: ["8L21", "8L1", "8L37"],
			lightscreen: ["8M"],
			lowsweep: ["8M"],
			mindreader: ["8L29"],
			nastyplot: ["8M", "8L53", "8L1"],
			poisongas: ["8L17"],
			pound: ["8L1"],
			protect: ["8M"],
			psybeam: ["8L25"],
			psychic: ["8M", "8L49"],
			psychup: ["8M", "8L33"],
			psyshock: ["8L57"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M", "8L45"],
			switcheroo: ["8L1"],
			taunt: ["8M"],
			thief: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
			zenheadbutt: ["8L41"],
		},
	},
	krabby: {
		learnset: {
			agility: ["8E"],
			allyswitch: ["8E"],
			amnesia: ["8E"],
			ancientpower: ["8E"],
			attract: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M"],
			bubblebeam: ["8L20"],
			crabhammer: ["8L44"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			flail: ["8L29", "8E"],
			fling: ["8M"],
			guillotine: ["8L48"],
			hail: ["8M"],
			hammerarm: ["8E"],
			harden: ["8L4"],
			haze: ["8E"],
			icebeam: ["8M"],
			knockoff: ["8E"],
			leer: ["8L1"],
			metalclaw: ["8L8"],
			mudshot: ["8L12"],
			nightslash: ["8E"],
			protect: ["8M", "8L16"],
			raindance: ["8M"],
			razorshell: ["8L32"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			slam: ["8L36", "8E"],
			slash: ["8E"],
			sleeptalk: ["8M"],
			stomp: ["8L24"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L40"],
			thief: ["8M"],
			tickle: ["8E"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			xscissor: ["8M"],
		},
	},
	kingler: {
		learnset: {
			attract: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M"],
			bubblebeam: ["8L20"],
			crabhammer: ["8L54"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			flail: ["8L31"],
			fling: ["8M"],
			gigaimpact: ["8M"],
			guillotine: ["8L60"],
			hail: ["8M"],
			hammerarm: ["8L1"],
			harden: ["8L1"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			leer: ["8L1"],
			metalclaw: ["8L1"],
			mudshot: ["8L12"],
			protect: ["8M", "8L16"],
			raindance: ["8M"],
			razorshell: ["8L36"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			slam: ["8L42"],
			sleeptalk: ["8M"],
			stomp: ["8L24"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L48"],
			thief: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			wideguard: ["8L1"],
			xscissor: ["8M"],
		},
	},
	voltorb: {
		learnset: {
			charge: ["8L1"],
			chargebeam: ["8M", "8L16"],
			discharge: ["8L37"],
			doubleteam: ["8M"],
			eerieimpulse: ["8L6"],
			electroball: ["8L22"],
			endure: ["8M"],
			explosion: ["8M", "8L41"],
			facade: ["8M"],
			flash: ["8M"],
			gyroball: ["8M", "8L46"],
			lightscreen: ["8M", "8L29"],
			magnetrise: ["8L34"],
			mirrorcoat: ["8L48"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rollout: ["8L11"],
			screech: ["8L13"],
			selfdestruct: ["8L26"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			spark: ["8L9"],
			substitute: ["8M"],
			swagger: ["8M"],
			swift: ["8L20"],
			tackle: ["8L1"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thundershock: ["8L4"],
			thunderwave: ["8M"],
			torment: ["8M"],
			voltswitch: ["8M"],
		},
	},
	electrode: {
		learnset: {
			charge: ["8L1"],
			chargebeam: ["8M", "8L16"],
			discharge: ["8L41"],
			doubleteam: ["8M"],
			eerieimpulse: ["8L6", "8L1"],
			electroball: ["8L22"],
			endure: ["8M"],
			explosion: ["8M", "8L47"],
			facade: ["8M"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			gyroball: ["8M", "8L54"],
			hyperbeam: ["8M"],
			lightscreen: ["8M", "8L29"],
			magneticflux: ["8L1"],
			magnetrise: ["8L36"],
			mirrorcoat: ["8L58"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rollout: ["8L11"],
			screech: ["8L13"],
			selfdestruct: ["8L26"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			spark: ["8L9"],
			substitute: ["8M"],
			swagger: ["8M"],
			swift: ["8L20"],
			tackle: ["8L1"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thundershock: ["8L4"],
			thunderwave: ["8M"],
			torment: ["8M"],
			voltswitch: ["8M"],
		},
	},
	exeggcute: {
		learnset: {
			absorb: ["8L1"],
			ancientpower: ["8E"],
			attract: ["8M"],
			block: ["8E"],
			bulletseed: ["8M", "8L30"],
			confusion: ["8L20"],
			curse: ["8E"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			explosion: ["8M"],
			extrasensory: ["8L40"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M", "8L35"],
			grassknot: ["8M"],
			grassyterrain: ["8E"],
			hypnosis: ["8L1"],
			ingrain: ["8E"],
			leafstorm: ["8E"],
			leechseed: ["8L10"],
			lightscreen: ["8M"],
			megadrain: ["8L15"],
			moonlight: ["8E"],
			naturepower: ["8E"],
			poisonpowder: ["8E"],
			powerswap: ["8E"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			reflect: ["8M", "8L5"],
			rest: ["8M"],
			skillswap: ["8M"],
			sleeppowder: ["8E"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M", "8L55"],
			strength: ["8M"],
			stunspore: ["8E"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			synthesis: ["8L25", "8E"],
			thief: ["8M"],
			trickroom: ["8M"],
			uproar: ["8L45"],
			worryseed: ["8L50"],
		},
	},
	exeggutor: {
		learnset: {
			absorb: ["8L1"],
			attract: ["8M"],
			bulldoze: ["8M"],
			bulletseed: ["8M", "8L1"],
			calmmind: ["8M"],
			confusion: ["8L1"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			explosion: ["8M"],
			extrasensory: ["8L1"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M", "8L1"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			hyperbeam: ["8M"],
			hypnosis: ["8L1"],
			leafstorm: ["8L1"],
			leechseed: ["8L1"],
			lightscreen: ["8M"],
			megadrain: ["8L1"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			psyshock: ["8L1"],
			reflect: ["8M", "8L1"],
			rest: ["8M"],
			seedbomb: ["8L1"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M", "8L1"],
			stomp: ["8L1"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			synthesis: ["8L1"],
			thief: ["8M"],
			trickroom: ["8M"],
			uproar: ["8L1"],
			woodhammer: ["8L1"],
			worryseed: ["8L1"],
		},
	},
	cubone: {
		learnset: {
			aerialace: ["8M"],
			ancientpower: ["8E"],
			attract: ["8M"],
			bellydrum: ["8E"],
			blizzard: ["8M"],
			bonemerang: ["8L40"],
			bonerush: ["8L29"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			curse: ["8E"],
			detect: ["8E"],
			dig: ["8M"],
			doubleedge: ["8L48"],
			doublekick: ["8E"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endeavor: ["8L36"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M", "8L8"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M", "8L20"],
			focusenergy: ["8L32"],
			focuspunch: ["8M"],
			growl: ["8L1"],
			headbutt: ["8L12"],
			icebeam: ["8M"],
			ironhead: ["8E"],
			irontail: ["8M"],
			leer: ["8E"],
			mudslap: ["8L1"],
			perishsong: ["8E"],
			protect: ["8M"],
			rest: ["8M"],
			retaliate: ["8L16"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			screech: ["8E"],
			skullbash: ["8E"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stompingtantrum: ["8L24"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			tailwhip: ["8L4"],
			thief: ["8M"],
			thrash: ["8L44"],
		},
	},
	marowak: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			blizzard: ["8M"],
			bonemerang: ["8L48"],
			bonerush: ["8L31"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			dig: ["8M"],
			doubleedge: ["8L60"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endeavor: ["8L42"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M", "8L1"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M", "8L20"],
			focusblast: ["8M"],
			focusenergy: ["8L36"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			headbutt: ["8L12"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			mudslap: ["8L1"],
			protect: ["8M"],
			rest: ["8M"],
			retaliate: ["8L16"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stompingtantrum: ["8L24"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			tailwhip: ["8L1"],
			thief: ["8M"],
			thrash: ["8L54"],
		},
	},
	hitmonlee: {
		learnset: {
			attract: ["8M"],
			blazekick: ["8L24"],
			brickbreak: ["8M", "8L1"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			closecombat: ["8L36"],
			doublekick: ["8L4"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M", "8L12"],
			facade: ["8M"],
			fakeout: ["8L1"],
			feint: ["8L1"],
			fling: ["8M"],
			focusblast: ["8M"],
			focusenergy: ["8L1"],
			focuspunch: ["8M"],
			helpinghand: ["8L1"],
			highjumpkick: ["8L44"],
			lowkick: ["8L8"],
			lowsweep: ["8M", "8L1"],
			megakick: ["8L32"],
			mindreader: ["8L28"],
			poisonjab: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8L16"],
			reversal: ["8L40"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sleeptalk: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
			wideguard: ["8L21"],
			workup: ["8M"],
		},
	},
	hitmonchan: {
		learnset: {
			agility: ["8L28"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			bulletpunch: ["8L1"],
			closecombat: ["8L36"],
			counter: ["8L40"],
			detect: ["8L12"],
			doubleteam: ["8M"],
			drainpunch: ["8M", "8L1"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8L1"],
			feint: ["8L1"],
			firepunch: ["8L24"],
			fling: ["8M"],
			focusblast: ["8M"],
			focusenergy: ["8L1"],
			focuspunch: ["8M", "8L44"],
			helpinghand: ["8L1"],
			icepunch: ["8L24"],
			lowsweep: ["8M"],
			machpunch: ["8L4"],
			megapunch: ["8L32"],
			poweruppunch: ["8L8"],
			protect: ["8M"],
			quickguard: ["8L21"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8L16"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sleeptalk: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
			thunderpunch: ["8L24"],
			vacuumwave: ["8L1"],
			workup: ["8M"],
		},
	},
	lickitung: {
		learnset: {
			amnesia: ["8E"],
			attract: ["8M"],
			belch: ["8E"],
			bellydrum: ["8L60", "8E"],
			blizzard: ["8M"],
			bodyslam: ["8E"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			curse: ["8E"],
			cut: ["8M"],
			defensecurl: ["8L1"],
			dig: ["8M"],
			disable: ["8L24"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			hammerarm: ["8E"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			knockoff: ["8L36"],
			lick: ["8L1"],
			muddywater: ["8E"],
			powerwhip: ["8L54"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L6"],
			sandstorm: ["8M"],
			screech: ["8L42"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			slam: ["8L48"],
			sleeptalk: ["8M"],
			snore: ["8E"],
			solarbeam: ["8M"],
			stomp: ["8L30"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L12"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			thief: ["8M"],
			thrash: ["8E"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
			wrap: ["8L18"],
			zenheadbutt: ["8E"],
		},
	},
	koffing: {
		learnset: {
			assurance: ["8L16"],
			attract: ["8M"],
			belch: ["8L40"],
			clearsmog: ["8L12"],
			curse: ["8E"],
			darkpulse: ["8M"],
			destinybond: ["8L52", "8E"],
			doubleteam: ["8M"],
			endure: ["8M"],
			explosion: ["8M", "8L44"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			grudge: ["8E"],
			gyroball: ["8M"],
			haze: ["8L24"],
			memento: ["8L48"],
			painsplit: ["8E"],
			payback: ["8M"],
			poisongas: ["8L1"],
			protect: ["8M"],
			psybeam: ["8E"],
			raindance: ["8M"],
			rest: ["8M"],
			screech: ["8E"],
			selfdestruct: ["8L28"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludge: ["8L20"],
			sludgebomb: ["8M", "8L32"],
			smog: ["8L4"],
			smokescreen: ["8L8"],
			spite: ["8E"],
			spitup: ["8E"],
			stockpile: ["8E"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8E"],
			tackle: ["8L1"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			torment: ["8M"],
			toxic: ["8M", "8L36"],
			toxicspikes: ["8E"],
			venomdrench: ["8E"],
			willowisp: ["8M"],
		},
	},
	weezing: {
		learnset: {
			assurance: ["8L16"],
			attract: ["8M"],
			belch: ["8L44"],
			clearsmog: ["8L12"],
			darkpulse: ["8M"],
			destinybond: ["8L62"],
			doublehit: ["8L1"],
			doubleteam: ["8M"],
			endure: ["8M"],
			explosion: ["8M", "8L50"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			gyroball: ["8M"],
			haze: ["8L24"],
			heatwave: ["8L1"],
			hyperbeam: ["8M"],
			memento: ["8L56"],
			payback: ["8M"],
			poisongas: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			selfdestruct: ["8L28"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludge: ["8L20"],
			sludgebomb: ["8M", "8L32"],
			smog: ["8L1"],
			smokescreen: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			torment: ["8M"],
			toxic: ["8M", "8L38"],
			willowisp: ["8M"],
		},
	},
	rhyhorn: {
		learnset: {
			attract: ["8M"],
			blizzard: ["8M"],
			bulldoze: ["8M", "8L10"],
			counter: ["8E"],
			crunch: ["8E"],
			crushclaw: ["8E"],
			curse: ["8E"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonpulse: ["8M"],
			dragonrush: ["8E"],
			drillrun: ["8L35"],
			earthquake: ["8M", "8L45"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			firefang: ["8E"],
			flamethrower: ["8M"],
			guardsplit: ["8E"],
			hornattack: ["8L15"],
			horndrill: ["8L60"],
			icebeam: ["8M"],
			icefang: ["8E"],
			irontail: ["8M"],
			megahorn: ["8L55"],
			metalburst: ["8E"],
			payback: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			reversal: ["8E"],
			roar: ["8M"],
			rockblast: ["8L30"],
			rockclimb: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			scaryface: ["8L20"],
			shockwave: ["8M"],
			skullbash: ["8E"],
			sleeptalk: ["8M"],
			smackdown: ["8L5"],
			stealthrock: ["8M"],
			stomp: ["8L25"],
			stoneedge: ["8M", "8L50"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			takedown: ["8L40"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderfang: ["8E"],
		},
	},
	rhydon: {
		learnset: {
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M", "8L1"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonpulse: ["8M"],
			drillrun: ["8L35"],
			earthquake: ["8M", "8L47"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			hammerarm: ["8L1"],
			hornattack: ["8L15"],
			horndrill: ["8L68"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			megahorn: ["8L61"],
			payback: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockblast: ["8L30"],
			rockclimb: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			scaryface: ["8L20"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			smackdown: ["8L1"],
			stealthrock: ["8M"],
			stomp: ["8L25"],
			stoneedge: ["8M", "8L54"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			takedown: ["8L40"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
		},
	},
	chansey: {
		learnset: {
			aromatherapy: ["8E"],
			attract: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			charm: ["8L1"],
			copycat: ["8L1"],
			counter: ["8E"],
			covet: ["8L1"],
			dazzlinggleam: ["8M"],
			defensecurl: ["8L1"],
			disarmingvoice: ["8L1"],
			doubleedge: ["8L40"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			echoedvoice: ["8L8"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M", "8L20"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			gravity: ["8E"],
			hail: ["8M"],
			healbell: ["8E"],
			healingwish: ["8L52"],
			healpulse: ["8L28"],
			helpinghand: ["8L32", "8E"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lastresort: ["8L48"],
			lifedew: ["8L12"],
			lightscreen: ["8M", "8L36"],
			metronome: ["8E"],
			minimize: ["8L1"],
			pound: ["8L1"],
			present: ["8E"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			seismictoss: ["8E"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sing: ["8L16"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			softboiled: ["8L44"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8L1"],
			tailwhip: ["8L4"],
			takedown: ["8L24"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	tangela: {
		learnset: {
			absorb: ["8L1"],
			amnesia: ["8E"],
			ancientpower: ["8L24"],
			attract: ["8M"],
			bind: ["8L1"],
			bulletseed: ["8M"],
			confusion: ["8E"],
			cut: ["8M"],
			doubleteam: ["8M"],
			endeavor: ["8E"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flail: ["8E"],
			flash: ["8M"],
			gigadrain: ["8M", "8L32"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			grassyterrain: ["8L56"],
			growth: ["8L8"],
			hyperbeam: ["8M"],
			ingrain: ["8L52"],
			knockoff: ["8L28"],
			leafstorm: ["8E"],
			leechseed: ["8E"],
			megadrain: ["8L12", "8E"],
			naturepower: ["8E"],
			poisonpowder: ["8L20"],
			powerswap: ["8E"],
			powerwhip: ["8L48"],
			protect: ["8M"],
			psychup: ["8M"],
			ragepowder: ["8E"],
			reflect: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			shockwave: ["8M"],
			slam: ["8L40"],
			sleeppowder: ["8L36"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			stunspore: ["8L4"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			thief: ["8M"],
			tickle: ["8L44"],
			vinewhip: ["8L16"],
		},
	},
	kangaskhan: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			avalanche: ["8M"],
			bite: ["8L12"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			circlethrow: ["8E"],
			counter: ["8E"],
			crunch: ["8L36"],
			crushclaw: ["8E"],
			cut: ["8M"],
			dig: ["8M"],
			disable: ["8E"],
			doubleedge: ["8E"],
			doublehit: ["8L32"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			earthquake: ["8M"],
			endeavor: ["8E"],
			endure: ["8M", "8L40"],
			facade: ["8M"],
			fakeout: ["8L8"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focusenergy: ["8L20", "8E"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L4"],
			hail: ["8M"],
			hammerarm: ["8E"],
			headbutt: ["8L24"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lastresort: ["8L52"],
			outrage: ["8L48"],
			pound: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			reversal: ["8L44"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stomp: ["8L16", "8E"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L28"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tailwhip: ["8L1"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			uproar: ["8E"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	horsea: {
		learnset: {
			agility: ["8L30"],
			attract: ["8M"],
			aurorabeam: ["8E"],
			blizzard: ["8M"],
			brine: ["8M"],
			bubblebeam: ["8L25"],
			clearsmog: ["8E"],
			disable: ["8E"],
			doubleteam: ["8M"],
			dragonbreath: ["8L20", "8E"],
			dragondance: ["8L50"],
			dragonpulse: ["8M", "8L40"],
			endure: ["8M"],
			facade: ["8M"],
			flail: ["8E"],
			flashcannon: ["8M"],
			focusenergy: ["8L15"],
			hail: ["8M"],
			hydropump: ["8L45"],
			icebeam: ["8M"],
			laserfocus: ["8L35"],
			leer: ["8L1"],
			muddywater: ["8E"],
			octazooka: ["8E"],
			outrage: ["8E"],
			protect: ["8M"],
			raindance: ["8M", "8L55"],
			rest: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			smokescreen: ["8L5"],
			splash: ["8E"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			twister: ["8L10"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
		},
	},
	seadra: {
		learnset: {
			agility: ["8L30"],
			attract: ["8M"],
			blizzard: ["8M"],
			brine: ["8M"],
			bubblebeam: ["8L25"],
			doubleteam: ["8M"],
			dragonbreath: ["8L20"],
			dragondance: ["8L58"],
			dragonpulse: ["8M", "8L44"],
			endure: ["8M"],
			facade: ["8M"],
			flashcannon: ["8M"],
			focusenergy: ["8L15"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hydropump: ["8L51"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			laserfocus: ["8L37"],
			leer: ["8L1"],
			protect: ["8M"],
			raindance: ["8M", "8L65"],
			rest: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			smokescreen: ["8L1"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			twister: ["8L1"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
		},
	},
	goldeen: {
		learnset: {
			acupressure: ["8E"],
			agility: ["8L20"],
			aquaring: ["8L25"],
			aquatail: ["8E"],
			attract: ["8M"],
			blizzard: ["8M"],
			bodyslam: ["8E"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flail: ["8L30"],
			hail: ["8M"],
			haze: ["8E"],
			hornattack: ["8L15"],
			horndrill: ["8L50"],
			hydropump: ["8E"],
			icebeam: ["8M"],
			megahorn: ["8L45"],
			mudshot: ["8E"],
			mudslap: ["8E"],
			peck: ["8L1"],
			poisonjab: ["8M"],
			protect: ["8M"],
			psybeam: ["8E"],
			raindance: ["8M"],
			rest: ["8M"],
			scald: ["8M"],
			skullbash: ["8E"],
			sleeptalk: ["8M"],
			soak: ["8L40"],
			substitute: ["8M"],
			supersonic: ["8L5"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			tailwhip: ["8L1"],
			waterfall: ["8M", "8L35"],
			waterpulse: ["8M", "8L10"],
		},
	},
	seaking: {
		learnset: {
			agility: ["8L20"],
			aquaring: ["8L25"],
			attract: ["8M"],
			blizzard: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flail: ["8L30"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hornattack: ["8L15"],
			horndrill: ["8L58"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			megahorn: ["8L51"],
			peck: ["8L1"],
			poisonjab: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			soak: ["8L44"],
			substitute: ["8M"],
			supersonic: ["8L1"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			tailwhip: ["8L1"],
			waterfall: ["8M", "8L37"],
			waterpulse: ["8M", "8L1"],
		},
	},
	staryu: {
		learnset: {
			blizzard: ["8M"],
			brine: ["8M", "8L28"],
			confuseray: ["8L8"],
			cosmicpower: ["8L52"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			flashcannon: ["8M"],
			gyroball: ["8M"],
			hail: ["8M"],
			harden: ["8L1"],
			hydropump: ["8L56"],
			icebeam: ["8M"],
			lightscreen: ["8M", "8L32"],
			minimize: ["8L16"],
			powergem: ["8L36"],
			protect: ["8M"],
			psybeam: ["8L24"],
			psychic: ["8M", "8L40"],
			psychup: ["8M"],
			raindance: ["8M"],
			rapidspin: ["8L12"],
			recover: ["8L48"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			surf: ["8M", "8L44"],
			swagger: ["8M"],
			swift: ["8L20"],
			tackle: ["8L1"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L4"],
			waterpulse: ["8M"],
		},
	},
	starmie: {
		learnset: {
			avalanche: ["8M"],
			blizzard: ["8M"],
			brine: ["8M", "8L1"],
			confuseray: ["8L1"],
			cosmicpower: ["8L1"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			flashcannon: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			gyroball: ["8M"],
			hail: ["8M"],
			harden: ["8L1"],
			hydropump: ["8L1"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			lightscreen: ["8M", "8L1"],
			minimize: ["8L1"],
			powergem: ["8L1"],
			protect: ["8M"],
			psybeam: ["8L1"],
			psychic: ["8M", "8L1"],
			psychup: ["8M"],
			raindance: ["8M"],
			rapidspin: ["8L1"],
			recover: ["8L1"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			scald: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			surf: ["8M", "8L1"],
			swagger: ["8M"],
			swift: ["8L1"],
			tackle: ["8L1"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			trickroom: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
		},
	},
	mrmime: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			batonpass: ["8L1"],
			brickbreak: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confuseray: ["8E"],
			confusion: ["8L12"],
			copycat: ["8L1"],
			dazzlinggleam: ["8M", "8L44"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			encore: ["8L1"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			fakeout: ["8E"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			futuresight: ["8E"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			guardswap: ["8L1"],
			hyperbeam: ["8M"],
			hypnosis: ["8E"],
			icywind: ["8E"],
			lightscreen: ["8M", "8L36"],
			magicroom: ["8E"],
			mimic: ["8L32", "8E"],
			nastyplot: ["8M"],
			payback: ["8M"],
			pound: ["8L1"],
			powersplit: ["8E"],
			powerswap: ["8L1"],
			protect: ["8M", "8L20"],
			psybeam: ["8L28"],
			psychic: ["8M", "8L48"],
			psychup: ["8M"],
			quickguard: ["8L1"],
			raindance: ["8M"],
			recycle: ["8M", "8L24"],
			reflect: ["8M", "8L36"],
			rest: ["8M"],
			roleplay: ["8L16"],
			safeguard: ["8M", "8L36"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L40"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			teeterdance: ["8L52", "8E"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			tickle: ["8E"],
			torment: ["8M"],
			trick: ["8E"],
			trickroom: ["8M"],
			wideguard: ["8L1"],
		},
	},
	scyther: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L32"],
			airslash: ["8L36"],
			attract: ["8M"],
			batonpass: ["8E"],
			brickbreak: ["8M"],
			bugbuzz: ["8M"],
			counter: ["8E"],
			cut: ["8M"],
			defog: ["8M"],
			doublehit: ["8L20"],
			doubleteam: ["8M", "8L16"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M", "8L8"],
			feint: ["8E"],
			focusenergy: ["8L28"],
			furycutter: ["8L4"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M"],
			laserfocus: ["8L44"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			nightslash: ["8E"],
			protect: ["8M"],
			quickattack: ["8L1"],
			quickguard: ["8E"],
			raindance: ["8M"],
			rest: ["8M"],
			reversal: ["8E"],
			rocksmash: ["8M"],
			roost: ["8M"],
			safeguard: ["8M"],
			slash: ["8L24"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L48"],
			thief: ["8M"],
			uturn: ["8M"],
			wingattack: ["8L12"],
			xscissor: ["8M", "8L40"],
		},
	},
	jynx: {
		learnset: {
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M", "8L58"],
			brickbreak: ["8M"],
			calmmind: ["8M"],
			confusion: ["8L12"],
			copycat: ["8L1"],
			covet: ["8L16"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			faketears: ["8L24"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			hail: ["8M"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			icepunch: ["8L28"],
			lick: ["8L1"],
			lightscreen: ["8M"],
			lovelykiss: ["8L40"],
			meanlook: ["8L46"],
			nastyplot: ["8M"],
			payback: ["8M"],
			perishsong: ["8L52"],
			pound: ["8L1"],
			powdersnow: ["8L1"],
			protect: ["8M"],
			psychic: ["8M", "8L34"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			shadowball: ["8M"],
			sing: ["8L20"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8L1"],
			taunt: ["8M"],
			thief: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
			waterpulse: ["8M"],
		},
	},
	electabuzz: {
		learnset: {
			attract: ["8M"],
			brickbreak: ["8M"],
			charge: ["8L1"],
			chargebeam: ["8M"],
			discharge: ["8L34"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M", "8L64"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			lightscreen: ["8M", "8L52"],
			lowkick: ["8L40"],
			lowsweep: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			quickattack: ["8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rocksmash: ["8M"],
			screech: ["8L24"],
			shockwave: ["8M", "8L16"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			swagger: ["8M"],
			swift: ["8L12"],
			thief: ["8M"],
			thunder: ["8M", "8L58"],
			thunderbolt: ["8M", "8L46"],
			thunderpunch: ["8L28"],
			thundershock: ["8L1"],
			thunderwave: ["8M", "8L20"],
			voltswitch: ["8M"],
		},
	},
	magmar: {
		learnset: {
			attract: ["8M"],
			brickbreak: ["8M"],
			clearsmog: ["8L12"],
			confuseray: ["8L20"],
			doubleteam: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M", "8L58"],
			firepunch: ["8L28"],
			flamethrower: ["8M", "8L46"],
			flamewheel: ["8L16"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M", "8L64"],
			irontail: ["8M"],
			lavaplume: ["8L34"],
			leer: ["8L1"],
			lowkick: ["8L40"],
			lowsweep: ["8M"],
			overheat: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rocksmash: ["8M"],
			scaryface: ["8L24"],
			sleeptalk: ["8M"],
			smog: ["8L1"],
			smokescreen: ["8L1"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M", "8L52"],
			swagger: ["8M"],
			thief: ["8M"],
			willowisp: ["8M"],
		},
	},
	pinsir: {
		learnset: {
			attract: ["8M"],
			bind: ["8L8"],
			brickbreak: ["8M"],
			bugbite: ["8L16", "8E"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			closecombat: ["8E"],
			cut: ["8M"],
			dig: ["8M"],
			doublehit: ["8L24"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			feint: ["8E"],
			flail: ["8E"],
			fling: ["8M"],
			focusblast: ["8M"],
			focusenergy: ["8L4"],
			focuspunch: ["8M"],
			furyattack: ["8E"],
			gigaimpact: ["8M"],
			guillotine: ["8L48"],
			harden: ["8L1"],
			hyperbeam: ["8M"],
			protect: ["8M"],
			quickattack: ["8E"],
			raindance: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			seismictoss: ["8L12"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			stormthrow: ["8L20"],
			strength: ["8M", "8L36"],
			submission: ["8L44"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			superpower: ["8L52", "8E"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L40"],
			thief: ["8M"],
			thrash: ["8E"],
			visegrip: ["8L1"],
			vitalthrow: ["8L28"],
			xscissor: ["8M", "8L32"],
		},
	},
	tauros: {
		learnset: {
			assurance: ["8L15"],
			attract: ["8M"],
			blizzard: ["8M"],
			bulldoze: ["8M"],
			doubleedge: ["8L55"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			gigaimpact: ["8M", "8L60"],
			hornattack: ["8L20"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			payback: ["8M", "8L10"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L40"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			scaryface: ["8L25"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M", "8L45"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			takedown: ["8L35"],
			thrash: ["8L50"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M", "8L5"],
			zenheadbutt: ["8L30"],
		},
	},
	magikarp: {
		learnset: {
			flail: ["8L25"],
			splash: ["8L1"],
			tackle: ["8L15"],
		},
	},
	gyarados: {
		learnset: {
			aquatail: ["8L32"],
			attract: ["8M"],
			avalanche: ["8M"],
			bite: ["8L1"],
			blizzard: ["8M"],
			brine: ["8M", "8L12"],
			bulldoze: ["8M"],
			crunch: ["8L24"],
			darkpulse: ["8M"],
			doubleteam: ["8M"],
			dragondance: ["8L36"],
			dragonpulse: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flail: ["8L1"],
			flamethrower: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hurricane: ["8L44"],
			hydropump: ["8L40"],
			hyperbeam: ["8M", "8L52"],
			icebeam: ["8M"],
			icefang: ["8L8"],
			irontail: ["8M"],
			leer: ["8L1"],
			payback: ["8M"],
			protect: ["8M"],
			raindance: ["8M", "8L28"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			sandstorm: ["8M"],
			scald: ["8M"],
			scaryface: ["8L16"],
			sleeptalk: ["8M"],
			splash: ["8L1"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			taunt: ["8M"],
			thrash: ["8L48"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			twister: ["8L1"],
			waterfall: ["8M", "8L21"],
			waterpulse: ["8M"],
			whirlpool: ["8L4"],
		},
	},
	lapras: {
		learnset: {
			ancientpower: ["8E"],
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			bodyslam: ["8L40"],
			brine: ["8M", "8L35"],
			bulldoze: ["8M"],
			confuseray: ["8L25"],
			curse: ["8E"],
			doubleteam: ["8M"],
			dragondance: ["8E"],
			dragonpulse: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fissure: ["8E"],
			freezedry: ["8E"],
			futuresight: ["8E"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hail: ["8M"],
			horndrill: ["8E"],
			hydropump: ["8L55"],
			hyperbeam: ["8M"],
			icebeam: ["8M", "8L45"],
			iceshard: ["8L20"],
			irontail: ["8M"],
			lifedew: ["8L15"],
			mist: ["8L10"],
			perishsong: ["8L60"],
			protect: ["8M"],
			psychic: ["8M"],
			raindance: ["8M", "8L50"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			sheercold: ["8L65"],
			shockwave: ["8M"],
			sing: ["8L5"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			tickle: ["8E"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L30"],
			whirlpool: ["8E"],
		},
	},
	ditto: {
		learnset: {
			transform: ["8L1"],
		},
	},
	eevee: {
		learnset: {
			attract: ["8M"],
			babydolleyes: ["8L15"],
			batonpass: ["8L35"],
			bite: ["8L25"],
			charm: ["8L45", "8E"],
			copycat: ["8L30"],
			covet: ["8L1", "8E"],
			curse: ["8E"],
			detect: ["8E"],
			dig: ["8M"],
			doubleedge: ["8L50"],
			doublekick: ["8E"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			faketears: ["8E"],
			flail: ["8E"],
			growl: ["8L1"],
			helpinghand: ["8L1"],
			irontail: ["8M"],
			lastresort: ["8L55"],
			mudslap: ["8E"],
			protect: ["8M"],
			quickattack: ["8L10"],
			raindance: ["8M"],
			rest: ["8M"],
			sandattack: ["8L5"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			storedpower: ["8E"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L20"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			takedown: ["8L40"],
			tickle: ["8E"],
			wish: ["8E"],
			workup: ["8M"],
			yawn: ["8E"],
		},
	},
	vaporeon: {
		learnset: {
			acidarmor: ["8L45"],
			aquaring: ["8L35"],
			attract: ["8M"],
			aurorabeam: ["8L30"],
			babydolleyes: ["8L15"],
			batonpass: ["8L1"],
			bite: ["8L1"],
			blizzard: ["8M"],
			brine: ["8M"],
			charm: ["8L1"],
			copycat: ["8L1"],
			covet: ["8L1"],
			dig: ["8M"],
			doubleedge: ["8L1"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hail: ["8M"],
			haze: ["8L20"],
			helpinghand: ["8L1"],
			hydropump: ["8L50"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lastresort: ["8L55"],
			muddywater: ["8L40"],
			protect: ["8M"],
			quickattack: ["8L10"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			sandattack: ["8L5"],
			scald: ["8M"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swift: ["8L1"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			takedown: ["8L1"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L25"],
			workup: ["8M"],
		},
	},
	jolteon: {
		learnset: {
			agility: ["8L45"],
			attract: ["8M"],
			babydolleyes: ["8L15"],
			batonpass: ["8L1"],
			bite: ["8L1"],
			chargebeam: ["8M"],
			charm: ["8L1"],
			copycat: ["8L1"],
			covet: ["8L1"],
			dig: ["8M"],
			discharge: ["8L40"],
			doubleedge: ["8L1"],
			doublekick: ["8L25"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			helpinghand: ["8L1"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			lastresort: ["8L55"],
			lightscreen: ["8M"],
			pinmissile: ["8L35"],
			protect: ["8M"],
			quickattack: ["8L10"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			sandattack: ["8L5"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L1"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			takedown: ["8L1"],
			thunder: ["8M", "8L50"],
			thunderbolt: ["8M"],
			thunderfang: ["8L30"],
			thundershock: ["8L1"],
			thunderwave: ["8M", "8L20"],
			voltswitch: ["8M"],
			workup: ["8M"],
		},
	},
	flareon: {
		learnset: {
			attract: ["8M"],
			babydolleyes: ["8L15"],
			batonpass: ["8L1"],
			bite: ["8L25"],
			charm: ["8L1"],
			copycat: ["8L1"],
			covet: ["8L1"],
			dig: ["8M"],
			doubleedge: ["8L1"],
			doubleteam: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			firefang: ["8L30"],
			firespin: ["8L35"],
			flamethrower: ["8M"],
			flareblitz: ["8L50"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			helpinghand: ["8L1"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			lastresort: ["8L55"],
			lavaplume: ["8L40"],
			overheat: ["8M"],
			protect: ["8M"],
			quickattack: ["8L10"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			sandattack: ["8L5"],
			scaryface: ["8L45"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			smog: ["8L20"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L1"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			takedown: ["8L1"],
			willowisp: ["8M"],
			workup: ["8M"],
		},
	},
	porygon: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L30"],
			blizzard: ["8M"],
			chargebeam: ["8M"],
			conversion: ["8L1"],
			conversion2: ["8L25"],
			discharge: ["8L40"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lockon: ["8L55"],
			magiccoat: ["8L50"],
			magnetrise: ["8L10"],
			protect: ["8M"],
			psybeam: ["8L20"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recover: ["8L35"],
			recycle: ["8M", "8L5"],
			rest: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thundershock: ["8L15"],
			thunderwave: ["8M"],
			triattack: ["8L45"],
			trickroom: ["8M"],
			zapcannon: ["8L60"],
		},
	},
	omanyte: {
		learnset: {
			ancientpower: ["8L30"],
			attract: ["8M"],
			aurorabeam: ["8E"],
			bind: ["8L1"],
			bite: ["8E"],
			blizzard: ["8M"],
			brine: ["8M", "8L35"],
			bubblebeam: ["8E"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			gyroball: ["8M"],
			hail: ["8M"],
			haze: ["8E"],
			hydropump: ["8L60"],
			icebeam: ["8M"],
			knockoff: ["8E"],
			leer: ["8L20"],
			muddywater: ["8E"],
			mudshot: ["8L25"],
			protect: ["8M", "8L41"],
			raindance: ["8M"],
			reflecttype: ["8E"],
			rest: ["8M"],
			rockblast: ["8L45"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L5"],
			sandattack: ["8L10"],
			sandstorm: ["8M"],
			scald: ["8M"],
			shellsmash: ["8L55"],
			slam: ["8E"],
			sleeptalk: ["8M"],
			spikes: ["8E"],
			stealthrock: ["8M"],
			substitute: ["8M"],
			supersonic: ["8E"],
			surf: ["8M", "8L50"],
			swagger: ["8M"],
			thief: ["8M"],
			tickle: ["8E"],
			toxicspikes: ["8E"],
			waterfall: ["8M"],
			watergun: ["8L15"],
			waterpulse: ["8M"],
			whirlpool: ["8E"],
			withdraw: ["8L1"],
		},
	},
	omastar: {
		learnset: {
			ancientpower: ["8L30"],
			attract: ["8M"],
			bind: ["8L1"],
			blizzard: ["8M"],
			brine: ["8M", "8L35"],
			crunch: ["8L1"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			gigaimpact: ["8M"],
			gyroball: ["8M"],
			hail: ["8M"],
			hydropump: ["8L70"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			leer: ["8L20"],
			mudshot: ["8L25"],
			protect: ["8M", "8L43"],
			raindance: ["8M"],
			rest: ["8M"],
			rockblast: ["8L49"],
			rockclimb: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L1"],
			sandattack: ["8L1"],
			sandstorm: ["8M"],
			scald: ["8M"],
			shellsmash: ["8L63"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			substitute: ["8M"],
			surf: ["8M", "8L56"],
			swagger: ["8M"],
			thief: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L15"],
			waterpulse: ["8M"],
			withdraw: ["8L1"],
		},
	},
	kabuto: {
		learnset: {
			absorb: ["8L1"],
			aerialace: ["8M"],
			ancientpower: ["8L30"],
			aquajet: ["8L15"],
			attract: ["8M"],
			aurorabeam: ["8E"],
			blizzard: ["8M"],
			brine: ["8M", "8L35"],
			bubblebeam: ["8E"],
			confuseray: ["8E"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flail: ["8E"],
			gigadrain: ["8M"],
			hail: ["8M"],
			harden: ["8L1"],
			icebeam: ["8M"],
			icywind: ["8E"],
			knockoff: ["8E"],
			leechlife: ["8L45"],
			leer: ["8L20"],
			liquidation: ["8L50"],
			megadrain: ["8E"],
			metalsound: ["8L55"],
			mudshot: ["8L25", "8E"],
			protect: ["8M", "8L41"],
			raindance: ["8M"],
			rapidspin: ["8E"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandattack: ["8L10"],
			sandstorm: ["8M"],
			scald: ["8M"],
			scratch: ["8L5"],
			screech: ["8E"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M", "8L60"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			takedown: ["8E"],
			thief: ["8M"],
			waterfall: ["8M"],
			waterpulse: ["8M"],
		},
	},
	kabutops: {
		learnset: {
			absorb: ["8L1"],
			aerialace: ["8M"],
			ancientpower: ["8L30"],
			aquajet: ["8L15"],
			attract: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M", "8L35"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			feint: ["8L1"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			harden: ["8L1"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			leechlife: ["8L49"],
			leer: ["8L20"],
			liquidation: ["8L56"],
			metalsound: ["8L63"],
			mudshot: ["8L25"],
			nightslash: ["8L1"],
			protect: ["8M", "8L43"],
			raindance: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandattack: ["8L1"],
			sandstorm: ["8M"],
			scald: ["8M"],
			scratch: ["8L1"],
			slash: ["8L1"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M", "8L70"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			thief: ["8M"],
			waterfall: ["8M"],
			waterpulse: ["8M"],
			xscissor: ["8M"],
		},
	},
	aerodactyl: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L50"],
			ancientpower: ["8L1"],
			assurance: ["8E"],
			attract: ["8M"],
			bite: ["8L1"],
			bulldoze: ["8M"],
			crunch: ["8L30"],
			curse: ["8E"],
			defog: ["8M"],
			doubleteam: ["8M"],
			dragonbreath: ["8E"],
			dragonclaw: ["8M"],
			dragonpulse: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fly: ["8M"],
			gigaimpact: ["8M", "8L60"],
			hyperbeam: ["8M", "8L55"],
			ironhead: ["8L35"],
			irontail: ["8M"],
			payback: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M", "8L25"],
			rockpolish: ["8M"],
			rockslide: ["8M", "8L20"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			roost: ["8M"],
			sandstorm: ["8M"],
			scaryface: ["8L15"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			steelwing: ["8M"],
			stoneedge: ["8M", "8L45"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L5"],
			swagger: ["8M"],
			tailwind: ["8E"],
			takedown: ["8L40"],
			taunt: ["8M"],
			thief: ["8M"],
			torment: ["8M"],
			whirlwind: ["8E"],
			wideguard: ["8E"],
			wingattack: ["8L10"],
		},
	},
	snorlax: {
		learnset: {
			afteryou: ["8E"],
			amnesia: ["8L36"],
			attract: ["8M"],
			belch: ["8L52", "8E"],
			bellydrum: ["8L48"],
			bite: ["8L16"],
			blizzard: ["8M"],
			block: ["8L1"],
			bodyslam: ["8L28"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			charm: ["8E"],
			counter: ["8E"],
			covet: ["8L1"],
			crunch: ["8L24"],
			curse: ["8E"],
			defensecurl: ["8L1"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			fissure: ["8E"],
			flail: ["8L1"],
			flamethrower: ["8M"],
			fling: ["8M", "8L1"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gastroacid: ["8E"],
			gigaimpact: ["8M", "8L56"],
			hammerarm: ["8L44"],
			heavyslam: ["8L32"],
			highhorsepower: ["8L40"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			lastresort: ["8L1"],
			lick: ["8L1", "8E"],
			metronome: ["8L1"],
			poweruppunch: ["8E"],
			protect: ["8M"],
			psychic: ["8M"],
			raindance: ["8M"],
			recycle: ["8M", "8L1"],
			rest: ["8M", "8L20"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			screech: ["8L1"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M", "8L20"],
			snore: ["8L20"],
			solarbeam: ["8M"],
			stockpile: ["8L1"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swallow: ["8L1"],
			tackle: ["8L1"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			waterpulse: ["8M"],
			whirlwind: ["8E"],
			workup: ["8M"],
			yawn: ["8L12"],
		},
	},
	articuno: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L20"],
			ancientpower: ["8L25"],
			avalanche: ["8M"],
			blizzard: ["8M", "8L65", "8S0"],
			defog: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fly: ["8M"],
			freezedry: ["8L35"],
			gigaimpact: ["8M"],
			gust: ["8L1"],
			hail: ["8M", "8L50"],
			hurricane: ["8L55", "8S0"],
			hyperbeam: ["8M"],
			icebeam: ["8M", "8L45"],
			iceshard: ["8L15"],
			mindreader: ["8L60", "8S0"],
			mist: ["8L1"],
			pluck: ["8M"],
			powdersnow: ["8L5"],
			protect: ["8M"],
			raindance: ["8M"],
			reflect: ["8M", "8L10"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			roost: ["8M", "8L40"],
			sandstorm: ["8M"],
			sheercold: ["8L70", "8S0"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tailwind: ["8L30"],
			uturn: ["8M"],
			waterpulse: ["8M"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, isHidden: true, moves: ['sheercold', 'blizzard', 'mindreader', 'hurricane']},
		],
	},
	zapdos: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L20"],
			ancientpower: ["8L25"],
			charge: ["8L30"],
			chargebeam: ["8M"],
			defog: ["8M"],
			detect: ["8L60", "8S0"],
			discharge: ["8L45"],
			doubleteam: ["8M"],
			drillpeck: ["8L35"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fly: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hyperbeam: ["8M"],
			lightscreen: ["8M", "8L10"],
			magneticflux: ["8L65", "8S0"],
			peck: ["8L1"],
			pluck: ["8M", "8L15"],
			protect: ["8M"],
			raindance: ["8M", "8L50"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			roost: ["8M", "8L40"],
			sandstorm: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thunder: ["8M", "8L55", "8S0"],
			thunderbolt: ["8M"],
			thundershock: ["8L5"],
			thunderwave: ["8M", "8L1"],
			uturn: ["8M"],
			voltswitch: ["8M"],
			zapcannon: ["8L70", "8S0"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, isHidden: true, moves: ['zapcannon', 'magneticflux', 'detect', 'thunder']},
		],
	},
	moltres: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L20"],
			airslash: ["8L35"],
			ancientpower: ["8L25"],
			burnup: ["8L65", "8S0"],
			defog: ["8M"],
			doubleteam: ["8M"],
			ember: ["8L5"],
			endure: ["8M", "8L60", "8S0"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fly: ["8M"],
			gigaimpact: ["8M"],
			gust: ["8L1"],
			heatwave: ["8L45"],
			hurricane: ["8L55", "8S0"],
			hyperbeam: ["8M"],
			incinerate: ["8L30"],
			leer: ["8L1"],
			overheat: ["8M"],
			pluck: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			roost: ["8M", "8L40"],
			safeguard: ["8M", "8L10"],
			sandstorm: ["8M"],
			skyattack: ["8L70", "8S0"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M", "8L50"],
			swagger: ["8M"],
			uturn: ["8M"],
			willowisp: ["8M"],
			wingattack: ["8L15"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, isHidden: true, moves: ['skyattack', 'burnup', 'endure', 'hurricane']},
		],
	},
	dratini: {
		learnset: {
			agility: ["8L20"],
			aquajet: ["8E"],
			aquatail: ["8L31"],
			attract: ["8M"],
			blizzard: ["8M"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonbreath: ["8E"],
			dragondance: ["8L50", "8E"],
			dragonpulse: ["8M"],
			dragonrush: ["8L35", "8E"],
			dragontail: ["8L15"],
			endure: ["8M"],
			extremespeed: ["8E"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			haze: ["8E"],
			hyperbeam: ["8M", "8L60"],
			icebeam: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			mist: ["8E"],
			outrage: ["8L55"],
			protect: ["8M"],
			raindance: ["8M", "8L45"],
			rest: ["8M"],
			safeguard: ["8M", "8L40"],
			shockwave: ["8M"],
			slam: ["8L25"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8E"],
			surf: ["8M"],
			swagger: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M", "8L10"],
			twister: ["8L5"],
			waterfall: ["8M"],
			waterpulse: ["8M"],
			wrap: ["8L1"],
		},
	},
	dragonair: {
		learnset: {
			agility: ["8L20"],
			aquatail: ["8L33"],
			attract: ["8M"],
			blizzard: ["8M"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragondance: ["8L60"],
			dragonpulse: ["8M"],
			dragonrush: ["8L39"],
			dragontail: ["8L15"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hyperbeam: ["8M", "8L74"],
			icebeam: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			outrage: ["8L67"],
			protect: ["8M"],
			raindance: ["8M", "8L53"],
			rest: ["8M"],
			safeguard: ["8M", "8L46"],
			shockwave: ["8M"],
			slam: ["8L25"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M", "8L1"],
			twister: ["8L1"],
			waterfall: ["8M"],
			waterpulse: ["8M"],
			wrap: ["8L1"],
		},
	},
	dragonite: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L20"],
			aquatail: ["8L33"],
			attract: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			cut: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonclaw: ["8M"],
			dragondance: ["8L62"],
			dragonpulse: ["8M"],
			dragonrush: ["8L39"],
			dragontail: ["8L15"],
			earthquake: ["8M"],
			endure: ["8M"],
			extremespeed: ["8L1"],
			facade: ["8M"],
			fireblast: ["8M"],
			firepunch: ["8L1"],
			flamethrower: ["8M"],
			fling: ["8M"],
			fly: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hurricane: ["8L1"],
			hyperbeam: ["8M", "8L80"],
			icebeam: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			outrage: ["8L41"],
			protect: ["8M"],
			raindance: ["8M", "8L53"],
			rest: ["8M"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			roost: ["8M", "8L1"],
			safeguard: ["8M", "8L46"],
			sandstorm: ["8M"],
			shockwave: ["8M"],
			slam: ["8L25"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderpunch: ["8L1"],
			thunderwave: ["8M", "8L1"],
			twister: ["8L1"],
			waterfall: ["8M"],
			waterpulse: ["8M"],
			wingattack: ["8L1"],
			wrap: ["8L1"],
		},
	},
	mewtwo: {
		learnset: {
			aerialace: ["8M"],
			amnesia: ["8L32"],
			ancientpower: ["8L8"],
			aurasphere: ["8L40"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confusion: ["8L1"],
			disable: ["8L1"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			futuresight: ["8L88"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			guardswap: ["8L56", "8S0"],
			hail: ["8M"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			laserfocus: ["8L1"],
			lifedew: ["8L1"],
			lightscreen: ["8M"],
			lowsweep: ["8M"],
			mist: ["8L64", "8S0"],
			nastyplot: ["8M"],
			poisonjab: ["8M"],
			powerswap: ["8L56", "8S0"],
			protect: ["8M"],
			psychic: ["8M", "8L48", "8S0"],
			psychocut: ["8L16"],
			psychup: ["8M"],
			psystrike: ["8L72"],
			raindance: ["8M"],
			recover: ["8L80"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M", "8L24"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L1"],
			taunt: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
			waterpulse: ["8M"],
			willowisp: ["8M"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, isHidden: true, moves: ['mist', 'guardswap', 'powerswap', 'psychic']},
		],
	},
	mew: {
		learnset: {
			aerialace: ["8M"],
			amnesia: ["8L10"],
			ancientpower: ["8L30"],
			attract: ["8M"],
			aurasphere: ["8L90"],
			avalanche: ["8M"],
			batonpass: ["8L20"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M"],
			bugbuzz: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			bulletseed: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			cut: ["8M"],
			darkpulse: ["8M"],
			dazzlinggleam: ["8M"],
			defog: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonclaw: ["8M"],
			dragonpulse: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			flashcannon: ["8M"],
			fling: ["8M"],
			fly: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			gyroball: ["8M"],
			hail: ["8M"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			imprison: ["8L70"],
			irontail: ["8M"],
			lifedew: ["8L40"],
			lightscreen: ["8M"],
			lowsweep: ["8M"],
			metronome: ["8L60"],
			nastyplot: ["8M", "8L50"],
			overheat: ["8M"],
			payback: ["8M"],
			pluck: ["8M"],
			poisonjab: ["8M"],
			pound: ["8L1", "8S0"],
			protect: ["8M"],
			psychic: ["8M", "8L100"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			reflecttype: ["8L1", "8S0"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			roost: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			scald: ["8M"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			snarl: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			steelwing: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			toxic: ["8M"],
			transform: ["8L80"],
			trickroom: ["8M"],
			uturn: ["8M"],
			voltswitch: ["8M"],
			waterfall: ["8M"],
			waterpulse: ["8M"],
			willowisp: ["8M"],
			workup: ["8M"],
			xscissor: ["8M"],
		},
		eventData: [
			{generation: 8, level: 1, moves: ['pound', 'reflecttype']},
		],
	},
	chikorita: {
		learnset: {
			ancientpower: ["8E"],
			aromatherapy: ["8L42", "8E"],
			attract: ["8M"],
			bodyslam: ["8L34", "8E"],
			bulletseed: ["8M"],
			counter: ["8E"],
			cut: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flail: ["8E"],
			flash: ["8M"],
			gigadrain: ["8M"],
			grassknot: ["8M"],
			grassyterrain: ["8E"],
			growl: ["8L1"],
			healpulse: ["8E"],
			ingrain: ["8E"],
			irontail: ["8M"],
			leafstorm: ["8E"],
			leechseed: ["8E"],
			lightscreen: ["8M", "8L31"],
			magicalleaf: ["8L20"],
			naturepower: ["8L23", "8E"],
			poisonpowder: ["8L9"],
			protect: ["8M"],
			razorleaf: ["8L6"],
			reflect: ["8M", "8L17"],
			rest: ["8M"],
			safeguard: ["8M", "8L39"],
			sleeptalk: ["8M"],
			solarbeam: ["8M", "8L45"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L28"],
			swordsdance: ["8M"],
			synthesis: ["8L12"],
			tackle: ["8L1"],
			vinewhip: ["8E"],
			workup: ["8M"],
		},
	},
	bayleef: {
		learnset: {
			aromatherapy: ["8L50"],
			attract: ["8M"],
			bodyslam: ["8L40"],
			bulletseed: ["8M"],
			cut: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			irontail: ["8M"],
			lightscreen: ["8M", "8L36"],
			magicalleaf: ["8L22"],
			naturepower: ["8L26"],
			poisonpowder: ["8L9", "8L1"],
			protect: ["8M"],
			razorleaf: ["8L6", "8L1"],
			reflect: ["8M", "8L18"],
			rest: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M", "8L46"],
			sleeptalk: ["8M"],
			solarbeam: ["8M", "8L54"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L32"],
			swordsdance: ["8M"],
			synthesis: ["8L12"],
			tackle: ["8L1"],
			workup: ["8M"],
		},
	},
	meganium: {
		learnset: {
			aromatherapy: ["8L60"],
			attract: ["8M"],
			bodyslam: ["8L46"],
			bulldoze: ["8M"],
			bulletseed: ["8M"],
			cut: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			frenzyplant: ["8T"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			lightscreen: ["8M", "8L40"],
			magicalleaf: ["8L22"],
			naturepower: ["8L26"],
			petalblizzard: ["8L70", "8L1"],
			petaldance: ["8L1"],
			poisonpowder: ["8L9", "8L1"],
			protect: ["8M"],
			razorleaf: ["8L6", "8L1"],
			reflect: ["8M", "8L18"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M", "8L54"],
			sleeptalk: ["8M"],
			solarbeam: ["8M", "8L66"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L34"],
			swordsdance: ["8M"],
			synthesis: ["8L12"],
			tackle: ["8L1"],
			workup: ["8M"],
		},
	},
	cyndaquil: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			burnup: ["8L58"],
			covet: ["8E"],
			crushclaw: ["8E"],
			cut: ["8M"],
			defensecurl: ["8L22"],
			dig: ["8M"],
			doubleedge: ["8L55", "8E"],
			doublekick: ["8E"],
			doubleteam: ["8M"],
			ember: ["8L10"],
			endure: ["8M"],
			eruption: ["8L64"],
			extrasensory: ["8E"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamecharge: ["8L28"],
			flamethrower: ["8M", "8L40"],
			flamewheel: ["8L19"],
			flareblitz: ["8E"],
			furyswipes: ["8E"],
			howl: ["8E"],
			inferno: ["8L46"],
			lavaplume: ["8L37"],
			leer: ["8L1"],
			naturepower: ["8E"],
			overheat: ["8M"],
			protect: ["8M"],
			quickattack: ["8L13", "8E"],
			rest: ["8M"],
			reversal: ["8E"],
			rollout: ["8L49"],
			sleeptalk: ["8M"],
			smokescreen: ["8L6"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L31"],
			tackle: ["8L1"],
			thrash: ["8E"],
			willowisp: ["8M"],
			workup: ["8M"],
		},
	},
	quilava: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			brickbreak: ["8M"],
			burnup: ["8L68"],
			cut: ["8M"],
			defensecurl: ["8L24"],
			dig: ["8M"],
			doubleedge: ["8L64"],
			doubleteam: ["8M"],
			ember: ["8L10"],
			endure: ["8M"],
			eruption: ["8L75"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamecharge: ["8L35"],
			flamethrower: ["8M", "8L46"],
			flamewheel: ["8L20"],
			focuspunch: ["8M"],
			inferno: ["8L53"],
			lavaplume: ["8L42"],
			leer: ["8L1"],
			overheat: ["8M"],
			protect: ["8M"],
			quickattack: ["8L13"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			rollout: ["8L57"],
			sleeptalk: ["8M"],
			smokescreen: ["8L6", "8L1"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L31"],
			tackle: ["8L1"],
			willowisp: ["8M"],
			workup: ["8M"],
		},
	},
	typhlosion: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			blastburn: ["8T"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			burnup: ["8L74"],
			cut: ["8M"],
			defensecurl: ["8L24"],
			dig: ["8M"],
			doubleedge: ["8L69", "8L1"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			ember: ["8L10", "8L1"],
			endure: ["8M"],
			eruption: ["8L82", "8L1"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamecharge: ["8L35"],
			flamethrower: ["8M", "8L48"],
			flamewheel: ["8L20"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			gyroball: ["8M", "8L1"],
			hyperbeam: ["8M"],
			inferno: ["8L56"],
			lavaplume: ["8L43"],
			leer: ["8L1"],
			overheat: ["8M"],
			protect: ["8M"],
			quickattack: ["8L13"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L61"],
			shadowclaw: ["8M"],
			sleeptalk: ["8M"],
			smokescreen: ["8L6", "8L1"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L31"],
			tackle: ["8L1"],
			willowisp: ["8M"],
			workup: ["8M"],
		},
	},
	totodile: {
		learnset: {
			aerialace: ["8M"],
			ancientpower: ["8E"],
			aquajet: ["8E"],
			aquatail: ["8L43"],
			attract: ["8M"],
			bite: ["8L13"],
			blizzard: ["8M"],
			block: ["8E"],
			brickbreak: ["8M"],
			crunch: ["8L27", "8E"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonclaw: ["8M"],
			dragondance: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			faketears: ["8E"],
			flail: ["8L22"],
			flatter: ["8E"],
			fling: ["8M"],
			focuspunch: ["8M"],
			hail: ["8M"],
			hydropump: ["8L50", "8E"],
			icebeam: ["8M"],
			icefang: ["8L20"],
			icepunch: ["8E"],
			irontail: ["8M"],
			leer: ["8L1"],
			lowkick: ["8L29"],
			metalclaw: ["8E"],
			mudslap: ["8L8"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			scaryface: ["8L15"],
			scratch: ["8L1"],
			screech: ["8L36"],
			shadowclaw: ["8M"],
			slash: ["8L34"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			superpower: ["8L48"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			thrash: ["8L41", "8E"],
			waterfall: ["8M"],
			watergun: ["8L6"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	croconaw: {
		learnset: {
			aerialace: ["8M"],
			aquatail: ["8L51"],
			attract: ["8M"],
			bite: ["8L13"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			crunch: ["8L30"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonclaw: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flail: ["8L24"],
			fling: ["8M"],
			focuspunch: ["8M"],
			hail: ["8M"],
			hydropump: ["8L60"],
			icebeam: ["8M"],
			icefang: ["8L21"],
			irontail: ["8M"],
			leer: ["8L1"],
			lowkick: ["8L33"],
			mudslap: ["8L8"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			scaryface: ["8L15"],
			scratch: ["8L1"],
			screech: ["8L42"],
			shadowclaw: ["8M"],
			slash: ["8L39"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			superpower: ["8L57"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			thrash: ["8L48"],
			waterfall: ["8M"],
			watergun: ["8L6", "8L1"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	feraligatr: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L1"],
			aquatail: ["8L63"],
			attract: ["8M"],
			avalanche: ["8M"],
			bite: ["8L13"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			crunch: ["8L32"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonclaw: ["8M"],
			dragonpulse: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flail: ["8L24"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hydrocannon: ["8T"],
			hydropump: ["8L76"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			icefang: ["8L21"],
			irontail: ["8M"],
			leer: ["8L1"],
			lowkick: ["8L37"],
			mudslap: ["8L8", "8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			scaryface: ["8L15"],
			scratch: ["8L1"],
			screech: ["8L50"],
			shadowclaw: ["8M"],
			slash: ["8L45"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			superpower: ["8L71"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			thrash: ["8L58"],
			waterfall: ["8M"],
			watergun: ["8L6", "8L1"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	sentret: {
		learnset: {
			amnesia: ["8L36"],
			attract: ["8M"],
			babydolleyes: ["8E"],
			batonpass: ["8L39"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			chargebeam: ["8M"],
			charm: ["8E"],
			covet: ["8E"],
			cut: ["8M"],
			defensecurl: ["8L4"],
			dig: ["8M"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusenergy: ["8E"],
			focuspunch: ["8M"],
			followme: ["8L19"],
			furyswipes: ["8L13"],
			grassknot: ["8M"],
			growl: ["8L1"],
			helpinghand: ["8L16"],
			hypervoice: ["8L47"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lastresort: ["8E"],
			protect: ["8M"],
			quickattack: ["8L7"],
			raindance: ["8M"],
			rest: ["8M", "8L28"],
			reversal: ["8L42", "8E"],
			scratch: ["8L1"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			slam: ["8L25"],
			slash: ["8E"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L31"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			thief: ["8M"],
			thunderbolt: ["8M"],
			trick: ["8E"],
			uturn: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	furret: {
		learnset: {
			agility: ["8L1"],
			amnesia: ["8L42"],
			attract: ["8M"],
			batonpass: ["8L46"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			chargebeam: ["8M"],
			coil: ["8L1"],
			cut: ["8M"],
			defensecurl: ["8L4", "8L1"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			followme: ["8L21"],
			furyswipes: ["8L13"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			helpinghand: ["8L17"],
			hyperbeam: ["8M"],
			hypervoice: ["8L56"],
			icebeam: ["8M"],
			irontail: ["8M"],
			protect: ["8M"],
			quickattack: ["8L7", "8L1"],
			raindance: ["8M"],
			rest: ["8M", "8L32"],
			reversal: ["8L50"],
			rocksmash: ["8M"],
			scratch: ["8L1"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			slam: ["8L28"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L36"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			uturn: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	hoothoot: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8E"],
			airslash: ["8L18"],
			attract: ["8M"],
			calmmind: ["8M"],
			confusion: ["8L9"],
			defog: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M", "8L39"],
			echoedvoice: ["8L6"],
			endure: ["8M"],
			extrasensory: ["8L21"],
			facade: ["8M"],
			featherdance: ["8E"],
			fly: ["8M"],
			growl: ["8L1"],
			hurricane: ["8E"],
			hypnosis: ["8L36"],
			meanlook: ["8E"],
			moonblast: ["8L33"],
			nastyplot: ["8M"],
			nightshade: ["8E"],
			peck: ["8L1"],
			pluck: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			psychoshift: ["8L15"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M", "8L12"],
			rest: ["8M"],
			roost: ["8M", "8L30"],
			shadowball: ["8M"],
			skyattack: ["8E"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8E"],
			swagger: ["8M"],
			tackle: ["8L3"],
			takedown: ["8L24"],
			thief: ["8M"],
			uproar: ["8L27"],
			whirlwind: ["8E"],
			wingattack: ["8E"],
			workup: ["8M"],
		},
	},
	noctowl: {
		learnset: {
			aerialace: ["8M"],
			airslash: ["8L18"],
			attract: ["8M"],
			calmmind: ["8M"],
			confusion: ["8L9"],
			defog: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M", "8L53"],
			echoedvoice: ["8L1"],
			endure: ["8M"],
			extrasensory: ["8L23"],
			facade: ["8M"],
			fly: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hyperbeam: ["8M"],
			hypnosis: ["8L48"],
			moonblast: ["8L43"],
			nastyplot: ["8M"],
			peck: ["8L1"],
			pluck: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			psychoshift: ["8L15"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M", "8L12"],
			rest: ["8M"],
			roost: ["8M", "8L38"],
			shadowball: ["8M"],
			skyattack: ["8L1"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L28"],
			thief: ["8M"],
			uproar: ["8L33"],
			workup: ["8M"],
		},
	},
	ledyba: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L29"],
			airslash: ["8L36"],
			attract: ["8M"],
			batonpass: ["8L26"],
			brickbreak: ["8M"],
			bugbite: ["8E"],
			bugbuzz: ["8M", "8L33"],
			counter: ["8E"],
			dig: ["8M"],
			doubleedge: ["8L40"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			encore: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			gigadrain: ["8M"],
			knockoff: ["8E"],
			lightscreen: ["8M", "8L12"],
			machpunch: ["8L15"],
			protect: ["8M"],
			psybeam: ["8E"],
			reflect: ["8M", "8L12"],
			rest: ["8M"],
			roost: ["8M", "8L19"],
			safeguard: ["8M", "8L12"],
			screech: ["8E"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strugglebug: ["8L22"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L5"],
			swagger: ["8M"],
			swift: ["8L8"],
			swordsdance: ["8M"],
			tackle: ["8L1"],
			tailwind: ["8E"],
			thief: ["8M"],
			uturn: ["8M"],
		},
	},
	ledian: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L33"],
			airslash: ["8L42"],
			attract: ["8M"],
			batonpass: ["8L29"],
			brickbreak: ["8M"],
			bugbuzz: ["8M", "8L38"],
			dig: ["8M"],
			doubleedge: ["8L47"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M"],
			lightscreen: ["8M", "8L12"],
			machpunch: ["8L15"],
			protect: ["8M"],
			reflect: ["8M", "8L12"],
			rest: ["8M"],
			rocksmash: ["8M"],
			roost: ["8M", "8L20"],
			safeguard: ["8M", "8L12"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			strugglebug: ["8L24"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L5", "8L1"],
			swagger: ["8M"],
			swift: ["8L8", "8L1"],
			swordsdance: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
			uturn: ["8M"],
		},
	},
	spinarak: {
		learnset: {
			absorb: ["8L5"],
			agility: ["8L33"],
			attract: ["8M"],
			batonpass: ["8E"],
			bugbuzz: ["8M"],
			crosspoison: ["8L47"],
			dig: ["8M"],
			disable: ["8E"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			furyswipes: ["8L22"],
			gigadrain: ["8M"],
			infestation: ["8L8"],
			leechlife: ["8L29"],
			lunge: ["8E"],
			megahorn: ["8E"],
			nightshade: ["8L15"],
			nightslash: ["8E"],
			pinmissile: ["8L36"],
			poisonjab: ["8M", "8L43"],
			poisonsting: ["8L1"],
			protect: ["8M"],
			psybeam: ["8E"],
			psychic: ["8M", "8L40"],
			ragepowder: ["8E"],
			rest: ["8M"],
			scaryface: ["8L12"],
			shadowsneak: ["8L19"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			stickyweb: ["8L50"],
			stringshot: ["8L1"],
			substitute: ["8M"],
			suckerpunch: ["8L26"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thief: ["8M"],
			toxicspikes: ["8E"],
			toxicthread: ["8L54"],
			xscissor: ["8M"],
		},
	},
	ariados: {
		learnset: {
			absorb: ["8L5", "8L1"],
			agility: ["8L37"],
			attract: ["8M"],
			bugbite: ["8L1"],
			bugbuzz: ["8M"],
			crosspoison: ["8L55"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fellstinger: ["8L1"],
			flash: ["8M"],
			focusenergy: ["8L1"],
			furyswipes: ["8L23"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M"],
			infestation: ["8L8"],
			leechlife: ["8L32"],
			nightshade: ["8L15"],
			pinmissile: ["8L41"],
			poisonjab: ["8M", "8L50"],
			poisonsting: ["8L1"],
			protect: ["8M"],
			psychic: ["8M", "8L46"],
			rest: ["8M"],
			scaryface: ["8L12"],
			shadowsneak: ["8L19"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			stickyweb: ["8L58"],
			stringshot: ["8L1"],
			substitute: ["8M"],
			suckerpunch: ["8L28"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L1"],
			thief: ["8M"],
			toxicthread: ["8L63"],
			venomdrench: ["8L1"],
			xscissor: ["8M"],
		},
	},
	crobat: {
		learnset: {
			absorb: ["8L1"],
			aerialace: ["8M"],
			aircutter: ["8L27"],
			airslash: ["8L62"],
			astonish: ["8L1"],
			attract: ["8M"],
			bite: ["8L34"],
			confuseray: ["8L55"],
			crosspoison: ["8L1"],
			darkpulse: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fly: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			haze: ["8L41"],
			hyperbeam: ["8M"],
			leechlife: ["8L69"],
			meanlook: ["8L1"],
			nastyplot: ["8M"],
			payback: ["8M"],
			pluck: ["8M"],
			poisonfang: ["8L15"],
			protect: ["8M"],
			quickguard: ["8L20"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M"],
			screech: ["8L1"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L1"],
			swagger: ["8M"],
			tailwind: ["8L1"],
			taunt: ["8M"],
			thief: ["8M"],
			torment: ["8M"],
			toxic: ["8M", "8L1"],
			uturn: ["8M"],
			venoshock: ["8L48"],
			xscissor: ["8M"],
		},
	},
	chinchou: {
		learnset: {
			agility: ["8E"],
			amnesia: ["8E"],
			aquaring: ["8L32"],
			attract: ["8M"],
			blizzard: ["8M"],
			brine: ["8M"],
			bubblebeam: ["8L12"],
			charge: ["8L24"],
			chargebeam: ["8M"],
			confuseray: ["8L16"],
			dazzlinggleam: ["8M"],
			discharge: ["8L28"],
			doubleteam: ["8M"],
			electroball: ["8L4"],
			endure: ["8M"],
			facade: ["8M"],
			flail: ["8L36", "8E"],
			flash: ["8M"],
			hail: ["8M"],
			hydropump: ["8L44"],
			icebeam: ["8M"],
			mist: ["8E"],
			protect: ["8M"],
			psybeam: ["8E"],
			raindance: ["8M"],
			rest: ["8M"],
			scald: ["8M"],
			screech: ["8E"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			soak: ["8E"],
			spark: ["8L20"],
			substitute: ["8M"],
			supersonic: ["8L1"],
			surf: ["8M"],
			swagger: ["8M"],
			takedown: ["8L40"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M", "8L8"],
			voltswitch: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			whirlpool: ["8E"],
		},
	},
	lanturn: {
		learnset: {
			aquaring: ["8L36"],
			attract: ["8M"],
			blizzard: ["8M"],
			brine: ["8M"],
			bubblebeam: ["8L12"],
			charge: ["8L24"],
			chargebeam: ["8M"],
			confuseray: ["8L16"],
			dazzlinggleam: ["8M"],
			discharge: ["8L30"],
			doubleteam: ["8M"],
			eerieimpulse: ["8L1"],
			electroball: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			flail: ["8L42"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hydropump: ["8L54"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			scald: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			spark: ["8L20"],
			spitup: ["8L1"],
			stockpile: ["8L1"],
			substitute: ["8M"],
			supersonic: ["8L1"],
			surf: ["8M"],
			swagger: ["8M"],
			swallow: ["8L1"],
			takedown: ["8L48"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M", "8L1"],
			voltswitch: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
		},
	},
	pichu: {
		learnset: {
			attract: ["8M"],
			charge: ["8E"],
			chargebeam: ["8M"],
			charm: ["8L20"],
			disarmingvoice: ["8E"],
			doubleteam: ["8M"],
			electricterrain: ["8E"],
			encore: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8E"],
			flail: ["8E"],
			flash: ["8M"],
			fling: ["8M"],
			grassknot: ["8M"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			nastyplot: ["8M", "8L16"],
			nuzzle: ["8L12"],
			playnice: ["8L4"],
			present: ["8E"],
			protect: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			reversal: ["8E"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8L8"],
			tailwhip: ["8L1"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderpunch: ["8E"],
			thundershock: ["8L1"],
			thunderwave: ["8M"],
			tickle: ["8E"],
			voltswitch: ["8M"],
			volttackle: ["8R"],
			wish: ["8E"],
		},
	},
	cleffa: {
		learnset: {
			amnesia: ["8E"],
			aromatherapy: ["8E"],
			attract: ["8M"],
			bellydrum: ["8E"],
			charm: ["8L20"],
			copycat: ["8L1"],
			covet: ["8E"],
			dig: ["8M"],
			disarmingvoice: ["8L12"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			encore: ["8L16"],
			endure: ["8M"],
			facade: ["8M"],
			faketears: ["8E"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			grassknot: ["8M"],
			healpulse: ["8E"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			metronome: ["8E"],
			mimic: ["8E"],
			mistyterrain: ["8E"],
			pound: ["8L1"],
			present: ["8E"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sing: ["8L4"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			splash: ["8L1", "8E"],
			storedpower: ["8E"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8L8"],
			thunderwave: ["8M"],
			tickle: ["8E"],
			waterpulse: ["8M"],
			wish: ["8E"],
			workup: ["8M"],
		},
	},
	igglybuff: {
		learnset: {
			attract: ["8M"],
			charm: ["8L20"],
			copycat: ["8L1"],
			covet: ["8E"],
			defensecurl: ["8L4"],
			dig: ["8M"],
			disable: ["8L16"],
			disarmingvoice: ["8L12"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			faketears: ["8E"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			grassknot: ["8M"],
			gravity: ["8E"],
			healpulse: ["8E"],
			lastresort: ["8E"],
			lightscreen: ["8M"],
			mistyterrain: ["8E"],
			perishsong: ["8E"],
			pound: ["8L1"],
			present: ["8E"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rollout: ["8E"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sing: ["8L1"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8L8"],
			thunderwave: ["8M"],
			waterpulse: ["8M"],
			wish: ["8E"],
			workup: ["8M"],
		},
	},
	togepi: {
		learnset: {
			afteryou: ["8L28"],
			ancientpower: ["8L16"],
			attract: ["8M"],
			batonpass: ["8L44"],
			charm: ["8L12"],
			dazzlinggleam: ["8M"],
			doubleedge: ["8L32"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			extrasensory: ["8E"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			followme: ["8L40"],
			futuresight: ["8E"],
			grassknot: ["8M"],
			growl: ["8L1"],
			lastresort: ["8L48"],
			lifedew: ["8L8"],
			lightscreen: ["8M"],
			metronome: ["8L24"],
			morningsun: ["8E"],
			nastyplot: ["8M"],
			peck: ["8E"],
			pound: ["8L1"],
			present: ["8E"],
			protect: ["8M"],
			psychic: ["8M"],
			psychoshift: ["8E"],
			psychup: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M", "8L36"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			storedpower: ["8E"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8L4"],
			thunderwave: ["8M"],
			waterpulse: ["8M"],
			wish: ["8L52"],
			workup: ["8M"],
			yawn: ["8L20"],
		},
	},
	togetic: {
		learnset: {
			aerialace: ["8M"],
			afteryou: ["8L28"],
			ancientpower: ["8L16"],
			attract: ["8M"],
			batonpass: ["8L44"],
			brickbreak: ["8M"],
			charm: ["8L12"],
			dazzlinggleam: ["8M"],
			defog: ["8M"],
			doubleedge: ["8L32"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fairywind: ["8L1"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			fly: ["8M"],
			focuspunch: ["8M"],
			followme: ["8L40"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			hyperbeam: ["8M"],
			lastresort: ["8L48"],
			lifedew: ["8L1"],
			lightscreen: ["8M"],
			metronome: ["8L24"],
			nastyplot: ["8M"],
			pound: ["8L1"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			roost: ["8M"],
			safeguard: ["8M", "8L36"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8L1"],
			thunderwave: ["8M"],
			waterpulse: ["8M"],
			wish: ["8L52"],
			workup: ["8M"],
			yawn: ["8L20"],
		},
	},
	natu: {
		learnset: {
			aerialace: ["8M"],
			allyswitch: ["8E"],
			attract: ["8M"],
			calmmind: ["8M"],
			confuseray: ["8L15"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			drillpeck: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			featherdance: ["8E"],
			flash: ["8M"],
			futuresight: ["8L45"],
			gigadrain: ["8M"],
			grassknot: ["8M"],
			guardswap: ["8L35"],
			haze: ["8E"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			nightshade: ["8L20"],
			peck: ["8L1"],
			pluck: ["8M"],
			powerswap: ["8L30"],
			protect: ["8M"],
			psychic: ["8M", "8L35"],
			psychoshift: ["8L26"],
			psychup: ["8M"],
			quickattack: ["8E"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			roost: ["8M"],
			shadowball: ["8M"],
			simplebeam: ["8E"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			steelwing: ["8M"],
			storedpower: ["8L5"],
			substitute: ["8M"],
			suckerpunch: ["8E"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			teleport: ["8L10"],
			thief: ["8M"],
			thunderwave: ["8M"],
			trickroom: ["8M"],
			uturn: ["8M"],
			wish: ["8L40"],
			zenheadbutt: ["8E"],
		},
	},
	xatu: {
		learnset: {
			aerialace: ["8M"],
			airslash: ["8L1"],
			attract: ["8M"],
			calmmind: ["8M"],
			confuseray: ["8L15"],
			dazzlinggleam: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fly: ["8M"],
			futuresight: ["8L55"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			guardswap: ["8L34"],
			hyperbeam: ["8M"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			nightshade: ["8L20"],
			peck: ["8L1"],
			pluck: ["8M"],
			powerswap: ["8L34"],
			protect: ["8M"],
			psychic: ["8M", "8L41"],
			psychoshift: ["8L28"],
			psychup: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			roost: ["8M"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			steelwing: ["8M"],
			storedpower: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tailwind: ["8L1"],
			teleport: ["8L1"],
			thief: ["8M"],
			thunderwave: ["8M"],
			trickroom: ["8M"],
			uturn: ["8M"],
			wish: ["8L48"],
		},
	},
	mareep: {
		learnset: {
			afteryou: ["8E"],
			agility: ["8E"],
			attract: ["8M"],
			bodyslam: ["8E"],
			charge: ["8L15", "8E"],
			chargebeam: ["8M", "8L39"],
			confuseray: ["8L25"],
			cottonguard: ["8L36"],
			cottonspore: ["8L11"],
			discharge: ["8L32"],
			doubleteam: ["8M"],
			eerieimpulse: ["8E"],
			electricterrain: ["8E"],
			electroball: ["8L22"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			flatter: ["8E"],
			growl: ["8L1"],
			irontail: ["8M"],
			lightscreen: ["8M", "8L43"],
			powergem: ["8L29"],
			protect: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			sandattack: ["8E"],
			screech: ["8E"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L18", "8E"],
			thunder: ["8M", "8L46"],
			thunderbolt: ["8M"],
			thundershock: ["8L8"],
			thunderwave: ["8M", "8L4"],
		},
	},
	flaaffy: {
		learnset: {
			attract: ["8M"],
			brickbreak: ["8M"],
			charge: ["8L16"],
			chargebeam: ["8M", "8L47"],
			confuseray: ["8L29"],
			cottonguard: ["8L43"],
			cottonspore: ["8L11"],
			discharge: ["8L38"],
			doubleteam: ["8M"],
			electroball: ["8L25"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			growl: ["8L1"],
			irontail: ["8M"],
			lightscreen: ["8M", "8L52"],
			powergem: ["8L34"],
			protect: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L20"],
			thunder: ["8M", "8L56"],
			thunderbolt: ["8M"],
			thundershock: ["8L8", "8L1"],
			thunderwave: ["8M", "8L4", "8L1"],
			voltswitch: ["8M"],
		},
	},
	ampharos: {
		learnset: {
			attract: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			charge: ["8L16"],
			chargebeam: ["8M", "8L51"],
			confuseray: ["8L29"],
			cottonguard: ["8L46"],
			cottonspore: ["8L11"],
			discharge: ["8L40"],
			doubleteam: ["8M"],
			dragonpulse: ["8M", "8L65", "8L1"],
			electroball: ["8L25"],
			endure: ["8M"],
			facade: ["8M"],
			firepunch: ["8L1"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			lightscreen: ["8M", "8L57"],
			magneticflux: ["8L1"],
			powergem: ["8L35"],
			protect: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L20"],
			thunder: ["8M", "8L62"],
			thunderbolt: ["8M"],
			thunderpunch: ["8L1"],
			thundershock: ["8L8", "8L1"],
			thunderwave: ["8M", "8L4", "8L1"],
			voltswitch: ["8M"],
			zapcannon: ["8L1"],
		},
	},
	bellossom: {
		learnset: {
			absorb: ["8L1"],
			acid: ["8L1"],
			attract: ["8M"],
			bulletseed: ["8M"],
			cut: ["8M"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			gigadrain: ["8M", "8L1"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			grassyterrain: ["8L1"],
			growth: ["8L1"],
			hyperbeam: ["8M"],
			megadrain: ["8L1"],
			moonblast: ["8L1"],
			moonlight: ["8L1"],
			petalblizzard: ["8L1"],
			petaldance: ["8L1"],
			poisonpowder: ["8L1"],
			protect: ["8M"],
			quiverdance: ["8L1"],
			rest: ["8M"],
			safeguard: ["8M"],
			sleeppowder: ["8L1"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			stunspore: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L1"],
			swordsdance: ["8M"],
			toxic: ["8M", "8L1"],
		},
	},
	marill: {
		learnset: {
			amnesia: ["8E"],
			aquajet: ["8E"],
			aquaring: ["8L24"],
			aquatail: ["8L19"],
			attract: ["8M"],
			bellydrum: ["8E"],
			blizzard: ["8M"],
			bodyslam: ["8E"],
			bounce: ["8L15"],
			brickbreak: ["8M"],
			bubblebeam: ["8L6"],
			charm: ["8L9"],
			copycat: ["8E"],
			defensecurl: ["8L1"],
			dig: ["8M"],
			doubleedge: ["8L33"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			futuresight: ["8E"],
			grassknot: ["8M"],
			hail: ["8M"],
			helpinghand: ["8L1"],
			hydropump: ["8L30"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			muddywater: ["8E"],
			perishsong: ["8E"],
			playrough: ["8L21"],
			present: ["8E"],
			protect: ["8M"],
			raindance: ["8M", "8L27"],
			rest: ["8M"],
			rocksmash: ["8M"],
			rollout: ["8L1"],
			scald: ["8M"],
			sing: ["8E"],
			slam: ["8L12"],
			sleeptalk: ["8M"],
			soak: ["8E"],
			splash: ["8L1"],
			strength: ["8M"],
			substitute: ["8M"],
			superpower: ["8L36", "8E"],
			supersonic: ["8E"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			tickle: ["8E"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	azumarill: {
		learnset: {
			aquaring: ["8L30"],
			aquatail: ["8L21"],
			attract: ["8M"],
			blizzard: ["8M"],
			bounce: ["8L15"],
			brickbreak: ["8M"],
			bubblebeam: ["8L6"],
			bulldoze: ["8M"],
			charm: ["8L9"],
			defensecurl: ["8L1"],
			dig: ["8M"],
			doubleedge: ["8L45"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			hail: ["8M"],
			helpinghand: ["8L1"],
			hydropump: ["8L40"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			playrough: ["8L25"],
			protect: ["8M"],
			raindance: ["8M", "8L35"],
			rest: ["8M"],
			rocksmash: ["8M"],
			rollout: ["8L1"],
			scald: ["8M"],
			slam: ["8L12"],
			sleeptalk: ["8M"],
			splash: ["8L1"],
			strength: ["8M"],
			substitute: ["8M"],
			superpower: ["8L50"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	sudowoodo: {
		learnset: {
			attract: ["8M"],
			block: ["8L12"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			copycat: ["8L1"],
			counter: ["8L40"],
			curse: ["8E"],
			defensecurl: ["8E"],
			dig: ["8M"],
			doubleedge: ["8L44"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			faketears: ["8L1"],
			flail: ["8L1"],
			fling: ["8M"],
			focuspunch: ["8M"],
			hammerarm: ["8L1"],
			harden: ["8E"],
			headbutt: ["8E"],
			headsmash: ["8L48"],
			lowkick: ["8L36"],
			mimic: ["8L16"],
			protect: ["8M"],
			psychup: ["8M"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M", "8L32"],
			rocksmash: ["8M"],
			rockthrow: ["8L1"],
			rocktomb: ["8M", "8L20"],
			rollout: ["8E"],
			sandstorm: ["8M"],
			sandtomb: ["8E"],
			selfdestruct: ["8E"],
			slam: ["8L1"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M", "8L1"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L28"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			tearfullook: ["8L24"],
			thief: ["8M"],
			torment: ["8M"],
			woodhammer: ["8L1"],
		},
	},
	politoed: {
		learnset: {
			attract: ["8M"],
			bellydrum: ["8L1"],
			blizzard: ["8M"],
			bodyslam: ["8L1"],
			bounce: ["8L1"],
			brickbreak: ["8M"],
			bubblebeam: ["8L1"],
			bulldoze: ["8M"],
			dig: ["8M"],
			doubleedge: ["8L1"],
			doubleteam: ["8M"],
			earthpower: ["8L1"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hydropump: ["8L1"],
			hyperbeam: ["8M"],
			hypervoice: ["8L1"],
			hypnosis: ["8L1"],
			icebeam: ["8M"],
			mudshot: ["8L1"],
			payback: ["8M"],
			perishsong: ["8L1"],
			pound: ["8L1"],
			protect: ["8M"],
			psychic: ["8M"],
			raindance: ["8M", "8L1"],
			rest: ["8M"],
			rocksmash: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M", "8L1"],
			thief: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
		},
	},
	hoppip: {
		learnset: {
			absorb: ["8L1"],
			acrobatics: ["8L28"],
			aerialace: ["8M"],
			amnesia: ["8E"],
			aromatherapy: ["8E"],
			attract: ["8M"],
			bounce: ["8L46"],
			bulletseed: ["8M", "8L19"],
			confusion: ["8E"],
			cottonguard: ["8E"],
			cottonspore: ["8L34"],
			dazzlinggleam: ["8M"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			encore: ["8E"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			fairywind: ["8L10"],
			flash: ["8M"],
			gigadrain: ["8M", "8L43"],
			grassknot: ["8M"],
			grassyterrain: ["8E"],
			helpinghand: ["8E"],
			leechseed: ["8L22"],
			megadrain: ["8L25"],
			memento: ["8L49"],
			poisonpowder: ["8L12"],
			protect: ["8M"],
			psychup: ["8M"],
			ragepowder: ["8L31"],
			reflect: ["8M"],
			rest: ["8M"],
			seedbomb: ["8E"],
			sleeppowder: ["8L16"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			splash: ["8L1"],
			strengthsap: ["8E"],
			stunspore: ["8L14"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			synthesis: ["8L4"],
			tackle: ["8L8"],
			tailwhip: ["8L6"],
			uturn: ["8M", "8L37"],
			worryseed: ["8L40", "8E"],
		},
	},
	skiploom: {
		learnset: {
			absorb: ["8L1"],
			acrobatics: ["8L32"],
			aerialace: ["8M"],
			attract: ["8M"],
			bounce: ["8L56"],
			bulletseed: ["8M", "8L20"],
			cottonspore: ["8L40"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			fairywind: ["8L10"],
			flash: ["8M"],
			gigadrain: ["8M", "8L52"],
			grassknot: ["8M"],
			leechseed: ["8L24"],
			megadrain: ["8L28"],
			memento: ["8L60"],
			poisonpowder: ["8L12"],
			protect: ["8M"],
			psychup: ["8M"],
			ragepowder: ["8L36"],
			reflect: ["8M"],
			rest: ["8M"],
			sleeppowder: ["8L16"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			splash: ["8L1"],
			stunspore: ["8L14"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			synthesis: ["8L4", "8L1"],
			tackle: ["8L8"],
			tailwhip: ["8L6", "8L1"],
			uturn: ["8M", "8L44"],
			worryseed: ["8L48"],
		},
	},
	jumpluff: {
		learnset: {
			absorb: ["8L1"],
			acrobatics: ["8L34"],
			aerialace: ["8M"],
			attract: ["8M"],
			bounce: ["8L64"],
			bulletseed: ["8M", "8L20"],
			cottonspore: ["8L44"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			fairywind: ["8L10"],
			flash: ["8M"],
			gigadrain: ["8M", "8L59"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			hyperbeam: ["8M"],
			leechseed: ["8L24"],
			megadrain: ["8L29"],
			memento: ["8L69"],
			poisonpowder: ["8L12"],
			protect: ["8M"],
			psychup: ["8M"],
			ragepowder: ["8L39"],
			reflect: ["8M"],
			rest: ["8M"],
			sleeppowder: ["8L16"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			splash: ["8L1"],
			stunspore: ["8L14"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			synthesis: ["8L4", "8L1"],
			tackle: ["8L8"],
			tailwhip: ["8L6", "8L1"],
			uturn: ["8M", "8L49"],
			worryseed: ["8L54"],
		},
	},
	aipom: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L29", "8E"],
			astonish: ["8L8"],
			attract: ["8M"],
			batonpass: ["8L11"],
			beatup: ["8E"],
			bounce: ["8E"],
			brickbreak: ["8M"],
			counter: ["8E"],
			covet: ["8E"],
			cut: ["8M"],
			dig: ["8M"],
			doublehit: ["8L32"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8E"],
			fling: ["8M", "8L36"],
			focuspunch: ["8M"],
			furyswipes: ["8L18"],
			grassknot: ["8M"],
			irontail: ["8M"],
			lastresort: ["8L43"],
			lowsweep: ["8M"],
			nastyplot: ["8M", "8L39"],
			payback: ["8M"],
			protect: ["8M"],
			quickguard: ["8E"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8E"],
			rocksmash: ["8M"],
			sandattack: ["8L4"],
			scratch: ["8L1"],
			screech: ["8L25", "8E"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			slam: ["8E"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			spite: ["8E"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L22"],
			switcheroo: ["8E"],
			tailwhip: ["8L1"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			tickle: ["8L15"],
			uturn: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	sunkern: {
		learnset: {
			absorb: ["8L7"],
			attract: ["8M"],
			bulletseed: ["8M"],
			curse: ["8E"],
			cut: ["8M"],
			doubleedge: ["8L37"],
			doubleteam: ["8M"],
			encore: ["8E"],
			endeavor: ["8L25"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M", "8L22"],
			grassknot: ["8M"],
			grassyterrain: ["8E"],
			growth: ["8L1"],
			helpinghand: ["8E"],
			ingrain: ["8L4", "8E"],
			leechseed: ["8L13", "8E"],
			lightscreen: ["8M"],
			megadrain: ["8L10"],
			morningsun: ["8E"],
			naturepower: ["8E"],
			protect: ["8M"],
			razorleaf: ["8L16"],
			rest: ["8M"],
			safeguard: ["8M"],
			seedbomb: ["8L43"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M", "8L34"],
			substitute: ["8M"],
			sunnyday: ["8M", "8L40"],
			swagger: ["8M"],
			sweetscent: ["8E"],
			synthesis: ["8L28"],
			tackle: ["8L1"],
			worryseed: ["8L19"],
		},
	},
	sunflora: {
		learnset: {
			absorb: ["8L7"],
			attract: ["8M"],
			bulletseed: ["8M", "8L25"],
			cut: ["8M"],
			doubleedge: ["8L37"],
			doubleteam: ["8M"],
			endeavor: ["8L1"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			flowershield: ["8L1"],
			gigadrain: ["8M", "8L22"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growth: ["8L1"],
			hyperbeam: ["8M"],
			ingrain: ["8L4"],
			leafstorm: ["8L43"],
			leechseed: ["8L13"],
			lightscreen: ["8M"],
			megadrain: ["8L10"],
			petalblizzard: ["8L50"],
			petaldance: ["8L28"],
			pound: ["8L1"],
			protect: ["8M"],
			razorleaf: ["8L16"],
			rest: ["8M"],
			safeguard: ["8M"],
			seedbomb: ["8L1"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M", "8L34"],
			substitute: ["8M"],
			sunnyday: ["8M", "8L40"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			synthesis: ["8L1"],
			tackle: ["8L1"],
			worryseed: ["8L19"],
		},
	},
	yanma: {
		learnset: {
			aerialace: ["8M", "8L14"],
			airslash: ["8L54"],
			ancientpower: ["8L33"],
			attract: ["8M"],
			bugbuzz: ["8M", "8L57"],
			defog: ["8M"],
			detect: ["8L17"],
			doubleedge: ["8E"],
			doubleteam: ["8M", "8L11"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			feint: ["8E"],
			flash: ["8M"],
			gigadrain: ["8M"],
			gust: ["8L1"],
			hypnosis: ["8L38"],
			leechlife: ["8E"],
			protect: ["8M"],
			psychic: ["8M"],
			quickattack: ["8L6"],
			rest: ["8M"],
			reversal: ["8E"],
			roost: ["8M"],
			screech: ["8L46"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			steelwing: ["8M"],
			stringshot: ["8L30"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L22"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
			uproar: ["8L27"],
			uturn: ["8M", "8L49"],
			whirlwind: ["8E"],
			wingattack: ["8L43"],
		},
	},
	wooper: {
		learnset: {
			acidspray: ["8E"],
			afteryou: ["8E"],
			amnesia: ["8L32"],
			ancientpower: ["8E"],
			aquatail: ["8L24"],
			attract: ["8M"],
			blizzard: ["8M"],
			bodyslam: ["8E"],
			bulldoze: ["8M"],
			counter: ["8E"],
			curse: ["8E"],
			dig: ["8M"],
			doublekick: ["8E"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L40"],
			eerieimpulse: ["8E"],
			encore: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			guardswap: ["8E"],
			hail: ["8M"],
			haze: ["8L12"],
			icebeam: ["8M"],
			irontail: ["8M"],
			mist: ["8L12"],
			muddywater: ["8L28"],
			mudshot: ["8L8"],
			poweruppunch: ["8E"],
			protect: ["8M"],
			raindance: ["8M", "8L4"],
			recover: ["8E"],
			rest: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			scald: ["8M"],
			slam: ["8L16"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			spitup: ["8E"],
			stockpile: ["8E"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swallow: ["8E"],
			tailwhip: ["8L1"],
			toxic: ["8M", "8L36"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			yawn: ["8L21"],
		},
	},
	quagsire: {
		learnset: {
			amnesia: ["8L40"],
			aquatail: ["8L28"],
			attract: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L52"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			haze: ["8L12"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			mist: ["8L12"],
			muddywater: ["8L34"],
			mudshot: ["8L1"],
			protect: ["8M"],
			raindance: ["8M", "8L1"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			scald: ["8M"],
			slam: ["8L16"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tailwhip: ["8L1"],
			thief: ["8M"],
			toxic: ["8M", "8L46"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			yawn: ["8L23"],
		},
	},
	espeon: {
		learnset: {
			attract: ["8M"],
			babydolleyes: ["8L15"],
			batonpass: ["8L1"],
			bite: ["8L1"],
			calmmind: ["8M"],
			charm: ["8L1"],
			confusion: ["8L1"],
			copycat: ["8L1"],
			covet: ["8L1"],
			cut: ["8M"],
			dazzlinggleam: ["8M"],
			dig: ["8M"],
			doubleedge: ["8L1"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			futuresight: ["8L50"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			helpinghand: ["8L1"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			lastresort: ["8L55"],
			lightscreen: ["8M"],
			morningsun: ["8L30"],
			powerswap: ["8L35"],
			protect: ["8M"],
			psybeam: ["8L25"],
			psychic: ["8M", "8L40"],
			psychup: ["8M", "8L45"],
			quickattack: ["8L10"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			sandattack: ["8L5"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L20"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			takedown: ["8L1"],
			trickroom: ["8M"],
			workup: ["8M"],
		},
	},
	umbreon: {
		learnset: {
			assurance: ["8L25"],
			attract: ["8M"],
			babydolleyes: ["8L15"],
			batonpass: ["8L1"],
			bite: ["8L1"],
			charm: ["8L1"],
			confuseray: ["8L20"],
			copycat: ["8L1"],
			covet: ["8L1"],
			cut: ["8M"],
			darkpulse: ["8M", "8L40"],
			dig: ["8M"],
			doubleedge: ["8L1"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			foulplay: ["8L1"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			guardswap: ["8L35"],
			helpinghand: ["8L1"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			lastresort: ["8L55"],
			meanlook: ["8L50"],
			moonlight: ["8L30"],
			payback: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			quickattack: ["8L10"],
			raindance: ["8M"],
			rest: ["8M"],
			sandattack: ["8L5"],
			screech: ["8L45"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			snarl: ["8M", "8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L1"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			takedown: ["8L1"],
			taunt: ["8M"],
			thief: ["8M"],
			torment: ["8M"],
			workup: ["8M"],
		},
	},
	murkrow: {
		learnset: {
			aerialace: ["8M"],
			aircutter: ["8L35"],
			assurance: ["8L25", "8E"],
			astonish: ["8L1"],
			attract: ["8M"],
			bravebird: ["8E"],
			calmmind: ["8M"],
			confuseray: ["8E"],
			darkpulse: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			drillpeck: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			featherdance: ["8E"],
			flatter: ["8E"],
			fly: ["8M"],
			foulplay: ["8L45"],
			gust: ["8L5"],
			haze: ["8L11"],
			meanlook: ["8L41"],
			nightshade: ["8L21"],
			payback: ["8M"],
			peck: ["8L1"],
			perishsong: ["8E"],
			pluck: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			psychoshift: ["8E"],
			psychup: ["8M"],
			quash: ["8L65"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M"],
			screech: ["8E"],
			shadowball: ["8M"],
			skyattack: ["8E"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L55"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tailwind: ["8L50"],
			taunt: ["8M", "8L31"],
			thief: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M", "8L61"],
			whirlwind: ["8E"],
			wingattack: ["8L15", "8E"],
		},
	},
	slowking: {
		learnset: {
			amnesia: ["8L27"],
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			confusion: ["8L12"],
			curse: ["8L1"],
			dig: ["8M"],
			disable: ["8L15"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			hail: ["8M"],
			headbutt: ["8L21"],
			healpulse: ["8L45"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			nastyplot: ["8M", "8L1"],
			powergem: ["8L1"],
			protect: ["8M"],
			psychic: ["8M", "8L36"],
			psychup: ["8M", "8L39"],
			raindance: ["8M", "8L42"],
			recycle: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			scald: ["8M"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			slackoff: ["8L33"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M", "8L30"],
			swagger: ["8M", "8L1"],
			tackle: ["8L1"],
			thunderwave: ["8M"],
			trickroom: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L18"],
			yawn: ["8L9"],
			zenheadbutt: ["8L24"],
		},
	},
	misdreavus: {
		learnset: {
			aerialace: ["8M"],
			astonish: ["8L10"],
			attract: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confuseray: ["8L14"],
			confusion: ["8L1"],
			curse: ["8E"],
			darkpulse: ["8M"],
			dazzlinggleam: ["8M"],
			destinybond: ["8E"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			growl: ["8L1"],
			grudge: ["8L50"],
			hex: ["8L23"],
			imprison: ["8E"],
			meanlook: ["8L19"],
			memento: ["8E"],
			nastyplot: ["8M"],
			painsplit: ["8L32"],
			payback: ["8M", "8L37"],
			perishsong: ["8L46"],
			powergem: ["8L55"],
			protect: ["8M"],
			psybeam: ["8L28"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			screech: ["8E"],
			shadowball: ["8M", "8L41"],
			shadowsneak: ["8E"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			spite: ["8L5", "8E"],
			substitute: ["8M"],
			suckerpunch: ["8E"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
			willowisp: ["8M"],
			wonderroom: ["8E"],
		},
	},
	unown: {
		learnset: {
			hiddenpower: ["8L1"],
		},
	},
	wobbuffet: {
		learnset: {
			amnesia: ["8L1"],
			charm: ["8L1"],
			counter: ["8L1"],
			destinybond: ["8L1"],
			encore: ["8L1"],
			mirrorcoat: ["8L1"],
			safeguard: ["8M", "8L1"],
			splash: ["8L1"],
		},
	},
	girafarig: {
		learnset: {
			agility: ["8L23"],
			amnesia: ["8E"],
			assurance: ["8L10"],
			astonish: ["8L1"],
			attract: ["8M"],
			batonpass: ["8L41"],
			beatup: ["8E"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confusion: ["8L5"],
			crunch: ["8L37"],
			dazzlinggleam: ["8M"],
			doublehit: ["8L28"],
			doublekick: ["8E"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			futuresight: ["8E"],
			grassknot: ["8M"],
			growl: ["8L1"],
			guardswap: ["8L1"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			magiccoat: ["8E"],
			meanlook: ["8E"],
			mirrorcoat: ["8E"],
			nastyplot: ["8M", "8L46"],
			powerswap: ["8L1"],
			protect: ["8M"],
			psybeam: ["8L19"],
			psychic: ["8M", "8L50"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			stomp: ["8L14"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8E"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			trickroom: ["8M"],
			wish: ["8E"],
			workup: ["8M"],
			zenheadbutt: ["8L32"],
		},
	},
	pineco: {
		learnset: {
			attract: ["8M"],
			autotomize: ["8L20"],
			bugbite: ["8L9"],
			bugbuzz: ["8M"],
			bulldoze: ["8M"],
			counter: ["8E"],
			dig: ["8M"],
			doubleedge: ["8L45", "8E"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M", "8L34"],
			facade: ["8M"],
			flail: ["8E"],
			gigadrain: ["8M"],
			gyroball: ["8M", "8L42"],
			irondefense: ["8L39"],
			lightscreen: ["8M"],
			payback: ["8M", "8L31"],
			pinmissile: ["8E"],
			powertrick: ["8E"],
			protect: ["8M", "8L1"],
			rapidspin: ["8L17"],
			reflect: ["8M"],
			rest: ["8M"],
			revenge: ["8E"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L23"],
			sandstorm: ["8M"],
			sandtomb: ["8E"],
			selfdestruct: ["8L6"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			spikes: ["8L28"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8E"],
			tackle: ["8L1"],
			takedown: ["8L12"],
			toxicspikes: ["8E"],
		},
	},
	forretress: {
		learnset: {
			attract: ["8M"],
			autotomize: ["8L1"],
			bugbite: ["8L9", "8L1"],
			bugbuzz: ["8M"],
			bulldoze: ["8M"],
			dig: ["8M"],
			doubleedge: ["8L50"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M", "8L36"],
			facade: ["8M"],
			flashcannon: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			gyroball: ["8M", "8L46"],
			heavyslam: ["8L64", "8L1"],
			hyperbeam: ["8M"],
			irondefense: ["8L42"],
			lightscreen: ["8M"],
			magnetrise: ["8L56", "8L1"],
			payback: ["8M", "8L32"],
			protect: ["8M", "8L1"],
			rapidspin: ["8L17"],
			reflect: ["8M", "8L20"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L23"],
			sandstorm: ["8M"],
			selfdestruct: ["8L6", "8L1"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			spikes: ["8L28"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L12"],
			toxicspikes: ["8L1"],
			voltswitch: ["8M"],
			zapcannon: ["8L60", "8L1"],
		},
	},
	dunsparce: {
		learnset: {
			agility: ["8E"],
			ancientpower: ["8L20", "8E"],
			aquatail: ["8E"],
			astonish: ["8E"],
			attract: ["8M"],
			bite: ["8E"],
			blizzard: ["8M"],
			bodyslam: ["8L32"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			coil: ["8L48"],
			curse: ["8E"],
			defensecurl: ["8L1"],
			dig: ["8M"],
			doubleedge: ["8L52"],
			doubleteam: ["8M"],
			dragonrush: ["8L44"],
			dreameater: ["8M"],
			drillrun: ["8L24"],
			earthquake: ["8M"],
			endeavor: ["8L56"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flail: ["8L1"],
			flamethrower: ["8M"],
			glare: ["8L12"],
			gyroball: ["8M"],
			headbutt: ["8E"],
			hex: ["8E"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lastresort: ["8E"],
			magiccoat: ["8E"],
			mudslap: ["8L4"],
			poisonjab: ["8M"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L8"],
			roost: ["8M", "8L40"],
			screech: ["8L16"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			snore: ["8E"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			takedown: ["8L36"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterpulse: ["8M"],
			yawn: ["8L28"],
		},
	},
	gligar: {
		learnset: {
			acrobatics: ["8L22"],
			aerialace: ["8M"],
			agility: ["8E"],
			attract: ["8M"],
			batonpass: ["8E"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			counter: ["8E"],
			crosspoison: ["8E"],
			cut: ["8M"],
			darkpulse: ["8M"],
			defog: ["8M"],
			dig: ["8M"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L45"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			feint: ["8E"],
			fling: ["8M"],
			furycutter: ["8L16"],
			guillotine: ["8L55"],
			harden: ["8L7"],
			irontail: ["8M"],
			knockoff: ["8L10"],
			metalclaw: ["8E"],
			mudslap: ["8L19"],
			nightslash: ["8E"],
			payback: ["8M"],
			poisonjab: ["8M"],
			poisonsting: ["8L1"],
			poisontail: ["8E"],
			powertrick: ["8E"],
			protect: ["8M"],
			quickattack: ["8L13"],
			raindance: ["8M"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			roost: ["8M"],
			sandattack: ["8L4"],
			sandstorm: ["8M"],
			sandtomb: ["8E"],
			screech: ["8L35"],
			slash: ["8L27"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			stealthrock: ["8M"],
			steelwing: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L50"],
			taunt: ["8M"],
			thief: ["8M"],
			torment: ["8M"],
			uturn: ["8M", "8L30"],
			wingattack: ["8E"],
			xscissor: ["8M", "8L40"],
		},
	},
	steelix: {
		learnset: {
			attract: ["8M"],
			autotomize: ["8L8"],
			bind: ["8L1"],
			bulldoze: ["8M"],
			crunch: ["8L1"],
			curse: ["8L16"],
			cut: ["8M"],
			darkpulse: ["8M"],
			dig: ["8M", "8L44"],
			doubleedge: ["8L56"],
			doubleteam: ["8M"],
			dragonbreath: ["8L12"],
			dragonpulse: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			firefang: ["8L1"],
			flashcannon: ["8M"],
			gigaimpact: ["8M"],
			gyroball: ["8M"],
			harden: ["8L1"],
			hyperbeam: ["8M"],
			icefang: ["8L1"],
			irontail: ["8M", "8L48"],
			magnetrise: ["8L60"],
			payback: ["8M"],
			protect: ["8M"],
			psychup: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockpolish: ["8M", "8L1"],
			rockslide: ["8M", "8L20"],
			rocksmash: ["8M"],
			rockthrow: ["8L1"],
			rocktomb: ["8M"],
			sandstorm: ["8M", "8L40"],
			sandtomb: ["8L28"],
			screech: ["8L24"],
			slam: ["8L36"],
			sleeptalk: ["8M"],
			smackdown: ["8L4"],
			stealthrock: ["8M", "8L32"],
			stoneedge: ["8M", "8L52"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			taunt: ["8M"],
			thunderfang: ["8L1"],
			torment: ["8M"],
		},
	},
	snubbull: {
		learnset: {
			attract: ["8M"],
			bite: ["8L7"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			charm: ["8L1"],
			closecombat: ["8E"],
			crunch: ["8L49", "8E"],
			dazzlinggleam: ["8M"],
			dig: ["8M"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			faketears: ["8E"],
			fireblast: ["8M"],
			firefang: ["8L1", "8E"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			headbutt: ["8L19"],
			healbell: ["8E"],
			icefang: ["8L1", "8E"],
			lick: ["8L13"],
			metronome: ["8E"],
			mimic: ["8E"],
			overheat: ["8M"],
			payback: ["8M", "8L43"],
			playrough: ["8L37"],
			present: ["8E"],
			protect: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			roar: ["8M", "8L25"],
			rocksmash: ["8M"],
			scaryface: ["8L1"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			snarl: ["8M"],
			snore: ["8E"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			taunt: ["8M", "8L31"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderfang: ["8L1", "8E"],
			thunderwave: ["8M"],
			torment: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	granbull: {
		learnset: {
			attract: ["8M"],
			bite: ["8L7"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			charm: ["8L1"],
			crunch: ["8L59"],
			dazzlinggleam: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			firefang: ["8L1"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			headbutt: ["8L19"],
			hyperbeam: ["8M"],
			icefang: ["8L1"],
			irontail: ["8M"],
			lick: ["8L13"],
			outrage: ["8L67", "8L1"],
			overheat: ["8M"],
			payback: ["8M", "8L51"],
			playrough: ["8L43"],
			protect: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			roar: ["8M", "8L27"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scaryface: ["8L1"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			snarl: ["8M"],
			solarbeam: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			taunt: ["8M", "8L35"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderfang: ["8L1"],
			thunderwave: ["8M"],
			torment: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	qwilfish: {
		learnset: {
			acidspray: ["8E"],
			acupressure: ["8L60"],
			aquajet: ["8E"],
			aquatail: ["8L56"],
			astonish: ["8E"],
			attract: ["8M"],
			blizzard: ["8M"],
			brine: ["8M", "8L24"],
			bubblebeam: ["8E"],
			destinybond: ["8L66"],
			doubleteam: ["8M"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			fellstinger: ["8L12"],
			flail: ["8E"],
			gyroball: ["8M"],
			hail: ["8M"],
			harden: ["8L4"],
			haze: ["8E"],
			icebeam: ["8M"],
			minimize: ["8L16"],
			payback: ["8M"],
			pinmissile: ["8L32"],
			poisonjab: ["8M", "8L40"],
			poisonsting: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8L28"],
			scald: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			spikes: ["8L20"],
			spitup: ["8L44"],
			stockpile: ["8L44"],
			substitute: ["8M"],
			supersonic: ["8E"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L48"],
			taunt: ["8M"],
			thunderwave: ["8M"],
			toxic: ["8M", "8L52"],
			toxicspikes: ["8L36"],
			waterfall: ["8M"],
			watergun: ["8L8"],
			waterpulse: ["8M"],
		},
	},
	scizor: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L1"],
			airslash: ["8L1"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bugbuzz: ["8M"],
			bulletpunch: ["8L1"],
			cut: ["8M"],
			defog: ["8M"],
			doublehit: ["8L20"],
			doubleteam: ["8M", "8L16"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M", "8L1"],
			flashcannon: ["8M"],
			fling: ["8M"],
			focusenergy: ["8L28"],
			furycutter: ["8L1"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M"],
			irondefense: ["8L32"],
			ironhead: ["8L36"],
			laserfocus: ["8L44"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			metalclaw: ["8L12"],
			protect: ["8M"],
			quickattack: ["8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			roost: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			slash: ["8L24"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L48"],
			thief: ["8M"],
			uturn: ["8M"],
			wingattack: ["8L1"],
			xscissor: ["8M", "8L40"],
		},
	},
	shuckle: {
		learnset: {
			acid: ["8E"],
			acupressure: ["8E"],
			attract: ["8M"],
			bugbite: ["8L30"],
			bulldoze: ["8M"],
			covet: ["8E"],
			defensecurl: ["8E"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			finalgambit: ["8E"],
			flash: ["8M"],
			gastroacid: ["8L45"],
			guardsplit: ["8L35"],
			gyroball: ["8M"],
			helpinghand: ["8E"],
			infestation: ["8E"],
			knockoff: ["8E"],
			mudslap: ["8E"],
			powersplit: ["8L35"],
			powertrick: ["8L55"],
			protect: ["8M"],
			rest: ["8M", "8L25"],
			rockblast: ["8E"],
			rockpolish: ["8M"],
			rockslide: ["8M", "8L40"],
			rocksmash: ["8M"],
			rockthrow: ["8L15"],
			rocktomb: ["8M"],
			rollout: ["8L5"],
			safeguard: ["8M", "8L20"],
			sandstorm: ["8M"],
			sandtomb: ["8E"],
			shellsmash: ["8L65"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			stealthrock: ["8M"],
			stickyweb: ["8L50"],
			stoneedge: ["8M", "8L60"],
			strength: ["8M"],
			strugglebug: ["8L10"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8E"],
			toxic: ["8M"],
			withdraw: ["8L1"],
			wrap: ["8L1"],
		},
	},
	heracross: {
		learnset: {
			aerialace: ["8M", "8L15"],
			attract: ["8M"],
			brickbreak: ["8M", "8L30"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			bulletseed: ["8M"],
			closecombat: ["8L60"],
			counter: ["8L25"],
			cut: ["8M"],
			dig: ["8M"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M", "8L10"],
			facade: ["8M"],
			falseswipe: ["8M"],
			feint: ["8E"],
			flail: ["8E"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			furyattack: ["8L5"],
			gigaimpact: ["8M"],
			harden: ["8E"],
			hornattack: ["8L20"],
			hyperbeam: ["8M"],
			leer: ["8L1"],
			megahorn: ["8L55", "8E"],
			nightslash: ["8E"],
			pinmissile: ["8L35"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8E"],
			rockblast: ["8E"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			seismictoss: ["8E"],
			shadowclaw: ["8M"],
			sleeptalk: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L50"],
			tackle: ["8L1"],
			takedown: ["8E"],
			thief: ["8M"],
			thrash: ["8L45"],
			throatchop: ["8L40"],
			workup: ["8M"],
		},
	},
	sneasel: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L48"],
			attract: ["8M"],
			avalanche: ["8M"],
			beatup: ["8L42"],
			bite: ["8E"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			calmmind: ["8M"],
			counter: ["8E"],
			crushclaw: ["8E"],
			cut: ["8M"],
			darkpulse: ["8M"],
			dig: ["8M"],
			doublehit: ["8E"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8E"],
			falseswipe: ["8M"],
			feint: ["8E"],
			fling: ["8M"],
			focuspunch: ["8M"],
			furyswipes: ["8L30"],
			hail: ["8M"],
			honeclaws: ["8L36"],
			icebeam: ["8M"],
			icepunch: ["8E"],
			iceshard: ["8E"],
			iciclecrash: ["8E"],
			icywind: ["8L24"],
			irontail: ["8M"],
			leer: ["8L1"],
			lowsweep: ["8M"],
			metalclaw: ["8L18"],
			payback: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			psychup: ["8M"],
			quickattack: ["8L12"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			scratch: ["8L1"],
			screech: ["8L54"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			slash: ["8L60"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			spite: ["8E"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			taunt: ["8M", "8L6"],
			thief: ["8M"],
			throatchop: ["8E"],
			torment: ["8M"],
			xscissor: ["8M"],
		},
	},
	teddiursa: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			babydolleyes: ["8L1"],
			bellydrum: ["8E"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			charm: ["8L36"],
			closecombat: ["8E"],
			counter: ["8E"],
			covet: ["8L1"],
			crosschop: ["8E"],
			crunch: ["8E"],
			cut: ["8M"],
			dig: ["8M"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			faketears: ["8L1", "8E"],
			fling: ["8M", "8L57", "8L1"],
			focuspunch: ["8M"],
			furyswipes: ["8L8"],
			lick: ["8L1"],
			metalclaw: ["8E"],
			nightslash: ["8E"],
			payback: ["8M", "8L15"],
			playnice: ["8L25"],
			playrough: ["8E"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L43"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scratch: ["8L1"],
			seismictoss: ["8E"],
			shadowclaw: ["8M"],
			slash: ["8L29"],
			sleeptalk: ["8M"],
			snore: ["8L43"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L22"],
			swordsdance: ["8M"],
			takedown: ["8E"],
			taunt: ["8M"],
			thief: ["8M"],
			thrash: ["8L50"],
			torment: ["8M"],
			workup: ["8M"],
			yawn: ["8E"],
		},
	},
	ursaring: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			avalanche: ["8M"],
			babydolleyes: ["8L1"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			charm: ["8L1"],
			covet: ["8L1"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			faketears: ["8L1"],
			fling: ["8M", "8L1"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			furyswipes: ["8L8"],
			gigaimpact: ["8M"],
			hammerarm: ["8L67", "8L1"],
			hyperbeam: ["8M"],
			leer: ["8L1"],
			lick: ["8L1"],
			payback: ["8M", "8L15"],
			playnice: ["8L25"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L47"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scaryface: ["8L38"],
			scratch: ["8L1"],
			shadowclaw: ["8M"],
			slash: ["8L29"],
			sleeptalk: ["8M"],
			snore: ["8L49"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L22"],
			swordsdance: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			thrash: ["8L58"],
			torment: ["8M"],
			workup: ["8M"],
		},
	},
	slugma: {
		learnset: {
			acidarmor: ["8E"],
			amnesia: ["8L36"],
			ancientpower: ["8L22"],
			attract: ["8M"],
			bodyslam: ["8L41"],
			clearsmog: ["8L20"],
			curse: ["8E"],
			doubleteam: ["8M"],
			earthpower: ["8L50", "8E"],
			ember: ["8L6"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M", "8L48"],
			guardswap: ["8E"],
			harden: ["8L13"],
			heatwave: ["8E"],
			incinerate: ["8L15"],
			inferno: ["8E"],
			lavaplume: ["8L34"],
			lightscreen: ["8M"],
			memento: ["8E"],
			overheat: ["8M"],
			protect: ["8M"],
			recover: ["8L43"],
			reflect: ["8M"],
			rest: ["8M"],
			rockslide: ["8M", "8L29"],
			rocksmash: ["8M"],
			rockthrow: ["8L8"],
			rocktomb: ["8M"],
			rollout: ["8E"],
			sandstorm: ["8M"],
			sleeptalk: ["8M"],
			smog: ["8L1"],
			smokescreen: ["8E"],
			spitup: ["8E"],
			stockpile: ["8E"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8E"],
			willowisp: ["8M"],
			yawn: ["8L1"],
		},
	},
	magcargo: {
		learnset: {
			amnesia: ["8L36"],
			ancientpower: ["8L22"],
			attract: ["8M"],
			bodyslam: ["8L43"],
			bulldoze: ["8M"],
			clearsmog: ["8L20"],
			doubleteam: ["8M"],
			earthpower: ["8L58", "8L1"],
			earthquake: ["8M"],
			ember: ["8L6", "8L1"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M", "8L54"],
			gigaimpact: ["8M"],
			gyroball: ["8M"],
			harden: ["8L13"],
			hyperbeam: ["8M"],
			incinerate: ["8L15"],
			lavaplume: ["8L34"],
			lightscreen: ["8M"],
			overheat: ["8M"],
			protect: ["8M"],
			recover: ["8L47"],
			reflect: ["8M"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M", "8L29"],
			rocksmash: ["8M"],
			rockthrow: ["8L8", "8L1"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			shellsmash: ["8L1"],
			sleeptalk: ["8M"],
			smog: ["8L1"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			willowisp: ["8M"],
			yawn: ["8L1"],
		},
	},
	swinub: {
		learnset: {
			amnesia: ["8L35"],
			ancientpower: ["8E"],
			attract: ["8M"],
			avalanche: ["8M"],
			bite: ["8E"],
			blizzard: ["8M", "8L50"],
			bodyslam: ["8E"],
			bulldoze: ["8M"],
			curse: ["8E"],
			dig: ["8M"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L45"],
			endure: ["8M", "8L25"],
			facade: ["8M"],
			fissure: ["8E"],
			flail: ["8L10"],
			freezedry: ["8E"],
			hail: ["8M"],
			icebeam: ["8M"],
			iceshard: ["8L15"],
			iciclecrash: ["8E"],
			iciclespear: ["8E"],
			icywind: ["8L30"],
			lightscreen: ["8M"],
			mist: ["8L20"],
			mudshot: ["8E"],
			mudslap: ["8L1"],
			powdersnow: ["8L5"],
			protect: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L40", "8E"],
		},
	},
	piloswine: {
		learnset: {
			amnesia: ["8L37"],
			ancientpower: ["8L1"],
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M", "8L58"],
			bulldoze: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L51"],
			endure: ["8M", "8L25"],
			facade: ["8M"],
			flail: ["8L1"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			icefang: ["8L1"],
			iceshard: ["8L15"],
			icywind: ["8L30"],
			lightscreen: ["8M"],
			mist: ["8L20"],
			mudslap: ["8L1"],
			powdersnow: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L44"],
			thrash: ["8L65"],
		},
	},
	corsola: {
		learnset: {
			amnesia: ["8E"],
			ancientpower: ["8L20"],
			aquaring: ["8L10", "8E"],
			attract: ["8M"],
			blizzard: ["8M"],
			brine: ["8M"],
			bubblebeam: ["8L25"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			confuseray: ["8E"],
			curse: ["8E"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthpower: ["8L45"],
			earthquake: ["8M"],
			endure: ["8M", "8L15"],
			explosion: ["8M"],
			facade: ["8M"],
			flail: ["8L30"],
			hail: ["8M"],
			harden: ["8L1"],
			headsmash: ["8E"],
			icebeam: ["8M"],
			iciclespear: ["8E"],
			ingrain: ["8E"],
			lifedew: ["8L35"],
			lightscreen: ["8M"],
			liquidation: ["8E"],
			mirrorcoat: ["8L55"],
			mist: ["8E"],
			naturepower: ["8E"],
			powergem: ["8L40"],
			protect: ["8M"],
			psychic: ["8M"],
			raindance: ["8M"],
			recover: ["8L50"],
			reflect: ["8M"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			scald: ["8M"],
			screech: ["8E"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			watergun: ["8L5"],
			waterpulse: ["8M"],
		},
	},
	remoraid: {
		learnset: {
			acidspray: ["8E"],
			attract: ["8M"],
			aurorabeam: ["8L16", "8E"],
			blizzard: ["8M"],
			brine: ["8M"],
			bubblebeam: ["8L20"],
			bulletseed: ["8M", "8L28"],
			chargebeam: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			entrainment: ["8E"],
			facade: ["8M"],
			fireblast: ["8M"],
			flail: ["8E"],
			flamethrower: ["8M"],
			focusenergy: ["8L8"],
			haze: ["8E"],
			helpinghand: ["8L1"],
			hydropump: ["8L36"],
			hyperbeam: ["8M", "8L44"],
			icebeam: ["8M", "8L32"],
			lockon: ["8L24"],
			mudshot: ["8E"],
			octazooka: ["8E"],
			protect: ["8M"],
			psybeam: ["8L12"],
			psychic: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockblast: ["8E"],
			scald: ["8M"],
			screech: ["8E"],
			sleeptalk: ["8M"],
			snore: ["8E"],
			soak: ["8L40"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8E"],
			surf: ["8M"],
			swagger: ["8M"],
			swift: ["8E"],
			thief: ["8M"],
			thunderwave: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L4"],
			waterspout: ["8E"],
		},
	},
	octillery: {
		learnset: {
			attract: ["8M"],
			aurorabeam: ["8L16"],
			blizzard: ["8M"],
			brine: ["8M"],
			bubblebeam: ["8L20"],
			bulletseed: ["8M", "8L30"],
			chargebeam: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flashcannon: ["8M"],
			focusenergy: ["8L1"],
			gigaimpact: ["8M"],
			gunkshot: ["8L1"],
			helpinghand: ["8L1"],
			hydropump: ["8L42"],
			hyperbeam: ["8M", "8L54"],
			icebeam: ["8M", "8L36"],
			lockon: ["8L24"],
			octazooka: ["8L1"],
			payback: ["8M"],
			protect: ["8M"],
			psybeam: ["8L12"],
			psychic: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockblast: ["8L1"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			soak: ["8L48"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			thief: ["8M"],
			thunderwave: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L1"],
			wrap: ["8L1"],
		},
	},
	delibird: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			aurorabeam: ["8E"],
			auroraveil: ["8E"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			counter: ["8E"],
			defog: ["8M"],
			destinybond: ["8E"],
			doubleteam: ["8M"],
			drillpeck: ["8L25"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8E"],
			fling: ["8M"],
			fly: ["8M"],
			focuspunch: ["8M"],
			freezedry: ["8E"],
			futuresight: ["8E"],
			hail: ["8M"],
			icebeam: ["8M"],
			icepunch: ["8E"],
			iceshard: ["8E"],
			icywind: ["8E"],
			memento: ["8E"],
			pluck: ["8M"],
			present: ["8L1"],
			protect: ["8M"],
			quickattack: ["8E"],
			raindance: ["8M"],
			rapidspin: ["8E"],
			recycle: ["8M"],
			rest: ["8M"],
			sleeptalk: ["8M"],
			spikes: ["8E"],
			splash: ["8E"],
			steelwing: ["8M"],
			substitute: ["8M"],
			swagger: ["8M"],
			thief: ["8M"],
			waterpulse: ["8M"],
		},
	},
	mantine: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L20"],
			airslash: ["8L32"],
			amnesia: ["8E"],
			aquaring: ["8L36"],
			attract: ["8M"],
			blizzard: ["8M"],
			bounce: ["8L40"],
			brine: ["8M"],
			bubblebeam: ["8L24"],
			bulldoze: ["8M"],
			bulletseed: ["8M", "8L1"],
			confuseray: ["8E"],
			defog: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			haze: ["8E"],
			headbutt: ["8L28"],
			hydropump: ["8L48", "8E"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			mirrorcoat: ["8E"],
			protect: ["8M"],
			psybeam: ["8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocktomb: ["8M"],
			roost: ["8M", "8L1"],
			scald: ["8M"],
			slam: ["8E"],
			sleeptalk: ["8M"],
			splash: ["8E"],
			substitute: ["8M"],
			supersonic: ["8L1"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailwind: ["8E"],
			takedown: ["8L44"],
			twister: ["8E"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L12"],
			wideguard: ["8L16", "8E"],
			wingattack: ["8L1"],
		},
	},
	skarmory: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L16"],
			aircutter: ["8E"],
			assurance: ["8E"],
			attract: ["8M"],
			autotomize: ["8L32"],
			bravebird: ["8L52", "8E"],
			curse: ["8E"],
			cut: ["8M"],
			darkpulse: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			drillpeck: ["8L36", "8E"],
			endure: ["8M"],
			facade: ["8M"],
			feint: ["8E"],
			flash: ["8M"],
			flashcannon: ["8M"],
			fly: ["8M"],
			furyattack: ["8L8"],
			guardswap: ["8E"],
			irondefense: ["8L48"],
			leer: ["8L1"],
			metalclaw: ["8L12"],
			metalsound: ["8L40"],
			nightslash: ["8E"],
			payback: ["8M"],
			peck: ["8L1"],
			pluck: ["8M"],
			protect: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			roost: ["8M"],
			sandattack: ["8L4"],
			sandstorm: ["8M"],
			skyattack: ["8E"],
			slash: ["8L24"],
			sleeptalk: ["8M"],
			spikes: ["8L44"],
			stealthrock: ["8M"],
			steelwing: ["8M", "8L28"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			torment: ["8M"],
			whirlwind: ["8E"],
			wingattack: ["8L20"],
			xscissor: ["8M"],
		},
	},
	houndour: {
		learnset: {
			attract: ["8M"],
			beatup: ["8L25", "8E"],
			bite: ["8L16"],
			counter: ["8E"],
			crunch: ["8L49"],
			darkpulse: ["8M"],
			destinybond: ["8E"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			feint: ["8E"],
			fireblast: ["8M"],
			firefang: ["8L28", "8E"],
			firespin: ["8E"],
			flamecharge: ["8L37"],
			flamethrower: ["8M", "8L44"],
			foulplay: ["8L40"],
			howl: ["8L4"],
			inferno: ["8L56"],
			irontail: ["8M"],
			leer: ["8L1"],
			nastyplot: ["8M", "8L52"],
			overheat: ["8M"],
			payback: ["8M", "8L32"],
			protect: ["8M"],
			rest: ["8M"],
			reversal: ["8E"],
			roar: ["8M", "8L13"],
			rocksmash: ["8M"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			smog: ["8L8"],
			snarl: ["8M"],
			solarbeam: ["8M"],
			spite: ["8E"],
			substitute: ["8M"],
			suckerpunch: ["8E"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M", "8L20"],
			thief: ["8M"],
			thunderfang: ["8E"],
			torment: ["8M"],
			willowisp: ["8M"],
		},
	},
	houndoom: {
		learnset: {
			attract: ["8M"],
			beatup: ["8L26"],
			bite: ["8L16"],
			crunch: ["8L56"],
			darkpulse: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			firefang: ["8L30"],
			flamecharge: ["8L41"],
			flamethrower: ["8M", "8L50"],
			foulplay: ["8L45"],
			gigaimpact: ["8M"],
			howl: ["8L4"],
			hyperbeam: ["8M"],
			inferno: ["8L65", "8L1"],
			irontail: ["8M"],
			leer: ["8L1"],
			nastyplot: ["8M", "8L60", "8L1"],
			overheat: ["8M"],
			payback: ["8M", "8L35"],
			protect: ["8M"],
			rest: ["8M"],
			roar: ["8M", "8L13"],
			rocksmash: ["8M"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			smog: ["8L8"],
			snarl: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M", "8L20"],
			thief: ["8M"],
			thunderfang: ["8L1"],
			torment: ["8M"],
			willowisp: ["8M"],
		},
	},
	kingdra: {
		learnset: {
			agility: ["8L30"],
			attract: ["8M"],
			blizzard: ["8M"],
			brine: ["8M"],
			bubblebeam: ["8L25"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonbreath: ["8L20"],
			dragondance: ["8L58"],
			dragonpulse: ["8M", "8L44"],
			endure: ["8M"],
			facade: ["8M"],
			flashcannon: ["8M"],
			focusenergy: ["8L15"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hydropump: ["8L51"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			laserfocus: ["8L37"],
			leer: ["8L1"],
			protect: ["8M"],
			raindance: ["8M", "8L65"],
			rest: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			smokescreen: ["8L1"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			twister: ["8L1"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			whirlpool: ["8L1"],
			yawn: ["8L1"],
		},
	},
	phanpy: {
		learnset: {
			ancientpower: ["8E"],
			attract: ["8M"],
			bodyslam: ["8E"],
			bulldoze: ["8M", "8L15"],
			charm: ["8L33"],
			counter: ["8E"],
			defensecurl: ["8L1"],
			doubleedge: ["8L42"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endeavor: ["8E"],
			endure: ["8M", "8L19"],
			facade: ["8M"],
			fissure: ["8E"],
			flail: ["8L6"],
			focusenergy: ["8E"],
			growl: ["8L1"],
			headsmash: ["8E"],
			heavyslam: ["8E"],
			highhorsepower: ["8E"],
			iceshard: ["8E"],
			irontail: ["8M"],
			lastresort: ["8L37"],
			mudslap: ["8E"],
			playrough: ["8E"],
			protect: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L10"],
			sandstorm: ["8M"],
			slam: ["8L24"],
			sleeptalk: ["8M"],
			snore: ["8E"],
			stealthrock: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L28"],
		},
	},
	donphan: {
		learnset: {
			assurance: ["8L15"],
			attract: ["8M"],
			bulldoze: ["8M", "8L1"],
			charm: ["8L1"],
			defensecurl: ["8L1"],
			doubleedge: ["8L1"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L43"],
			endure: ["8M", "8L1"],
			facade: ["8M"],
			firefang: ["8L1"],
			flail: ["8L1"],
			furyattack: ["8L1"],
			gigaimpact: ["8M", "8L50"],
			growl: ["8L1"],
			gyroball: ["8M"],
			hornattack: ["8L1"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			knockoff: ["8L19"],
			lastresort: ["8L1"],
			poisonjab: ["8M"],
			protect: ["8M"],
			rapidspin: ["8L6"],
			rest: ["8M"],
			roar: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M", "8L30"],
			rollout: ["8L10"],
			sandstorm: ["8M"],
			scaryface: ["8L37"],
			slam: ["8L24"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L1"],
			thunderfang: ["8L1"],
		},
	},
	porygon2: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L30"],
			blizzard: ["8M"],
			chargebeam: ["8M"],
			conversion: ["8L1"],
			conversion2: ["8L25"],
			defensecurl: ["8L1"],
			discharge: ["8L40"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M", "8L65"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lockon: ["8L55"],
			magiccoat: ["8L50"],
			magnetrise: ["8L1"],
			protect: ["8M"],
			psybeam: ["8L20"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recover: ["8L35"],
			recycle: ["8M", "8L1"],
			rest: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thundershock: ["8L15"],
			thunderwave: ["8M"],
			triattack: ["8L45"],
			trickroom: ["8M"],
			zapcannon: ["8L60"],
		},
	},
	stantler: {
		learnset: {
			astonish: ["8L7"],
			attract: ["8M"],
			bite: ["8E"],
			bulldoze: ["8M"],
			calmmind: ["8M", "8L27"],
			chargebeam: ["8M"],
			confuseray: ["8L23"],
			disable: ["8E"],
			doubleedge: ["8L55"],
			doublekick: ["8E"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			entrainment: ["8L50"],
			extrasensory: ["8E"],
			facade: ["8M"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			hypnosis: ["8L10"],
			imprison: ["8L49"],
			irontail: ["8M"],
			leer: ["8L3"],
			lightscreen: ["8M"],
			lunge: ["8L43"],
			megahorn: ["8E"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			roleplay: ["8L33"],
			sandattack: ["8L16"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			spite: ["8E"],
			stomp: ["8L13"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L21"],
			thief: ["8M"],
			thrash: ["8E"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			trickroom: ["8M"],
			workup: ["8M"],
			zenheadbutt: ["8L38", "8E"],
		},
	},
	smeargle: {
		learnset: {
			sketch: ["8L11", "8L1", "8L21", "8L31", "8L41", "8L51", "8L61", "8L71", "8L81", "8L91"],
		},
	},
	tyrogue: {
		learnset: {
			attract: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			bulletpunch: ["8E"],
			counter: ["8E"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8L1"],
			feint: ["8E"],
			focusenergy: ["8L1"],
			helpinghand: ["8L1", "8E"],
			highjumpkick: ["8E"],
			lowsweep: ["8M"],
			machpunch: ["8E"],
			mindreader: ["8E"],
			protect: ["8M"],
			raindance: ["8M"],
			rapidspin: ["8E"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
			vacuumwave: ["8E"],
			workup: ["8M"],
		},
	},
	hitmontop: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L28"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			closecombat: ["8L36"],
			counter: ["8L40"],
			detect: ["8L12"],
			dig: ["8M", "8L32"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endeavor: ["8L44"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8L1"],
			feint: ["8L1"],
			focusblast: ["8M"],
			focusenergy: ["8L1"],
			gyroball: ["8M", "8L8"],
			helpinghand: ["8L1"],
			lowsweep: ["8M"],
			protect: ["8M"],
			quickattack: ["8L4"],
			quickguard: ["8L21"],
			raindance: ["8M"],
			rapidspin: ["8L1"],
			rest: ["8M"],
			revenge: ["8L16"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			sandstorm: ["8M"],
			sleeptalk: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L24"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
			triplekick: ["8L1"],
			wideguard: ["8L21"],
			workup: ["8M"],
		},
	},
	smoochum: {
		learnset: {
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M", "8L48"],
			calmmind: ["8M"],
			confusion: ["8L12"],
			copycat: ["8L8"],
			covet: ["8L16"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8E"],
			faketears: ["8L24"],
			flash: ["8M"],
			fling: ["8M"],
			grassknot: ["8M"],
			hail: ["8M"],
			icebeam: ["8M"],
			icepunch: ["8L28", "8E"],
			lick: ["8L1"],
			lightscreen: ["8M"],
			meanlook: ["8L40"],
			nastyplot: ["8M"],
			payback: ["8M"],
			perishsong: ["8L44"],
			pound: ["8L1"],
			powdersnow: ["8L4"],
			protect: ["8M"],
			psychic: ["8M", "8L32"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			roleplay: ["8E"],
			shadowball: ["8M"],
			sing: ["8L20"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8L36"],
			thief: ["8M"],
			trickroom: ["8M"],
			waterpulse: ["8M"],
			wish: ["8E"],
		},
	},
	elekid: {
		learnset: {
			attract: ["8M"],
			brickbreak: ["8M"],
			charge: ["8L8"],
			chargebeam: ["8M"],
			crosschop: ["8E"],
			discharge: ["8L32"],
			doubleteam: ["8M"],
			dynamicpunch: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			feint: ["8E"],
			firepunch: ["8E"],
			flash: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			hammerarm: ["8E"],
			icepunch: ["8E"],
			leer: ["8L1"],
			lightscreen: ["8M", "8L44"],
			lowkick: ["8L36"],
			protect: ["8M"],
			psychic: ["8M"],
			quickattack: ["8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			screech: ["8L24"],
			shockwave: ["8M", "8L16"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			swagger: ["8M"],
			swift: ["8L12"],
			thief: ["8M"],
			thunder: ["8M", "8L48"],
			thunderbolt: ["8M", "8L40"],
			thunderpunch: ["8L28"],
			thundershock: ["8L4"],
			thunderwave: ["8M", "8L20"],
			voltswitch: ["8M"],
		},
	},
	magby: {
		learnset: {
			attract: ["8M"],
			belch: ["8E"],
			bellydrum: ["8E"],
			brickbreak: ["8M"],
			clearsmog: ["8L12"],
			confuseray: ["8L20"],
			crosschop: ["8E"],
			doubleteam: ["8M"],
			dynamicpunch: ["8E"],
			ember: ["8L4"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M", "8L48"],
			firepunch: ["8L28"],
			flamethrower: ["8M", "8L40"],
			flamewheel: ["8L16"],
			flareblitz: ["8E"],
			fling: ["8M"],
			focusenergy: ["8E"],
			focuspunch: ["8M"],
			irontail: ["8M"],
			lavaplume: ["8L32"],
			leer: ["8L1"],
			lowkick: ["8L36"],
			machpunch: ["8E"],
			megapunch: ["8E"],
			overheat: ["8M"],
			powerswap: ["8E"],
			protect: ["8M"],
			psychic: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			scaryface: ["8L24"],
			screech: ["8E"],
			sleeptalk: ["8M"],
			smog: ["8L1"],
			smokescreen: ["8L8"],
			substitute: ["8M"],
			sunnyday: ["8M", "8L44"],
			swagger: ["8M"],
			thief: ["8M"],
			thunderpunch: ["8E"],
			willowisp: ["8M"],
		},
	},
	miltank: {
		learnset: {
			attract: ["8M"],
			belch: ["8E"],
			blizzard: ["8M"],
			bodyslam: ["8L40"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			charm: ["8L50"],
			curse: ["8E"],
			defensecurl: ["8L10"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			gyroball: ["8M"],
			hammerarm: ["8E"],
			headbutt: ["8L25"],
			healbell: ["8L20"],
			helpinghand: ["8E"],
			highhorsepower: ["8L55"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			milkdrink: ["8L35"],
			playrough: ["8L45"],
			present: ["8E"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			reversal: ["8E"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L5"],
			sandstorm: ["8M"],
			seismictoss: ["8E"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			stomp: ["8L15"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
			zenheadbutt: ["8L30"],
		},
	},
	blissey: {
		learnset: {
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			charm: ["8L1"],
			copycat: ["8L1"],
			covet: ["8L1"],
			dazzlinggleam: ["8M"],
			defensecurl: ["8L1"],
			disarmingvoice: ["8L1"],
			doubleedge: ["8L40"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			echoedvoice: ["8L8"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M", "8L20"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			hail: ["8M"],
			healingwish: ["8L52"],
			healpulse: ["8L28"],
			helpinghand: ["8L32"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lastresort: ["8L48"],
			lifedew: ["8L12"],
			lightscreen: ["8M", "8L36"],
			minimize: ["8L1"],
			pound: ["8L1"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sing: ["8L16"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			softboiled: ["8L44"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8L1"],
			tailwhip: ["8L4"],
			takedown: ["8L24"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	raikou: {
		learnset: {
			bite: ["8L12"],
			bulldoze: ["8M"],
			calmmind: ["8M", "8L18"],
			charge: ["8L1"],
			chargebeam: ["8M"],
			crunch: ["8L42"],
			cut: ["8M"],
			dig: ["8M"],
			discharge: ["8L54", "8S0"],
			doubleteam: ["8M"],
			endure: ["8M"],
			extrasensory: ["8L48", "8S0"],
			extremespeed: ["8L1"],
			facade: ["8M"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			howl: ["8L36"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			protect: ["8M"],
			psychup: ["8M"],
			quickattack: ["8L1"],
			raindance: ["8M", "8L66", "8S0"],
			reflect: ["8M", "8L60", "8S0"],
			rest: ["8M"],
			roar: ["8M", "8L24"],
			rockclimb: ["8M"],
			rocksmash: ["8M"],
			sandstorm: ["8M"],
			scald: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			spark: ["8L6"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thunder: ["8M", "8L72"],
			thunderbolt: ["8M"],
			thunderfang: ["8L30"],
			thundershock: ["8L1"],
			thunderwave: ["8M"],
			voltswitch: ["8M"],
			zapcannon: ["8L78"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, isHidden: true, moves: ['raindance', 'reflect', 'discharge', 'extrasensory']},
		],
	},
	entei: {
		learnset: {
			bite: ["8L12"],
			bulldoze: ["8M"],
			calmmind: ["8M", "8L18"],
			crunch: ["8L42"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			eruption: ["8L78"],
			extrasensory: ["8L48", "8S0"],
			extremespeed: ["8L1"],
			facade: ["8M"],
			fireblast: ["8M", "8L72"],
			firefang: ["8L30"],
			flamethrower: ["8M"],
			flamewheel: ["8L6"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			lavaplume: ["8L54", "8S0"],
			leer: ["8L1"],
			overheat: ["8M"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			roar: ["8M", "8L24"],
			rockclimb: ["8M"],
			rocksmash: ["8M"],
			sacredfire: ["8L1"],
			sandstorm: ["8M"],
			scaryface: ["8L36"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			smokescreen: ["8L1"],
			snarl: ["8M"],
			solarbeam: ["8M"],
			stomp: ["8L1"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M", "8L66", "8S0"],
			swagger: ["8M", "8L60", "8S0"],
			willowisp: ["8M"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, isHidden: true, moves: ['sunnyday', 'swagger', 'lavaplume', 'extrasensory']},
		],
	},
	suicune: {
		learnset: {
			avalanche: ["8M"],
			bite: ["8L12"],
			blizzard: ["8M", "8L78"],
			brine: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M", "8L18"],
			crunch: ["8L42"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			extrasensory: ["8L48", "8S0"],
			extremespeed: ["8L1"],
			facade: ["8M"],
			gigaimpact: ["8M"],
			gust: ["8L1"],
			hail: ["8M"],
			hydropump: ["8L72"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			icefang: ["8L30"],
			irontail: ["8M"],
			leer: ["8L1"],
			mirrorcoat: ["8L60", "8S0"],
			mist: ["8L1"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M", "8L66", "8S0"],
			reflect: ["8M"],
			rest: ["8M"],
			roar: ["8M", "8L24"],
			rockclimb: ["8M"],
			rocksmash: ["8M"],
			sandstorm: ["8M"],
			scald: ["8M"],
			shadowball: ["8M"],
			sheercold: ["8L1"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M", "8L54", "8S0"],
			swagger: ["8M"],
			tailwind: ["8L36"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L6"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, isHidden: true, moves: ['raindance', 'mirrorcoat', 'surf', 'extrasensory']},
		],
	},
	larvitar: {
		learnset: {
			ancientpower: ["8E"],
			assurance: ["8E"],
			attract: ["8M"],
			bite: ["8L9"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			crunch: ["8L27"],
			curse: ["8E"],
			darkpulse: ["8M", "8L24"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragondance: ["8E"],
			earthquake: ["8M", "8L31"],
			endure: ["8M"],
			facade: ["8M"],
			focusenergy: ["8E"],
			hyperbeam: ["8M", "8L42"],
			irondefense: ["8E"],
			ironhead: ["8E"],
			irontail: ["8M"],
			leer: ["8L1"],
			outrage: ["8E"],
			payback: ["8M", "8L6"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M", "8L15"],
			rocksmash: ["8M"],
			rockthrow: ["8L3"],
			rocktomb: ["8M"],
			sandstorm: ["8M", "8L39"],
			scaryface: ["8L12"],
			screech: ["8L21"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			stealthrock: ["8M"],
			stomp: ["8E"],
			stompingtantrum: ["8L18"],
			stoneedge: ["8M", "8L33"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			taunt: ["8M"],
			thrash: ["8L36"],
			torment: ["8M"],
		},
	},
	pupitar: {
		learnset: {
			attract: ["8M"],
			bite: ["8L9"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			crunch: ["8L27"],
			darkpulse: ["8M", "8L24"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L33"],
			endure: ["8M"],
			facade: ["8M"],
			hyperbeam: ["8M", "8L52"],
			irondefense: ["8L1"],
			irontail: ["8M"],
			leer: ["8L1"],
			payback: ["8M", "8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M", "8L15"],
			rocksmash: ["8M"],
			rockthrow: ["8L1"],
			rocktomb: ["8M"],
			sandstorm: ["8M", "8L47"],
			scaryface: ["8L12"],
			screech: ["8L21"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			stealthrock: ["8M"],
			stompingtantrum: ["8L18"],
			stoneedge: ["8M", "8L37"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			taunt: ["8M"],
			thrash: ["8L42"],
			torment: ["8M"],
		},
	},
	tyranitar: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			avalanche: ["8M"],
			bite: ["8L9"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			crunch: ["8L27"],
			cut: ["8M"],
			darkpulse: ["8M", "8L24"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonclaw: ["8M"],
			dragonpulse: ["8M"],
			earthquake: ["8M", "8L33"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			firefang: ["8L1"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M", "8L59"],
			hyperbeam: ["8M", "8L52"],
			icebeam: ["8M"],
			icefang: ["8L1"],
			irondefense: ["8L1"],
			irontail: ["8M"],
			leer: ["8L1"],
			payback: ["8M", "8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M", "8L15"],
			rocksmash: ["8M"],
			rockthrow: ["8L1"],
			rocktomb: ["8M"],
			sandstorm: ["8M", "8L47"],
			scaryface: ["8L12"],
			screech: ["8L21"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			stealthrock: ["8M"],
			stompingtantrum: ["8L18"],
			stoneedge: ["8M", "8L37"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			taunt: ["8M"],
			thrash: ["8L42"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderfang: ["8L1"],
			thunderwave: ["8M"],
			torment: ["8M"],
			waterpulse: ["8M"],
		},
	},
	lugia: {
		learnset: {
			aerialace: ["8M"],
			aeroblast: ["8L54", "8S0"],
			ancientpower: ["8L1"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brine: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M", "8L27"],
			chargebeam: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			dragonpulse: ["8M"],
			dragonrush: ["8L1"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			extrasensory: ["8L36", "8S0"],
			facade: ["8M"],
			flash: ["8M"],
			fly: ["8M"],
			futuresight: ["8L81"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			gust: ["8L1"],
			hail: ["8M"],
			hydropump: ["8L72"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			mist: ["8L9"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M", "8L63", "8S0"],
			recover: ["8L45", "8S0"],
			reflect: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			roost: ["8M"],
			safeguard: ["8M", "8L18"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			skyattack: ["8L90"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterfall: ["8M"],
			waterpulse: ["8M"],
			weatherball: ["8L1"],
			whirlwind: ["8L1"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, isHidden: true, moves: ['raindance', 'aeroblast', 'recover', 'extrasensory']},
		],
	},
	hooh: {
		learnset: {
			aerialace: ["8M"],
			ancientpower: ["8L1"],
			bulldoze: ["8M"],
			burnup: ["8L99"],
			calmmind: ["8M", "8L27"],
			chargebeam: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			extrasensory: ["8L36", "8S0"],
			facade: ["8M"],
			fireblast: ["8M", "8L72"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fly: ["8M"],
			futuresight: ["8L81"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			gust: ["8L1"],
			hyperbeam: ["8M"],
			lifedew: ["8L9"],
			lightscreen: ["8M"],
			overheat: ["8M"],
			pluck: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recover: ["8L45", "8S0"],
			reflect: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			roost: ["8M"],
			sacredfire: ["8L54", "8S0"],
			safeguard: ["8M", "8L18"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skyattack: ["8L90"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			steelwing: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M", "8L63", "8S0"],
			swagger: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			weatherball: ["8L1"],
			whirlwind: ["8L1"],
			willowisp: ["8M"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, isHidden: true, moves: ['sunnyday', 'sacredfire', 'recover', 'extrasensory']},
		],
	},
	celebi: {
		learnset: {
			aerialace: ["8M"],
			ancientpower: ["8L30"],
			batonpass: ["8L20"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confusion: ["8L1"],
			cut: ["8M"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			futuresight: ["8L70"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			healbell: ["8L1"],
			healingwish: ["8L80"],
			hyperbeam: ["8M"],
			leafstorm: ["8L90"],
			leechseed: ["8L50"],
			lifedew: ["8L40"],
			lightscreen: ["8M"],
			magicalleaf: ["8L10"],
			nastyplot: ["8M"],
			perishsong: ["8L100"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recover: ["8L60"],
			reflect: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			thunderwave: ["8M"],
			trickroom: ["8M"],
			uturn: ["8M"],
			waterpulse: ["8M"],
		},
	},
	treecko: {
		learnset: {
			absorb: ["8E"],
			aerialace: ["8M"],
			assurance: ["8L18"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulletseed: ["8M"],
			crunch: ["8E"],
			crushclaw: ["8E"],
			cut: ["8M"],
			detect: ["8L12"],
			dig: ["8M"],
			doublekick: ["8E"],
			doubleteam: ["8M", "8L27"],
			dragonbreath: ["8E"],
			drainpunch: ["8M"],
			endeavor: ["8L36", "8E"],
			endure: ["8M"],
			energyball: ["8M", "8L30"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			gigadrain: ["8M", "8L21"],
			grassknot: ["8M"],
			grassyterrain: ["8E"],
			irontail: ["8M"],
			leafage: ["8L3"],
			leafstorm: ["8L39", "8E"],
			leechseed: ["8E"],
			leer: ["8L1"],
			magicalleaf: ["8E"],
			megadrain: ["8L9"],
			nightslash: ["8E"],
			pound: ["8L1"],
			protect: ["8M"],
			quickattack: ["8L6"],
			quickguard: ["8L15"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			screech: ["8L33"],
			slam: ["8L24"],
			slash: ["8E"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			synthesis: ["8E"],
			workup: ["8M"],
			worryseed: ["8E"],
		},
	},
	grovyle: {
		learnset: {
			aerialace: ["8M"],
			assurance: ["8L20"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulletseed: ["8M"],
			cut: ["8M"],
			detect: ["8L12"],
			dig: ["8M"],
			doubleteam: ["8M", "8L35"],
			drainpunch: ["8M"],
			endeavor: ["8L50"],
			endure: ["8M"],
			energyball: ["8M", "8L1"],
			facade: ["8M"],
			falseswipe: ["8M", "8L1"],
			flash: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			furycutter: ["8L1"],
			gigadrain: ["8M", "8L25"],
			grassknot: ["8M"],
			irontail: ["8M"],
			leafage: ["8L1"],
			leafblade: ["8L40"],
			leafstorm: ["8L55"],
			leer: ["8L1"],
			lowsweep: ["8M"],
			megadrain: ["8L9"],
			pound: ["8L1"],
			protect: ["8M"],
			quickattack: ["8L1"],
			quickguard: ["8L15"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			screech: ["8L45"],
			slam: ["8L30"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			workup: ["8M"],
			xscissor: ["8M", "8L1"],
		},
	},
	sceptile: {
		learnset: {
			aerialace: ["8M"],
			assurance: ["8L20"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			bulletseed: ["8M"],
			cut: ["8M"],
			detect: ["8L12"],
			dig: ["8M"],
			doubleteam: ["8M", "8L35"],
			dragonclaw: ["8M"],
			dragonpulse: ["8M"],
			drainpunch: ["8M"],
			dualchop: ["8L1"],
			earthquake: ["8M"],
			endeavor: ["8L56"],
			endure: ["8M"],
			energyball: ["8M", "8L1"],
			facade: ["8M"],
			falseswipe: ["8M", "8L1"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			frenzyplant: ["8T"],
			furycutter: ["8L1"],
			gigadrain: ["8M", "8L25"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			leafage: ["8L1"],
			leafblade: ["8L42"],
			leafstorm: ["8L63"],
			leer: ["8L1"],
			lowsweep: ["8M"],
			megadrain: ["8L5"],
			pound: ["8L1"],
			protect: ["8M"],
			quickattack: ["8L1"],
			quickguard: ["8L15"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			screech: ["8L49"],
			slam: ["8L30"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			workup: ["8M"],
			xscissor: ["8M", "8L1"],
		},
	},
	torchic: {
		learnset: {
			aerialace: ["8M", "8L18"],
			agility: ["8E"],
			attract: ["8M"],
			batonpass: ["8E"],
			bounce: ["8L24"],
			counter: ["8E"],
			crushclaw: ["8E"],
			curse: ["8E"],
			cut: ["8M"],
			detect: ["8L12"],
			dig: ["8M"],
			doubleteam: ["8M"],
			ember: ["8L3"],
			endure: ["8M"],
			facade: ["8M"],
			featherdance: ["8L33", "8E"],
			feint: ["8E"],
			fireblast: ["8M"],
			flamecharge: ["8L9"],
			flamethrower: ["8M", "8L30"],
			flareblitz: ["8L39"],
			focusenergy: ["8L27"],
			growl: ["8L1"],
			lastresort: ["8E"],
			lowkick: ["8E"],
			nightslash: ["8E"],
			overheat: ["8M"],
			peck: ["8E"],
			protect: ["8M"],
			quickattack: ["8L6"],
			rest: ["8M"],
			reversal: ["8L36", "8E"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandattack: ["8L15"],
			scratch: ["8L1"],
			shadowclaw: ["8M"],
			slash: ["8L21"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			willowisp: ["8M"],
			workup: ["8M"],
		},
	},
	combusken: {
		learnset: {
			aerialace: ["8M", "8L20"],
			attract: ["8M"],
			blazekick: ["8L40"],
			bounce: ["8L30"],
			brickbreak: ["8M"],
			bulkup: ["8M", "8L45"],
			cut: ["8M"],
			detect: ["8L12"],
			dig: ["8M"],
			doublekick: ["8L1"],
			doubleteam: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			featherdance: ["8L1"],
			fireblast: ["8M"],
			flamecharge: ["8L9"],
			flamethrower: ["8M", "8L1"],
			flareblitz: ["8L55"],
			fling: ["8M"],
			focusblast: ["8M"],
			focusenergy: ["8L35"],
			focuspunch: ["8M"],
			growl: ["8L1"],
			lowsweep: ["8M"],
			overheat: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			quickattack: ["8L1"],
			rest: ["8M"],
			reversal: ["8L50"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandattack: ["8L15"],
			scratch: ["8L1"],
			shadowclaw: ["8M"],
			slash: ["8L25"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			willowisp: ["8M"],
			workup: ["8M"],
		},
	},
	blaziken: {
		learnset: {
			aerialace: ["8M", "8L20"],
			attract: ["8M"],
			blastburn: ["8T"],
			blazekick: ["8L42"],
			bounce: ["8L30"],
			bravebird: ["8L1"],
			brickbreak: ["8M"],
			bulkup: ["8M", "8L49"],
			bulldoze: ["8M"],
			closecombat: ["8L1"],
			cut: ["8M"],
			detect: ["8L12"],
			dig: ["8M"],
			doublekick: ["8L1"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			featherdance: ["8L1"],
			fireblast: ["8M"],
			firepunch: ["8L1"],
			flamecharge: ["8L9"],
			flamethrower: ["8M", "8L1"],
			flareblitz: ["8L63"],
			fling: ["8M"],
			focusblast: ["8M"],
			focusenergy: ["8L35"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hyperbeam: ["8M"],
			lowsweep: ["8M"],
			overheat: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			quickattack: ["8L1"],
			rest: ["8M"],
			reversal: ["8L56"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandattack: ["8L15"],
			scratch: ["8L1"],
			shadowclaw: ["8M"],
			slash: ["8L25"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			uturn: ["8M"],
			willowisp: ["8M"],
			workup: ["8M"],
		},
	},
	mudkip: {
		learnset: {
			amnesia: ["8L27"],
			ancientpower: ["8E"],
			attract: ["8M"],
			avalanche: ["8M"],
			bite: ["8E"],
			blizzard: ["8M"],
			counter: ["8E"],
			curse: ["8E"],
			dig: ["8M"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			endeavor: ["8L36"],
			endure: ["8M"],
			facade: ["8M"],
			growl: ["8L1"],
			hail: ["8M"],
			hydropump: ["8L39"],
			icebeam: ["8M"],
			irontail: ["8M"],
			mirrorcoat: ["8E"],
			mudslap: ["8E"],
			protect: ["8M", "8L12"],
			raindance: ["8M"],
			rest: ["8M"],
			rockslide: ["8M", "8L21"],
			rocksmash: ["8M", "8L6"],
			rockthrow: ["8L9"],
			rocktomb: ["8M"],
			scald: ["8M"],
			screech: ["8L33"],
			sleeptalk: ["8M"],
			sludge: ["8E"],
			stomp: ["8E"],
			strength: ["8M"],
			substitute: ["8M"],
			supersonic: ["8L15"],
			surf: ["8M", "8L30"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L24"],
			uproar: ["8E"],
			waterfall: ["8M"],
			watergun: ["8L3"],
			waterpulse: ["8M", "8L18"],
			whirlpool: ["8E"],
			wideguard: ["8E"],
			workup: ["8M"],
			yawn: ["8E"],
		},
	},
	marshtomp: {
		learnset: {
			amnesia: ["8L35"],
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L1"],
			endeavor: ["8L50"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			growl: ["8L1"],
			hail: ["8M"],
			hydropump: ["8L55"],
			icebeam: ["8M"],
			irontail: ["8M"],
			muddywater: ["8L40"],
			mudshot: ["8L1"],
			protect: ["8M", "8L12"],
			raindance: ["8M"],
			rest: ["8M"],
			rockslide: ["8M", "8L25"],
			rocksmash: ["8M", "8L1"],
			rockthrow: ["8L9"],
			rocktomb: ["8M"],
			scald: ["8M"],
			screech: ["8L45"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			supersonic: ["8L15"],
			surf: ["8M", "8L1"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L30"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L20"],
			workup: ["8M"],
		},
	},
	swampert: {
		learnset: {
			amnesia: ["8L35"],
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L1"],
			endeavor: ["8L56"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hail: ["8M"],
			hammerarm: ["8L1"],
			hydrocannon: ["8T"],
			hydropump: ["8L63"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			muddywater: ["8L42"],
			mudshot: ["8L1"],
			protect: ["8M", "8L12"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M", "8L25"],
			rocksmash: ["8M", "8L1"],
			rockthrow: ["8L9"],
			rocktomb: ["8M"],
			scald: ["8M"],
			screech: ["8L49"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			supersonic: ["8L15"],
			surf: ["8M", "8L1"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L30"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L20"],
			workup: ["8M"],
		},
	},
	poochyena: {
		learnset: {
			assurance: ["8L22"],
			astonish: ["8E"],
			attract: ["8M"],
			bite: ["8L10"],
			covet: ["8E"],
			crunch: ["8L34"],
			darkpulse: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			firefang: ["8E"],
			headbutt: ["8L28"],
			howl: ["8L4"],
			icefang: ["8E"],
			irontail: ["8M"],
			leer: ["8E"],
			mudslap: ["8L13"],
			nastyplot: ["8M"],
			payback: ["8M"],
			playrough: ["8L46", "8E"],
			poisonfang: ["8E"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M", "8L16"],
			rocksmash: ["8M"],
			sandattack: ["8L7"],
			scaryface: ["8L25"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L43", "8E"],
			sunnyday: ["8M"],
			swagger: ["8M", "8L19"],
			tackle: ["8L1"],
			takedown: ["8L40"],
			taunt: ["8M", "8L31"],
			thief: ["8M"],
			thunderfang: ["8E"],
			torment: ["8M"],
			yawn: ["8L37", "8E"],
		},
	},
	mightyena: {
		learnset: {
			assurance: ["8L24"],
			attract: ["8M"],
			bite: ["8L10", "8L1"],
			crunch: ["8L40", "8L1"],
			darkpulse: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			firefang: ["8L1"],
			gigaimpact: ["8M"],
			headbutt: ["8L32"],
			howl: ["8L4", "8L1"],
			hyperbeam: ["8M"],
			icefang: ["8L1"],
			irontail: ["8M"],
			mudslap: ["8L13"],
			nastyplot: ["8M"],
			payback: ["8M"],
			playrough: ["8L56"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M", "8L16"],
			rocksmash: ["8M"],
			sandattack: ["8L7", "8L1"],
			scaryface: ["8L28"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			snarl: ["8M", "8L1"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L52"],
			sunnyday: ["8M"],
			swagger: ["8M", "8L20"],
			tackle: ["8L1"],
			takedown: ["8L48"],
			taunt: ["8M", "8L36"],
			thief: ["8M", "8L1"],
			thunderfang: ["8L1"],
			torment: ["8M"],
			yawn: ["8L44"],
		},
	},
	zigzagoon: {
		learnset: {
			attract: ["8M"],
			babydolleyes: ["8L15"],
			bellydrum: ["8L33"],
			blizzard: ["8M"],
			chargebeam: ["8M"],
			charm: ["8E"],
			covet: ["8L9"],
			cut: ["8M"],
			dig: ["8M"],
			doubleedge: ["8L36"],
			doubleteam: ["8M"],
			endure: ["8M"],
			extremespeed: ["8E"],
			facade: ["8M"],
			flail: ["8L30"],
			fling: ["8M", "8L27"],
			grassknot: ["8M"],
			growl: ["8L1"],
			headbutt: ["8L12"],
			helpinghand: ["8E"],
			icebeam: ["8M"],
			irontail: ["8M"],
			mudslap: ["8E"],
			pinmissile: ["8L18"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L21"],
			rocksmash: ["8M"],
			sandattack: ["8L3"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			simplebeam: ["8E"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailwhip: ["8L6"],
			takedown: ["8L24"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			tickle: ["8E"],
			trick: ["8E"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	linoone: {
		learnset: {
			attract: ["8M"],
			babydolleyes: ["8L1"],
			bellydrum: ["8L43"],
			blizzard: ["8M"],
			chargebeam: ["8M"],
			covet: ["8L9"],
			cut: ["8M"],
			dig: ["8M"],
			doubleedge: ["8L48"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flail: ["8L38"],
			fling: ["8M", "8L33"],
			furyswipes: ["8L18"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			headbutt: ["8L12"],
			honeclaws: ["8L15"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			pinmissile: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L23"],
			roar: ["8M"],
			rocksmash: ["8M"],
			sandattack: ["8L1"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			slash: ["8L1"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			switcheroo: ["8L1"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			takedown: ["8L28"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	wurmple: {
		learnset: {
			bugbite: ["8L15"],
			poisonsting: ["8L5"],
			stringshot: ["8L1"],
			tackle: ["8L1"],
		},
	},
	silcoon: {
		learnset: {
			harden: ["8L1"],
		},
	},
	beautifly: {
		learnset: {
			absorb: ["8L12"],
			aerialace: ["8M"],
			aircutter: ["8L20"],
			attract: ["8M", "8L27"],
			bugbite: ["8L1"],
			bugbuzz: ["8M", "8L35"],
			defog: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M", "8L32"],
			gigaimpact: ["8M"],
			gust: ["8L1"],
			harden: ["8L1"],
			hyperbeam: ["8M"],
			leechlife: ["8L25"],
			megadrain: ["8L22"],
			morningsun: ["8L17"],
			poisonsting: ["8L1"],
			protect: ["8M", "8L37"],
			psychic: ["8M"],
			quiverdance: ["8L40"],
			rest: ["8M"],
			roost: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stringshot: ["8L1"],
			stunspore: ["8L15"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
			uturn: ["8M"],
			whirlwind: ["8L30"],
		},
	},
	cascoon: {
		learnset: {
			harden: ["8L1"],
		},
	},
	dustox: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			bugbite: ["8L1"],
			bugbuzz: ["8M", "8L35"],
			confusion: ["8L12"],
			defog: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			gust: ["8L1"],
			harden: ["8L1"],
			hyperbeam: ["8M"],
			leechlife: ["8L25"],
			lightscreen: ["8M", "8L27"],
			moonlight: ["8L17"],
			poisonpowder: ["8L15"],
			poisonsting: ["8L1"],
			protect: ["8M", "8L37"],
			psybeam: ["8L22"],
			psychic: ["8M"],
			quiverdance: ["8L40"],
			rest: ["8M"],
			roost: ["8M"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			stringshot: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
			toxic: ["8M", "8L32"],
			uturn: ["8M"],
			venoshock: ["8L20"],
			whirlwind: ["8L30"],
		},
	},
	lotad: {
		learnset: {
			absorb: ["8L3"],
			astonish: ["8L1"],
			attract: ["8M"],
			blizzard: ["8M"],
			bubblebeam: ["8L20"],
			bulletseed: ["8M"],
			counter: ["8E"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M", "8L43"],
			facade: ["8M"],
			flail: ["8L16", "8E"],
			flash: ["8M"],
			gigadrain: ["8M", "8L28"],
			grassknot: ["8M"],
			growl: ["8L1"],
			hail: ["8M"],
			icebeam: ["8M"],
			leechseed: ["8E"],
			megadrain: ["8L12"],
			mist: ["8L9"],
			naturepower: ["8L24"],
			protect: ["8M"],
			raindance: ["8M", "8L33"],
			razorleaf: ["8E"],
			rest: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8E"],
			swordsdance: ["8M"],
			synthesis: ["8E"],
			teeterdance: ["8E"],
			thief: ["8M"],
			tickle: ["8E"],
			watergun: ["8L6", "8E"],
			waterpulse: ["8M"],
			zenheadbutt: ["8L38"],
		},
	},
	lombre: {
		learnset: {
			absorb: ["8L1"],
			astonish: ["8L1"],
			attract: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bubblebeam: ["8L24"],
			bulletseed: ["8M"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			endure: ["8M"],
			energyball: ["8M", "8L57"],
			facade: ["8M"],
			fakeout: ["8L1"],
			flail: ["8L1"],
			flash: ["8M"],
			fling: ["8M"],
			furyswipes: ["8L18"],
			gigadrain: ["8M", "8L36"],
			grassknot: ["8M"],
			growl: ["8L1"],
			hail: ["8M"],
			hydropump: ["8L64"],
			icebeam: ["8M"],
			knockoff: ["8L1"],
			megadrain: ["8L12"],
			mist: ["8L9"],
			naturepower: ["8L30"],
			protect: ["8M"],
			raindance: ["8M", "8L43"],
			rest: ["8M"],
			rocksmash: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			teeterdance: ["8L1"],
			thief: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			zenheadbutt: ["8L50"],
		},
	},
	ludicolo: {
		learnset: {
			absorb: ["8L1"],
			astonish: ["8L1"],
			attract: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bubblebeam: ["8L1"],
			bulletseed: ["8M"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			endure: ["8M"],
			energyball: ["8M", "8L1"],
			facade: ["8M"],
			fakeout: ["8L1"],
			flail: ["8L1"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			furyswipes: ["8L1"],
			gigadrain: ["8M", "8L1"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			hail: ["8M"],
			hydropump: ["8L1"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			knockoff: ["8L1"],
			megadrain: ["8L1"],
			mist: ["8L1"],
			naturepower: ["8L1"],
			protect: ["8M"],
			raindance: ["8M", "8L1"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rocksmash: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			teeterdance: ["8L1"],
			thief: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			zenheadbutt: ["8L1"],
		},
	},
	seedot: {
		learnset: {
			absorb: ["8L3"],
			amnesia: ["8E"],
			astonish: ["8L6"],
			attract: ["8M"],
			beatup: ["8E"],
			bulletseed: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			explosion: ["8M", "8L33"],
			facade: ["8M"],
			falseswipe: ["8M"],
			flash: ["8M"],
			foulplay: ["8E"],
			gigadrain: ["8M"],
			grassknot: ["8M"],
			grassyterrain: ["8E"],
			growth: ["8L9"],
			harden: ["8L1"],
			leechseed: ["8E"],
			megadrain: ["8L15"],
			nastyplot: ["8M"],
			naturepower: ["8L21"],
			nightslash: ["8E"],
			payback: ["8M", "8L18"],
			powerswap: ["8E"],
			protect: ["8M"],
			quickattack: ["8E"],
			rest: ["8M"],
			rocksmash: ["8M"],
			rollout: ["8L12"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L30"],
			sunnyday: ["8M", "8L24"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			synthesis: ["8L27"],
			tackle: ["8L1"],
			takedown: ["8E"],
			worryseed: ["8E"],
		},
	},
	nuzleaf: {
		learnset: {
			absorb: ["8L1"],
			aircutter: ["8L1"],
			astonish: ["8L1"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulletseed: ["8M"],
			cut: ["8M"],
			darkpulse: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			explosion: ["8M", "8L1"],
			extrasensory: ["8L43"],
			facade: ["8M"],
			fakeout: ["8L1"],
			falseswipe: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			gigadrain: ["8M"],
			grassknot: ["8M"],
			growth: ["8L9"],
			harden: ["8L1"],
			hyperbeam: ["8M"],
			leafblade: ["8L57"],
			lowsweep: ["8M"],
			megadrain: ["8L18"],
			nastyplot: ["8M"],
			naturepower: ["8L30"],
			payback: ["8M", "8L24"],
			protect: ["8M"],
			psychup: ["8M"],
			razorleaf: ["8L1"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L12"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L50"],
			sunnyday: ["8M", "8L36"],
			swagger: ["8M", "8L1"],
			swordsdance: ["8M"],
			synthesis: ["8L1"],
			tackle: ["8L1"],
			thief: ["8M"],
			torment: ["8M", "8L1"],
		},
	},
	shiftry: {
		learnset: {
			absorb: ["8L1"],
			aerialace: ["8M"],
			aircutter: ["8L1"],
			astonish: ["8L1"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulletseed: ["8M"],
			cut: ["8M"],
			darkpulse: ["8M"],
			defog: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			explosion: ["8M", "8L1"],
			extrasensory: ["8L1"],
			facade: ["8M"],
			fakeout: ["8L1"],
			falseswipe: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growth: ["8L1"],
			harden: ["8L1"],
			hurricane: ["8L1"],
			hyperbeam: ["8M"],
			leafblade: ["8L1"],
			leaftornado: ["8L1"],
			lowsweep: ["8M"],
			megadrain: ["8L1"],
			nastyplot: ["8M"],
			naturepower: ["8L1"],
			payback: ["8M", "8L1"],
			protect: ["8M"],
			psychup: ["8M"],
			razorleaf: ["8L1"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L1"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L1"],
			sunnyday: ["8M", "8L1"],
			swagger: ["8M", "8L1"],
			swordsdance: ["8M"],
			synthesis: ["8L1"],
			tackle: ["8L1"],
			thief: ["8M"],
			torment: ["8M", "8L1"],
			whirlwind: ["8L1"],
			xscissor: ["8M"],
		},
	},
	taillow: {
		learnset: {
			aerialace: ["8M", "8L21"],
			agility: ["8L29"],
			airslash: ["8L33"],
			attract: ["8M"],
			boomburst: ["8E"],
			bravebird: ["8L41", "8E"],
			defog: ["8M"],
			doubleteam: ["8M", "8L17"],
			endeavor: ["8L37"],
			endure: ["8M"],
			facade: ["8M"],
			fly: ["8M"],
			focusenergy: ["8L5"],
			growl: ["8L1"],
			hurricane: ["8E"],
			peck: ["8L1"],
			pluck: ["8M"],
			protect: ["8M"],
			quickattack: ["8L9"],
			quickguard: ["8L25"],
			raindance: ["8M"],
			rest: ["8M"],
			reversal: ["8L45"],
			roost: ["8M"],
			skyattack: ["8E"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8E"],
			swagger: ["8M"],
			thief: ["8M"],
			uturn: ["8M"],
			whirlwind: ["8E"],
			wingattack: ["8L13"],
			workup: ["8M"],
		},
	},
	swellow: {
		learnset: {
			aerialace: ["8M", "8L21"],
			agility: ["8L33"],
			airslash: ["8L39", "8L1"],
			attract: ["8M"],
			bravebird: ["8L51", "8L1"],
			defog: ["8M"],
			doubleteam: ["8M", "8L17"],
			endeavor: ["8L45"],
			endure: ["8M"],
			facade: ["8M"],
			fly: ["8M"],
			focusenergy: ["8L5", "8L1"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hyperbeam: ["8M"],
			peck: ["8L1"],
			pluck: ["8M", "8L1"],
			protect: ["8M"],
			quickattack: ["8L9", "8L1"],
			quickguard: ["8L27"],
			raindance: ["8M"],
			rest: ["8M"],
			reversal: ["8L57"],
			roost: ["8M"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thief: ["8M"],
			uturn: ["8M"],
			wingattack: ["8L13"],
			workup: ["8M"],
		},
	},
	wingull: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L26", "8E"],
			aircutter: ["8E"],
			airslash: ["8L30"],
			aquaring: ["8E"],
			attract: ["8M"],
			blizzard: ["8M"],
			brine: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fly: ["8M"],
			growl: ["8L1"],
			gust: ["8E"],
			hail: ["8M"],
			hurricane: ["8L45"],
			icebeam: ["8M"],
			knockoff: ["8E"],
			mist: ["8L35", "8E"],
			pluck: ["8M"],
			protect: ["8M"],
			quickattack: ["8L5"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M", "8L40"],
			scald: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			soak: ["8E"],
			steelwing: ["8M"],
			substitute: ["8M"],
			supersonic: ["8L10"],
			swagger: ["8M"],
			thief: ["8M"],
			twister: ["8E"],
			uturn: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L20"],
			wideguard: ["8E"],
			wingattack: ["8L15"],
		},
	},
	pelipper: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L1"],
			airslash: ["8L1"],
			attract: ["8M"],
			blizzard: ["8M"],
			brine: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M", "8L34"],
			fly: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hail: ["8M"],
			hurricane: ["8L55"],
			hydropump: ["8L62"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			mist: ["8L41"],
			payback: ["8M"],
			pluck: ["8M"],
			protect: ["8M", "8L1"],
			quickattack: ["8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M", "8L48"],
			scald: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			soak: ["8L1"],
			spitup: ["8L28"],
			steelwing: ["8M"],
			stockpile: ["8L28"],
			substitute: ["8M"],
			supersonic: ["8L1"],
			surf: ["8M"],
			swagger: ["8M"],
			swallow: ["8L28"],
			tailwind: ["8L1"],
			thief: ["8M"],
			uturn: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L20"],
			wingattack: ["8L15"],
		},
	},
	ralts: {
		learnset: {
			allyswitch: ["8E"],
			attract: ["8M"],
			calmmind: ["8M", "8L27"],
			chargebeam: ["8M"],
			charm: ["8L24"],
			confuseray: ["8E"],
			confusion: ["8L6"],
			dazzlinggleam: ["8M"],
			destinybond: ["8E"],
			disable: ["8E"],
			disarmingvoice: ["8L1"],
			doubleteam: ["8M", "8L3"],
			drainingkiss: ["8L12"],
			dreameater: ["8M", "8L36"],
			encore: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			futuresight: ["8L39"],
			grassknot: ["8M"],
			growl: ["8L1"],
			grudge: ["8E"],
			healpulse: ["8L33"],
			hypnosis: ["8L9"],
			knockoff: ["8E"],
			lifedew: ["8L21"],
			lightscreen: ["8M"],
			meanlook: ["8E"],
			memento: ["8E"],
			mistyterrain: ["8E"],
			protect: ["8M"],
			psybeam: ["8L18"],
			psychic: ["8M", "8L30"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shadowsneak: ["8E"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			teleport: ["8L15"],
			thief: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
			willowisp: ["8M"],
		},
	},
	kirlia: {
		learnset: {
			attract: ["8M"],
			calmmind: ["8M", "8L33"],
			chargebeam: ["8M"],
			charm: ["8L28"],
			confusion: ["8L1"],
			dazzlinggleam: ["8M"],
			disarmingvoice: ["8L1"],
			doubleteam: ["8M", "8L1"],
			drainingkiss: ["8L12"],
			dreameater: ["8M", "8L48"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			futuresight: ["8L53"],
			grassknot: ["8M"],
			growl: ["8L1"],
			healpulse: ["8L43"],
			hypnosis: ["8L9"],
			lifedew: ["8L23"],
			lightscreen: ["8M"],
			protect: ["8M"],
			psybeam: ["8L18"],
			psychic: ["8M", "8L38"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			teleport: ["8L15"],
			thief: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
			willowisp: ["8M"],
		},
	},
	gardevoir: {
		learnset: {
			attract: ["8M"],
			calmmind: ["8M", "8L35"],
			chargebeam: ["8M"],
			charm: ["8L1"],
			confusion: ["8L1"],
			dazzlinggleam: ["8M", "8L1"],
			disarmingvoice: ["8L1"],
			doubleteam: ["8M", "8L1"],
			drainingkiss: ["8L12"],
			dreameater: ["8M", "8L56"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			futuresight: ["8L63"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			healingwish: ["8L1"],
			healpulse: ["8L49"],
			hyperbeam: ["8M"],
			hypnosis: ["8L9"],
			lifedew: ["8L23"],
			lightscreen: ["8M"],
			mistyterrain: ["8L1"],
			moonblast: ["8L1"],
			protect: ["8M"],
			psybeam: ["8L18"],
			psychic: ["8M", "8L42"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			teleport: ["8L15"],
			thief: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
			willowisp: ["8M"],
			wish: ["8L28"],
		},
	},
	surskit: {
		learnset: {
			agility: ["8L22"],
			aquajet: ["8L30", "8E"],
			attract: ["8M"],
			batonpass: ["8L35"],
			blizzard: ["8M"],
			bubblebeam: ["8L17"],
			bugbite: ["8E"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fellstinger: ["8E"],
			flash: ["8M"],
			gigadrain: ["8M"],
			haze: ["8L25"],
			hydropump: ["8E"],
			icebeam: ["8M"],
			lunge: ["8E"],
			mindreader: ["8E"],
			mist: ["8L25"],
			mudshot: ["8E"],
			powersplit: ["8E"],
			protect: ["8M"],
			psybeam: ["8E"],
			psychup: ["8M"],
			quickattack: ["8L6"],
			raindance: ["8M"],
			rest: ["8M"],
			scald: ["8M"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			soak: ["8L14"],
			solarbeam: ["8M"],
			stickyweb: ["8L38"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L9"],
			thief: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
		},
	},
	masquerain: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L1"],
			aircutter: ["8L22"],
			airslash: ["8L38"],
			aquajet: ["8L1"],
			attract: ["8M"],
			batonpass: ["8L1"],
			blizzard: ["8M"],
			bubblebeam: ["8L1"],
			bugbuzz: ["8M", "8L42", "8L1"],
			defog: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			gust: ["8L17"],
			haze: ["8L1"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			mist: ["8L1"],
			protect: ["8M"],
			psychup: ["8M"],
			quickattack: ["8L6", "8L1"],
			quiverdance: ["8L52", "8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M"],
			scald: ["8M"],
			scaryface: ["8L22"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			soak: ["8L14"],
			solarbeam: ["8M"],
			stickyweb: ["8L1"],
			stunspore: ["8L26"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L32"],
			swagger: ["8M"],
			sweetscent: ["8L9", "8L1"],
			thief: ["8M"],
			uturn: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			whirlwind: ["8L48", "8L1"],
		},
	},
	shroomish: {
		learnset: {
			absorb: ["8L1"],
			attract: ["8M"],
			bulletseed: ["8M"],
			charm: ["8E"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			faketears: ["8E"],
			falseswipe: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M", "8L26"],
			grassknot: ["8M"],
			growth: ["8L29"],
			headbutt: ["8L15"],
			helpinghand: ["8E"],
			leechseed: ["8L8"],
			megadrain: ["8L12"],
			poisonpowder: ["8L19"],
			protect: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			seedbomb: ["8L36", "8E"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			spore: ["8L40"],
			stunspore: ["8L5"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			toxic: ["8M", "8L33"],
			worryseed: ["8L22", "8E"],
		},
	},
	breloom: {
		learnset: {
			absorb: ["8L1"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulletseed: ["8M"],
			counter: ["8L22"],
			cut: ["8M"],
			doubleteam: ["8M"],
			drainpunch: ["8M", "8L39"],
			dynamicpunch: ["8L50"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			feint: ["8L19"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			forcepalm: ["8L28"],
			gigadrain: ["8M", "8L1"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growth: ["8L1"],
			headbutt: ["8L15"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			leechseed: ["8L8", "8L1"],
			lowsweep: ["8M"],
			machpunch: ["8L1"],
			megadrain: ["8L12"],
			mindreader: ["8L33"],
			poisonpowder: ["8L1"],
			protect: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			seedbomb: ["8L44"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			spore: ["8L1"],
			stoneedge: ["8M"],
			strength: ["8M"],
			stunspore: ["8L5", "8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			tackle: ["8L1"],
			toxic: ["8L1"],
			workup: ["8M"],
			worryseed: ["8L1"],
		},
	},
	slakoth: {
		learnset: {
			aerialace: ["8M"],
			afteryou: ["8E"],
			amnesia: ["8L17"],
			attract: ["8M"],
			blizzard: ["8M"],
			bodyslam: ["8E"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			counter: ["8L30"],
			covet: ["8L22"],
			crushclaw: ["8E"],
			curse: ["8E"],
			cut: ["8M"],
			doubleteam: ["8M"],
			encore: ["8L6"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flail: ["8L33"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			hammerarm: ["8E"],
			headbutt: ["8L25"],
			icebeam: ["8M"],
			nightslash: ["8E"],
			playrough: ["8L38"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L14"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scratch: ["8L1"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			slackoff: ["8L9"],
			slash: ["8E"],
			sleeptalk: ["8M"],
			snore: ["8E"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			tickle: ["8E"],
			waterpulse: ["8M"],
			workup: ["8M"],
			yawn: ["8L1"],
		},
	},
	vigoroth: {
		learnset: {
			aerialace: ["8M"],
			amnesia: ["8L1"],
			attract: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			counter: ["8L33"],
			covet: ["8L1"],
			cut: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			encore: ["8L6", "8L1"],
			endure: ["8M", "8L17"],
			facade: ["8M"],
			fireblast: ["8M"],
			flail: ["8L1"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focusenergy: ["8L1"],
			focuspunch: ["8M", "8L37"],
			furyswipes: ["8L14"],
			headbutt: ["8L27"],
			icebeam: ["8M"],
			lowsweep: ["8M"],
			playrough: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L1"],
			reversal: ["8L43", "8L1"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scratch: ["8L1"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			slackoff: ["8L1"],
			slash: ["8L23"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			uproar: ["8L9", "8L1"],
			waterpulse: ["8M"],
			workup: ["8M"],
			yawn: ["8L1"],
		},
	},
	slaking: {
		learnset: {
			aerialace: ["8M"],
			amnesia: ["8L17"],
			attract: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			counter: ["8L33"],
			covet: ["8L23"],
			cut: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			encore: ["8L6", "8L1"],
			endure: ["8M", "8L1"],
			facade: ["8M"],
			fireblast: ["8M"],
			flail: ["8L39"],
			flamethrower: ["8M"],
			fling: ["8M", "8L47", "8L1"],
			focusblast: ["8M"],
			focusenergy: ["8L1"],
			focuspunch: ["8M", "8L1"],
			furyswipes: ["8L1"],
			gigaimpact: ["8M"],
			hammerarm: ["8L61", "8L1"],
			headbutt: ["8L27"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			lowsweep: ["8M"],
			playrough: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L14"],
			reversal: ["8L1"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scratch: ["8L1"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			slackoff: ["8L9", "8L1"],
			slash: ["8L1"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L53"],
			sunnyday: ["8M"],
			swagger: ["8M", "8L1"],
			taunt: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			uproar: ["8L1"],
			waterpulse: ["8M"],
			workup: ["8M"],
			yawn: ["8L1"],
		},
	},
	nincada: {
		learnset: {
			absorb: ["8L21"],
			aerialace: ["8M"],
			bugbite: ["8E"],
			bugbuzz: ["8M"],
			cut: ["8M"],
			dig: ["8M", "8L40"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M", "8L10"],
			finalgambit: ["8E"],
			flail: ["8E"],
			flash: ["8M"],
			furyswipes: ["8L30"],
			gigadrain: ["8M"],
			gust: ["8E"],
			harden: ["8L5"],
			metalclaw: ["8L25"],
			mindreader: ["8L35"],
			mudslap: ["8L15"],
			nightslash: ["8E"],
			protect: ["8M"],
			rest: ["8M"],
			sandattack: ["8L1"],
			sandstorm: ["8M"],
			scratch: ["8L1"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			xscissor: ["8M"],
		},
	},
	ninjask: {
		learnset: {
			absorb: ["8L23"],
			aerialace: ["8M", "8L1"],
			agility: ["8L15"],
			batonpass: ["8L1"],
			bugbite: ["8L29"],
			bugbuzz: ["8M"],
			cut: ["8M"],
			defog: ["8M"],
			dig: ["8M", "8L1"],
			doubleteam: ["8M", "8L1"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M", "8L1"],
			flash: ["8M"],
			furycutter: ["8L1"],
			furyswipes: ["8L36"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			harden: ["8L1"],
			hyperbeam: ["8M"],
			metalclaw: ["8L1"],
			mindreader: ["8L43"],
			mudslap: ["8L1"],
			protect: ["8M"],
			rest: ["8M"],
			roost: ["8M"],
			sandattack: ["8L1"],
			sandstorm: ["8M"],
			scratch: ["8L1"],
			screech: ["8L1"],
			shadowball: ["8M"],
			slash: ["8L50"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L57"],
			thief: ["8M"],
			uturn: ["8M"],
			xscissor: ["8M", "8L64"],
		},
	},
	shedinja: {
		learnset: {
			absorb: ["8L23"],
			aerialace: ["8M"],
			bugbuzz: ["8M"],
			confuseray: ["8L15"],
			cut: ["8M"],
			dig: ["8M", "8L1"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M", "8L1"],
			flash: ["8M"],
			furyswipes: ["8L36"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			grudge: ["8L1"],
			harden: ["8L1"],
			hyperbeam: ["8M"],
			metalclaw: ["8L1"],
			mindreader: ["8L43"],
			mudslap: ["8L1"],
			phantomforce: ["8L64"],
			protect: ["8M"],
			rest: ["8M"],
			sandattack: ["8L1"],
			sandstorm: ["8M"],
			scratch: ["8L1"],
			shadowball: ["8M", "8L50"],
			shadowclaw: ["8M", "8L1"],
			shadowsneak: ["8L29"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			spite: ["8L57"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thief: ["8M"],
			willowisp: ["8M"],
			xscissor: ["8M"],
		},
	},
	whismur: {
		learnset: {
			astonish: ["8L1"],
			attract: ["8M"],
			blizzard: ["8M"],
			circlethrow: ["8E"],
			disarmingvoice: ["8E"],
			doubleteam: ["8M"],
			echoedvoice: ["8L5"],
			endeavor: ["8E"],
			endure: ["8M"],
			extrasensory: ["8E"],
			facade: ["8M"],
			faketears: ["8E"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M"],
			hammerarm: ["8E"],
			howl: ["8L10"],
			hypervoice: ["8L45"],
			icebeam: ["8M"],
			pound: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L15"],
			roar: ["8M", "8L25"],
			screech: ["8L40"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M", "8L15"],
			smokescreen: ["8E"],
			snore: ["8E"],
			solarbeam: ["8M"],
			stomp: ["8L21"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L30"],
			swagger: ["8M"],
			takedown: ["8E"],
			uproar: ["8L35"],
			waterpulse: ["8M"],
			whirlwind: ["8E"],
			workup: ["8M"],
		},
	},
	loudred: {
		learnset: {
			astonish: ["8L1"],
			attract: ["8M"],
			bite: ["8L1"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			echoedvoice: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M"],
			howl: ["8L1"],
			hypervoice: ["8L57"],
			icebeam: ["8M"],
			overheat: ["8M"],
			pound: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L15"],
			roar: ["8M", "8L29"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			screech: ["8L50"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M", "8L15"],
			solarbeam: ["8M"],
			stomp: ["8L23"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L36"],
			swagger: ["8M"],
			taunt: ["8M"],
			torment: ["8M"],
			uproar: ["8L43"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	exploud: {
		learnset: {
			astonish: ["8L1"],
			attract: ["8M"],
			avalanche: ["8M"],
			bite: ["8L1"],
			blizzard: ["8M"],
			boomburst: ["8L72"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			crunch: ["8L1"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			echoedvoice: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			firefang: ["8L1"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			gigaimpact: ["8M"],
			howl: ["8L1"],
			hyperbeam: ["8M", "8L81"],
			hypervoice: ["8L63"],
			icebeam: ["8M"],
			icefang: ["8L1"],
			overheat: ["8M"],
			pound: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L15"],
			roar: ["8M", "8L29"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			screech: ["8L54"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M", "8L15"],
			solarbeam: ["8M"],
			stomp: ["8L23"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L36"],
			surf: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thunderfang: ["8L1"],
			torment: ["8M"],
			uproar: ["8L45"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	makuhita: {
		learnset: {
			armthrust: ["8L7"],
			attract: ["8M"],
			bellydrum: ["8L25"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			bulletpunch: ["8E"],
			closecombat: ["8L40"],
			counter: ["8E"],
			crosschop: ["8E"],
			detect: ["8L28", "8E"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dynamicpunch: ["8E"],
			earthquake: ["8M"],
			endure: ["8M", "8L37"],
			facade: ["8M"],
			fakeout: ["8L10"],
			feint: ["8E"],
			fling: ["8M"],
			focusblast: ["8M"],
			focusenergy: ["8L1"],
			focuspunch: ["8M", "8L34"],
			forcepalm: ["8L13"],
			heavyslam: ["8L46"],
			helpinghand: ["8E"],
			knockoff: ["8L19"],
			lowsweep: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8E"],
			reversal: ["8L43"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandattack: ["8L4"],
			seismictoss: ["8L31"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			vitalthrow: ["8L22"],
			whirlwind: ["8L16"],
			wideguard: ["8E"],
			workup: ["8M"],
		},
	},
	hariyama: {
		learnset: {
			armthrust: ["8L7", "8L1"],
			attract: ["8M"],
			bellydrum: ["8L26"],
			brickbreak: ["8M"],
			brine: ["8M", "8L1"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			closecombat: ["8L46"],
			detect: ["8L30"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M", "8L42"],
			facade: ["8M"],
			fakeout: ["8L10"],
			fling: ["8M"],
			focusblast: ["8M"],
			focusenergy: ["8L1"],
			focuspunch: ["8M", "8L38"],
			forcepalm: ["8L13"],
			gigaimpact: ["8M"],
			heavyslam: ["8L54"],
			hyperbeam: ["8M"],
			knockoff: ["8L19"],
			lowsweep: ["8M"],
			payback: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			reversal: ["8L50"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandattack: ["8L4", "8L1"],
			seismictoss: ["8L34"],
			sleeptalk: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			vitalthrow: ["8L22"],
			whirlwind: ["8L16"],
			workup: ["8M"],
		},
	},
	azurill: {
		learnset: {
			aquajet: ["8E"],
			attract: ["8M"],
			bellydrum: ["8E"],
			blizzard: ["8M"],
			bodyslam: ["8E"],
			bounce: ["8L15"],
			bubblebeam: ["8L6"],
			charm: ["8L9"],
			copycat: ["8E"],
			doubleteam: ["8M"],
			encore: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			faketears: ["8E"],
			hail: ["8M"],
			helpinghand: ["8L3"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			muddywater: ["8E"],
			perishsong: ["8E"],
			present: ["8E"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			scald: ["8M"],
			sing: ["8E"],
			slam: ["8L12", "8E"],
			sleeptalk: ["8M"],
			soak: ["8E"],
			splash: ["8L1"],
			substitute: ["8M"],
			supersonic: ["8E"],
			surf: ["8M"],
			swagger: ["8M"],
			tailwhip: ["8L1"],
			tickle: ["8E"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	nosepass: {
		learnset: {
			attract: ["8M"],
			block: ["8L7", "8E"],
			bulldoze: ["8M"],
			dazzlinggleam: ["8M"],
			discharge: ["8L31"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			earthpower: ["8L37"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			harden: ["8L4"],
			lockon: ["8L43"],
			powergem: ["8L25"],
			protect: ["8M"],
			rest: ["8M", "8L16"],
			rockblast: ["8L28"],
			rockpolish: ["8M"],
			rockslide: ["8M", "8L22"],
			rocksmash: ["8M"],
			rockthrow: ["8L10"],
			rocktomb: ["8M"],
			rollout: ["8E"],
			sandstorm: ["8M", "8L34"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			spark: ["8L19"],
			stealthrock: ["8M"],
			stoneedge: ["8M", "8L40"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			taunt: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M", "8L13"],
			torment: ["8M"],
			voltswitch: ["8M"],
			wideguard: ["8E"],
			zapcannon: ["8L43"],
		},
	},
	skitty: {
		learnset: {
			attract: ["8M", "8L10"],
			babydolleyes: ["8L43"],
			batonpass: ["8E"],
			blizzard: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			charm: ["8L25"],
			copycat: ["8L19"],
			cosmicpower: ["8E"],
			covet: ["8L34"],
			dig: ["8M"],
			disarmingvoice: ["8L13"],
			doubleedge: ["8L40"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M", "8L31"],
			fakeout: ["8L1", "8E"],
			faketears: ["8E"],
			flash: ["8M"],
			furyswipes: ["8L16"],
			grassknot: ["8M"],
			growl: ["8L1"],
			healbell: ["8L37"],
			helpinghand: ["8E"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lastresort: ["8E"],
			nastyplot: ["8M"],
			payback: ["8M", "8L22"],
			playrough: ["8L46"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			simplebeam: ["8E"],
			sing: ["8L7"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8E"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L4"],
			tailwhip: ["8L1"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			tickle: ["8E"],
			uproar: ["8E"],
			waterpulse: ["8M"],
			wish: ["8E"],
			workup: ["8M"],
			zenheadbutt: ["8E"],
		},
	},
	delcatty: {
		learnset: {
			attract: ["8M", "8L1"],
			babydolleyes: ["8L1"],
			blizzard: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			charm: ["8L1"],
			copycat: ["8L1"],
			covet: ["8L1"],
			dig: ["8M"],
			disarmingvoice: ["8L1"],
			doubleedge: ["8L1"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M", "8L1"],
			fakeout: ["8L1"],
			flash: ["8M"],
			furyswipes: ["8L1"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			healbell: ["8L1"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			nastyplot: ["8M"],
			payback: ["8M", "8L1"],
			playrough: ["8L1"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sing: ["8L1"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	sableye: {
		learnset: {
			aerialace: ["8M"],
			astonish: ["8L3"],
			attract: ["8M"],
			brickbreak: ["8M"],
			calmmind: ["8M"],
			confuseray: ["8L6"],
			cut: ["8M"],
			darkpulse: ["8M"],
			dazzlinggleam: ["8M"],
			detect: ["8L18"],
			dig: ["8M"],
			disable: ["8L15"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8L12"],
			feint: ["8E"],
			flash: ["8M"],
			flatter: ["8E"],
			fling: ["8M"],
			focuspunch: ["8M"],
			foulplay: ["8L48"],
			furyswipes: ["8L24"],
			gyroball: ["8M"],
			imprison: ["8E"],
			knockoff: ["8L27"],
			leer: ["8L1"],
			lowsweep: ["8M"],
			meanlook: ["8L36", "8E"],
			metalburst: ["8E"],
			moonlight: ["8E"],
			nastyplot: ["8M"],
			nightshade: ["8L21"],
			payback: ["8M"],
			poisonjab: ["8M"],
			powergem: ["8L39"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			quash: ["8L30"],
			raindance: ["8M"],
			recover: ["8E"],
			rest: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scratch: ["8L1"],
			shadowball: ["8M", "8L45"],
			shadowclaw: ["8M", "8L33"],
			shadowsneak: ["8L9"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8E"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			torment: ["8M"],
			trick: ["8E"],
			waterpulse: ["8M"],
			willowisp: ["8M"],
			zenheadbutt: ["8L42"],
		},
	},
	mawile: {
		learnset: {
			ancientpower: ["8E"],
			astonish: ["8L1"],
			attract: ["8M"],
			batonpass: ["8L8"],
			bite: ["8L12"],
			brickbreak: ["8M"],
			chargebeam: ["8M"],
			crunch: ["8L28"],
			darkpulse: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fairywind: ["8L4"],
			faketears: ["8L44"],
			falseswipe: ["8M"],
			fireblast: ["8M"],
			firefang: ["8E"],
			flamethrower: ["8M"],
			flashcannon: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			guardswap: ["8E"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			icefang: ["8E"],
			irondefense: ["8L24"],
			ironhead: ["8L36"],
			metalburst: ["8E"],
			mistyterrain: ["8E"],
			payback: ["8M"],
			playrough: ["8L48"],
			poisonfang: ["8E"],
			poweruppunch: ["8E"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			seismictoss: ["8E"],
			shadowball: ["8M"],
			slam: ["8E"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			spitup: ["8L16"],
			stealthrock: ["8M"],
			stockpile: ["8L16"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L20", "8E"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8L16"],
			sweetscent: ["8L32"],
			swordsdance: ["8M"],
			taunt: ["8M", "8L40"],
			thunderfang: ["8E"],
			tickle: ["8E"],
			torment: ["8M"],
		},
	},
	aron: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			autotomize: ["8L40"],
			bodyslam: ["8E"],
			bulldoze: ["8M"],
			curse: ["8E"],
			cut: ["8M"],
			dig: ["8M"],
			doubleedge: ["8L56"],
			doubleteam: ["8M"],
			dragonrush: ["8E"],
			earthquake: ["8M"],
			endeavor: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			harden: ["8L1"],
			headbutt: ["8L16"],
			headsmash: ["8E"],
			heavyslam: ["8L52"],
			irondefense: ["8L48"],
			ironhead: ["8L28", "8E"],
			irontail: ["8M", "8L44"],
			metalburst: ["8L60"],
			metalclaw: ["8L4"],
			metalsound: ["8L33"],
			mudslap: ["8E"],
			protect: ["8M", "8L20"],
			raindance: ["8M"],
			rest: ["8M"],
			reversal: ["8E"],
			roar: ["8M", "8L12"],
			rockpolish: ["8M"],
			rockslide: ["8M", "8L24"],
			rocksmash: ["8M"],
			rocktomb: ["8M", "8L8"],
			sandstorm: ["8M"],
			screech: ["8E"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stomp: ["8E"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			superpower: ["8E"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L36"],
			waterpulse: ["8M"],
		},
	},
	lairon: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			autotomize: ["8L46"],
			bulldoze: ["8M"],
			cut: ["8M"],
			dig: ["8M"],
			doubleedge: ["8L70"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			harden: ["8L1"],
			headbutt: ["8L16"],
			heavyslam: ["8L64"],
			irondefense: ["8L58"],
			ironhead: ["8L28"],
			irontail: ["8M", "8L52"],
			metalburst: ["8L76"],
			metalclaw: ["8L1"],
			metalsound: ["8L35"],
			protect: ["8M", "8L20"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M", "8L12"],
			rockpolish: ["8M"],
			rockslide: ["8M", "8L24"],
			rocksmash: ["8M"],
			rocktomb: ["8M", "8L1"],
			sandstorm: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L40"],
			waterpulse: ["8M"],
		},
	},
	aggron: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			autotomize: ["8L48"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			cut: ["8M"],
			darkpulse: ["8M"],
			dig: ["8M"],
			doubleedge: ["8L80"],
			doubleteam: ["8M"],
			dragonclaw: ["8M"],
			dragonpulse: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flashcannon: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			harden: ["8L1"],
			headbutt: ["8L16"],
			heavyslam: ["8L72"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irondefense: ["8L64"],
			ironhead: ["8L28"],
			irontail: ["8M", "8L56"],
			metalburst: ["8L88"],
			metalclaw: ["8L1"],
			metalsound: ["8L35"],
			payback: ["8M"],
			protect: ["8M", "8L20"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M", "8L12"],
			rockclimb: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M", "8L24"],
			rocksmash: ["8M"],
			rocktomb: ["8M", "8L1"],
			sandstorm: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L40"],
			taunt: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterpulse: ["8M"],
		},
	},
	meditite: {
		learnset: {
			acupressure: ["8L33"],
			attract: ["8M"],
			batonpass: ["8E"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulletpunch: ["8E"],
			calmmind: ["8M", "8L23"],
			confusion: ["8L7"],
			counter: ["8L44"],
			detect: ["8L9"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			dynamicpunch: ["8E"],
			endure: ["8M", "8L12"],
			facade: ["8M"],
			fakeout: ["8E"],
			feint: ["8L15"],
			firepunch: ["8E"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			forcepalm: ["8L17"],
			grassknot: ["8M"],
			guardswap: ["8E"],
			highjumpkick: ["8L28"],
			icepunch: ["8E"],
			lightscreen: ["8M"],
			lowkick: ["8L4"],
			lowsweep: ["8M"],
			mindreader: ["8L25"],
			poisonjab: ["8M"],
			pound: ["8L1"],
			powerswap: ["8E"],
			powertrick: ["8L36"],
			protect: ["8M"],
			psybeam: ["8L20"],
			psychic: ["8M"],
			psychocut: ["8E"],
			psychup: ["8M", "8L31"],
			quickguard: ["8E"],
			raindance: ["8M"],
			recover: ["8L41"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			reversal: ["8L39"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thunderpunch: ["8E"],
			workup: ["8M"],
		},
	},
	medicham: {
		learnset: {
			acupressure: ["8L33"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			calmmind: ["8M", "8L23"],
			confusion: ["8L7", "8L1"],
			counter: ["8L53"],
			detect: ["8L9", "8L1"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			endure: ["8M", "8L12"],
			energyball: ["8M"],
			facade: ["8M"],
			feint: ["8L15"],
			firepunch: ["8L1"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			forcepalm: ["8L17"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			highjumpkick: ["8L28"],
			hyperbeam: ["8M"],
			icepunch: ["8L1"],
			lightscreen: ["8M"],
			lowkick: ["8L4"],
			lowsweep: ["8M"],
			mindreader: ["8L25"],
			poisonjab: ["8M"],
			pound: ["8L1"],
			powertrick: ["8L36"],
			protect: ["8M"],
			psybeam: ["8L20"],
			psychic: ["8M"],
			psychup: ["8M", "8L31"],
			raindance: ["8M"],
			recover: ["8L47"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			reversal: ["8L42"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thunderpunch: ["8L1"],
			workup: ["8M"],
			zenheadbutt: ["8L1"],
		},
	},
	electrike: {
		learnset: {
			attract: ["8M"],
			bite: ["8L20"],
			charge: ["8L36"],
			chargebeam: ["8M"],
			crunch: ["8E"],
			curse: ["8E"],
			discharge: ["8L32", "8E"],
			doubleteam: ["8M"],
			eerieimpulse: ["8E"],
			electroball: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			firefang: ["8E"],
			flamethrower: ["8M"],
			flash: ["8M"],
			headbutt: ["8E"],
			howl: ["8L8"],
			icefang: ["8E"],
			irontail: ["8M"],
			leer: ["8L4"],
			lightscreen: ["8M"],
			protect: ["8M"],
			quickattack: ["8L12"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M", "8L28"],
			shockwave: ["8M", "8L16"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			spark: ["8E"],
			strength: ["8M"],
			substitute: ["8M"],
			swagger: ["8M"],
			swift: ["8E"],
			switcheroo: ["8E"],
			tackle: ["8L1"],
			thief: ["8M"],
			thunder: ["8M", "8L44"],
			thunderbolt: ["8M"],
			thunderfang: ["8L24", "8E"],
			thunderwave: ["8M", "8L1"],
			uproar: ["8E"],
			voltswitch: ["8M"],
			wildcharge: ["8L40"],
		},
	},
	manectric: {
		learnset: {
			attract: ["8M"],
			bite: ["8L20"],
			charge: ["8L42"],
			chargebeam: ["8M"],
			discharge: ["8L36"],
			doubleteam: ["8M"],
			electricterrain: ["8L60"],
			endure: ["8M"],
			facade: ["8M"],
			firefang: ["8L1"],
			flamethrower: ["8M"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			howl: ["8L1"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			overheat: ["8M"],
			protect: ["8M"],
			quickattack: ["8L12"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M", "8L30"],
			shockwave: ["8M", "8L16"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
			thunder: ["8M", "8L54"],
			thunderbolt: ["8M"],
			thunderfang: ["8L24"],
			thunderwave: ["8M", "8L1"],
			voltswitch: ["8M"],
			wildcharge: ["8L48"],
		},
	},
	plusle: {
		learnset: {
			agility: ["8L37"],
			attract: ["8M"],
			batonpass: ["8L34"],
			charge: ["8L28"],
			chargebeam: ["8M"],
			charm: ["8L25", "8E"],
			copycat: ["8L22"],
			discharge: ["8L31", "8E"],
			doubleteam: ["8M"],
			electroball: ["8L19"],
			encore: ["8L10"],
			endure: ["8M"],
			entrainment: ["8L49"],
			facade: ["8M"],
			faketears: ["8E"],
			flash: ["8M"],
			fling: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			helpinghand: ["8L4"],
			irontail: ["8M"],
			lastresort: ["8L40"],
			lightscreen: ["8M"],
			nastyplot: ["8M", "8L46"],
			nuzzle: ["8L1"],
			playnice: ["8L1"],
			protect: ["8M"],
			quickattack: ["8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			shockwave: ["8M"],
			sing: ["8E"],
			skillswap: ["8M", "8L13"],
			sleeptalk: ["8M"],
			spark: ["8L7"],
			substitute: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8E"],
			swift: ["8L16"],
			tearfullook: ["8E"],
			thunder: ["8M", "8L43"],
			thunderbolt: ["8M"],
			thunderwave: ["8M", "8L1"],
			voltswitch: ["8M"],
			wish: ["8E"],
		},
	},
	minun: {
		learnset: {
			agility: ["8L37"],
			attract: ["8M"],
			batonpass: ["8L34"],
			charge: ["8L28"],
			chargebeam: ["8M"],
			charm: ["8E"],
			copycat: ["8L22"],
			discharge: ["8L31", "8E"],
			doubleteam: ["8M"],
			electroball: ["8L19"],
			encore: ["8L10"],
			endure: ["8M"],
			entrainment: ["8L49"],
			facade: ["8M"],
			faketears: ["8L25", "8E"],
			flash: ["8M"],
			fling: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			helpinghand: ["8L4"],
			irontail: ["8M"],
			lastresort: ["8L40"],
			lightscreen: ["8M"],
			nastyplot: ["8M", "8L46"],
			nuzzle: ["8L1"],
			playnice: ["8L1"],
			protect: ["8M"],
			quickattack: ["8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			shockwave: ["8M"],
			sing: ["8E"],
			sleeptalk: ["8M"],
			spark: ["8L7"],
			substitute: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8E"],
			swift: ["8L16"],
			switcheroo: ["8L13"],
			tearfullook: ["8E"],
			thunder: ["8M", "8L43"],
			thunderbolt: ["8M"],
			thunderwave: ["8M", "8L1"],
			voltswitch: ["8M"],
			wish: ["8E"],
		},
	},
	volbeat: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			batonpass: ["8E"],
			brickbreak: ["8M"],
			bugbuzz: ["8M", "8L40"],
			chargebeam: ["8M"],
			confuseray: ["8L8"],
			dazzlinggleam: ["8M"],
			doubleedge: ["8L47"],
			doubleteam: ["8M", "8L5"],
			encore: ["8L26", "8E"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			gigadrain: ["8M"],
			helpinghand: ["8L36"],
			infestation: ["8L50"],
			lightscreen: ["8M"],
			lunge: ["8E"],
			moonlight: ["8L19"],
			playnice: ["8L1"],
			playrough: ["8L43"],
			protect: ["8M", "8L29"],
			psychup: ["8M"],
			quickattack: ["8L12"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M"],
			seismictoss: ["8E"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strugglebug: ["8L15"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailglow: ["8L22"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			trick: ["8E"],
			uturn: ["8M"],
			waterpulse: ["8M"],
			zenheadbutt: ["8L33"],
		},
	},
	illumise: {
		learnset: {
			aerialace: ["8M"],
			aromatherapy: ["8E"],
			attract: ["8M"],
			batonpass: ["8E"],
			brickbreak: ["8M"],
			bugbuzz: ["8M", "8L40"],
			chargebeam: ["8M"],
			charm: ["8L9"],
			confuseray: ["8E"],
			covet: ["8L47"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			encore: ["8L26", "8E"],
			endure: ["8M"],
			facade: ["8M"],
			faketears: ["8E"],
			flash: ["8M"],
			flatter: ["8L29"],
			fling: ["8M"],
			focuspunch: ["8M"],
			gigadrain: ["8M"],
			growth: ["8E"],
			helpinghand: ["8L36"],
			infestation: ["8L50"],
			lightscreen: ["8M"],
			moonlight: ["8L19"],
			playnice: ["8L1"],
			playrough: ["8L43"],
			protect: ["8M"],
			psychup: ["8M"],
			quickattack: ["8L12"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strugglebug: ["8L15"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L5"],
			tackle: ["8L1"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			uturn: ["8M"],
			waterpulse: ["8M"],
			wish: ["8L22"],
			zenheadbutt: ["8L33"],
		},
	},
	roselia: {
		learnset: {
			absorb: ["8L1"],
			aromatherapy: ["8L50"],
			attract: ["8M"],
			bulletseed: ["8M"],
			cottonspore: ["8E"],
			cut: ["8M"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			extrasensory: ["8E"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M", "8L30"],
			grassknot: ["8M"],
			growth: ["8L1"],
			ingrain: ["8L55"],
			leafstorm: ["8E"],
			leechseed: ["8L10"],
			lifedew: ["8E"],
			magicalleaf: ["8L15"],
			megadrain: ["8L5"],
			mindreader: ["8E"],
			petalblizzard: ["8L45"],
			petaldance: ["8L60"],
			pinmissile: ["8E"],
			poisonjab: ["8M"],
			poisonsting: ["8L1"],
			powerwhip: ["8E"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			razorleaf: ["8E"],
			rest: ["8M"],
			seedbomb: ["8E"],
			shadowball: ["8M"],
			sleeppowder: ["8E"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			spikes: ["8E"],
			stunspore: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L25"],
			swordsdance: ["8M"],
			synthesis: ["8L35", "8E"],
			toxic: ["8M", "8L40"],
			toxicspikes: ["8L20"],
			worryseed: ["8L1"],
		},
	},
	gulpin: {
		learnset: {
			acidarmor: ["8E"],
			acidspray: ["8L17"],
			amnesia: ["8L12"],
			attract: ["8M"],
			belch: ["8L41"],
			bulletseed: ["8M"],
			curse: ["8E"],
			destinybond: ["8E"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			encore: ["8L20"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			gastroacid: ["8L36"],
			gunkshot: ["8L49", "8E"],
			icebeam: ["8M"],
			mudslap: ["8E"],
			painsplit: ["8L44", "8E"],
			poisongas: ["8L8"],
			pound: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludge: ["8L10"],
			sludgebomb: ["8M", "8L33"],
			smog: ["8E"],
			solarbeam: ["8M"],
			spitup: ["8L28"],
			stockpile: ["8L28"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8L28"],
			toxic: ["8M", "8L25"],
			venomdrench: ["8E"],
			waterpulse: ["8M"],
			yawn: ["8L5"],
		},
	},
	swalot: {
		learnset: {
			acidspray: ["8L17"],
			amnesia: ["8L12"],
			attract: ["8M"],
			belch: ["8L49"],
			bodyslam: ["8L1"],
			bulldoze: ["8M"],
			bulletseed: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			encore: ["8L20"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			gastroacid: ["8L42"],
			gigaimpact: ["8M"],
			gunkshot: ["8L61", "8L1"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			painsplit: ["8L54"],
			poisongas: ["8L8", "8L1"],
			pound: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludge: ["8L10", "8L1"],
			sludgebomb: ["8M", "8L37"],
			solarbeam: ["8M"],
			spitup: ["8L30"],
			stockpile: ["8L30"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8L30"],
			toxic: ["8M", "8L25"],
			venomdrench: ["8L1"],
			waterpulse: ["8M"],
			yawn: ["8L5", "8L1"],
		},
	},
	carvanha: {
		learnset: {
			agility: ["8L36"],
			ancientpower: ["8E"],
			aquajet: ["8L1"],
			attract: ["8M"],
			bite: ["8L16"],
			blizzard: ["8M"],
			brine: ["8M"],
			crunch: ["8L32"],
			darkpulse: ["8M"],
			destinybond: ["8E"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			focusenergy: ["8L8"],
			hail: ["8M"],
			hydropump: ["8E"],
			icebeam: ["8M"],
			icefang: ["8L20"],
			leer: ["8L1"],
			liquidation: ["8L40"],
			payback: ["8M"],
			poisonfang: ["8L4"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			scald: ["8M"],
			scaryface: ["8L12"],
			screech: ["8L24"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M", "8L28"],
			swift: ["8E"],
			takedown: ["8L44"],
			taunt: ["8M"],
			thief: ["8M"],
			thrash: ["8E"],
			torment: ["8M"],
			waterfall: ["8M"],
			waterpulse: ["8M"],
		},
	},
	sharpedo: {
		learnset: {
			agility: ["8L40"],
			aquajet: ["8L1"],
			attract: ["8M"],
			avalanche: ["8M"],
			bite: ["8L16"],
			blizzard: ["8M"],
			brine: ["8M"],
			bulldoze: ["8M"],
			crunch: ["8L34"],
			darkpulse: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			focusenergy: ["8L1"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			icefang: ["8L20"],
			leer: ["8L1"],
			liquidation: ["8L46"],
			nightslash: ["8L1"],
			payback: ["8M"],
			poisonfang: ["8L1"],
			poisonjab: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			scaryface: ["8L12"],
			screech: ["8L24"],
			slash: ["8L1"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M", "8L28"],
			takedown: ["8L52"],
			taunt: ["8M"],
			thief: ["8M"],
			torment: ["8M"],
			waterfall: ["8M"],
			waterpulse: ["8M"],
		},
	},
	wailmer: {
		learnset: {
			amnesia: ["8L42"],
			aquaring: ["8E"],
			astonish: ["8L6"],
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			bodyslam: ["8L36", "8E"],
			bounce: ["8L33"],
			brine: ["8M", "8L24"],
			bulldoze: ["8M"],
			clearsmog: ["8E"],
			curse: ["8E"],
			defensecurl: ["8E"],
			dive: ["8L30"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fissure: ["8E"],
			growl: ["8L3"],
			hail: ["8M"],
			heavyslam: ["8L21"],
			hydropump: ["8L45"],
			icebeam: ["8M"],
			mist: ["8L15"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L39"],
			roar: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8E"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			snore: ["8E"],
			soak: ["8E"],
			splash: ["8L1"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			thrash: ["8E"],
			tickle: ["8E"],
			waterfall: ["8M"],
			watergun: ["8L12"],
			waterpulse: ["8M", "8L18"],
			waterspout: ["8L48"],
			whirlpool: ["8L27"],
			zenheadbutt: ["8E"],
		},
	},
	wailord: {
		learnset: {
			amnesia: ["8L44"],
			astonish: ["8L1"],
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			bodyslam: ["8L36"],
			bounce: ["8L33"],
			brine: ["8M", "8L24"],
			bulldoze: ["8M"],
			dive: ["8L30"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hail: ["8M"],
			heavyslam: ["8L21"],
			hydropump: ["8L49"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			mist: ["8L15"],
			nobleroar: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L39"],
			roar: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			soak: ["8L1"],
			splash: ["8L1"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L18"],
			waterspout: ["8L54"],
			whirlpool: ["8L27"],
		},
	},
	numel: {
		learnset: {
			amnesia: ["8L19"],
			ancientpower: ["8E"],
			attract: ["8M"],
			bodyslam: ["8E"],
			bulldoze: ["8M", "8L12"],
			curse: ["8L29"],
			defensecurl: ["8E"],
			dig: ["8M"],
			doubleedge: ["8L47"],
			doubleteam: ["8M"],
			earthpower: ["8L26"],
			earthquake: ["8M", "8L40"],
			ember: ["8L5"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M", "8L43"],
			flamewheel: ["8L15"],
			focusenergy: ["8L8"],
			growl: ["8L1"],
			growth: ["8E"],
			heatwave: ["8E"],
			heavyslam: ["8E"],
			howl: ["8E"],
			ironhead: ["8E"],
			lavaplume: ["8L22"],
			overheat: ["8M"],
			protect: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8E"],
			sandstorm: ["8M"],
			scaryface: ["8E"],
			sleeptalk: ["8M"],
			spitup: ["8E"],
			stealthrock: ["8M"],
			stockpile: ["8E"],
			stomp: ["8E"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8E"],
			tackle: ["8L1"],
			takedown: ["8L31"],
			willowisp: ["8M"],
			yawn: ["8L36", "8E"],
		},
	},
	camerupt: {
		learnset: {
			amnesia: ["8L19"],
			attract: ["8M"],
			bulldoze: ["8M", "8L12"],
			curse: ["8L29"],
			dig: ["8M"],
			doubleedge: ["8L1"],
			doubleteam: ["8M"],
			earthpower: ["8L26"],
			earthquake: ["8M", "8L46"],
			ember: ["8L8", "8L1"],
			endure: ["8M"],
			eruption: ["8L52", "8L1"],
			explosion: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			fissure: ["8L59", "8L1"],
			flamethrower: ["8M", "8L1"],
			flamewheel: ["8L15"],
			flashcannon: ["8M"],
			focusenergy: ["8L8", "8L1"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hyperbeam: ["8M"],
			lavaplume: ["8L22"],
			overheat: ["8M"],
			protect: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M", "8L1"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L31"],
			willowisp: ["8M"],
			yawn: ["8L39"],
		},
	},
	torkoal: {
		learnset: {
			amnesia: ["8L52"],
			ancientpower: ["8E"],
			attract: ["8M"],
			bodyslam: ["8L32"],
			bulldoze: ["8M"],
			clearsmog: ["8L16", "8E"],
			curse: ["8L44"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			eruption: ["8L64", "8E"],
			explosion: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			fissure: ["8E"],
			flail: ["8E"],
			flamethrower: ["8M", "8L40"],
			flamewheel: ["8L20"],
			gigaimpact: ["8M"],
			gyroball: ["8M"],
			heatwave: ["8L48"],
			hyperbeam: ["8M"],
			inferno: ["8L56"],
			irondefense: ["8L36"],
			irontail: ["8M"],
			lavaplume: ["8L28"],
			overheat: ["8M"],
			protect: ["8M", "8L24"],
			rapidspin: ["8L8"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			shellsmash: ["8L60"],
			skullbash: ["8E"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			smog: ["8L1"],
			smokescreen: ["8L12"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			superpower: ["8E"],
			swagger: ["8M"],
			willowisp: ["8M"],
			withdraw: ["8L4"],
			yawn: ["8E"],
		},
	},
	spoink: {
		learnset: {
			amnesia: ["8E"],
			attract: ["8M"],
			bounce: ["8L50"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confuseray: ["8L18"],
			confusion: ["8L7"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			extrasensory: ["8E"],
			facade: ["8M"],
			flash: ["8M"],
			futuresight: ["8E"],
			grassknot: ["8M"],
			growl: ["8L10"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			magiccoat: ["8L21"],
			mirrorcoat: ["8E"],
			payback: ["8M", "8L40"],
			powergem: ["8L29"],
			protect: ["8M"],
			psybeam: ["8L14"],
			psychic: ["8M", "8L44"],
			psychup: ["8M", "8L15"],
			psyshock: ["8L38"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M", "8L29"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			simplebeam: ["8E"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			snore: ["8L33"],
			splash: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trick: ["8E"],
			trickroom: ["8M"],
			whirlwind: ["8E"],
			zenheadbutt: ["8L26", "8E"],
		},
	},
	grumpig: {
		learnset: {
			attract: ["8M"],
			belch: ["8L1"],
			bounce: ["8L60"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confuseray: ["8L18"],
			confusion: ["8L7"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L10"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			magiccoat: ["8L21"],
			nastyplot: ["8M"],
			payback: ["8M", "8L46"],
			powergem: ["8L29"],
			protect: ["8M"],
			psybeam: ["8L14"],
			psychic: ["8M", "8L52"],
			psychup: ["8M", "8L15"],
			psyshock: ["8L42"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M", "8L35"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			snore: ["8L35"],
			splash: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			teeterdance: ["8L1"],
			thief: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
			zenheadbutt: ["8L26"],
		},
	},
	spinda: {
		learnset: {
			attract: ["8M"],
			batonpass: ["8E"],
			bodyslam: ["8L23"],
			brickbreak: ["8M"],
			calmmind: ["8M"],
			copycat: ["8L5"],
			dig: ["8M"],
			disable: ["8E"],
			doubleedge: ["8L46"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			encore: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8E"],
			faketears: ["8E"],
			flail: ["8L50"],
			flash: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			guardsplit: ["8E"],
			hypnosis: ["8L19"],
			icywind: ["8E"],
			protect: ["8M"],
			psybeam: ["8L14"],
			psychic: ["8M"],
			psychocut: ["8E"],
			psychoshift: ["8E"],
			psychup: ["8M", "8L41"],
			raindance: ["8M"],
			rapidspin: ["8E"],
			recycle: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			roleplay: ["8E"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L28"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			teeterdance: ["8L10", "8L32"],
			thief: ["8M"],
			thrash: ["8L55"],
			trick: ["8E"],
			trickroom: ["8M"],
			uproar: ["8L37"],
			waterpulse: ["8M"],
			wish: ["8E"],
			workup: ["8M"],
		},
	},
	trapinch: {
		learnset: {
			astonish: ["8L1"],
			attract: ["8M"],
			bite: ["8L8"],
			bugbite: ["8E"],
			bulldoze: ["8M", "8L20"],
			crunch: ["8L28"],
			dig: ["8M", "8L24"],
			doubleteam: ["8M"],
			earthpower: ["8L36", "8E"],
			earthquake: ["8M", "8L40"],
			endure: ["8M"],
			facade: ["8M"],
			feint: ["8E"],
			fissure: ["8L48"],
			flail: ["8E"],
			focusenergy: ["8E"],
			furycutter: ["8E"],
			gigadrain: ["8M"],
			gust: ["8E"],
			hyperbeam: ["8M"],
			laserfocus: ["8L4"],
			mudshot: ["8E"],
			mudslap: ["8L12"],
			protect: ["8M"],
			quickattack: ["8E"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandattack: ["8L1"],
			sandstorm: ["8M", "8L32"],
			sandtomb: ["8L16"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			superpower: ["8L44"],
			swagger: ["8M"],
		},
	},
	vibrava: {
		learnset: {
			astonish: ["8L1"],
			attract: ["8M"],
			bite: ["8L1"],
			boomburst: ["8L62"],
			bugbuzz: ["8M", "8L28"],
			bulldoze: ["8M", "8L1"],
			crunch: ["8L1"],
			defog: ["8M"],
			dig: ["8M", "8L1"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonbreath: ["8L1"],
			dragonpulse: ["8M"],
			dragonrush: ["8L56"],
			dragontail: ["8L20"],
			earthpower: ["8L38"],
			earthquake: ["8M", "8L44"],
			endure: ["8M"],
			facade: ["8M"],
			fissure: ["8L1"],
			fly: ["8M"],
			gigadrain: ["8M"],
			hyperbeam: ["8M"],
			laserfocus: ["8L1"],
			mudslap: ["8L12"],
			protect: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			roost: ["8M"],
			sandattack: ["8L1"],
			sandstorm: ["8M", "8L32"],
			sandtomb: ["8L16"],
			screech: ["8L24"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			steelwing: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			superpower: ["8L1"],
			supersonic: ["8L1"],
			swagger: ["8M"],
			uproar: ["8L50"],
			uturn: ["8M"],
		},
	},
	flygon: {
		learnset: {
			aerialace: ["8M"],
			astonish: ["8L1"],
			attract: ["8M"],
			bite: ["8L1"],
			boomburst: ["8L68"],
			bugbuzz: ["8M", "8L28"],
			bulldoze: ["8M", "8L1"],
			crunch: ["8L1"],
			defog: ["8M"],
			dig: ["8M", "8L1"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonbreath: ["8L1"],
			dragonclaw: ["8M", "8L1"],
			dragondance: ["8L1"],
			dragonpulse: ["8M"],
			dragonrush: ["8L60"],
			dragontail: ["8L20"],
			earthpower: ["8L38"],
			earthquake: ["8M", "8L44"],
			endure: ["8M"],
			facade: ["8M"],
			feint: ["8L1"],
			fireblast: ["8M"],
			fissure: ["8L1"],
			flamethrower: ["8M"],
			fly: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			laserfocus: ["8L1"],
			mudslap: ["8L12"],
			outrage: ["8L1"],
			protect: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			roost: ["8M"],
			sandattack: ["8L1"],
			sandstorm: ["8M", "8L32"],
			sandtomb: ["8L16"],
			screech: ["8L24"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			steelwing: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			superpower: ["8L1"],
			supersonic: ["8L1"],
			swagger: ["8M"],
			uproar: ["8L52"],
			uturn: ["8M"],
		},
	},
	cacnea: {
		learnset: {
			absorb: ["8L4"],
			acid: ["8E"],
			assurance: ["8L19"],
			attract: ["8M"],
			belch: ["8E"],
			block: ["8E"],
			brickbreak: ["8M"],
			bulletseed: ["8M"],
			cottonspore: ["8L46"],
			counter: ["8E"],
			cut: ["8M"],
			darkpulse: ["8M"],
			destinybond: ["8L54"],
			disable: ["8E"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dynamicpunch: ["8E"],
			endure: ["8M"],
			energyball: ["8M", "8L42"],
			facade: ["8M"],
			fellstinger: ["8E"],
			flash: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			gigadrain: ["8M"],
			grassknot: ["8M"],
			growth: ["8L7"],
			ingrain: ["8L22"],
			leechseed: ["8L10"],
			leer: ["8L1"],
			lowkick: ["8E"],
			magicalleaf: ["8E"],
			nastyplot: ["8M"],
			payback: ["8M", "8L26"],
			pinmissile: ["8L38"],
			poisonjab: ["8M", "8L16"],
			poisonsting: ["8L1"],
			poweruppunch: ["8E"],
			protect: ["8M"],
			rest: ["8M"],
			sandattack: ["8L13"],
			sandstorm: ["8M", "8L50"],
			seedbomb: ["8E"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			spikes: ["8L30"],
			substitute: ["8M"],
			suckerpunch: ["8L34"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			switcheroo: ["8E"],
			swordsdance: ["8M"],
			teeterdance: ["8E"],
			worryseed: ["8E"],
		},
	},
	cacturne: {
		learnset: {
			absorb: ["8L4", "8L1"],
			assurance: ["8L19"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulletseed: ["8M"],
			cottonspore: ["8L49"],
			cut: ["8M"],
			darkpulse: ["8M"],
			destinybond: ["8L59", "8L1"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			endure: ["8M"],
			energyball: ["8M", "8L44"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growth: ["8L7", "8L1"],
			hyperbeam: ["8M"],
			ingrain: ["8L22"],
			leechseed: ["8L10"],
			leer: ["8L1"],
			nastyplot: ["8M"],
			payback: ["8M", "8L26"],
			pinmissile: ["8L38"],
			poisonjab: ["8M", "8L16"],
			poisonsting: ["8L1"],
			protect: ["8M"],
			rest: ["8M"],
			revenge: ["8L1"],
			sandattack: ["8L13"],
			sandstorm: ["8M", "8L54"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			spikes: ["8L30"],
			spikyshield: ["8L1"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L35"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
		},
	},
	swablu: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8E"],
			astonish: ["8E"],
			attract: ["8M"],
			cottonguard: ["8L32"],
			dazzlinggleam: ["8M"],
			disarmingvoice: ["8L4"],
			doubleteam: ["8M"],
			dragonbreath: ["8L20"],
			dragonpulse: ["8M"],
			dragonrush: ["8E"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			featherdance: ["8E"],
			fly: ["8M"],
			furyattack: ["8L12"],
			growl: ["8L1"],
			haze: ["8E"],
			hypervoice: ["8E"],
			icebeam: ["8M"],
			mist: ["8L8"],
			moonblast: ["8L40"],
			peck: ["8L1"],
			perishsong: ["8L44"],
			playrough: ["8E"],
			pluck: ["8M"],
			powerswap: ["8E"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M"],
			round: ["8L16"],
			safeguard: ["8M", "8L24"],
			sing: ["8L28"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tailwind: ["8E"],
			takedown: ["8L36"],
			thief: ["8M"],
		},
	},
	altaria: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			bulldoze: ["8M"],
			cottonguard: ["8L32"],
			dazzlinggleam: ["8M"],
			disarmingvoice: ["8L1"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonbreath: ["8L20"],
			dragonclaw: ["8M"],
			dragonpulse: ["8M", "8L1"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fly: ["8M"],
			furyattack: ["8L12"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hurricane: ["8L1"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			mist: ["8L1"],
			moonblast: ["8L44"],
			peck: ["8L1"],
			perishsong: ["8L50"],
			pluck: ["8M", "8L1"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			roost: ["8M"],
			round: ["8L16"],
			safeguard: ["8M", "8L24"],
			sing: ["8L28"],
			skyattack: ["8L56"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			takedown: ["8L38"],
			thief: ["8M"],
		},
	},
	zangoose: {
		learnset: {
			aerialace: ["8M", "8L15"],
			attract: ["8M"],
			bellydrum: ["8E"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			closecombat: ["8L50"],
			counter: ["8E"],
			crushclaw: ["8L26"],
			curse: ["8E"],
			detect: ["8L36"],
			dig: ["8M"],
			disable: ["8E"],
			doublehit: ["8E"],
			doublekick: ["8E"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M", "8L33"],
			falseswipe: ["8M", "8L29"],
			feint: ["8E"],
			finalgambit: ["8E"],
			fireblast: ["8M"],
			flail: ["8E"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			furycutter: ["8L8"],
			furyswipes: ["8E"],
			gigadrain: ["8M"],
			honeclaws: ["8L12"],
			icebeam: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			metalclaw: ["8E"],
			nightslash: ["8E"],
			payback: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			quickattack: ["8L5"],
			quickguard: ["8E"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8L22"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scratch: ["8L1"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			slash: ["8L19"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L47"],
			taunt: ["8M", "8L43"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
			xscissor: ["8M", "8L40"],
		},
	},
	seviper: {
		learnset: {
			assurance: ["8E"],
			attract: ["8M"],
			belch: ["8L41"],
			bite: ["8L4"],
			bodyslam: ["8E"],
			bulldoze: ["8M"],
			coil: ["8L44"],
			crunch: ["8L39"],
			darkpulse: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			feint: ["8L11"],
			finalgambit: ["8E"],
			flamethrower: ["8M"],
			gastroacid: ["8L29"],
			gigadrain: ["8M"],
			glare: ["8L19"],
			haze: ["8L34"],
			irontail: ["8M"],
			lick: ["8L6"],
			nightslash: ["8L26", "8E"],
			payback: ["8M"],
			poisonfang: ["8L21"],
			poisonjab: ["8M", "8L31"],
			poisontail: ["8L9"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			scaryface: ["8E"],
			screech: ["8L14"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M", "8L46"],
			spitup: ["8E"],
			stockpile: ["8E"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M", "8L1"],
			swallow: ["8E"],
			switcheroo: ["8E"],
			swordsdance: ["8M", "8L36"],
			taunt: ["8M"],
			thief: ["8M"],
			venomdrench: ["8L24"],
			venoshock: ["8L16"],
			wrap: ["8L1"],
			xscissor: ["8M"],
		},
	},
	lunatone: {
		learnset: {
			blizzard: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confusion: ["8L1"],
			cosmicpower: ["8L25"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M", "8L50"],
			facade: ["8M"],
			flash: ["8M"],
			futuresight: ["8L40"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			gyroball: ["8M"],
			hail: ["8M"],
			harden: ["8L1"],
			hyperbeam: ["8M"],
			hypnosis: ["8L5"],
			icebeam: ["8M"],
			lightscreen: ["8M"],
			magicroom: ["8L45"],
			moonblast: ["8L1"],
			moonlight: ["8L1"],
			nastyplot: ["8M"],
			protect: ["8M"],
			psychic: ["8M", "8L30"],
			psychup: ["8M"],
			psyshock: ["8L20"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rockpolish: ["8M", "8L10"],
			rockslide: ["8M", "8L15"],
			rockthrow: ["8L1"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M", "8L35"],
			substitute: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			trickroom: ["8M"],
		},
	},
	solrock: {
		learnset: {
			bulldoze: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confusion: ["8L1"],
			cosmicpower: ["8L25"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M", "8L50"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flareblitz: ["8L1"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			gyroball: ["8M"],
			harden: ["8L1"],
			hyperbeam: ["8M"],
			hypnosis: ["8L5"],
			lightscreen: ["8M"],
			morningsun: ["8L1"],
			overheat: ["8M"],
			protect: ["8M"],
			psychic: ["8M", "8L30"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rockpolish: ["8M", "8L10"],
			rockslide: ["8M", "8L15"],
			rockthrow: ["8L1"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M", "8L40"],
			stealthrock: ["8M"],
			stoneedge: ["8M", "8L35"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			tackle: ["8L1"],
			trickroom: ["8M"],
			willowisp: ["8M"],
			wonderroom: ["8L45"],
			zenheadbutt: ["8L20"],
		},
	},
	barboach: {
		learnset: {
			amnesia: ["8L18"],
			aquatail: ["8L24"],
			attract: ["8M"],
			blizzard: ["8M"],
			bulldoze: ["8M"],
			doubleteam: ["8M"],
			dragondance: ["8E"],
			earthpower: ["8E"],
			earthquake: ["8M", "8L36"],
			endure: ["8M"],
			facade: ["8M"],
			fissure: ["8L48"],
			flail: ["8E"],
			futuresight: ["8L42"],
			hail: ["8M"],
			hydropump: ["8E"],
			icebeam: ["8M"],
			muddywater: ["8L31", "8E"],
			mudshot: ["8E"],
			mudslap: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L6"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			snore: ["8L6"],
			spark: ["8E"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			takedown: ["8E"],
			thrash: ["8E"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L12"],
			whirlpool: ["8E"],
		},
	},
	whiscash: {
		learnset: {
			amnesia: ["8L18"],
			aquatail: ["8L24"],
			attract: ["8M"],
			belch: ["8L1"],
			blizzard: ["8M"],
			bulldoze: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L40"],
			endure: ["8M"],
			facade: ["8M"],
			fissure: ["8L56"],
			futuresight: ["8L48"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			muddywater: ["8L33"],
			mudslap: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L1"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			snore: ["8L1"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			thrash: ["8L1"],
			tickle: ["8L1"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L12"],
			zenheadbutt: ["8L1"],
		},
	},
	corphish: {
		learnset: {
			aerialace: ["8M"],
			ancientpower: ["8E"],
			aquajet: ["8E"],
			attract: ["8M"],
			blizzard: ["8M"],
			bodyslam: ["8E"],
			brickbreak: ["8M"],
			bubblebeam: ["8L12"],
			crabhammer: ["8L44"],
			crunch: ["8L40"],
			cut: ["8M"],
			dig: ["8M"],
			doubleedge: ["8E"],
			doublehit: ["8L20"],
			doubleteam: ["8M"],
			dragondance: ["8E"],
			endeavor: ["8L48", "8E"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fling: ["8M"],
			guillotine: ["8L52"],
			hail: ["8M"],
			harden: ["8L1"],
			icebeam: ["8M"],
			knockoff: ["8L16", "8E"],
			leer: ["8L4"],
			metalclaw: ["8E"],
			nightslash: ["8L28"],
			payback: ["8M"],
			protect: ["8M", "8L24"],
			raindance: ["8M"],
			razorshell: ["8L32"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			slash: ["8E"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			superpower: ["8E"],
			surf: ["8M"],
			swagger: ["8M"],
			switcheroo: ["8E"],
			swordsdance: ["8M", "8L36"],
			taunt: ["8M", "8L8"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			xscissor: ["8M"],
		},
	},
	crawdaunt: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bubblebeam: ["8L12"],
			crabhammer: ["8L52"],
			crunch: ["8L46"],
			cut: ["8M"],
			darkpulse: ["8M"],
			dig: ["8M"],
			doublehit: ["8L20"],
			doubleteam: ["8M"],
			endeavor: ["8L58"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fling: ["8M"],
			gigaimpact: ["8M"],
			guillotine: ["8L64"],
			hail: ["8M"],
			harden: ["8L1"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			knockoff: ["8L16"],
			leer: ["8L1"],
			nastyplot: ["8M"],
			nightslash: ["8L28"],
			payback: ["8M"],
			protect: ["8M", "8L24"],
			raindance: ["8M"],
			razorshell: ["8L34"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			snarl: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swift: ["8L1"],
			swordsdance: ["8M", "8L40"],
			taunt: ["8M", "8L1"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			xscissor: ["8M"],
		},
	},
	baltoy: {
		learnset: {
			ancientpower: ["8L18"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confusion: ["8L6"],
			cosmicpower: ["8L24"],
			dazzlinggleam: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			earthpower: ["8L30"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M", "8L42"],
			extrasensory: ["8L27"],
			facade: ["8M"],
			flash: ["8M"],
			grassknot: ["8M"],
			guardsplit: ["8L36"],
			gyroball: ["8M"],
			harden: ["8L1"],
			icebeam: ["8M"],
			imprison: ["8L21"],
			lightscreen: ["8M"],
			mudslap: ["8L1"],
			powersplit: ["8L36"],
			powertrick: ["8L12"],
			protect: ["8M"],
			psybeam: ["8L15"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rapidspin: ["8L3"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocktomb: ["8M", "8L9"],
			safeguard: ["8M"],
			sandstorm: ["8M", "8L39"],
			selfdestruct: ["8L33"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			trickroom: ["8M"],
		},
	},
	claydol: {
		learnset: {
			ancientpower: ["8L18"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confusion: ["8L1"],
			cosmicpower: ["8L24"],
			dazzlinggleam: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			earthpower: ["8L30"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M", "8L48"],
			extrasensory: ["8L27"],
			facade: ["8M"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			guardsplit: ["8L38"],
			gyroball: ["8M"],
			harden: ["8L1"],
			hyperbeam: ["8M", "8L1"],
			icebeam: ["8M"],
			imprison: ["8L21"],
			lightscreen: ["8M"],
			mudslap: ["8L1"],
			nastyplot: ["8M"],
			powersplit: ["8L38"],
			powertrick: ["8L12"],
			protect: ["8M"],
			psybeam: ["8L15"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rapidspin: ["8L1"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M", "8L9"],
			safeguard: ["8M"],
			sandstorm: ["8M", "8L43"],
			selfdestruct: ["8L33"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			teleport: ["8L1"],
			trickroom: ["8M"],
		},
	},
	lileep: {
		learnset: {
			acid: ["8L4"],
			amnesia: ["8L28"],
			ancientpower: ["8L16"],
			astonish: ["8L1"],
			attract: ["8M"],
			bind: ["8E"],
			brine: ["8M", "8L24"],
			bulletseed: ["8M"],
			confuseray: ["8L8"],
			curse: ["8E"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M", "8L44"],
			facade: ["8M"],
			flash: ["8M"],
			gastroacid: ["8L32"],
			gigadrain: ["8M", "8L36"],
			grassknot: ["8M"],
			ingrain: ["8L12"],
			megadrain: ["8L20", "8E"],
			mirrorcoat: ["8E"],
			protect: ["8M"],
			recover: ["8E"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			spitup: ["8L41"],
			stealthrock: ["8M"],
			stockpile: ["8L41"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8L41"],
			swordsdance: ["8M"],
			tickle: ["8E"],
			wrap: ["8L1"],
		},
	},
	cradily: {
		learnset: {
			acid: ["8L1"],
			amnesia: ["8L28"],
			ancientpower: ["8L16"],
			astonish: ["8L1"],
			attract: ["8M"],
			brine: ["8M", "8L24"],
			bulldoze: ["8M"],
			bulletseed: ["8M"],
			confuseray: ["8L1"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			energyball: ["8M", "8L48"],
			facade: ["8M"],
			flash: ["8M"],
			gastroacid: ["8L32"],
			gigadrain: ["8M", "8L36"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			hyperbeam: ["8M"],
			ingrain: ["8L12"],
			leechseed: ["8L1"],
			megadrain: ["8L20"],
			protect: ["8M"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			spitup: ["8L43"],
			stealthrock: ["8M"],
			stockpile: ["8L43"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8L43"],
			swordsdance: ["8M"],
			wrap: ["8L1"],
		},
	},
	anorith: {
		learnset: {
			aerialace: ["8M"],
			ancientpower: ["8L16"],
			aquajet: ["8E"],
			attract: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M", "8L24"],
			bugbite: ["8L20"],
			crosspoison: ["8E"],
			crushclaw: ["8L32"],
			curse: ["8E"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			furycutter: ["8L1"],
			harden: ["8L1"],
			irondefense: ["8E"],
			knockoff: ["8E"],
			metalclaw: ["8L12"],
			protect: ["8M", "8L41"],
			rapidspin: ["8E"],
			rest: ["8M"],
			rockblast: ["8L36"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandattack: ["8E"],
			sandstorm: ["8M"],
			screech: ["8E"],
			slash: ["8L28"],
			sleeptalk: ["8M"],
			smackdown: ["8L8"],
			stealthrock: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			watergun: ["8L4"],
			waterpulse: ["8M"],
			xscissor: ["8M", "8L44"],
		},
	},
	armaldo: {
		learnset: {
			aerialace: ["8M"],
			ancientpower: ["8L16"],
			attract: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M", "8L24"],
			bugbite: ["8L20"],
			bulldoze: ["8M"],
			crushclaw: ["8L32"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			flashcannon: ["8M"],
			furycutter: ["8L1"],
			gigaimpact: ["8M"],
			harden: ["8L1"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			metalclaw: ["8L12"],
			protect: ["8M", "8L43"],
			rest: ["8M"],
			rockblast: ["8L36"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			shadowclaw: ["8M"],
			slash: ["8L28"],
			sleeptalk: ["8M"],
			smackdown: ["8L1"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			xscissor: ["8M", "8L48"],
		},
	},
	feebas: {
		learnset: {
			attract: ["8M"],
			blizzard: ["8M"],
			brine: ["8M"],
			confuseray: ["8E"],
			doubleteam: ["8M"],
			dragonbreath: ["8E"],
			dragonpulse: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flail: ["8L25"],
			hail: ["8M"],
			haze: ["8E"],
			hypnosis: ["8E"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			mirrorcoat: ["8E"],
			mist: ["8E"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			splash: ["8L1"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L15"],
			tickle: ["8E"],
			waterfall: ["8M"],
			waterpulse: ["8M"],
		},
	},
	milotic: {
		learnset: {
			aquaring: ["8L12"],
			aquatail: ["8L32"],
			attract: ["8M", "8L16"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brine: ["8M"],
			bulldoze: ["8M"],
			coil: ["8L48"],
			disarmingvoice: ["8L4"],
			doubleteam: ["8M"],
			dragonpulse: ["8M"],
			dragontail: ["8L24"],
			endure: ["8M"],
			facade: ["8M"],
			flail: ["8L1"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hydropump: ["8L52"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lifedew: ["8L20"],
			lightscreen: ["8M"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M", "8L44"],
			recover: ["8L28"],
			rest: ["8M"],
			safeguard: ["8M", "8L36"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			splash: ["8L1"],
			substitute: ["8M"],
			surf: ["8M", "8L40"],
			swagger: ["8M"],
			tackle: ["8L1"],
			twister: ["8L8"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L1"],
			wrap: ["8L1"],
		},
	},
	castform: {
		learnset: {
			amnesia: ["8E"],
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M", "8L35"],
			clearsmog: ["8E"],
			cosmicpower: ["8E"],
			disable: ["8E"],
			doubleteam: ["8M"],
			ember: ["8L10"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			fireblast: ["8M", "8L35"],
			flamethrower: ["8M"],
			flash: ["8M"],
			futuresight: ["8E"],
			guardswap: ["8E"],
			hail: ["8M", "8L20"],
			headbutt: ["8L15"],
			hex: ["8E"],
			hurricane: ["8L45"],
			hydropump: ["8L35"],
			icebeam: ["8M"],
			powdersnow: ["8L10"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M", "8L20"],
			reflecttype: ["8E"],
			rest: ["8M"],
			sandstorm: ["8M"],
			scald: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M", "8L20"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			watergun: ["8L10"],
			waterpulse: ["8M"],
			weatherball: ["8L25"],
			workup: ["8M"],
		},
	},
	kecleon: {
		learnset: {
			aerialace: ["8M"],
			ancientpower: ["8L21"],
			astonish: ["8L1"],
			attract: ["8M"],
			bind: ["8L4"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			chargebeam: ["8M"],
			cut: ["8M"],
			detect: ["8L30"],
			dig: ["8M"],
			disable: ["8L16", "8E"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8E"],
			feint: ["8L10"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			foulplay: ["8L50", "8E"],
			furyswipes: ["8L13"],
			grassknot: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lick: ["8L1"],
			magiccoat: ["8E"],
			nastyplot: ["8M"],
			poweruppunch: ["8E"],
			protect: ["8M"],
			psybeam: ["8L18"],
			psychup: ["8M"],
			raindance: ["8M"],
			recover: ["8E"],
			recycle: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scratch: ["8L1"],
			screech: ["8L38"],
			shadowball: ["8M"],
			shadowclaw: ["8M", "8L33"],
			shadowsneak: ["8L7"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			slash: ["8L25"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			strength: ["8M"],
			substitute: ["8M", "8L42"],
			suckerpunch: ["8L46"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tailwhip: ["8L1"],
			thief: ["8M", "8L1"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			trick: ["8E"],
			trickroom: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	shuppet: {
		learnset: {
			astonish: ["8E"],
			attract: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confuseray: ["8E"],
			curse: ["8L26"],
			darkpulse: ["8M"],
			dazzlinggleam: ["8M"],
			destinybond: ["8E"],
			disable: ["8E"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			grudge: ["8L46"],
			gunkshot: ["8E"],
			hex: ["8L22"],
			imprison: ["8E"],
			knockoff: ["8L42", "8L1"],
			nightshade: ["8L7"],
			painsplit: ["8L19"],
			payback: ["8M"],
			phantomforce: ["8L54", "8E"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roleplay: ["8L34"],
			screech: ["8L4"],
			shadowball: ["8M", "8L30"],
			shadowsneak: ["8L13", "8E"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			spite: ["8L10"],
			substitute: ["8M"],
			suckerpunch: ["8L38"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trick: ["8L50"],
			trickroom: ["8M"],
			willowisp: ["8M", "8L16"],
		},
	},
	banette: {
		learnset: {
			attract: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			curse: ["8L26"],
			darkpulse: ["8M"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			gigaimpact: ["8M"],
			grudge: ["8L52"],
			hex: ["8L22"],
			hyperbeam: ["8M"],
			knockoff: ["8L46", "8L1"],
			nightshade: ["8L7", "8L1"],
			painsplit: ["8L19"],
			payback: ["8M"],
			phantomforce: ["8L64", "8L1"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roleplay: ["8L34"],
			screech: ["8L4", "8L1"],
			shadowball: ["8M", "8L30"],
			shadowclaw: ["8M"],
			shadowsneak: ["8L13"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			spite: ["8L10", "8L1"],
			substitute: ["8M"],
			suckerpunch: ["8L40"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trick: ["8L58"],
			trickroom: ["8M"],
			willowisp: ["8M", "8L16"],
		},
	},
	duskull: {
		learnset: {
			astonish: ["8L1"],
			attract: ["8M"],
			blizzard: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confuseray: ["8L12"],
			curse: ["8L36"],
			darkpulse: ["8M"],
			destinybond: ["8E"],
			disable: ["8L4"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			futuresight: ["8L44"],
			grudge: ["8E"],
			haze: ["8E"],
			hex: ["8L32"],
			icebeam: ["8M"],
			imprison: ["8E"],
			leer: ["8L1"],
			meanlook: ["8L28"],
			memento: ["8E"],
			nightshade: ["8L16"],
			painsplit: ["8E"],
			payback: ["8M", "8L20"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			shadowball: ["8M", "8L40"],
			shadowsneak: ["8L8"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
			willowisp: ["8M", "8L24"],
		},
	},
	dusclops: {
		learnset: {
			astonish: ["8L1"],
			attract: ["8M"],
			bind: ["8L1"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confuseray: ["8L12"],
			curse: ["8L36"],
			darkpulse: ["8M"],
			disable: ["8L1"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			firepunch: ["8L1"],
			flash: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			futuresight: ["8L48"],
			gigaimpact: ["8M"],
			gravity: ["8L1"],
			hex: ["8L32"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			icepunch: ["8L1"],
			leer: ["8L1"],
			meanlook: ["8L28"],
			nightshade: ["8L16"],
			payback: ["8M", "8L20"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			shadowball: ["8M", "8L42"],
			shadowpunch: ["8L1"],
			shadowsneak: ["8L1"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			thunderpunch: ["8L1"],
			torment: ["8M"],
			trickroom: ["8M"],
			willowisp: ["8M", "8L24"],
		},
	},
	tropius: {
		learnset: {
			aerialace: ["8M"],
			airslash: ["8L36"],
			attract: ["8M"],
			bodyslam: ["8L41"],
			bulldoze: ["8M"],
			bulletseed: ["8M"],
			curse: ["8E"],
			cut: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			dragondance: ["8L30", "8E"],
			dragonhammer: ["8L46", "8E"],
			dragonpulse: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fly: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growth: ["8L1"],
			gust: ["8L1"],
			headbutt: ["8E"],
			hyperbeam: ["8M"],
			leafblade: ["8E"],
			leafstorm: ["8L61", "8L1", "8E"],
			leaftornado: ["8L26"],
			leechseed: ["8E"],
			leer: ["8L1"],
			magicalleaf: ["8L16"],
			naturepower: ["8E"],
			protect: ["8M"],
			razorleaf: ["8L1"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			roost: ["8M"],
			safeguard: ["8M"],
			slam: ["8E"],
			sleeptalk: ["8M"],
			solarbeam: ["8M", "8L56"],
			steelwing: ["8M"],
			stomp: ["8L10"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L6"],
			swordsdance: ["8M"],
			synthesis: ["8L50", "8E"],
			whirlwind: ["8L21"],
		},
	},
	chimecho: {
		learnset: {
			astonish: ["8L7", "8L1"],
			attract: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confusion: ["8L10", "8L1"],
			cosmicpower: ["8E"],
			curse: ["8E"],
			dazzlinggleam: ["8M"],
			disable: ["8E"],
			doubleedge: ["8L42"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			entrainment: ["8L1"],
			extrasensory: ["8L22"],
			facade: ["8M"],
			flash: ["8M"],
			futuresight: ["8E"],
			grassknot: ["8M"],
			growl: ["8L4", "8L1"],
			healbell: ["8L27"],
			healingwish: ["8L57", "8L1"],
			healpulse: ["8L47"],
			hypnosis: ["8E"],
			lastresort: ["8L1"],
			lightscreen: ["8M", "8L16"],
			perishsong: ["8E"],
			protect: ["8M"],
			psychic: ["8M", "8L52"],
			psychup: ["8M"],
			raindance: ["8M"],
			recover: ["8E"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			safeguard: ["8M", "8L37"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			storedpower: ["8E"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			takedown: ["8L19"],
			taunt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
			uproar: ["8L32"],
			wish: ["8E"],
			wrap: ["8L1"],
			yawn: ["8L13"],
		},
	},
	absol: {
		learnset: {
			aerialace: ["8M"],
			assurance: ["8E"],
			attract: ["8M"],
			batonpass: ["8E"],
			bite: ["8E"],
			blizzard: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			curse: ["8E"],
			cut: ["8M"],
			darkpulse: ["8M"],
			detect: ["8L15"],
			doubleedge: ["8E"],
			doubleteam: ["8M", "8L5"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			feint: ["8E"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			focusenergy: ["8L35"],
			futuresight: ["8L50"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hex: ["8E"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			knockoff: ["8L10"],
			leer: ["8L1"],
			magiccoat: ["8E"],
			meanlook: ["8E"],
			megahorn: ["8E"],
			nightslash: ["8L30"],
			payback: ["8M"],
			perishsong: ["8L55", "8E"],
			playrough: ["8E"],
			protect: ["8M"],
			psychup: ["8M"],
			quickattack: ["8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			slash: ["8L25"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L40", "8E"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L45"],
			taunt: ["8M", "8L20"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			waterpulse: ["8M"],
			willowisp: ["8M"],
			xscissor: ["8M"],
			zenheadbutt: ["8E"],
		},
	},
	wynaut: {
		learnset: {
			amnesia: ["8L1"],
			charm: ["8L1"],
			counter: ["8L1"],
			destinybond: ["8L1"],
			encore: ["8L1"],
			mirrorcoat: ["8L1"],
			safeguard: ["8M", "8L1"],
			splash: ["8L1"],
		},
	},
	snorunt: {
		learnset: {
			astonish: ["8L1"],
			attract: ["8M"],
			avalanche: ["8M"],
			bite: ["8L35"],
			blizzard: ["8M", "8L60"],
			block: ["8E"],
			crunch: ["8L55"],
			disable: ["8E"],
			doubleteam: ["8M", "8L10"],
			endure: ["8M"],
			facade: ["8M"],
			faketears: ["8E"],
			flash: ["8M"],
			frostbreath: ["8L30"],
			hail: ["8M", "8L45"],
			headbutt: ["8L50"],
			hex: ["8E"],
			icebeam: ["8M"],
			icefang: ["8L40"],
			iceshard: ["8L15"],
			iciclecrash: ["8E"],
			icywind: ["8L25"],
			leer: ["8L5"],
			lightscreen: ["8M"],
			powdersnow: ["8L1"],
			protect: ["8M", "8L20"],
			raindance: ["8M"],
			rest: ["8M"],
			rollout: ["8E"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			spikes: ["8E"],
			substitute: ["8M"],
			swagger: ["8M"],
			switcheroo: ["8E"],
			waterpulse: ["8M"],
			weatherball: ["8E"],
		},
	},
	glalie: {
		learnset: {
			astonish: ["8L1"],
			attract: ["8M"],
			avalanche: ["8M"],
			bite: ["8L35"],
			blizzard: ["8M", "8L68"],
			bulldoze: ["8M"],
			crunch: ["8L61"],
			darkpulse: ["8M"],
			doubleteam: ["8M", "8L1"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			freezedry: ["8L1"],
			frostbreath: ["8L30"],
			gigaimpact: ["8M"],
			gyroball: ["8M"],
			hail: ["8M", "8L47"],
			headbutt: ["8L54"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			icefang: ["8L40"],
			iceshard: ["8L15"],
			icywind: ["8L25"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			payback: ["8M"],
			powdersnow: ["8L1"],
			protect: ["8M", "8L20"],
			raindance: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			sheercold: ["8L1"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			torment: ["8M"],
			waterpulse: ["8M"],
		},
	},
	spheal: {
		learnset: {
			aquaring: ["8E"],
			attract: ["8M"],
			aurorabeam: ["8L28"],
			bellydrum: ["8E"],
			blizzard: ["8M", "8L44"],
			bodyslam: ["8L36"],
			brine: ["8M", "8L24"],
			bulldoze: ["8M"],
			curse: ["8E"],
			defensecurl: ["8L1"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			encore: ["8L33"],
			endure: ["8M"],
			facade: ["8M"],
			fissure: ["8E"],
			growl: ["8L4"],
			hail: ["8M", "8L48"],
			icebeam: ["8M"],
			irontail: ["8M"],
			powdersnow: ["8L12"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L16"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L1", "8E"],
			sheercold: ["8L52"],
			sleeptalk: ["8M"],
			snore: ["8L20"],
			spitup: ["8E"],
			stockpile: ["8E"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M", "8L40"],
			swagger: ["8M"],
			swallow: ["8E"],
			waterfall: ["8M"],
			watergun: ["8L8"],
			waterpulse: ["8M"],
			yawn: ["8E"],
		},
	},
	sealeo: {
		learnset: {
			attract: ["8M"],
			aurorabeam: ["8L28"],
			blizzard: ["8M", "8L52"],
			bodyslam: ["8L40"],
			brine: ["8M", "8L24"],
			bulldoze: ["8M"],
			defensecurl: ["8L1"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			encore: ["8L35"],
			endure: ["8M"],
			facade: ["8M"],
			growl: ["8L1"],
			hail: ["8M", "8L58"],
			icebeam: ["8M"],
			irontail: ["8M"],
			powdersnow: ["8L12"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L16"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L1"],
			sheercold: ["8L64"],
			sleeptalk: ["8M"],
			snore: ["8L20"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M", "8L46"],
			swagger: ["8M", "8L1"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
		},
	},
	walrein: {
		learnset: {
			attract: ["8M"],
			aurorabeam: ["8L28"],
			avalanche: ["8M"],
			blizzard: ["8M", "8L56"],
			bodyslam: ["8L40"],
			brine: ["8M", "8L24"],
			bulldoze: ["8M"],
			crunch: ["8L1"],
			defensecurl: ["8L1"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			encore: ["8L35"],
			endure: ["8M"],
			facade: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hail: ["8M", "8L64"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			icefang: ["8L1"],
			irontail: ["8M"],
			powdersnow: ["8L12"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L16"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L1"],
			sheercold: ["8L72"],
			sleeptalk: ["8M"],
			snore: ["8L20"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M", "8L48"],
			swagger: ["8M", "8L1"],
			swordsdance: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
		},
	},
	clamperl: {
		learnset: {
			aquaring: ["8E"],
			attract: ["8M"],
			blizzard: ["8M"],
			bodyslam: ["8E"],
			brine: ["8M"],
			confuseray: ["8E"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			hail: ["8M"],
			icebeam: ["8M"],
			irondefense: ["8L1"],
			muddywater: ["8E"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			scald: ["8M"],
			shellsmash: ["8L50"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			supersonic: ["8E"],
			surf: ["8M"],
			swagger: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			whirlpool: ["8L1"],
		},
	},
	huntail: {
		learnset: {
			aquatail: ["8L39"],
			attract: ["8M"],
			batonpass: ["8L29"],
			bite: ["8L1"],
			blizzard: ["8M"],
			brine: ["8M", "8L19"],
			coil: ["8L45"],
			crunch: ["8L34"],
			dive: ["8L26"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hydropump: ["8L50"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			icefang: ["8L16"],
			irondefense: ["8L1"],
			protect: ["8M"],
			raindance: ["8M", "8L11"],
			rest: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			scaryface: ["8L9"],
			screech: ["8L5"],
			shellsmash: ["8L1"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L23"],
			surf: ["8M"],
			swagger: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L14"],
			whirlpool: ["8L1"],
		},
	},
	gorebyss: {
		learnset: {
			agility: ["8L9"],
			amnesia: ["8L16"],
			aquaring: ["8L19"],
			aquatail: ["8L39"],
			attract: ["8M"],
			batonpass: ["8L29"],
			blizzard: ["8M"],
			brine: ["8M"],
			coil: ["8L45"],
			confusion: ["8L1"],
			dive: ["8L26"],
			doubleteam: ["8M"],
			drainingkiss: ["8L11"],
			endure: ["8M"],
			facade: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hydropump: ["8L50"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irondefense: ["8L1"],
			protect: ["8M"],
			psychic: ["8M", "8L34"],
			psychup: ["8M"],
			raindance: ["8M", "8L5"],
			rest: ["8M"],
			safeguard: ["8M", "8L23"],
			scald: ["8M"],
			shadowball: ["8M"],
			shellsmash: ["8L1"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L14"],
			whirlpool: ["8L1"],
		},
	},
	relicanth: {
		learnset: {
			amnesia: ["8E"],
			ancientpower: ["8L10"],
			aquatail: ["8L30", "8E"],
			attract: ["8M"],
			blizzard: ["8M"],
			brine: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			dive: ["8L20"],
			doubleedge: ["8L50"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flail: ["8L40"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			harden: ["8L1"],
			headsmash: ["8L55"],
			hydropump: ["8L45"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			muddywater: ["8E"],
			mudshot: ["8E"],
			mudslap: ["8E"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L35"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			scald: ["8M"],
			skullbash: ["8E"],
			sleeptalk: ["8M"],
			snore: ["8E"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L25"],
			waterfall: ["8M"],
			watergun: ["8L5"],
			waterpulse: ["8M"],
			yawn: ["8L15"],
			zenheadbutt: ["8E"],
		},
	},
	luvdisc: {
		learnset: {
			agility: ["8L7"],
			aquajet: ["8E"],
			aquaring: ["8L40", "8E"],
			attract: ["8M", "8L20"],
			babydolleyes: ["8L37"],
			blizzard: ["8M"],
			brine: ["8M", "8L22"],
			charm: ["8L1"],
			doubleteam: ["8M"],
			drainingkiss: ["8L9"],
			endure: ["8M"],
			entrainment: ["8E"],
			facade: ["8M"],
			flail: ["8L26"],
			hail: ["8M"],
			healpulse: ["8E"],
			hydropump: ["8L46"],
			icebeam: ["8M"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			safeguard: ["8M", "8L49"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			soak: ["8L42"],
			splash: ["8E"],
			substitute: ["8M"],
			supersonic: ["8E"],
			surf: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8L31"],
			tackle: ["8L1"],
			takedown: ["8L34"],
			tearfullook: ["8L13"],
			waterfall: ["8M"],
			watergun: ["8L4"],
			waterpulse: ["8M", "8L17"],
		},
	},
	bagon: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			bite: ["8L5"],
			brickbreak: ["8M"],
			crunch: ["8L25"],
			cut: ["8M"],
			defensecurl: ["8E"],
			doubleedge: ["8L55"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonbreath: ["8L10"],
			dragonclaw: ["8M", "8L31"],
			dragondance: ["8E"],
			dragonpulse: ["8M"],
			dragonrush: ["8E"],
			ember: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			firefang: ["8E"],
			flamethrower: ["8M", "8L45"],
			focusenergy: ["8L40"],
			headbutt: ["8L15"],
			hydropump: ["8E"],
			leer: ["8L1"],
			outrage: ["8L50"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scaryface: ["8L20"],
			shadowclaw: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thrash: ["8E"],
			twister: ["8E"],
			zenheadbutt: ["8L35"],
		},
	},
	shelgon: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			bite: ["8L1"],
			brickbreak: ["8M"],
			crunch: ["8L25"],
			cut: ["8M"],
			doubleedge: ["8L67"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonbreath: ["8L1"],
			dragonclaw: ["8M", "8L33"],
			dragonpulse: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M", "8L53"],
			focusenergy: ["8L46"],
			headbutt: ["8L15"],
			leer: ["8L1"],
			outrage: ["8L60"],
			protect: ["8M", "8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scaryface: ["8L20"],
			shadowclaw: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			zenheadbutt: ["8L39"],
		},
	},
	salamence: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			bite: ["8L1"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			crunch: ["8L25"],
			cut: ["8M"],
			defog: ["8M"],
			doubleedge: ["8L73"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonbreath: ["8L1"],
			dragonclaw: ["8M", "8L33"],
			dragonpulse: ["8M"],
			dragontail: ["8L1"],
			earthquake: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M", "8L55"],
			fly: ["8M", "8L1"],
			focusenergy: ["8L46"],
			gigaimpact: ["8M"],
			headbutt: ["8L15"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			outrage: ["8L64"],
			protect: ["8M", "8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			roost: ["8M"],
			scaryface: ["8L20"],
			shadowclaw: ["8M"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			zenheadbutt: ["8L39"],
		},
	},
	beldum: {
		learnset: {
			tackle: ["8L1"],
		},
	},
	metang: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L66"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			bulletpunch: ["8L1"],
			confusion: ["8L1"],
			cut: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			flashcannon: ["8M", "8L18"],
			grassknot: ["8M"],
			gyroball: ["8M"],
			hyperbeam: ["8M", "8L74"],
			irondefense: ["8L58"],
			lightscreen: ["8M"],
			magnetrise: ["8L12"],
			metalclaw: ["8L1"],
			meteormash: ["8L50"],
			protect: ["8M"],
			psychic: ["8M", "8L34"],
			psychup: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			scaryface: ["8L42"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			stealthrock: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L26"],
			zenheadbutt: ["8L6"],
		},
	},
	metagross: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L72"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			bulletpunch: ["8L1"],
			confusion: ["8L1"],
			cut: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			flashcannon: ["8M", "8L16"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			gyroball: ["8M"],
			hammerarm: ["8L1"],
			hyperbeam: ["8M", "8L82"],
			irondefense: ["8L62"],
			lightscreen: ["8M"],
			magnetrise: ["8L12"],
			metalclaw: ["8L1"],
			meteormash: ["8L52"],
			protect: ["8M"],
			psychic: ["8M", "8L34"],
			psychup: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			scaryface: ["8L42"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			stealthrock: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L26"],
			zenheadbutt: ["8L6"],
		},
	},
	regirock: {
		learnset: {
			ancientpower: ["8L12"],
			brickbreak: ["8M"],
			bulldoze: ["8M", "8L6"],
			chargebeam: ["8M", "8L1"],
			curse: ["8L30"],
			dig: ["8M"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M", "8L78"],
			facade: ["8M"],
			flashcannon: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			hammerarm: ["8L42"],
			hyperbeam: ["8M", "8L72"],
			irondefense: ["8L36"],
			lockon: ["8L60", "8S0"],
			protect: ["8M"],
			psychup: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M", "8L24"],
			rocksmash: ["8M"],
			rockthrow: ["8L1"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stomp: ["8L18"],
			stoneedge: ["8M", "8L48", "8S0"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			superpower: ["8L54", "8S0"],
			swagger: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			zapcannon: ["8L66", "8S0"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, isHidden: true, moves: ['zapcannon', 'lockon', 'superpower', 'stoneedge']},
		],
	},
	regice: {
		learnset: {
			amnesia: ["8L36"],
			ancientpower: ["8L12"],
			avalanche: ["8M"],
			blizzard: ["8M", "8L48", "8S0"],
			brickbreak: ["8M"],
			bulldoze: ["8M", "8L6"],
			chargebeam: ["8M", "8L1"],
			curse: ["8L30"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M", "8L78"],
			facade: ["8M"],
			flashcannon: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hammerarm: ["8L42"],
			hyperbeam: ["8M", "8L72"],
			icebeam: ["8M", "8L24"],
			icywind: ["8L1"],
			lockon: ["8L60", "8S0"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			stomp: ["8L18"],
			strength: ["8M"],
			substitute: ["8M"],
			superpower: ["8L54", "8S0"],
			swagger: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			zapcannon: ["8L66", "8S0"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, isHidden: true, moves: ['zapcannon', 'lockon', 'superpower', 'blizzard']},
		],
	},
	registeel: {
		learnset: {
			aerialace: ["8M"],
			amnesia: ["8L36"],
			ancientpower: ["8L12"],
			brickbreak: ["8M"],
			bulldoze: ["8M", "8L6"],
			chargebeam: ["8M", "8L1"],
			curse: ["8L30"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M", "8L78"],
			facade: ["8M"],
			flashcannon: ["8M", "8L24"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			hammerarm: ["8L42"],
			heavyslam: ["8L48", "8S0"],
			hyperbeam: ["8M", "8L72"],
			irondefense: ["8L36"],
			ironhead: ["8L24"],
			lockon: ["8L60", "8S0"],
			metalclaw: ["8L1"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stomp: ["8L18"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			superpower: ["8L54", "8S0"],
			swagger: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			zapcannon: ["8L66", "8S0"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, isHidden: true, moves: ['zapcannon', 'lockon', 'superpower', 'heavyslam']},
		],
	},
	latias: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			charm: ["8L1"],
			confusion: ["8L15"],
			cut: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonbreath: ["8L25"],
			dragonclaw: ["8M"],
			dragonpulse: ["8M", "8L45"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fly: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			guardsplit: ["8L65", "8S0"],
			healingwish: ["8L70", "8S0"],
			healpulse: ["8L50"],
			helpinghand: ["8L5"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			lightscreen: ["8M"],
			mistball: ["8L35"],
			protect: ["8M"],
			psychic: ["8M", "8L60", "8S0"],
			psychoshift: ["8L75"],
			psychup: ["8M"],
			raindance: ["8M"],
			recover: ["8L10"],
			reflect: ["8M"],
			reflecttype: ["8L55", "8S0"],
			rest: ["8M"],
			roar: ["8M"],
			roost: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			steelwing: ["8M"],
			storedpower: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tailwind: ["8L20"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterfall: ["8M"],
			waterpulse: ["8M"],
			wish: ["8L30"],
			zenheadbutt: ["8L40"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, moves: ['healingwish', 'guardsplit', 'psychic', 'reflecttype']},
		],
	},
	latios: {
		learnset: {
			aerialace: ["8M"],
			allyswitch: ["8L30"],
			attract: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confusion: ["8L15"],
			cut: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonbreath: ["8L25"],
			dragonclaw: ["8M"],
			dragondance: ["8L1"],
			dragonpulse: ["8M", "8L45"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fly: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			healpulse: ["8L50"],
			helpinghand: ["8L5"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			lightscreen: ["8M"],
			lusterpurge: ["8L35"],
			memento: ["8L70", "8S0"],
			powersplit: ["8L65", "8S0"],
			protect: ["8M"],
			psychic: ["8M", "8L60", "8S0"],
			psychoshift: ["8L75"],
			psychup: ["8M"],
			raindance: ["8M"],
			recover: ["8L10"],
			reflect: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			roost: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			simplebeam: ["8L55", "8S0"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			steelwing: ["8M"],
			storedpower: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tailwind: ["8L20"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterfall: ["8M"],
			waterpulse: ["8M"],
			zenheadbutt: ["8L40"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, moves: ['memento', 'powersplit', 'psychic', 'simplebeam']},
		],
	},
	kyogre: {
		learnset: {
			ancientpower: ["8L1"],
			aquaring: ["8L54", "8S0"],
			aquatail: ["8L9"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			bodyslam: ["8L1"],
			brickbreak: ["8M"],
			brine: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M", "8L18"],
			doubleedge: ["8L81"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hydropump: ["8L72"],
			hyperbeam: ["8M"],
			icebeam: ["8M", "8L36", "8S0"],
			muddywater: ["8L27"],
			originpulse: ["8L63", "8S0"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			scald: ["8M"],
			scaryface: ["8L1"],
			sheercold: ["8L45", "8S0"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterfall: ["8M"],
			waterpulse: ["8M", "8L1"],
			waterspout: ["8L90"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, moves: ['originpulse', 'aquaring', 'sheercold', 'icebeam']},
		],
	},
	groudon: {
		learnset: {
			aerialace: ["8M"],
			ancientpower: ["8L1"],
			brickbreak: ["8M"],
			bulkup: ["8M", "8L18"],
			bulldoze: ["8M"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonclaw: ["8M"],
			dragonpulse: ["8M"],
			earthpower: ["8L9"],
			earthquake: ["8M", "8L27"],
			endure: ["8M"],
			eruption: ["8L90"],
			facade: ["8M"],
			fireblast: ["8M", "8L72"],
			fissure: ["8L45", "8S0"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			gigaimpact: ["8M"],
			hammerarm: ["8L36", "8S0"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			lavaplume: ["8L1"],
			mudshot: ["8L1"],
			overheat: ["8M"],
			precipiceblades: ["8L63", "8S0"],
			protect: ["8M"],
			psychup: ["8M"],
			rest: ["8M", "8L54", "8S0"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			scaryface: ["8L1"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M", "8L81"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, moves: ['precipiceblades', 'rest', 'fissure', 'hammerarm']},
		],
	},
	rayquaza: {
		learnset: {
			aerialace: ["8M"],
			airslash: ["8L1"],
			ancientpower: ["8L1"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			crunch: ["8L9"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonascent: ["8L1"],
			dragonclaw: ["8M"],
			dragondance: ["8L18"],
			dragonpulse: ["8M", "8L36", "8S0"],
			earthquake: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			extremespeed: ["8L27"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M"],
			fly: ["8M", "8L63", "8S0"],
			focusblast: ["8M"],
			gigaimpact: ["8M"],
			gyroball: ["8M"],
			hurricane: ["8L72"],
			hyperbeam: ["8M", "8L90"],
			hypervoice: ["8L45", "8S0"],
			icebeam: ["8M"],
			irontail: ["8M"],
			outrage: ["8L81"],
			overheat: ["8M"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M", "8L54", "8S0"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			scaryface: ["8L1"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			twister: ["8L1"],
			waterfall: ["8M"],
			waterpulse: ["8M"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, moves: ['fly', 'rest', 'hypervoice', 'dragonpulse']},
		],
	},
	jirachi: {
		learnset: {
			aerialace: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confusion: ["8L1", "8S0"],
			cosmicpower: ["8L84"],
			dazzlinggleam: ["8M"],
			doomdesire: ["8L98"],
			doubleedge: ["8L77"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			flashcannon: ["8M"],
			fling: ["8M"],
			futuresight: ["8L70"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			gravity: ["8L35"],
			healingwish: ["8L56"],
			helpinghand: ["8L14"],
			hyperbeam: ["8M"],
			lastresort: ["8L91"],
			lifedew: ["8L21"],
			lightscreen: ["8M"],
			meteormash: ["8L49"],
			protect: ["8M"],
			psychic: ["8M", "8L42"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M", "8L63"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L7"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			trickroom: ["8M"],
			uturn: ["8M"],
			waterpulse: ["8M"],
			wish: ["8L1", "8S0"],
			zenheadbutt: ["8L28"],
		},
		eventData: [
			{generation: 8, level: 5, moves: ['confusion', 'wish']},
		],
	},
	deoxys: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L55"],
			amnesia: ["8L55"],
			avalanche: ["8M"],
			brickbreak: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			cosmicpower: ["8L55"],
			counter: ["8L73"],
			cut: ["8M"],
			darkpulse: ["8M"],
			doubleteam: ["8M", "8L13"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			extremespeed: ["8L73"],
			facade: ["8M"],
			flash: ["8M"],
			flashcannon: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			hyperbeam: ["8M", "8L73"],
			icebeam: ["8M"],
			irondefense: ["8L55"],
			knockoff: ["8L19"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			lowsweep: ["8M"],
			mirrorcoat: ["8L73"],
			nastyplot: ["8M"],
			nightshade: ["8L7"],
			poisonjab: ["8M"],
			protect: ["8M"],
			psychic: ["8M", "8L31"],
			psychoboost: ["8L67"],
			psychoshift: ["8L43"],
			psychup: ["8M"],
			raindance: ["8M"],
			recover: ["8L61"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			spikes: ["8L25"],
			stealthrock: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			superpower: ["8L37"],
			swagger: ["8M"],
			swift: ["8L37"],
			switcheroo: ["8L37"],
			taunt: ["8M", "8L19"],
			teleport: ["8L13"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			toxicspikes: ["8L25"],
			trickroom: ["8M"],
			waterpulse: ["8M"],
			wrap: ["8L1"],
			zapcannon: ["8L61"],
			zenheadbutt: ["8L49"],
		},
	},
	turtwig: {
		learnset: {
			amnesia: ["8E"],
			attract: ["8M"],
			bite: ["8L21"],
			bodyslam: ["8E"],
			bulletseed: ["8M"],
			crunch: ["8L37"],
			curse: ["8L17"],
			cut: ["8M"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			earthpower: ["8E"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M", "8L41"],
			grassknot: ["8M"],
			grassyterrain: ["8E"],
			growth: ["8L10", "8E"],
			heavyslam: ["8E"],
			irontail: ["8M"],
			leafage: ["8L6"],
			leafstorm: ["8L45"],
			leechseed: ["8L29"],
			lightscreen: ["8M"],
			megadrain: ["8L25"],
			protect: ["8M"],
			razorleaf: ["8L13"],
			reflect: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			sandtomb: ["8E"],
			seedbomb: ["8E"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			spitup: ["8E"],
			stealthrock: ["8M"],
			stockpile: ["8E"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			superpower: ["8E"],
			swagger: ["8M"],
			swallow: ["8E"],
			swordsdance: ["8M"],
			synthesis: ["8L33"],
			tackle: ["8L1"],
			thrash: ["8E"],
			tickle: ["8E"],
			wideguard: ["8E"],
			withdraw: ["8L5"],
			workup: ["8M"],
			worryseed: ["8E"],
		},
	},
	grotle: {
		learnset: {
			absorb: ["8L1"],
			attract: ["8M"],
			bite: ["8L22"],
			bulletseed: ["8M"],
			crunch: ["8L42"],
			curse: ["8L17"],
			cut: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M", "8L47"],
			grassknot: ["8M"],
			growth: ["8L10"],
			irontail: ["8M"],
			leafage: ["8L6"],
			leafstorm: ["8L52"],
			leechseed: ["8L32"],
			lightscreen: ["8M"],
			megadrain: ["8L27"],
			protect: ["8M"],
			razorleaf: ["8L13"],
			reflect: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			synthesis: ["8L37"],
			tackle: ["8L1"],
			withdraw: ["8L5", "8L1"],
			workup: ["8M"],
		},
	},
	torterra: {
		learnset: {
			absorb: ["8L1"],
			attract: ["8M"],
			bite: ["8L22"],
			bulldoze: ["8M"],
			bulletseed: ["8M"],
			crunch: ["8L45"],
			curse: ["8L17"],
			cut: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L1"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			frenzyplant: ["8T"],
			gigadrain: ["8M", "8L51"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growth: ["8L10"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			leafage: ["8L6"],
			leafstorm: ["8L57"],
			leechseed: ["8L33"],
			lightscreen: ["8M"],
			megadrain: ["8L27"],
			protect: ["8M"],
			razorleaf: ["8L13", "8L1"],
			reflect: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			synthesis: ["8L39"],
			tackle: ["8L1"],
			withdraw: ["8L5", "8L1"],
			woodhammer: ["8L1"],
			workup: ["8M"],
		},
	},
	chimchar: {
		learnset: {
			acrobatics: ["8L39"],
			aerialace: ["8M"],
			attract: ["8M"],
			blazekick: ["8E"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			counter: ["8E"],
			cut: ["8M"],
			dig: ["8M"],
			doublekick: ["8E"],
			doubleteam: ["8M"],
			ember: ["8L6"],
			encore: ["8E"],
			endure: ["8M"],
			facade: ["8M", "8L31"],
			fakeout: ["8E"],
			fireblast: ["8M"],
			firepunch: ["8E"],
			firespin: ["8L33"],
			flamethrower: ["8M", "8L47"],
			flamewheel: ["8L17"],
			fling: ["8M"],
			focusenergy: ["8E"],
			focuspunch: ["8M"],
			furyswipes: ["8L15"],
			grassknot: ["8M"],
			heatwave: ["8E"],
			helpinghand: ["8E"],
			irontail: ["8M"],
			leer: ["8L1"],
			lowsweep: ["8M"],
			nastyplot: ["8M", "8L23"],
			overheat: ["8M"],
			poweruppunch: ["8L12", "8E"],
			protect: ["8M"],
			quickguard: ["8E"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rocksmash: ["8M"],
			scratch: ["8L1"],
			shadowclaw: ["8M"],
			slackoff: ["8L41"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			strength: ["8M"],
			submission: ["8E"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			taunt: ["8M", "8L9"],
			thunderpunch: ["8E"],
			torment: ["8M", "8L25"],
			uturn: ["8M"],
			willowisp: ["8M"],
			workup: ["8M"],
		},
	},
	monferno: {
		learnset: {
			acrobatics: ["8L46"],
			aerialace: ["8M"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			closecombat: ["8L36"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			ember: ["8L7", "8L1"],
			endure: ["8M"],
			facade: ["8M", "8L1"],
			feint: ["8L26"],
			fireblast: ["8M"],
			firespin: ["8L39"],
			flamethrower: ["8M", "8L1"],
			flamewheel: ["8L19"],
			flareblitz: ["8L56"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			furyswipes: ["8L16"],
			grassknot: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			lowsweep: ["8M"],
			machpunch: ["8L1"],
			nastyplot: ["8M", "8L1"],
			overheat: ["8M"],
			poisonjab: ["8M"],
			poweruppunch: ["8L12"],
			protect: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scratch: ["8L1"],
			shadowclaw: ["8M"],
			slackoff: ["8L49"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			taunt: ["8M", "8L9"],
			torment: ["8M", "8L29"],
			uturn: ["8M"],
			willowisp: ["8M"],
			workup: ["8M"],
		},
	},
	infernape: {
		learnset: {
			acrobatics: ["8L52"],
			aerialace: ["8M"],
			attract: ["8M"],
			blastburn: ["8T"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M", "8L58"],
			closecombat: ["8L1"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			ember: ["8L7", "8L1"],
			endure: ["8M"],
			facade: ["8M", "8L1"],
			feint: ["8L26"],
			fireblast: ["8M"],
			firespin: ["8L42"],
			flamethrower: ["8M", "8L1"],
			flamewheel: ["8L19"],
			flareblitz: ["8L68", "8L1"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			furyswipes: ["8L16"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			lowsweep: ["8M"],
			machpunch: ["8L1"],
			nastyplot: ["8M", "8L1"],
			overheat: ["8M"],
			poisonjab: ["8M"],
			poweruppunch: ["8L12"],
			protect: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scratch: ["8L1"],
			shadowclaw: ["8M"],
			slackoff: ["8L1"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			taunt: ["8M", "8L9", "8L1"],
			torment: ["8M", "8L1"],
			uturn: ["8M", "8L29"],
			willowisp: ["8M"],
			workup: ["8M"],
		},
	},
	piplup: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8E"],
			aquaring: ["8E"],
			attract: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M", "8L29"],
			bubblebeam: ["8L18"],
			charm: ["8L11"],
			cut: ["8M"],
			defog: ["8M"],
			dig: ["8M"],
			doublehit: ["8E"],
			doubleteam: ["8M"],
			drillpeck: ["8L39"],
			endure: ["8M"],
			facade: ["8M"],
			featherdance: ["8E"],
			flail: ["8E"],
			fling: ["8M"],
			furyattack: ["8L25"],
			grassknot: ["8M"],
			growl: ["8L4"],
			hail: ["8M"],
			hydropump: ["8L43", "8E"],
			icebeam: ["8M"],
			icywind: ["8E"],
			mist: ["8L36"],
			mudslap: ["8E"],
			peck: ["8L15"],
			pluck: ["8M"],
			pound: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			snore: ["8E"],
			stealthrock: ["8M"],
			substitute: ["8M"],
			supersonic: ["8E"],
			surf: ["8M"],
			swagger: ["8M", "8L22"],
			waterfall: ["8M"],
			watergun: ["8L6"],
			waterpulse: ["8M"],
			whirlpool: ["8L32"],
			workup: ["8M"],
			yawn: ["8E"],
		},
	},
	prinplup: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M", "8L33"],
			bubblebeam: ["8L19"],
			charm: ["8L11"],
			cut: ["8M"],
			defog: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			drillpeck: ["8L46"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			furyattack: ["8L28"],
			grassknot: ["8M"],
			growl: ["8L4", "8L1"],
			hail: ["8M"],
			hydropump: ["8L50"],
			icebeam: ["8M"],
			metalclaw: ["8L1"],
			mist: ["8L42"],
			peck: ["8L15"],
			pluck: ["8M"],
			pound: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			shadowclaw: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M", "8L24"],
			tackle: ["8L1"],
			waterfall: ["8M"],
			watergun: ["8L8"],
			waterpulse: ["8M"],
			whirlpool: ["8L37"],
			workup: ["8M"],
		},
	},
	empoleon: {
		learnset: {
			aerialace: ["8M"],
			aquajet: ["8L1"],
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M", "8L33"],
			bubblebeam: ["8L19"],
			bulldoze: ["8M"],
			charm: ["8L1"],
			cut: ["8M"],
			defog: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			drillpeck: ["8L52"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flashcannon: ["8M"],
			fling: ["8M"],
			furyattack: ["8L28"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L4", "8L1"],
			hail: ["8M"],
			hydrocannon: ["8T"],
			hydropump: ["8L59"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			metalclaw: ["8L1"],
			mist: ["8L46"],
			peck: ["8L15"],
			pluck: ["8M"],
			pound: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			shadowclaw: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			steelwing: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M", "8L24"],
			swordsdance: ["8M", "8L11"],
			tackle: ["8L1"],
			waterfall: ["8M"],
			watergun: ["8L8"],
			waterpulse: ["8M"],
			whirlpool: ["8L39"],
			workup: ["8M"],
		},
	},
	starly: {
		learnset: {
			aerialace: ["8M", "8L25"],
			agility: ["8L33"],
			astonish: ["8E"],
			attract: ["8M"],
			bravebird: ["8L37"],
			defog: ["8M"],
			detect: ["8E"],
			doubleedge: ["8E"],
			doubleteam: ["8M", "8L13"],
			endeavor: ["8L17"],
			endure: ["8M"],
			facade: ["8M"],
			featherdance: ["8E"],
			finalgambit: ["8L41"],
			fly: ["8M"],
			furyattack: ["8E"],
			growl: ["8L1"],
			pluck: ["8M"],
			protect: ["8M"],
			quickattack: ["8L5"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8E"],
			roost: ["8M"],
			sandattack: ["8E"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L29"],
			thief: ["8M"],
			uproar: ["8E"],
			uturn: ["8M"],
			whirlwind: ["8L21"],
			wingattack: ["8L9"],
			workup: ["8M"],
		},
	},
	staravia: {
		learnset: {
			aerialace: ["8M", "8L28"],
			agility: ["8L38"],
			attract: ["8M"],
			bravebird: ["8L43"],
			defog: ["8M"],
			doubleteam: ["8M", "8L13"],
			endeavor: ["8L18"],
			endure: ["8M"],
			facade: ["8M"],
			finalgambit: ["8L48"],
			fly: ["8M"],
			growl: ["8L1"],
			pluck: ["8M"],
			protect: ["8M"],
			quickattack: ["8L5", "8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L33"],
			thief: ["8M"],
			uturn: ["8M"],
			whirlwind: ["8L23"],
			wingattack: ["8L9"],
			workup: ["8M"],
		},
	},
	staraptor: {
		learnset: {
			aerialace: ["8M", "8L28"],
			agility: ["8L41"],
			attract: ["8M"],
			bravebird: ["8L49"],
			closecombat: ["8L1"],
			defog: ["8M"],
			doubleteam: ["8M", "8L13"],
			endeavor: ["8L18"],
			endure: ["8M"],
			facade: ["8M"],
			finalgambit: ["8L57"],
			fly: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hyperbeam: ["8M"],
			pluck: ["8M"],
			protect: ["8M"],
			quickattack: ["8L5", "8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L33"],
			thief: ["8M"],
			uturn: ["8M"],
			whirlwind: ["8L23"],
			wingattack: ["8L9", "8L1"],
			workup: ["8M"],
		},
	},
	bidoof: {
		learnset: {
			amnesia: ["8L41"],
			aquatail: ["8E"],
			attract: ["8M"],
			blizzard: ["8M"],
			chargebeam: ["8M"],
			crunch: ["8L25"],
			curse: ["8L49"],
			cut: ["8M"],
			defensecurl: ["8L5", "8E"],
			dig: ["8M"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			furyswipes: ["8E"],
			grassknot: ["8M"],
			growl: ["8L1"],
			headbutt: ["8L13"],
			icebeam: ["8M"],
			irontail: ["8M"],
			pluck: ["8M"],
			protect: ["8M"],
			quickattack: ["8E"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			rollout: ["8L9", "8E"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skullbash: ["8E"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			superfang: ["8L33"],
			superpower: ["8L45"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L37"],
			tackle: ["8L1"],
			takedown: ["8L29"],
			taunt: ["8M", "8L17"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			workup: ["8M"],
			yawn: ["8L21"],
		},
	},
	bibarel: {
		learnset: {
			amnesia: ["8L48"],
			aquajet: ["8L1"],
			attract: ["8M"],
			blizzard: ["8M"],
			bulldoze: ["8M"],
			chargebeam: ["8M"],
			crunch: ["8L28"],
			curse: ["8L58"],
			cut: ["8M"],
			defensecurl: ["8L5"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			headbutt: ["8L13"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			pluck: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rocksmash: ["8M"],
			rollout: ["8L9"],
			scald: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			superfang: ["8L38"],
			superpower: ["8L53"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L43"],
			tackle: ["8L1"],
			takedown: ["8L33"],
			taunt: ["8M", "8L18"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			workup: ["8M"],
			yawn: ["8L23"],
		},
	},
	kricketot: {
		learnset: {
			bugbite: ["8L16"],
			growl: ["8L1"],
			pound: ["8L1"],
			strugglebug: ["8L6"],
		},
	},
	kricketune: {
		learnset: {
			absorb: ["8L14"],
			aerialace: ["8M"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bugbite: ["8L1"],
			bugbuzz: ["8M", "8L46"],
			cut: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fellstinger: ["8L36"],
			flash: ["8M"],
			focusenergy: ["8L22"],
			furycutter: ["8L1"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hyperbeam: ["8M"],
			nightslash: ["8L42"],
			perishsong: ["8L50"],
			pound: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			screech: ["8L34"],
			sing: ["8L18"],
			slash: ["8L26"],
			sleeptalk: ["8M"],
			stickyweb: ["8L44"],
			strength: ["8M"],
			strugglebug: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			taunt: ["8M", "8L38"],
			xscissor: ["8M", "8L30"],
		},
	},
	shinx: {
		learnset: {
			attract: ["8M"],
			babydolleyes: ["8E"],
			bite: ["8L12"],
			charge: ["8L8"],
			chargebeam: ["8M"],
			crunch: ["8L36"],
			discharge: ["8L40"],
			doublekick: ["8E"],
			doubleteam: ["8M"],
			eerieimpulse: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			faketears: ["8E"],
			firefang: ["8E"],
			flash: ["8M"],
			helpinghand: ["8E"],
			howl: ["8E"],
			icefang: ["8E"],
			irontail: ["8M"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			nightslash: ["8E"],
			protect: ["8M"],
			quickattack: ["8E"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M", "8L20"],
			scaryface: ["8L28"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			spark: ["8L16"],
			strength: ["8M"],
			substitute: ["8M"],
			swagger: ["8M", "8L44"],
			swift: ["8E"],
			tackle: ["8L1"],
			takedown: ["8E"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderfang: ["8E"],
			thundershock: ["8L4"],
			thunderwave: ["8M", "8L32"],
			voltswitch: ["8M", "8L24"],
			wildcharge: ["8L48"],
		},
	},
	luxio: {
		learnset: {
			attract: ["8M"],
			bite: ["8L12"],
			charge: ["8L1"],
			chargebeam: ["8M"],
			crunch: ["8L48"],
			discharge: ["8L54"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M", "8L24"],
			scaryface: ["8L36"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			spark: ["8L18"],
			strength: ["8M"],
			substitute: ["8M"],
			swagger: ["8M", "8L60"],
			tackle: ["8L1"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thundershock: ["8L1"],
			thunderwave: ["8M", "8L42"],
			voltswitch: ["8M", "8L31"],
			wildcharge: ["8L68"],
		},
	},
	luxray: {
		learnset: {
			attract: ["8M"],
			bite: ["8L12"],
			charge: ["8L1"],
			chargebeam: ["8M"],
			crunch: ["8L56"],
			discharge: ["8L64"],
			doubleteam: ["8M"],
			electricterrain: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M", "8L24"],
			scaryface: ["8L40"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			spark: ["8L18"],
			strength: ["8M"],
			substitute: ["8M"],
			swagger: ["8M", "8L72"],
			tackle: ["8L1"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thundershock: ["8L1"],
			thunderwave: ["8M", "8L48"],
			voltswitch: ["8M", "8L33"],
			wildcharge: ["8L80"],
		},
	},
	budew: {
		learnset: {
			absorb: ["8L1"],
			attract: ["8M"],
			bulletseed: ["8M"],
			cottonspore: ["8E"],
			cut: ["8M"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			extrasensory: ["8E"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M"],
			grassknot: ["8M"],
			growth: ["8L1"],
			leafstorm: ["8E"],
			lifedew: ["8E"],
			mindreader: ["8E"],
			pinmissile: ["8E"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			razorleaf: ["8E"],
			rest: ["8M"],
			seedbomb: ["8E"],
			shadowball: ["8M"],
			sleeppowder: ["8E"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			spikes: ["8E"],
			stunspore: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			synthesis: ["8E"],
			worryseed: ["8L1"],
		},
	},
	roserade: {
		learnset: {
			absorb: ["8L1"],
			aromatherapy: ["8L1"],
			attract: ["8M"],
			bulletseed: ["8M"],
			cut: ["8M"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M", "8L1"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			grassyterrain: ["8L1"],
			growth: ["8L1"],
			hyperbeam: ["8M"],
			ingrain: ["8L1"],
			leechseed: ["8L1"],
			magicalleaf: ["8L1"],
			megadrain: ["8L1"],
			petalblizzard: ["8L1"],
			petaldance: ["8L1"],
			poisonjab: ["8M"],
			poisonsting: ["8L1"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			stunspore: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L1"],
			swordsdance: ["8M"],
			synthesis: ["8L1"],
			toxic: ["8M", "8L1"],
			toxicspikes: ["8L1"],
			venomdrench: ["8L1"],
			worryseed: ["8L1"],
		},
	},
	cranidos: {
		learnset: {
			ancientpower: ["8L33"],
			assurance: ["8L24"],
			attract: ["8M"],
			blizzard: ["8M"],
			bulldoze: ["8M"],
			crunch: ["8E"],
			curse: ["8E"],
			dig: ["8M"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			dragonpulse: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusenergy: ["8L6"],
			hammerarm: ["8E"],
			headbutt: ["8L1"],
			headsmash: ["8L46"],
			icebeam: ["8M"],
			ironhead: ["8E"],
			irontail: ["8M"],
			leer: ["8L1", "8E"],
			payback: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockpolish: ["8M", "8L10"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			scaryface: ["8L19"],
			screech: ["8L42"],
			shockwave: ["8M"],
			slam: ["8E"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stomp: ["8E"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L28"],
			takedown: ["8L15"],
			thief: ["8M"],
			thrash: ["8E"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			whirlwind: ["8E"],
			zenheadbutt: ["8L37"],
		},
	},
	rampardos: {
		learnset: {
			ancientpower: ["8L36"],
			assurance: ["8L24"],
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonpulse: ["8M"],
			earthquake: ["8M"],
			endeavor: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focusenergy: ["8L6", "8L1"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			headbutt: ["8L1"],
			headsmash: ["8L58"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			payback: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockpolish: ["8M", "8L10"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			scaryface: ["8L19"],
			screech: ["8L51"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L28"],
			takedown: ["8L15"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			zenheadbutt: ["8L43"],
		},
	},
	shieldon: {
		learnset: {
			ancientpower: ["8L28"],
			attract: ["8M"],
			blizzard: ["8M"],
			bodyslam: ["8E"],
			bulldoze: ["8M"],
			counter: ["8E"],
			curse: ["8E"],
			dig: ["8M"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M", "8L33"],
			facade: ["8M"],
			fireblast: ["8M"],
			fissure: ["8E"],
			flamethrower: ["8M"],
			flashcannon: ["8M"],
			focusenergy: ["8E"],
			guardsplit: ["8E"],
			headbutt: ["8E"],
			heavyslam: ["8L46"],
			icebeam: ["8M"],
			irondefense: ["8L19"],
			ironhead: ["8L42"],
			irontail: ["8M"],
			metalburst: ["8L37"],
			metalsound: ["8L10"],
			protect: ["8M", "8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockblast: ["8E"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			scaryface: ["8E"],
			screech: ["8E"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M", "8L24"],
			tackle: ["8L1"],
			takedown: ["8L15"],
			taunt: ["8M", "8L6"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			torment: ["8M"],
			wideguard: ["8E"],
		},
	},
	bastiodon: {
		learnset: {
			ancientpower: ["8L28"],
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			block: ["8L1"],
			bulldoze: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M", "8L36"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flashcannon: ["8M"],
			gigaimpact: ["8M"],
			heavyslam: ["8L58"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irondefense: ["8L19"],
			ironhead: ["8L51"],
			irontail: ["8M"],
			metalburst: ["8L43"],
			metalsound: ["8L10", "8L1"],
			protect: ["8M", "8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M", "8L24"],
			tackle: ["8L1"],
			takedown: ["8L15"],
			taunt: ["8M", "8L6", "8L1"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			torment: ["8M"],
		},
	},
	burmy: {
		learnset: {
			bugbite: ["8L15"],
			protect: ["8M", "8L1"],
			stringshot: ["8L20"],
			tackle: ["8L10"],
		},
	},
	wormadam: {
		learnset: {
			attract: ["8M", "8L41"],
			bugbite: ["8L15", "8L1"],
			bugbuzz: ["8M", "8L50"],
			bulletseed: ["8M"],
			confusion: ["8L23"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flail: ["8L38"],
			flash: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growth: ["8L29"],
			hyperbeam: ["8M"],
			infestation: ["8L35"],
			leafstorm: ["8L47"],
			protect: ["8M", "8L10", "8L1"],
			psybeam: ["8L32"],
			psychic: ["8M", "8L44"],
			psychup: ["8M"],
			quiverdance: ["8L1"],
			raindance: ["8M"],
			razorleaf: ["8L26"],
			rest: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stringshot: ["8L20"],
			substitute: ["8M"],
			suckerpunch: ["8L1"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
		},
	},
	wormadamsandy: {
		learnset: {
			attract: ["8M", "8L41"],
			bugbite: ["8L15", "8L1"],
			bugbuzz: ["8M", "8L50"],
			bulldoze: ["8M"],
			confusion: ["8L23"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fissure: ["8L47"],
			flail: ["8L38"],
			flash: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			harden: ["8L29"],
			hyperbeam: ["8M"],
			infestation: ["8L35"],
			protect: ["8M", "8L10", "8L1"],
			psybeam: ["8L32"],
			psychic: ["8M", "8L44"],
			psychup: ["8M"],
			quiverdance: ["8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			rockblast: ["8L26"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			stringshot: ["8L20"],
			substitute: ["8M"],
			suckerpunch: ["8L1"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
		},
	},
	wormadamtrash: {
		learnset: {
			attract: ["8M", "8L41"],
			bugbite: ["8L15", "8L1"],
			bugbuzz: ["8M", "8L50"],
			confusion: ["8L23"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flail: ["8L38"],
			flash: ["8M"],
			flashcannon: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			gyroball: ["8M"],
			hyperbeam: ["8M"],
			infestation: ["8L35"],
			ironhead: ["8L47"],
			metalburst: ["8L26", "8L1"],
			metalsound: ["8L29"],
			protect: ["8M", "8L10", "8L1"],
			psybeam: ["8L32"],
			psychic: ["8M", "8L44"],
			psychup: ["8M"],
			quiverdance: ["8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			stringshot: ["8L20"],
			substitute: ["8M"],
			suckerpunch: ["8L1"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
		},
	},
	mothim: {
		learnset: {
			aerialace: ["8M"],
			airslash: ["8L41"],
			attract: ["8M"],
			bugbite: ["8L15", "8L1"],
			bugbuzz: ["8M", "8L50"],
			confusion: ["8L23"],
			defog: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			gust: ["8L26"],
			hyperbeam: ["8M"],
			lunge: ["8L47"],
			poisonpowder: ["8L29"],
			protect: ["8M", "8L10", "8L1"],
			psybeam: ["8L32"],
			psychic: ["8M", "8L44"],
			psychup: ["8M"],
			quiverdance: ["8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M", "8L35"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stringshot: ["8L20"],
			strugglebug: ["8L38"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
			uturn: ["8M"],
		},
	},
	combee: {
		learnset: {
			bugbite: ["8L1"],
			bugbuzz: ["8M"],
			gust: ["8L1"],
			strugglebug: ["8L1"],
			sweetscent: ["8L1"],
		},
	},
	vespiquen: {
		learnset: {
			aerialace: ["8M"],
			airslash: ["8L28"],
			aromatherapy: ["8L24"],
			aromaticmist: ["8L8"],
			attackorder: ["8L40"],
			attract: ["8M"],
			bugbite: ["8L1"],
			bugbuzz: ["8M"],
			confuseray: ["8L1"],
			cut: ["8M"],
			defendorder: ["8L40"],
			defog: ["8M"],
			destinybond: ["8L44"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fellstinger: ["8L12"],
			flash: ["8M"],
			fling: ["8M"],
			furycutter: ["8L4"],
			furyswipes: ["8L16"],
			gigaimpact: ["8M"],
			gust: ["8L1"],
			hyperbeam: ["8M"],
			poisonsting: ["8L1"],
			powergem: ["8L32"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M"],
			slash: ["8L1"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			strugglebug: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M", "8L20"],
			sweetscent: ["8L1"],
			thief: ["8M"],
			toxic: ["8M", "8L36"],
			uturn: ["8M"],
			xscissor: ["8M"],
		},
	},
	pachirisu: {
		learnset: {
			attract: ["8M"],
			babydolleyes: ["8L1", "8E"],
			bite: ["8E"],
			charge: ["8E"],
			chargebeam: ["8M"],
			charm: ["8L9"],
			covet: ["8E"],
			cut: ["8M"],
			defensecurl: ["8E"],
			dig: ["8M"],
			discharge: ["8L41"],
			doubleteam: ["8M"],
			electroball: ["8L25"],
			endure: ["8M", "8L17"],
			facade: ["8M"],
			faketears: ["8E"],
			flail: ["8E"],
			flash: ["8M"],
			flatter: ["8E"],
			fling: ["8M"],
			followme: ["8E"],
			grassknot: ["8M"],
			growl: ["8L1"],
			irontail: ["8M"],
			lastresort: ["8L45"],
			lightscreen: ["8M"],
			nuzzle: ["8L19"],
			protect: ["8M"],
			quickattack: ["8L5"],
			raindance: ["8M"],
			rest: ["8M"],
			rollout: ["8E"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			spark: ["8L13"],
			substitute: ["8M"],
			superfang: ["8L37"],
			swagger: ["8M"],
			sweetkiss: ["8L29"],
			swift: ["8L21"],
			tailwhip: ["8E"],
			thunder: ["8M", "8L49"],
			thunderbolt: ["8M"],
			thunderwave: ["8M", "8L33"],
			uturn: ["8M"],
			voltswitch: ["8M"],
		},
	},
	buizel: {
		learnset: {
			agility: ["8L41"],
			aquajet: ["8L24"],
			aquaring: ["8E"],
			aquatail: ["8L38", "8E"],
			attract: ["8M"],
			batonpass: ["8E"],
			bite: ["8L18"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M"],
			bulkup: ["8M"],
			dig: ["8M"],
			doublehit: ["8L27"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			focuspunch: ["8M"],
			furycutter: ["8E"],
			furyswipes: ["8E"],
			growl: ["8L4"],
			hail: ["8M"],
			headbutt: ["8E"],
			helpinghand: ["8E"],
			hydropump: ["8L45"],
			icebeam: ["8M"],
			irontail: ["8M"],
			mudslap: ["8E"],
			protect: ["8M"],
			quickattack: ["8L11"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			slash: ["8E"],
			sleeptalk: ["8M"],
			soak: ["8E"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swift: ["8L21"],
			switcheroo: ["8E"],
			tackle: ["8L1"],
			tailwhip: ["8L7"],
			waterfall: ["8M", "8L35"],
			watergun: ["8L15"],
			waterpulse: ["8M"],
			whirlpool: ["8L31"],
		},
	},
	floatzel: {
		learnset: {
			agility: ["8L51"],
			aquajet: ["8L24"],
			aquatail: ["8L46"],
			attract: ["8M"],
			bite: ["8L18"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M"],
			bulkup: ["8M"],
			crunch: ["8L1"],
			dig: ["8M"],
			doublehit: ["8L29"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L4", "8L1"],
			hail: ["8M"],
			hydropump: ["8L57"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			icefang: ["8L1"],
			irontail: ["8M"],
			payback: ["8M"],
			protect: ["8M"],
			quickattack: ["8L11", "8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swift: ["8L21"],
			tackle: ["8L1"],
			tailwhip: ["8L7"],
			taunt: ["8M"],
			torment: ["8M"],
			waterfall: ["8M", "8L41"],
			watergun: ["8L15"],
			waterpulse: ["8M"],
			whirlpool: ["8L35"],
		},
	},
	cherubi: {
		learnset: {
			aromatherapy: ["8E"],
			attract: ["8M"],
			bulletseed: ["8M"],
			dazzlinggleam: ["8M"],
			defensecurl: ["8E"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			flowershield: ["8E"],
			gigadrain: ["8M"],
			grassknot: ["8M"],
			grassyterrain: ["8E"],
			growth: ["8L10"],
			healingwish: ["8E"],
			healpulse: ["8E"],
			helpinghand: ["8L15"],
			leafage: ["8L5"],
			leechseed: ["8L26"],
			magicalleaf: ["8L20"],
			morningsun: ["8L1"],
			naturepower: ["8E"],
			petalblizzard: ["8L35"],
			protect: ["8M"],
			razorleaf: ["8E"],
			rest: ["8M"],
			rollout: ["8E"],
			safeguard: ["8M"],
			seedbomb: ["8E"],
			sleeptalk: ["8M"],
			solarbeam: ["8M", "8L45"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8E"],
			swordsdance: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L30"],
			tickle: ["8E"],
			weatherball: ["8E"],
			worryseed: ["8L40"],
		},
	},
	cherrim: {
		learnset: {
			attract: ["8M"],
			bulletseed: ["8M"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			flowershield: ["8L1"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growth: ["8L1"],
			helpinghand: ["8L15"],
			hyperbeam: ["8M"],
			leafage: ["8L1"],
			leechseed: ["8L28"],
			magicalleaf: ["8L20"],
			morningsun: ["8L1"],
			petalblizzard: ["8L41"],
			petaldance: ["8L62"],
			protect: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M", "8L55"],
			substitute: ["8M"],
			sunnyday: ["8M", "8L1"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L34"],
			worryseed: ["8L48"],
		},
	},
	shellos: {
		learnset: {
			acidarmor: ["8E"],
			amnesia: ["8E"],
			ancientpower: ["8L20"],
			attract: ["8M"],
			blizzard: ["8M"],
			bodyslam: ["8L25"],
			brine: ["8M"],
			clearsmog: ["8E"],
			counter: ["8E"],
			curse: ["8E"],
			doubleteam: ["8M"],
			earthpower: ["8L35"],
			endure: ["8M"],
			facade: ["8M"],
			fissure: ["8E"],
			hail: ["8M"],
			harden: ["8L5"],
			icebeam: ["8M"],
			memento: ["8L45", "8E"],
			mirrorcoat: ["8E"],
			mist: ["8E"],
			muddywater: ["8L31"],
			mudslap: ["8L1"],
			protect: ["8M"],
			raindance: ["8M", "8L40"],
			recover: ["8L10"],
			rest: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			sludge: ["8E"],
			spitup: ["8E"],
			stockpile: ["8E"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swallow: ["8E"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L15"],
			yawn: ["8E"],
		},
	},
	gastrodon: {
		learnset: {
			ancientpower: ["8L20"],
			attract: ["8M"],
			blizzard: ["8M"],
			bodyslam: ["8L25"],
			brine: ["8M"],
			bulldoze: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthpower: ["8L39"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			harden: ["8L1"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			memento: ["8L53"],
			muddywater: ["8L33"],
			mudslap: ["8L1"],
			protect: ["8M"],
			raindance: ["8M", "8L46"],
			recover: ["8L1"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L15"],
		},
	},
	ambipom: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L29"],
			astonish: ["8L8", "8L1"],
			attract: ["8M"],
			batonpass: ["8L11"],
			brickbreak: ["8M"],
			cut: ["8M"],
			dig: ["8M"],
			doublehit: ["8L32"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			dualchop: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M", "8L36"],
			focuspunch: ["8M"],
			furyswipes: ["8L18"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			lastresort: ["8L43"],
			lowsweep: ["8M"],
			nastyplot: ["8M", "8L39"],
			payback: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			sandattack: ["8L4", "8L1"],
			scratch: ["8L1"],
			screech: ["8L25"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L22"],
			tailwhip: ["8L1"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			tickle: ["8L15"],
			uturn: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	drifloon: {
		learnset: {
			astonish: ["8L1"],
			attract: ["8M"],
			batonpass: ["8L36"],
			bodyslam: ["8E"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			clearsmog: ["8E"],
			cut: ["8M"],
			defog: ["8M"],
			destinybond: ["8L32", "8E"],
			disable: ["8E"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			explosion: ["8M", "8L44"],
			facade: ["8M"],
			flash: ["8M"],
			focusenergy: ["8L8"],
			gust: ["8L4"],
			gyroball: ["8M"],
			haze: ["8E"],
			hex: ["8L16"],
			hypnosis: ["8E"],
			memento: ["8E"],
			minimize: ["8L1"],
			payback: ["8M", "8L12"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			rest: ["8M"],
			selfdestruct: ["8L29"],
			shadowball: ["8M", "8L20"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			spitup: ["8L24"],
			stockpile: ["8L24"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8L24"],
			tailwind: ["8L40", "8E"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			weatherball: ["8E"],
			willowisp: ["8M"],
		},
	},
	drifblim: {
		learnset: {
			astonish: ["8L1"],
			attract: ["8M"],
			batonpass: ["8L42"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			cut: ["8M"],
			defog: ["8M"],
			destinybond: ["8L36"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			explosion: ["8M", "8L54"],
			facade: ["8M"],
			flash: ["8M"],
			fly: ["8M"],
			focusenergy: ["8L1"],
			gigaimpact: ["8M"],
			gust: ["8L1"],
			gyroball: ["8M"],
			hex: ["8L16"],
			hyperbeam: ["8M"],
			minimize: ["8L1"],
			payback: ["8M", "8L12"],
			phantomforce: ["8L1"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			rest: ["8M"],
			selfdestruct: ["8L31"],
			shadowball: ["8M", "8L20"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			spitup: ["8L24"],
			stockpile: ["8L24"],
			strengthsap: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8L24"],
			tailwind: ["8L48"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			willowisp: ["8M"],
		},
	},
	buneary: {
		learnset: {
			afteryou: ["8L12"],
			agility: ["8L36"],
			attract: ["8M"],
			babydolleyes: ["8L8"],
			batonpass: ["8L28"],
			bounce: ["8L48"],
			chargebeam: ["8M"],
			charm: ["8L24"],
			circlethrow: ["8E"],
			copycat: ["8E"],
			cosmicpower: ["8E"],
			cut: ["8M"],
			defensecurl: ["8L4"],
			dig: ["8M"],
			doublehit: ["8E"],
			doublekick: ["8L20"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			encore: ["8E"],
			endure: ["8M"],
			entrainment: ["8L40"],
			facade: ["8M"],
			fakeout: ["8E"],
			faketears: ["8E"],
			firepunch: ["8E"],
			flail: ["8E"],
			flatter: ["8L44"],
			fling: ["8M"],
			focuspunch: ["8M"],
			grassknot: ["8M"],
			headbutt: ["8L32"],
			healingwish: ["8L52"],
			icebeam: ["8M"],
			icepunch: ["8E"],
			irontail: ["8M"],
			lowkick: ["8E"],
			lowsweep: ["8M"],
			payback: ["8M"],
			pound: ["8L1"],
			poweruppunch: ["8E"],
			protect: ["8M"],
			quickattack: ["8L16"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			splash: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8E"],
			switcheroo: ["8E"],
			teeterdance: ["8E"],
			thunderbolt: ["8M"],
			thunderpunch: ["8E"],
			thunderwave: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	lopunny: {
		learnset: {
			afteryou: ["8L12"],
			agility: ["8L36"],
			attract: ["8M"],
			babydolleyes: ["8L1"],
			batonpass: ["8L28"],
			blizzard: ["8M"],
			bounce: ["8L48"],
			chargebeam: ["8M"],
			charm: ["8L24"],
			cut: ["8M"],
			defensecurl: ["8L1"],
			dig: ["8M"],
			doublekick: ["8L20"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			endure: ["8M"],
			entrainment: ["8L40"],
			facade: ["8M"],
			flatter: ["8L44"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			headbutt: ["8L32"],
			healingwish: ["8L52"],
			highjumpkick: ["8L56"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lowsweep: ["8M"],
			magiccoat: ["8L1"],
			mirrorcoat: ["8L1"],
			payback: ["8M"],
			pound: ["8L1"],
			protect: ["8M"],
			quickattack: ["8L16"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			splash: ["8L1"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			uturn: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	mismagius: {
		learnset: {
			aerialace: ["8M"],
			astonish: ["8L1"],
			attract: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confuseray: ["8L1"],
			confusion: ["8L1"],
			darkpulse: ["8M"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			grudge: ["8L1"],
			hex: ["8L1"],
			hyperbeam: ["8M"],
			magicalleaf: ["8L1"],
			meanlook: ["8L1"],
			mysticalfire: ["8L1"],
			nastyplot: ["8M"],
			painsplit: ["8L1"],
			payback: ["8M", "8L1"],
			perishsong: ["8L1"],
			phantomforce: ["8L1"],
			powergem: ["8L1"],
			protect: ["8M"],
			psybeam: ["8L1"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			shadowball: ["8M", "8L1"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			spite: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
			willowisp: ["8M"],
		},
	},
	honchkrow: {
		learnset: {
			aerialace: ["8M"],
			aircutter: ["8L1"],
			assurance: ["8L1"],
			astonish: ["8L1"],
			attract: ["8M"],
			calmmind: ["8M"],
			darkpulse: ["8M", "8L75"],
			defog: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fly: ["8M"],
			foulplay: ["8L45"],
			gigaimpact: ["8M"],
			gust: ["8L1"],
			haze: ["8L1"],
			hyperbeam: ["8M"],
			meanlook: ["8L1"],
			nastyplot: ["8M", "8L35"],
			nightshade: ["8L1"],
			nightslash: ["8L55", "8L1"],
			payback: ["8M"],
			peck: ["8L1"],
			pluck: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			quash: ["8L65"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L1"],
			sunnyday: ["8M"],
			swagger: ["8M", "8L25"],
			tailwind: ["8L1"],
			taunt: ["8M", "8L1"],
			thief: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M", "8L1"],
			wingattack: ["8L1"],
		},
	},
	glameow: {
		learnset: {
			aerialace: ["8M", "8L17"],
			assurance: ["8E"],
			attract: ["8M", "8L44"],
			bite: ["8E"],
			charm: ["8L25"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8L1"],
			faketears: ["8E"],
			flail: ["8E"],
			flash: ["8M"],
			furyswipes: ["8L20"],
			growl: ["8L8"],
			honeclaws: ["8L48"],
			hypnosis: ["8L13"],
			irontail: ["8M"],
			lastresort: ["8E"],
			payback: ["8M"],
			playrough: ["8L50"],
			protect: ["8M"],
			psychup: ["8M"],
			quickattack: ["8E"],
			raindance: ["8M"],
			rest: ["8M"],
			retaliate: ["8L32"],
			sandattack: ["8E"],
			scratch: ["8L5"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			slash: ["8L37"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L41"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tailwhip: ["8E"],
			taunt: ["8M", "8L29"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			torment: ["8M"],
			uturn: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	purugly: {
		learnset: {
			aerialace: ["8M", "8L17"],
			attract: ["8M", "8L52"],
			bodyslam: ["8L45"],
			bulldoze: ["8M"],
			charm: ["8L25"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8L1"],
			flash: ["8M"],
			furyswipes: ["8L20"],
			gigaimpact: ["8M"],
			growl: ["8L8", "8L1"],
			honeclaws: ["8L60"],
			hyperbeam: ["8M"],
			hypnosis: ["8L13"],
			irontail: ["8M"],
			payback: ["8M"],
			playrough: ["8L1"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			retaliate: ["8L32"],
			roar: ["8M"],
			scratch: ["8L5", "8L1"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			slash: ["8L37"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L1"],
			sunnyday: ["8M"],
			swagger: ["8M", "8L1"],
			taunt: ["8M", "8L29"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			torment: ["8M"],
			uturn: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	chingling: {
		learnset: {
			astonish: ["8L7"],
			attract: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confusion: ["8L10"],
			cosmicpower: ["8E"],
			curse: ["8E"],
			dazzlinggleam: ["8M"],
			disable: ["8E"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			entrainment: ["8L19"],
			facade: ["8M"],
			flash: ["8M"],
			futuresight: ["8E"],
			grassknot: ["8M"],
			growl: ["8L4"],
			hypnosis: ["8E"],
			lastresort: ["8L16"],
			lightscreen: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recover: ["8E"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			storedpower: ["8E"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
			uproar: ["8L32"],
			wish: ["8E"],
			wrap: ["8L1"],
			yawn: ["8L13"],
		},
	},
	stunky: {
		learnset: {
			acidspray: ["8L9"],
			astonish: ["8E"],
			attract: ["8M"],
			belch: ["8L39"],
			bite: ["8L18"],
			crunch: ["8E"],
			cut: ["8M"],
			darkpulse: ["8M"],
			defog: ["8M"],
			dig: ["8M"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			endure: ["8M"],
			explosion: ["8M", "8L45"],
			facade: ["8M"],
			feint: ["8L3"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			focusenergy: ["8L15"],
			foulplay: ["8E"],
			furyswipes: ["8L12"],
			haze: ["8E"],
			irontail: ["8M"],
			leer: ["8E"],
			memento: ["8L33"],
			nastyplot: ["8M"],
			nightslash: ["8L36"],
			payback: ["8M"],
			playrough: ["8E"],
			poisongas: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			scaryface: ["8E"],
			scratch: ["8L1"],
			screech: ["8L24"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			slash: ["8E"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			smog: ["8E"],
			smokescreen: ["8L6"],
			snarl: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L30"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			torment: ["8M"],
			toxic: ["8M", "8L27"],
			venomdrench: ["8L42"],
			venoshock: ["8L21"],
		},
	},
	skuntank: {
		learnset: {
			acidspray: ["8L9"],
			attract: ["8M"],
			belch: ["8L43"],
			bite: ["8L18"],
			cut: ["8M"],
			darkpulse: ["8M"],
			defog: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			explosion: ["8M", "8L53"],
			facade: ["8M"],
			feint: ["8L1"],
			fireblast: ["8M"],
			flamethrower: ["8M", "8L1"],
			focusenergy: ["8L15"],
			furyswipes: ["8L12"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			memento: ["8L33"],
			nastyplot: ["8M"],
			nightslash: ["8L38"],
			payback: ["8M"],
			poisongas: ["8L1"],
			poisonjab: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			scratch: ["8L1"],
			screech: ["8L24"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			smokescreen: ["8L1"],
			snarl: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L30"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			torment: ["8M"],
			toxic: ["8M", "8L27"],
			venomdrench: ["8L48"],
			venoshock: ["8L21"],
		},
	},
	bronzor: {
		learnset: {
			bulldoze: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confuseray: ["8L4"],
			confusion: ["8L1"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			extrasensory: ["8L28"],
			facade: ["8M"],
			flash: ["8M"],
			flashcannon: ["8M"],
			futuresight: ["8L44"],
			grassknot: ["8M"],
			gyroball: ["8M", "8L16"],
			heavyslam: ["8L32"],
			hypnosis: ["8L20"],
			imprison: ["8L12"],
			irondefense: ["8L36"],
			lightscreen: ["8M"],
			metalsound: ["8L40"],
			payback: ["8M", "8L8"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M", "8L24"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			trickroom: ["8M"],
		},
	},
	bronzong: {
		learnset: {
			block: ["8L1"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confuseray: ["8L1"],
			confusion: ["8L1"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M"],
			extrasensory: ["8L28"],
			facade: ["8M"],
			flash: ["8M"],
			flashcannon: ["8M"],
			futuresight: ["8L50"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			gyroball: ["8M", "8L16"],
			heavyslam: ["8L32"],
			hyperbeam: ["8M"],
			hypnosis: ["8L20"],
			imprison: ["8L12"],
			irondefense: ["8L38"],
			lightscreen: ["8M"],
			metalsound: ["8L44"],
			payback: ["8M", "8L1"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M", "8L56"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M", "8L24"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M", "8L1"],
			swagger: ["8M"],
			tackle: ["8L1"],
			trickroom: ["8M"],
			weatherball: ["8L1"],
		},
	},
	bonsly: {
		learnset: {
			attract: ["8M"],
			block: ["8L12"],
			brickbreak: ["8M"],
			calmmind: ["8M"],
			copycat: ["8L1"],
			counter: ["8L40"],
			curse: ["8E"],
			defensecurl: ["8E"],
			dig: ["8M"],
			doubleedge: ["8L44"],
			doubleteam: ["8M"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			faketears: ["8L1"],
			flail: ["8L4"],
			harden: ["8E"],
			headbutt: ["8E"],
			lowkick: ["8L36"],
			mimic: ["8L16"],
			protect: ["8M"],
			psychup: ["8M"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M", "8L32"],
			rockthrow: ["8L8"],
			rocktomb: ["8M", "8L20"],
			rollout: ["8E"],
			sandstorm: ["8M"],
			sandtomb: ["8E"],
			selfdestruct: ["8E"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L28"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tearfullook: ["8L24"],
			thief: ["8M"],
		},
	},
	mimejr: {
		learnset: {
			attract: ["8M"],
			batonpass: ["8L4"],
			brickbreak: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			charm: ["8E"],
			confuseray: ["8E"],
			confusion: ["8L12"],
			copycat: ["8L1"],
			dazzlinggleam: ["8M", "8L44"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			encore: ["8L8"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8E"],
			flash: ["8M"],
			fling: ["8M"],
			focuspunch: ["8M"],
			futuresight: ["8E"],
			grassknot: ["8M"],
			healingwish: ["8E"],
			hypnosis: ["8E"],
			icywind: ["8E"],
			lightscreen: ["8M", "8L36"],
			magicroom: ["8E"],
			mimic: ["8L32", "8E"],
			nastyplot: ["8M"],
			pound: ["8L1"],
			powersplit: ["8E"],
			protect: ["8M", "8L20"],
			psybeam: ["8L28"],
			psychic: ["8M", "8L48"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M", "8L24"],
			reflect: ["8M", "8L36"],
			rest: ["8M"],
			roleplay: ["8L16"],
			safeguard: ["8M", "8L36"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L40"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			teeterdance: ["8L52", "8E"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			tickle: ["8E"],
			torment: ["8M"],
			trick: ["8E"],
			trickroom: ["8M"],
		},
	},
	happiny: {
		learnset: {
			aromatherapy: ["8E"],
			attract: ["8M"],
			charm: ["8L20"],
			copycat: ["8L1"],
			counter: ["8E"],
			covet: ["8L16"],
			defensecurl: ["8L4"],
			disarmingvoice: ["8L12"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			grassknot: ["8M"],
			gravity: ["8E"],
			hail: ["8M"],
			healbell: ["8E"],
			helpinghand: ["8E"],
			lastresort: ["8E"],
			lightscreen: ["8M"],
			metronome: ["8E"],
			minimize: ["8L1"],
			pound: ["8L1"],
			present: ["8E"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			seismictoss: ["8E"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8L8"],
			thunderwave: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	chatot: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8E"],
			aircutter: ["8E"],
			attract: ["8M"],
			boomburst: ["8E"],
			chatter: ["8L21", "8L1"],
			confide: ["8L1"],
			defog: ["8M"],
			doubleteam: ["8M"],
			echoedvoice: ["8L37"],
			encore: ["8E"],
			endure: ["8M"],
			facade: ["8M"],
			featherdance: ["8L50"],
			fly: ["8M"],
			furyattack: ["8L17"],
			growl: ["8L9"],
			hypervoice: ["8L57", "8L1"],
			mimic: ["8L33"],
			nastyplot: ["8M"],
			nightshade: ["8E"],
			partingshot: ["8L49"],
			peck: ["8L5"],
			pluck: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roost: ["8M", "8L41"],
			round: ["8L29"],
			sing: ["8L13"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8E"],
			swagger: ["8M"],
			taunt: ["8M", "8L25", "8L1"],
			thief: ["8M"],
			torment: ["8M"],
			uproar: ["8L45"],
			uturn: ["8M"],
			workup: ["8M"],
		},
	},
	spiritomb: {
		learnset: {
			attract: ["8M"],
			calmmind: ["8M"],
			confuseray: ["8L1"],
			curse: ["8L40"],
			darkpulse: ["8M", "8L50"],
			destinybond: ["8E"],
			disable: ["8E"],
			doubleteam: ["8M"],
			dreameater: ["8M", "8L60"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			foulplay: ["8E"],
			gigaimpact: ["8M"],
			grudge: ["8E"],
			hex: ["8L25"],
			hyperbeam: ["8M"],
			hypnosis: ["8L55"],
			imprison: ["8E"],
			memento: ["8L30"],
			nastyplot: ["8M", "8L20"],
			nightshade: ["8L1"],
			painsplit: ["8E"],
			payback: ["8M", "8L15"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rocktomb: ["8M"],
			shadowball: ["8M", "8L45"],
			shadowsneak: ["8L5", "8E"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			smokescreen: ["8E"],
			snarl: ["8M"],
			spite: ["8L10"],
			substitute: ["8M"],
			suckerpunch: ["8L35"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			torment: ["8M"],
			waterpulse: ["8M"],
			willowisp: ["8M"],
		},
	},
	gible: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			bite: ["8L25"],
			bodyslam: ["8E"],
			bulldoze: ["8M", "8L18"],
			cut: ["8M"],
			dig: ["8M", "8L42"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonbreath: ["8L12", "8E"],
			dragonclaw: ["8M", "8L36"],
			dragonpulse: ["8M"],
			dragonrush: ["8L60"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			ironhead: ["8E"],
			irontail: ["8M"],
			metalclaw: ["8E"],
			mudshot: ["8E"],
			outrage: ["8E"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandattack: ["8L6"],
			sandstorm: ["8M", "8L48"],
			sandtomb: ["8L1", "8E"],
			scaryface: ["8E"],
			shadowclaw: ["8M"],
			slash: ["8L30"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L54"],
			thrash: ["8E"],
			twister: ["8E"],
		},
	},
	gabite: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			bite: ["8L27"],
			bulldoze: ["8M", "8L18"],
			cut: ["8M"],
			dig: ["8M", "8L50"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonbreath: ["8L1"],
			dragonclaw: ["8M", "8L42"],
			dragonpulse: ["8M"],
			dragonrush: ["8L74"],
			dualchop: ["8L1"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			irontail: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandattack: ["8L1"],
			sandstorm: ["8M", "8L58"],
			sandtomb: ["8L1"],
			shadowclaw: ["8M"],
			slash: ["8L34"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L66"],
		},
	},
	garchomp: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			bite: ["8L27"],
			brickbreak: ["8M"],
			bulldoze: ["8M", "8L18"],
			crunch: ["8L1"],
			cut: ["8M"],
			dig: ["8M", "8L52"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonbreath: ["8L1"],
			dragonclaw: ["8M", "8L42"],
			dragonpulse: ["8M"],
			dragonrush: ["8L82"],
			dualchop: ["8L1"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandattack: ["8L1"],
			sandstorm: ["8M", "8L62"],
			sandtomb: ["8L1"],
			shadowclaw: ["8M"],
			slash: ["8L34"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L72"],
		},
	},
	munchlax: {
		learnset: {
			afteryou: ["8E"],
			amnesia: ["8L36"],
			attract: ["8M"],
			belch: ["8E"],
			bellydrum: ["8L48"],
			bite: ["8L16"],
			blizzard: ["8M"],
			bodyslam: ["8L28"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			charm: ["8E"],
			counter: ["8E"],
			covet: ["8L12"],
			curse: ["8E"],
			defensecurl: ["8L4"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			fissure: ["8E"],
			flail: ["8L44"],
			flamethrower: ["8M"],
			fling: ["8M", "8L32"],
			focuspunch: ["8M"],
			icebeam: ["8M"],
			lastresort: ["8L52"],
			lick: ["8L1", "8E"],
			metronome: ["8L40"],
			protect: ["8M"],
			psychic: ["8M"],
			raindance: ["8M"],
			recycle: ["8M", "8L8"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			screech: ["8L24"],
			selfdestruct: ["8E"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stockpile: ["8L20"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swallow: ["8L20"],
			tackle: ["8L1"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			waterpulse: ["8M"],
			whirlwind: ["8E"],
			workup: ["8M"],
			zenheadbutt: ["8E"],
		},
	},
	riolu: {
		learnset: {
			agility: ["8E"],
			attract: ["8M"],
			bite: ["8E"],
			blazekick: ["8E"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			bulletpunch: ["8E"],
			circlethrow: ["8E"],
			copycat: ["8L48"],
			counter: ["8L12"],
			crosschop: ["8E"],
			crunch: ["8E"],
			detect: ["8E"],
			dig: ["8M"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			earthquake: ["8M"],
			endure: ["8M", "8L1"],
			facade: ["8M"],
			feint: ["8L4"],
			finalgambit: ["8L52"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			followme: ["8E"],
			forcepalm: ["8L36"],
			helpinghand: ["8L44"],
			highjumpkick: ["8E"],
			howl: ["8E"],
			irondefense: ["8E"],
			irontail: ["8M"],
			lowkick: ["8E"],
			lowsweep: ["8M"],
			metalclaw: ["8L8"],
			meteormash: ["8E"],
			mindreader: ["8E"],
			nastyplot: ["8M", "8L24"],
			payback: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			quickattack: ["8L1"],
			quickguard: ["8L32"],
			raindance: ["8M"],
			rest: ["8M"],
			reversal: ["8L56"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M", "8L20"],
			rocktomb: ["8M"],
			screech: ["8L28"],
			shadowclaw: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L40"],
			vacuumwave: ["8E"],
			workup: ["8M", "8L16"],
		},
	},
	lucario: {
		learnset: {
			attract: ["8M"],
			aurasphere: ["8L1"],
			bonerush: ["8L36"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M", "8L24"],
			closecombat: ["8L60"],
			copycat: ["8L1"],
			counter: ["8L12"],
			darkpulse: ["8M"],
			detect: ["8L1"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonpulse: ["8M", "8L52"],
			drainpunch: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			extremespeed: ["8L56"],
			facade: ["8M"],
			feint: ["8L1"],
			finalgambit: ["8L1"],
			flashcannon: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			forcepalm: ["8L1"],
			gigaimpact: ["8M"],
			healpulse: ["8L44"],
			helpinghand: ["8L1"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			laserfocus: ["8L16"],
			lifedew: ["8L1"],
			lowsweep: ["8M"],
			metalclaw: ["8L1"],
			metalsound: ["8L28"],
			meteormash: ["8L48"],
			nastyplot: ["8M", "8L1"],
			payback: ["8M"],
			poisonjab: ["8M"],
			poweruppunch: ["8L20"],
			protect: ["8M"],
			psychic: ["8M"],
			quickattack: ["8L1"],
			quickguard: ["8L32"],
			raindance: ["8M"],
			rest: ["8M"],
			reversal: ["8L1"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M", "8L1"],
			rocktomb: ["8M"],
			screech: ["8L1"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			sleeptalk: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L40"],
			waterpulse: ["8M"],
			workup: ["8M", "8L1"],
		},
	},
	hippopotas: {
		learnset: {
			attract: ["8M"],
			bite: ["8L4"],
			bodyslam: ["8E"],
			bulldoze: ["8M"],
			crunch: ["8L20"],
			curse: ["8E"],
			dig: ["8M", "8L16"],
			doubleedge: ["8L44"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L40"],
			endure: ["8M"],
			facade: ["8M"],
			fissure: ["8L48"],
			irontail: ["8M"],
			protect: ["8M"],
			rest: ["8M", "8L36"],
			revenge: ["8E"],
			roar: ["8M", "8L32"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandattack: ["8L1"],
			sandstorm: ["8M", "8L24"],
			sandtomb: ["8L12", "8E"],
			slackoff: ["8L52", "8E"],
			sleeptalk: ["8M"],
			spitup: ["8E"],
			stealthrock: ["8M"],
			stockpile: ["8E"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8E"],
			tackle: ["8L1"],
			takedown: ["8L28"],
			waterpulse: ["8M"],
			whirlwind: ["8E"],
			yawn: ["8L8"],
		},
	},
	hippowdon: {
		learnset: {
			attract: ["8M"],
			bite: ["8L1"],
			bulldoze: ["8M"],
			crunch: ["8L20"],
			dig: ["8M", "8L16"],
			doubleedge: ["8L50"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L44"],
			endure: ["8M"],
			facade: ["8M"],
			firefang: ["8L1"],
			fissure: ["8L56"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M"],
			icefang: ["8L1"],
			irontail: ["8M"],
			protect: ["8M"],
			rest: ["8M", "8L38"],
			roar: ["8M", "8L32"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandattack: ["8L1"],
			sandstorm: ["8M", "8L24"],
			sandtomb: ["8L12"],
			slackoff: ["8L62"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L28"],
			thunderfang: ["8L1"],
			waterpulse: ["8M"],
			yawn: ["8L1"],
		},
	},
	skorupi: {
		learnset: {
			acupressure: ["8L45"],
			aerialace: ["8M"],
			agility: ["8E"],
			attract: ["8M"],
			bite: ["8L12"],
			brickbreak: ["8M"],
			bugbite: ["8L18"],
			bugbuzz: ["8M"],
			confuseray: ["8E"],
			crosspoison: ["8L39"],
			crunch: ["8L48"],
			cut: ["8M"],
			darkpulse: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fellstinger: ["8L6"],
			flash: ["8M"],
			fling: ["8M"],
			honeclaws: ["8L3"],
			irontail: ["8M"],
			knockoff: ["8L24"],
			leer: ["8L1"],
			nightslash: ["8L36", "8E"],
			payback: ["8M"],
			pinmissile: ["8L30"],
			poisonfang: ["8L9"],
			poisonjab: ["8M"],
			poisonsting: ["8L1"],
			poisontail: ["8E"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandattack: ["8E"],
			scaryface: ["8L27"],
			screech: ["8E"],
			shadowball: ["8M"],
			slash: ["8E"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			torment: ["8M"],
			toxic: ["8M", "8L33"],
			toxicspikes: ["8L15"],
			venoshock: ["8L21"],
			whirlwind: ["8E"],
			xscissor: ["8M", "8L42"],
		},
	},
	drapion: {
		learnset: {
			acupressure: ["8L49"],
			aerialace: ["8M"],
			attract: ["8M"],
			bite: ["8L12"],
			brickbreak: ["8M"],
			bugbite: ["8L18"],
			bugbuzz: ["8M"],
			bulldoze: ["8M"],
			crosspoison: ["8L39"],
			crunch: ["8L54"],
			cut: ["8M"],
			darkpulse: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fellstinger: ["8L1"],
			firefang: ["8L1"],
			flash: ["8M"],
			fling: ["8M"],
			gigaimpact: ["8M"],
			honeclaws: ["8L1"],
			hyperbeam: ["8M"],
			icefang: ["8L1"],
			irontail: ["8M"],
			knockoff: ["8L24"],
			leer: ["8L1"],
			nightslash: ["8L36"],
			payback: ["8M"],
			pinmissile: ["8L30"],
			poisonfang: ["8L9"],
			poisonjab: ["8M"],
			poisonsting: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scaryface: ["8L27"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			snarl: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			thunderfang: ["8L1"],
			torment: ["8M"],
			toxic: ["8M", "8L33"],
			toxicspikes: ["8L15"],
			venoshock: ["8L21"],
			xscissor: ["8M", "8L44"],
		},
	},
	croagunk: {
		learnset: {
			acupressure: ["8E"],
			astonish: ["8L4"],
			attract: ["8M"],
			belch: ["8L48"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			bulletpunch: ["8E"],
			counter: ["8E"],
			crosschop: ["8E"],
			darkpulse: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dynamicpunch: ["8E"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fakeout: ["8E"],
			feint: ["8E"],
			flatter: ["8L12"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			headbutt: ["8E"],
			lowsweep: ["8M"],
			mudslap: ["8L1"],
			nastyplot: ["8M", "8L40"],
			payback: ["8M"],
			poisonjab: ["8M", "8L32"],
			poisonsting: ["8L1"],
			protect: ["8M"],
			quickguard: ["8E"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8L16"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M", "8L44"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L24"],
			sunnyday: ["8M"],
			swagger: ["8M", "8L28"],
			taunt: ["8M", "8L8"],
			thief: ["8M"],
			torment: ["8M"],
			toxic: ["8M", "8L36"],
			vacuumwave: ["8E"],
			venoshock: ["8L20"],
			workup: ["8M"],
			xscissor: ["8M"],
		},
	},
	toxicroak: {
		learnset: {
			astonish: ["8L1"],
			attract: ["8M"],
			belch: ["8L54"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			cut: ["8M"],
			darkpulse: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flatter: ["8L12"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M"],
			lowsweep: ["8M"],
			mudslap: ["8L1"],
			nastyplot: ["8M", "8L42"],
			payback: ["8M"],
			poisonjab: ["8M", "8L32"],
			poisonsting: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8L16"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M", "8L48"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L24"],
			sunnyday: ["8M"],
			swagger: ["8M", "8L28"],
			swordsdance: ["8M"],
			taunt: ["8M", "8L1"],
			thief: ["8M"],
			torment: ["8M"],
			toxic: ["8M", "8L36"],
			venoshock: ["8L20"],
			workup: ["8M"],
			xscissor: ["8M"],
		},
	},
	carnivine: {
		learnset: {
			acidspray: ["8E"],
			attract: ["8M"],
			bind: ["8L1"],
			bite: ["8L7"],
			bulletseed: ["8M"],
			crunch: ["8L41"],
			cut: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M", "8L27"],
			growth: ["8L1"],
			hyperbeam: ["8M"],
			ingrain: ["8L21"],
			leaftornado: ["8L31"],
			leechseed: ["8E"],
			magicalleaf: ["8E"],
			payback: ["8M"],
			powerwhip: ["8L50"],
			protect: ["8M"],
			ragepowder: ["8E"],
			razorleaf: ["8E"],
			rest: ["8M"],
			seedbomb: ["8L47"],
			slam: ["8E"],
			sleeppowder: ["8E"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			spitup: ["8L37"],
			stockpile: ["8L37"],
			stunspore: ["8E"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8L37"],
			sweetscent: ["8L17"],
			swordsdance: ["8M"],
			synthesis: ["8E"],
			thief: ["8M"],
			vinewhip: ["8L11"],
			worryseed: ["8E"],
		},
	},
	finneon: {
		learnset: {
			agility: ["8E"],
			aquaring: ["8L33"],
			aquatail: ["8E"],
			attract: ["8M", "8L10"],
			aurorabeam: ["8E"],
			blizzard: ["8M"],
			bounce: ["8L45"],
			brine: ["8M"],
			charm: ["8E"],
			confuseray: ["8E"],
			defog: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flail: ["8L26", "8E"],
			flash: ["8M"],
			gust: ["8L17"],
			hail: ["8M"],
			icebeam: ["8M"],
			payback: ["8M"],
			pound: ["8L1"],
			protect: ["8M"],
			psybeam: ["8E"],
			psychup: ["8M"],
			raindance: ["8M", "8L13"],
			rest: ["8M"],
			safeguard: ["8M", "8L29"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			soak: ["8L54"],
			splash: ["8E"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8E"],
			tailwind: ["8L49"],
			tickle: ["8E"],
			uturn: ["8M", "8L42"],
			waterfall: ["8M"],
			watergun: ["8L6"],
			waterpulse: ["8M", "8L22"],
			whirlpool: ["8L38"],
		},
	},
	lumineon: {
		learnset: {
			aquaring: ["8L35"],
			attract: ["8M", "8L10", "8L1"],
			blizzard: ["8M"],
			bounce: ["8L53"],
			brine: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flail: ["8L26"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			gust: ["8L17", "8L1"],
			hail: ["8M"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			payback: ["8M"],
			pound: ["8L1"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M", "8L13"],
			rest: ["8M"],
			safeguard: ["8M", "8L29"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			soak: ["8L66", "8L1"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tailwind: ["8L59"],
			uturn: ["8M", "8L48"],
			waterfall: ["8M"],
			watergun: ["8L6", "8L1"],
			waterpulse: ["8M", "8L22"],
			whirlpool: ["8L42"],
		},
	},
	mantyke: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L20"],
			airslash: ["8L32"],
			amnesia: ["8E"],
			aquaring: ["8L36"],
			attract: ["8M"],
			blizzard: ["8M"],
			bounce: ["8L40"],
			bubblebeam: ["8L24"],
			bulldoze: ["8M"],
			confuseray: ["8E"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			hail: ["8M"],
			haze: ["8E"],
			headbutt: ["8L28"],
			hydropump: ["8L48", "8E"],
			icebeam: ["8M"],
			mirrorcoat: ["8E"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			scald: ["8M"],
			slam: ["8E"],
			sleeptalk: ["8M"],
			splash: ["8E"],
			substitute: ["8M"],
			supersonic: ["8L4"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			tailwind: ["8E"],
			takedown: ["8L44"],
			twister: ["8E"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L12"],
			wideguard: ["8L16", "8E"],
			wingattack: ["8L8"],
		},
	},
	snover: {
		learnset: {
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M", "8L45"],
			bulletseed: ["8M"],
			doubleedge: ["8E"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M"],
			grassknot: ["8M"],
			growth: ["8E"],
			hail: ["8M"],
			icebeam: ["8M"],
			iceshard: ["8L15"],
			icywind: ["8L25"],
			ingrain: ["8L35"],
			irontail: ["8M"],
			leafage: ["8L5"],
			leechseed: ["8E"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			magicalleaf: ["8E"],
			mist: ["8L10", "8E"],
			powdersnow: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			razorleaf: ["8L20"],
			rest: ["8M"],
			safeguard: ["8M"],
			seedbomb: ["8E"],
			shadowball: ["8M"],
			sheercold: ["8L50"],
			skullbash: ["8E"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stomp: ["8E"],
			substitute: ["8M"],
			swagger: ["8M", "8L30"],
			swordsdance: ["8M"],
			waterpulse: ["8M"],
			woodhammer: ["8L41"],
		},
	},
	abomasnow: {
		learnset: {
			attract: ["8M"],
			auroraveil: ["8L1"],
			avalanche: ["8M"],
			blizzard: ["8M", "8L49"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			bulletseed: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			hail: ["8M"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			icepunch: ["8L1"],
			iceshard: ["8L15"],
			icywind: ["8L25"],
			ingrain: ["8L35"],
			irontail: ["8M"],
			leafage: ["8L1"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			mist: ["8L1"],
			powdersnow: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			razorleaf: ["8L20"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			sheercold: ["8L56"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			swagger: ["8M", "8L30"],
			swordsdance: ["8M"],
			waterpulse: ["8M"],
			woodhammer: ["8L43"],
		},
	},
	weavile: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L1"],
			assurance: ["8L1"],
			attract: ["8M"],
			avalanche: ["8M"],
			beatup: ["8L1"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			calmmind: ["8M"],
			cut: ["8M"],
			darkpulse: ["8M", "8L66"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fling: ["8M", "8L42"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			furyswipes: ["8L30"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			honeclaws: ["8L36"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			iceshard: ["8L1"],
			icywind: ["8L24"],
			irontail: ["8M"],
			leer: ["8L1"],
			lowsweep: ["8M"],
			metalclaw: ["8L18"],
			nastyplot: ["8M", "8L48"],
			nightslash: ["8L60"],
			payback: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			psychup: ["8M"],
			quickattack: ["8L1"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			revenge: ["8L1"],
			rocksmash: ["8M"],
			scratch: ["8L1"],
			screech: ["8L54"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			slash: ["8L1"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			taunt: ["8M", "8L1"],
			thief: ["8M"],
			torment: ["8M"],
			xscissor: ["8M"],
		},
	},
	magnezone: {
		learnset: {
			chargebeam: ["8M"],
			discharge: ["8L40"],
			doubleteam: ["8M"],
			electricterrain: ["8L1"],
			electroball: ["8L12"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			flashcannon: ["8M", "8L34"],
			gigaimpact: ["8M"],
			gyroball: ["8M", "8L16"],
			hyperbeam: ["8M"],
			lightscreen: ["8M", "8L52"],
			lockon: ["8L58"],
			magneticflux: ["8L1"],
			magnetrise: ["8L28"],
			metalsound: ["8L46"],
			mirrorcoat: ["8L1"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			screech: ["8L24"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			spark: ["8L20"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L1"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thundershock: ["8L1"],
			thunderwave: ["8M", "8L1"],
			triattack: ["8L1"],
			voltswitch: ["8M"],
			zapcannon: ["8L64"],
		},
	},
	lickilicky: {
		learnset: {
			attract: ["8M"],
			bellydrum: ["8L60"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			cut: ["8M"],
			defensecurl: ["8L1"],
			dig: ["8M"],
			disable: ["8L24"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			gyroball: ["8M"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			knockoff: ["8L36"],
			lick: ["8L1"],
			powerwhip: ["8L54"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L1"],
			sandstorm: ["8M"],
			screech: ["8L42"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			slam: ["8L48"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stomp: ["8L30"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L1"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			waterpulse: ["8M"],
			workup: ["8M"],
			wrap: ["8L18"],
		},
	},
	rhyperior: {
		learnset: {
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M", "8L1"],
			cut: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonpulse: ["8M"],
			drillrun: ["8L35"],
			earthquake: ["8M", "8L47"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flashcannon: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			hammerarm: ["8L1"],
			hornattack: ["8L15"],
			horndrill: ["8L68"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			megahorn: ["8L61"],
			payback: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockblast: ["8L30"],
			rockclimb: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rockwrecker: ["8L75"],
			sandstorm: ["8M"],
			scaryface: ["8L20"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			smackdown: ["8L1"],
			stealthrock: ["8M"],
			stomp: ["8L25"],
			stoneedge: ["8M", "8L54"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			takedown: ["8L40"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
		},
	},
	tangrowth: {
		learnset: {
			absorb: ["8L1"],
			aerialace: ["8M"],
			ancientpower: ["8L24"],
			attract: ["8M"],
			bind: ["8L1"],
			block: ["8L1"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			bulletseed: ["8M"],
			cut: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			gigadrain: ["8M", "8L32"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			grassyterrain: ["8L56"],
			growth: ["8L1"],
			hyperbeam: ["8M"],
			ingrain: ["8L52"],
			knockoff: ["8L28"],
			megadrain: ["8L12"],
			payback: ["8M"],
			poisonjab: ["8M"],
			poisonpowder: ["8L20"],
			powerwhip: ["8L48"],
			protect: ["8M"],
			psychup: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			shockwave: ["8M"],
			slam: ["8L40"],
			sleeppowder: ["8L36"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			stunspore: ["8L1"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			thief: ["8M"],
			tickle: ["8L44"],
			vinewhip: ["8L16"],
		},
	},
	electivire: {
		learnset: {
			attract: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			charge: ["8L1"],
			chargebeam: ["8M"],
			dig: ["8M"],
			discharge: ["8L34"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M", "8L64"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			leer: ["8L1"],
			lightscreen: ["8M", "8L52"],
			lowkick: ["8L40"],
			lowsweep: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			quickattack: ["8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			screech: ["8L24"],
			shockwave: ["8M", "8L16"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			swagger: ["8M"],
			swift: ["8L12"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M", "8L58"],
			thunderbolt: ["8M", "8L46"],
			thunderpunch: ["8L28"],
			thundershock: ["8L1"],
			thunderwave: ["8M", "8L20"],
			torment: ["8M"],
			voltswitch: ["8M"],
			wildcharge: ["8L1"],
		},
	},
	magmortar: {
		learnset: {
			attract: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			clearsmog: ["8L12"],
			confuseray: ["8L20"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M", "8L58"],
			firepunch: ["8L28"],
			flamethrower: ["8M", "8L46"],
			flamewheel: ["8L16"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M", "8L64"],
			irontail: ["8M"],
			lavaplume: ["8L34"],
			leer: ["8L1"],
			lowkick: ["8L40"],
			lowsweep: ["8M"],
			overheat: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scaryface: ["8L24"],
			sleeptalk: ["8M"],
			smog: ["8L1"],
			smokescreen: ["8L1"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M", "8L52"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			thunderbolt: ["8M"],
			torment: ["8M"],
			willowisp: ["8M"],
		},
	},
	togekiss: {
		learnset: {
			aerialace: ["8M"],
			afteryou: ["8L1"],
			airslash: ["8L1"],
			ancientpower: ["8L1"],
			attract: ["8M"],
			aurasphere: ["8L1"],
			batonpass: ["8L1"],
			brickbreak: ["8M"],
			charm: ["8L1"],
			dazzlinggleam: ["8M"],
			defog: ["8M"],
			doubleedge: ["8L1"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			extremespeed: ["8L1"],
			facade: ["8M"],
			fairywind: ["8L1"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			fly: ["8M"],
			focuspunch: ["8M"],
			followme: ["8L1"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			hyperbeam: ["8M"],
			lastresort: ["8L1"],
			lifedew: ["8L1"],
			lightscreen: ["8M"],
			metronome: ["8L1"],
			nastyplot: ["8M"],
			pluck: ["8M"],
			pound: ["8L1"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rocksmash: ["8M"],
			roost: ["8M"],
			safeguard: ["8M", "8L1"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skyattack: ["8L1"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8L1"],
			thunderwave: ["8M"],
			triattack: ["8L1"],
			waterpulse: ["8M"],
			wish: ["8L1"],
			workup: ["8M"],
			yawn: ["8L1"],
		},
	},
	yanmega: {
		learnset: {
			aerialace: ["8M", "8L14"],
			airslash: ["8L54", "8L1"],
			ancientpower: ["8L33"],
			attract: ["8M"],
			bugbite: ["8L1"],
			bugbuzz: ["8M", "8L57", "8L1"],
			defog: ["8M"],
			detect: ["8L17"],
			doubleteam: ["8M", "8L11", "8L1"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			feint: ["8L38"],
			flash: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			gust: ["8L1"],
			hyperbeam: ["8M"],
			hypnosis: ["8L1"],
			nightslash: ["8L1"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			quickattack: ["8L6", "8L1"],
			rest: ["8M"],
			roost: ["8M"],
			screech: ["8L46"],
			shadowball: ["8M"],
			slash: ["8L43"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			steelwing: ["8M"],
			stringshot: ["8L30"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			supersonic: ["8L22"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
			uproar: ["8L27"],
			uturn: ["8M", "8L49"],
			wingattack: ["8L1"],
		},
	},
	leafeon: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			babydolleyes: ["8L15"],
			batonpass: ["8L1"],
			bite: ["8L1"],
			bulletseed: ["8M"],
			charm: ["8L1"],
			copycat: ["8L1"],
			covet: ["8L1"],
			dig: ["8M"],
			doubleedge: ["8L1"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M", "8L40"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			helpinghand: ["8L1"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			lastresort: ["8L55"],
			leafblade: ["8L50"],
			leechseed: ["8L20"],
			magicalleaf: ["8L25"],
			protect: ["8M"],
			quickattack: ["8L10"],
			raindance: ["8M"],
			razorleaf: ["8L1"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			sandattack: ["8L5"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M", "8L35"],
			swagger: ["8M"],
			swift: ["8L1"],
			swordsdance: ["8M", "8L45"],
			synthesis: ["8L30"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			takedown: ["8L1"],
			workup: ["8M"],
			xscissor: ["8M"],
		},
	},
	glaceon: {
		learnset: {
			attract: ["8M"],
			avalanche: ["8M"],
			babydolleyes: ["8L15"],
			batonpass: ["8L1"],
			bite: ["8L25"],
			blizzard: ["8M", "8L50"],
			charm: ["8L1"],
			copycat: ["8L1"],
			covet: ["8L1"],
			dig: ["8M"],
			doubleedge: ["8L1"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			freezedry: ["8L40"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hail: ["8M", "8L35"],
			helpinghand: ["8L1"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			icefang: ["8L30"],
			iceshard: ["8L20"],
			icywind: ["8L1"],
			irontail: ["8M"],
			lastresort: ["8L55"],
			mirrorcoat: ["8L45"],
			protect: ["8M"],
			quickattack: ["8L10"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rocksmash: ["8M"],
			sandattack: ["8L5"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L1"],
			tackle: ["8L1"],
			tailwhip: ["8L1"],
			takedown: ["8L1"],
			waterpulse: ["8M"],
			workup: ["8M"],
		},
	},
	gliscor: {
		learnset: {
			acrobatics: ["8L22"],
			aerialace: ["8M"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			cut: ["8M"],
			darkpulse: ["8M"],
			defog: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L45"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			firefang: ["8L1"],
			fling: ["8M"],
			furycutter: ["8L16"],
			gigaimpact: ["8M"],
			guillotine: ["8L55", "8L1"],
			harden: ["8L7", "8L1"],
			hyperbeam: ["8M"],
			icefang: ["8L1"],
			irontail: ["8M"],
			knockoff: ["8L10", "8L1"],
			mudslap: ["8L19"],
			nightslash: ["8L27", "8L1"],
			payback: ["8M"],
			poisonjab: ["8M", "8L1"],
			poisonsting: ["8L1"],
			protect: ["8M"],
			quickattack: ["8L13"],
			raindance: ["8M"],
			rest: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			roost: ["8M"],
			sandattack: ["8L4", "8L1"],
			sandstorm: ["8M"],
			screech: ["8L35"],
			slash: ["8L1"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			stealthrock: ["8M"],
			steelwing: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L50"],
			taunt: ["8M"],
			thief: ["8M"],
			thunderfang: ["8L1"],
			torment: ["8M"],
			uturn: ["8M", "8L30"],
			xscissor: ["8M", "8L40"],
		},
	},
	mamoswine: {
		learnset: {
			amnesia: ["8L37"],
			ancientpower: ["8L1"],
			attract: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M", "8L58"],
			bulldoze: ["8M"],
			dig: ["8M"],
			doublehit: ["8L1"],
			doubleteam: ["8M"],
			earthquake: ["8M", "8L51"],
			endure: ["8M", "8L25"],
			facade: ["8M"],
			flail: ["8L1"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			icefang: ["8L1"],
			iceshard: ["8L15"],
			icywind: ["8L30"],
			lightscreen: ["8M"],
			mist: ["8L20"],
			mudslap: ["8L1"],
			powdersnow: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			takedown: ["8L44"],
			thrash: ["8L65"],
		},
	},
	porygonz: {
		learnset: {
			aerialace: ["8M"],
			agility: ["8L30"],
			blizzard: ["8M"],
			chargebeam: ["8M"],
			conversion: ["8L1"],
			conversion2: ["8L25"],
			darkpulse: ["8M"],
			defensecurl: ["8L1"],
			discharge: ["8L40"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M", "8L65"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lockon: ["8L55"],
			magiccoat: ["8L50"],
			magnetrise: ["8L1"],
			nastyplot: ["8M", "8L1"],
			protect: ["8M"],
			psybeam: ["8L20"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recover: ["8L35"],
			recycle: ["8M", "8L1"],
			rest: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thundershock: ["8L15"],
			thunderwave: ["8M"],
			triattack: ["8L45"],
			trickroom: ["8M", "8L1"],
			zapcannon: ["8L60"],
		},
	},
	gallade: {
		learnset: {
			aerialace: ["8M", "8L18"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M", "8L1"],
			chargebeam: ["8M"],
			charm: ["8L1"],
			closecombat: ["8L63"],
			confusion: ["8L1"],
			cut: ["8M"],
			dazzlinggleam: ["8M"],
			disarmingvoice: ["8L1"],
			doubleteam: ["8M", "8L1"],
			drainingkiss: ["8L1"],
			drainpunch: ["8M"],
			dreameater: ["8M", "8L1"],
			earthquake: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M", "8L23"],
			feint: ["8L12"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			furycutter: ["8L1"],
			futuresight: ["8L1"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growl: ["8L1"],
			healpulse: ["8L49"],
			helpinghand: ["8L9"],
			hyperbeam: ["8M"],
			hypnosis: ["8L1"],
			imprison: ["8L1"],
			leer: ["8L1"],
			lifedew: ["8L1"],
			lightscreen: ["8M"],
			lowsweep: ["8M"],
			nightslash: ["8L1"],
			poisonjab: ["8M"],
			protect: ["8M", "8L28"],
			psybeam: ["8L1"],
			psychic: ["8M", "8L1"],
			psychocut: ["8L42"],
			psychup: ["8M"],
			quickguard: ["8L56"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			slash: ["8L1"],
			sleeptalk: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M", "8L35"],
			taunt: ["8M"],
			teleport: ["8L15"],
			thief: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
			wideguard: ["8L56"],
			willowisp: ["8M"],
			workup: ["8M"],
			xscissor: ["8M"],
		},
	},
	probopass: {
		learnset: {
			attract: ["8M"],
			block: ["8L7", "8L1"],
			bodypress: ["8L50"],
			bulldoze: ["8M"],
			dazzlinggleam: ["8M"],
			discharge: ["8L31"],
			doubleteam: ["8M"],
			earthpower: ["8L37"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			flashcannon: ["8M"],
			gigaimpact: ["8M"],
			gravity: ["8L1"],
			harden: ["8L1"],
			hyperbeam: ["8M"],
			irondefense: ["8L4", "8L1"],
			lockon: ["8L43"],
			magneticflux: ["8L1"],
			magnetrise: ["8L1"],
			powergem: ["8L25"],
			protect: ["8M"],
			rest: ["8M", "8L16"],
			rockblast: ["8L28"],
			rockpolish: ["8M"],
			rockslide: ["8M", "8L22"],
			rocksmash: ["8M"],
			rockthrow: ["8L1"],
			rocktomb: ["8M"],
			sandstorm: ["8M", "8L34"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			smackdown: ["8L10"],
			spark: ["8L19"],
			stealthrock: ["8M"],
			stoneedge: ["8M", "8L40"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			taunt: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M", "8L13"],
			torment: ["8M"],
			triattack: ["8L1"],
			voltswitch: ["8M"],
			wideguard: ["8L1"],
			zapcannon: ["8L43"],
		},
	},
	dusknoir: {
		learnset: {
			astonish: ["8L1"],
			attract: ["8M"],
			bind: ["8L1"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confuseray: ["8L12"],
			curse: ["8L36"],
			darkpulse: ["8M"],
			destinybond: ["8L54"],
			disable: ["8L1"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			firepunch: ["8L1"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			futuresight: ["8L48"],
			gigaimpact: ["8M"],
			gravity: ["8L1"],
			hex: ["8L32"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			icepunch: ["8L1"],
			leer: ["8L1"],
			meanlook: ["8L28"],
			nightshade: ["8L16"],
			payback: ["8M", "8L20"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			shadowball: ["8M", "8L42"],
			shadowpunch: ["8L1"],
			shadowsneak: ["8L1"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			thunderpunch: ["8L1"],
			torment: ["8M"],
			trickroom: ["8M"],
			willowisp: ["8M", "8L24"],
		},
	},
	froslass: {
		learnset: {
			astonish: ["8L1"],
			attract: ["8M"],
			auroraveil: ["8L54"],
			avalanche: ["8M"],
			bite: ["8L1"],
			blizzard: ["8M", "8L68"],
			confuseray: ["8L35"],
			crunch: ["8L1"],
			destinybond: ["8L1"],
			doubleteam: ["8M", "8L1"],
			drainingkiss: ["8L20"],
			dreameater: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			frostbreath: ["8L30"],
			gigaimpact: ["8M"],
			hail: ["8M", "8L40"],
			headbutt: ["8L1"],
			hex: ["8L1"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			icefang: ["8L1"],
			iceshard: ["8L15"],
			icywind: ["8L25"],
			leer: ["8L1"],
			lightscreen: ["8M"],
			payback: ["8M"],
			powdersnow: ["8L1"],
			protect: ["8M", "8L1"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			shadowball: ["8M", "8L61"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			waterpulse: ["8M"],
			willowisp: ["8M", "8L47"],
		},
	},
	rotom: {
		learnset: {
			astonish: ["8L1"],
			charge: ["8L15"],
			chargebeam: ["8M"],
			confuseray: ["8L10"],
			darkpulse: ["8M"],
			discharge: ["8L50"],
			doubleteam: ["8M", "8L1"],
			dreameater: ["8M"],
			electroball: ["8L20"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			hex: ["8L35"],
			lightscreen: ["8M"],
			nastyplot: ["8M"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M", "8L30"],
			sleeptalk: ["8M"],
			substitute: ["8M", "8L40"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thundershock: ["8L5"],
			thunderwave: ["8M", "8L25"],
			trick: ["8L45"],
			uproar: ["8L55"],
			voltswitch: ["8M"],
			willowisp: ["8M"],
		},
	},
	rotomheat: {
		learnset: {
			overheat: ["8T"],
		},
	},
	rotomwash: {
		learnset: {
			hydropump: ["8T"],
		},
	},
	rotomfrost: {
		learnset: {
			blizzard: ["8T"],
		},
	},
	rotomfan: {
		learnset: {
			airslash: ["8T"],
		},
	},
	rotommow: {
		learnset: {
			leafstorm: ["8T"],
		},
	},
	uxie: {
		learnset: {
			amnesia: ["8L42", "8S0"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confusion: ["8L1"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			endure: ["8M", "8L14"],
			energyball: ["8M"],
			extrasensory: ["8L35", "8S0"],
			facade: ["8M"],
			flail: ["8L70"],
			flash: ["8M"],
			fling: ["8M"],
			futuresight: ["8L63"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			hyperbeam: ["8M"],
			imprison: ["8L28", "8S0"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			memento: ["8L77"],
			nastyplot: ["8M"],
			protect: ["8M"],
			psybeam: ["8L21"],
			psychic: ["8M", "8L49", "8S0"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M", "8L1"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L7"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			trickroom: ["8M"],
			uturn: ["8M"],
			waterpulse: ["8M"],
			yawn: ["8L56"],
		},
		eventData: [
			{generation: 8, level: 50, shiny: 1, moves: ['psychic', 'amnesia', 'extrasensory', 'imprison']},
		],
	},
	mesprit: {
		learnset: {
			blizzard: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			charm: ["8L42", "8S0"],
			confusion: ["8L1"],
			copycat: ["8L70"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			extrasensory: ["8L35", "8S0"],
			facade: ["8M"],
			flash: ["8M"],
			flatter: ["8L56"],
			fling: ["8M"],
			futuresight: ["8L63"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			healingwish: ["8L77"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			imprison: ["8L28", "8S0"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			nastyplot: ["8M"],
			protect: ["8M", "8L14"],
			psybeam: ["8L21"],
			psychic: ["8M", "8L49", "8S0"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M", "8L1"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L7"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			trickroom: ["8M"],
			uturn: ["8M"],
			waterpulse: ["8M"],
		},
		eventData: [
			{generation: 8, level: 50, shiny: 1, moves: ['psychic', 'charm', 'extrasensory', 'imprison']},
		],
	},
	azelf: {
		learnset: {
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confusion: ["8L1"],
			dazzlinggleam: ["8M"],
			detect: ["8L14"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			explosion: ["8M", "8L77"],
			extrasensory: ["8L35", "8S0"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			futuresight: ["8L63"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			hyperbeam: ["8M"],
			imprison: ["8L28", "8S0"],
			irontail: ["8M"],
			lastresort: ["8L70"],
			lightscreen: ["8M"],
			nastyplot: ["8M", "8L42", "8S0"],
			payback: ["8M"],
			protect: ["8M"],
			psybeam: ["8L21"],
			psychic: ["8M", "8L49", "8S0"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M", "8L1"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			shockwave: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swift: ["8L7"],
			taunt: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			trickroom: ["8M"],
			uproar: ["8L56"],
			uturn: ["8M"],
			waterpulse: ["8M"],
		},
		eventData: [
			{generation: 8, level: 50, shiny: 1, moves: ['psychic', 'nastyplot', 'extrasensory', 'imprison']},
		],
	},
	dialga: {
		learnset: {
			aerialace: ["8M"],
			ancientpower: ["8L16", "8S0"],
			aurasphere: ["8L56"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			cut: ["8M"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonbreath: ["8L8"],
			dragonclaw: ["8M", "8L48"],
			dragonpulse: ["8M"],
			earthpower: ["8L80"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			flashcannon: ["8M", "8L32", "8S0"],
			gigaimpact: ["8M"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M", "8L88"],
			metalburst: ["8L72"],
			metalclaw: ["8L1"],
			overheat: ["8M"],
			powergem: ["8L64"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			roaroftime: ["8L40", "8S0"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			scaryface: ["8L1"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			slash: ["8L24", "8S0"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			trickroom: ["8M"],
		},
		eventData: [
			{generation: 8, level: 47, shiny: 1, moves: ['roaroftime', 'flashcannon', 'slash', 'ancientpower']},
		],
	},
	palkia: {
		learnset: {
			aerialace: ["8M"],
			ancientpower: ["8L16", "8S0"],
			aquaring: ["8L32", "8S0"],
			aquatail: ["8L72"],
			aurasphere: ["8L56"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			cut: ["8M"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonbreath: ["8L8"],
			dragonclaw: ["8M", "8L48"],
			dragonpulse: ["8M"],
			earthpower: ["8L80"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			hydropump: ["8L88"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			powergem: ["8L64"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			scaryface: ["8L1"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			slash: ["8L24", "8S0"],
			sleeptalk: ["8M"],
			spacialrend: ["8L40", "8S0"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			trickroom: ["8M"],
			waterpulse: ["8M", "8L1"],
		},
		eventData: [
			{generation: 8, level: 47, shiny: 1, moves: ['spacialrend', 'aquaring', 'slash', 'ancientpower']},
		],
	},
	heatran: {
		learnset: {
			ancientpower: ["8L12"],
			attract: ["8M"],
			bulldoze: ["8M"],
			crunch: ["8L36"],
			darkpulse: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dragonpulse: ["8M"],
			earthpower: ["8L54", "8S0"],
			earthquake: ["8M"],
			endure: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			firefang: ["8L18"],
			firespin: ["8L1"],
			flamethrower: ["8M"],
			flashcannon: ["8M"],
			gigaimpact: ["8M"],
			heatwave: ["8L60", "8S0"],
			hyperbeam: ["8M"],
			ironhead: ["8L30"],
			lavaplume: ["8L42"],
			leer: ["8L1"],
			magmastorm: ["8L72"],
			metalclaw: ["8L6"],
			metalsound: ["8L48", "8S0"],
			overheat: ["8M"],
			payback: ["8M"],
			protect: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			scaryface: ["8L24"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M", "8L66", "8S0"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			torment: ["8M"],
			willowisp: ["8M"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, moves: ['stoneedge', 'heatwave', 'earthpower', 'metalsound']},
		],
	},
	regigigas: {
		learnset: {
			aerialace: ["8M"],
			avalanche: ["8M"],
			bodypress: ["8L42"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			confuseray: ["8L1"],
			crushgrip: ["8L78", "8S0"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			gigaimpact: ["8M", "8L72", "8S0"],
			hammerarm: ["8L66", "8S0"],
			heavyslam: ["8L60", "8S0"],
			hyperbeam: ["8M"],
			knockoff: ["8L30"],
			megapunch: ["8L36"],
			payback: ["8M", "8L6"],
			pound: ["8L1"],
			protect: ["8M", "8L24"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8L12"],
			rockclimb: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			stomp: ["8L18"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			wideguard: ["8L48"],
			zenheadbutt: ["8L54"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, moves: ['crushgrip', 'gigaimpact', 'hammerarm', 'heavyslam']},
		],
	},
	giratina: {
		learnset: {
			aerialace: ["8M"],
			ancientpower: ["8L14"],
			aurasphere: ["8L63", "8S0"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			cut: ["8M"],
			darkpulse: ["8M"],
			defog: ["8M", "8L1"],
			destinybond: ["8L84"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonbreath: ["8L7"],
			dragonclaw: ["8M", "8L70", "8S0"],
			dragonpulse: ["8M"],
			dreameater: ["8M"],
			earthpower: ["8L77"],
			earthquake: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			fly: ["8M"],
			gigaimpact: ["8M"],
			hex: ["8L21"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			painsplit: ["8L56", "8S0"],
			payback: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rocksmash: ["8M"],
			safeguard: ["8M"],
			scaryface: ["8L35"],
			shadowball: ["8M"],
			shadowclaw: ["8M", "8L42"],
			shadowforce: ["8L49", "8S0"],
			shadowsneak: ["8L1"],
			shockwave: ["8M"],
			slash: ["8L28"],
			sleeptalk: ["8M"],
			steelwing: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			willowisp: ["8M"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, moves: ['dragonclaw', 'aurasphere', 'painsplit', 'shadowforce']},
		],
	},
	cresselia: {
		learnset: {
			attract: ["8M"],
			aurorabeam: ["8L12"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confusion: ["8L1"],
			doubleteam: ["8M", "8L1"],
			dreameater: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			futuresight: ["8L66"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			lightscreen: ["8M"],
			lunardance: ["8L72"],
			mist: ["8L6"],
			moonblast: ["8L60"],
			moonlight: ["8L42", "8S0"],
			protect: ["8M"],
			psybeam: ["8L18"],
			psychic: ["8M", "8L54"],
			psychocut: ["8L36", "8S0"],
			psychoshift: ["8L24"],
			psychup: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			safeguard: ["8M", "8L48", "8S0"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			slash: ["8L30", "8S0"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			thunderwave: ["8M"],
			trickroom: ["8M"],
		},
		eventData: [
			{generation: 8, level: 50, shiny: 1, moves: ['safeguard', 'moonlight', 'psychocut', 'slash']},
		],
	},
	phione: {
		learnset: {
			acidarmor: ["8L31"],
			aquaring: ["8L54"],
			blizzard: ["8M"],
			brine: ["8M"],
			bubblebeam: ["8L24"],
			charm: ["8L9"],
			dazzlinggleam: ["8M"],
			dive: ["8L61"],
			doubleteam: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			grassknot: ["8M"],
			hail: ["8M"],
			icebeam: ["8M"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M", "8L69"],
			rest: ["8M"],
			safeguard: ["8M"],
			scald: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			supersonic: ["8L16"],
			surf: ["8M"],
			swagger: ["8M"],
			uturn: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M", "8L46"],
			whirlpool: ["8L39"],
		},
	},
	manaphy: {
		learnset: {
			acidarmor: ["8L31"],
			aquaring: ["8L54"],
			blizzard: ["8M"],
			brine: ["8M"],
			bubblebeam: ["8L24"],
			calmmind: ["8M"],
			charm: ["8L9"],
			dazzlinggleam: ["8M"],
			dive: ["8L61"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			hail: ["8M"],
			heartswap: ["8L76"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			lightscreen: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M", "8L69"],
			reflect: ["8M"],
			rest: ["8M"],
			safeguard: ["8M"],
			scald: ["8M"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			supersonic: ["8L16"],
			surf: ["8M"],
			swagger: ["8M"],
			tailglow: ["8L1", "8S0"],
			uturn: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1", "8S0"],
			waterpulse: ["8M", "8L46"],
			whirlpool: ["8L39"],
		},
		eventData: [
			{generation: 8, moves: ['tailglow', 'watergun'], pokeball: 'pokeball'},
		],
	},
	darkrai: {
		learnset: {
			aerialace: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			confuseray: ["8L1"],
			cut: ["8M"],
			darkpulse: ["8M", "8L93"],
			darkvoid: ["8L66"],
			disable: ["8L1"],
			doubleteam: ["8M", "8L47", "8S0"],
			drainpunch: ["8M"],
			dreameater: ["8M", "8L84"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			foulplay: ["8L38", "8S0"],
			gigaimpact: ["8M"],
			haze: ["8L57"],
			hyperbeam: ["8M"],
			hypnosis: ["8L20", "8S0"],
			icebeam: ["8M"],
			nastyplot: ["8M", "8L75"],
			payback: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			quickattack: ["8L11"],
			raindance: ["8M"],
			rest: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			snarl: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L29", "8S0"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			taunt: ["8M"],
			thief: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			willowisp: ["8M"],
			xscissor: ["8M"],
		},
		eventData: [
			{generation: 8, level: 50, shiny: 1, moves: ["hypnosis", "suckerpunch", "foulplay", "doubleteam"]},
		],
	},
	shaymin: {
		learnset: {
			airslash: ["8L64"],
			aromatherapy: ["8L64"],
			bulletseed: ["8M"],
			dazzlinggleam: ["8M"],
			doubleteam: ["8M"],
			endure: ["8M"],
			energyball: ["8M", "8L73"],
			facade: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growth: ["8L1", "8S0"],
			healingwish: ["8L46", "8L91"],
			hyperbeam: ["8M"],
			leafstorm: ["8L91"],
			leechseed: ["8L19", "8S0"],
			magicalleaf: ["8L10", "8S0"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			quickattack: ["8L28"],
			rest: ["8M"],
			safeguard: ["8M"],
			seedflare: ["8L100"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetkiss: ["8L82"],
			sweetscent: ["8L37"],
			swordsdance: ["8M"],
			synthesis: ["8L28", "8S0"],
			worryseed: ["8L55"],
		},
		eventData: [
			{generation: 8, level: 30, shiny: 1, moves: ["growth", "magicalleaf", "leechseed", "synthesis"]},
		],
	},
	shayminsky: {
	},
	arceus: {
		learnset: {
			aerialace: ["8M"],
			avalanche: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M"],
			bulldoze: ["8M"],
			bulletseed: ["8M"],
			calmmind: ["8M"],
			chargebeam: ["8M"],
			cosmicpower: ["8L1"],
			cut: ["8M"],
			darkpulse: ["8M"],
			defog: ["8M"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonclaw: ["8M"],
			dragonpulse: ["8M"],
			dreameater: ["8M"],
			earthpower: ["8L20"],
			earthquake: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			extremespeed: ["8L40"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			flashcannon: ["8M"],
			fly: ["8M"],
			focusblast: ["8M"],
			futuresight: ["8L60", "8S0"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			gravity: ["8L10"],
			hail: ["8M"],
			healingwish: ["8L50", "8S0"],
			hyperbeam: ["8M", "8L80", "8S0"],
			hypervoice: ["8L30"],
			icebeam: ["8M"],
			irontail: ["8M"],
			judgment: ["8L100"],
			lightscreen: ["8M"],
			overheat: ["8M"],
			payback: ["8M"],
			perishsong: ["8L90"],
			poisonjab: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			recover: ["8L70", "8S0"],
			recycle: ["8M"],
			reflect: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockclimb: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			seismictoss: ["8L1"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			snarl: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			thunder: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			trickroom: ["8M"],
			waterfall: ["8M"],
			waterpulse: ["8M"],
			willowisp: ["8M"],
			workup: ["8M"],
			xscissor: ["8M"],
		},
		eventData: [
			{generation: 8, level: 80, shiny: 1, moves: ["healingwish", "futuresight", "recover", "hyperbeam"]},
		],
	},
	syclar: {
		learnset: {
			counter: ["8E"],
			doubleedge: ["8E"],
			earthpower: ["8E"],
			fellstinger: ["8E"],
			pinmissile: ["8E"],
			spikes: ["8E"],
			superpower: ["8E"],
			tailglow: ["8E"],
		},
	},
	syclant: {
		learnset: {
			absorb: ["8L1"],
			attract: ["8M"],
			avalanche: ["8M", "8L50"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			bugbuzz: ["8L46"],
			bulldoze: ["8M"],
			cut: ["8M"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focusenergy: ["8L10"],
			furyattack: ["8L14"],
			furycutter: ["8L23"],
			gigaimpact: ["8M"],
			hail: ["8M", "8L37"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			icepunch: ["8L1"],
			iceshard: ["8L5"],
			iciclecrash: ["8L41"],
			iciclespear: ["8L1"],
			icywind: ["8L19"],
			leer: ["8L1"],
			nastyplot: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			rockclimb: ["8L55"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			sheercold: ["8L59"],
			slash: ["8L28"],
			sleeptalk: ["8M"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			swagger: ["8M"],
			swordsdance: ["8M"],
			taunt: ["8M"],
			uturn: ["8M"],
			waterpulse: ["8M"],
			xscissor: ["8M", "8L32"],
		},
	},
	revenankh: {
		learnset: {
			armthrust: ["8L5"],
			attract: ["8M"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			counter: ["8E"],
			curse: ["8E"],
			doubleteam: ["8M"],
			drainpunch: ["8M", "8L55"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M", "8L70"],
			forcepalm: ["8E"],
			gigaimpact: ["8M"],
			glare: ["8L35"],
			hammerarm: ["8L65"],
			hex: ["8E"],
			hyperbeam: ["8M"],
			knockoff: ["8L40"],
			machpunch: ["8E"],
			meanlook: ["8L25"],
			memento: ["8E"],
			mimic: ["8E"],
			moonlight: ["8L45"],
			nastyplot: ["8M"],
			payback: ["8M", "8L20"],
			protect: ["8M"],
			quickguard: ["8L15"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8L50"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			sandstorm: ["8M"],
			sandtomb: ["8L1"],
			shadowball: ["8M"],
			shadowclaw: ["8M"],
			shadowpunch: ["8L30"],
			shadowsneak: ["8L10", "8E"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L60"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			willowisp: ["8M"],
			workup: ["8M"],
			wrap: ["8L1"],
		},
	},
	embirch: {
		learnset: {
			aromatherapy: ["8E"],
			block: ["8E"],
			dragonbreath: ["8E"],
			firespin: ["8E"],
			grassyterrain: ["8E"],
			revenge: ["8E"],
			sandtomb: ["8E"],
		},
	},
	flarelm: {
		learnset: {},
	},
	pyroak: {
		learnset: {
			amnesia: ["8L41"],
			aromaticmist: ["8L1"],
			attract: ["8M"],
			bulldoze: ["8M"],
			bulletseed: ["8M", "8L1"],
			burnup: ["8L64"],
			doubleedge: ["8L1"],
			doubleteam: ["8M"],
			dragonpulse: ["8M"],
			earthquake: ["8M"],
			ember: ["8L1"],
			endure: ["8M"],
			energyball: ["8M", "8L1"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamecharge: ["8L1"],
			flamethrower: ["8M"],
			flamewheel: ["8L16"],
			flareblitz: ["8L1"],
			flashcannon: ["8M"],
			gigadrain: ["8M", "8L20"],
			gigaimpact: ["8M"],
			grassknot: ["8M"],
			growth: ["8L12"],
			hyperbeam: ["8M"],
			irondefense: ["8L41"],
			irontail: ["8M"],
			lavaplume: ["8L48"],
			leechseed: ["8L1"],
			lightscreen: ["8M"],
			overheat: ["8M"],
			petalblizzard: ["8L1"],
			petaldance: ["8L56"],
			protect: ["8M"],
			rest: ["8M"],
			roar: ["8M"],
			rockpolish: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			seedbomb: ["8L32"],
			sleeptalk: ["8M"],
			solarbeam: ["8M"],
			stealthrock: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			sweetscent: ["8L1"],
			swordsdance: ["8M"],
			synthesis: ["8L27"],
			willowisp: ["8M"],
			woodhammer: ["8L1"],
			zapcannon: ["8L1"],
		},
	},
	breezi: {
		learnset: {
			disable: ["8E"],
			doubleedge: ["8E"],
			entrainment: ["8E"],
			followme: ["8E"],
			metronome: ["8E"],
			mimic: ["8E"],
			spikes: ["8E"],
			wish: ["8E"],
		},
	},
	fidgit: {
		learnset: {
			acrobatics: ["8L1"],
			aerialace: ["8M", "8L1"],
			attract: ["8M"],
			bodyslam: ["8L28"],
			bulldoze: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			drillrun: ["8L1"],
			earthpower: ["8L58"],
			earthquake: ["8M"],
			encore: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fling: ["8M"],
			followme: ["8L1"],
			gastroacid: ["8L1"],
			gigaimpact: ["8M"],
			gravity: ["8L52"],
			gunkshot: ["8L64"],
			gust: ["8L1"],
			helpinghand: ["8L1"],
			hyperbeam: ["8M"],
			knockoff: ["8L24"],
			lightscreen: ["8M"],
			poisonjab: ["8M"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rapidspin: ["8L16"],
			reflect: ["8M"],
			rest: ["8M", "8L1"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8L1"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M", "8L38"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tailwind: ["8L1"],
			taunt: ["8M"],
			thief: ["8M"],
			torment: ["8M"],
			toxic: ["8L46"],
			toxicspikes: ["8L20"],
			trickroom: ["8M"],
			uturn: ["8M"],
			whirlwind: ["8L32"],
			wideguard: ["8L12"],
		},
	},
	rebble: {
		learnset: {
			tackle: ["8L1"],
		},
	},
	tactite: {
		learnset: {
			tackle: ["8L1"],
		},
	},
	stratagem: {
		learnset: {
			acupressure: ["8L48"],
			aerialace: ["8M"],
			ancientpower: ["8L24"],
			bulldoze: ["8M"],
			calmmind: ["8M"],
			cut: ["8M"],
			dazzlinggleam: ["8M"],
			defensecurl: ["8L1"],
			disable: ["8L16"],
			doubleedge: ["8L56"],
			doubleteam: ["8M"],
			earthpower: ["8L42"],
			earthquake: ["8M"],
			endure: ["8M"],
			energyball: ["8M"],
			explosion: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			gigadrain: ["8M"],
			gigaimpact: ["8M"],
			headsmash: ["8L70"],
			hyperbeam: ["8M"],
			laserfocus: ["8L1"],
			lockon: ["8L64"],
			metalsound: ["8L31"],
			mudslap: ["8L1"],
			paleowave: ["8L1"],
			powergem: ["8L36"],
			protect: ["8M"],
			quickguard: ["8L1"],
			raindance: ["8M"],
			rest: ["8M"],
			rockblast: ["8L12"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			rollout: ["8L1"],
			sandstorm: ["8M"],
			shadowball: ["8M"],
			sleeptalk: ["8M"],
			stealthrock: ["8M"],
			stoneedge: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			vacuumwave: ["8L20"],
			weatherball: ["8L1"],
		},
	},
	privatyke: {
		learnset: {
			headbutt: ["8E"],
			octazooka: ["8E"],
			recover: ["8E"],
		},
	},
	arghonaut: {
		learnset: {
			aquajet: ["8L16"],
			armthrust: ["8L1"],
			attract: ["8M"],
			blizzard: ["8M"],
			brickbreak: ["8M"],
			brine: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			circlethrow: ["8L1"],
			cut: ["8M"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			falseswipe: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8L60"],
			gigaimpact: ["8M"],
			hail: ["8M"],
			headbutt: ["8L36"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			knockoff: ["8L24"],
			lowsweep: ["8M"],
			machpunch: ["8L16"],
			poisonjab: ["8M"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8L28"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			safeguard: ["8M"],
			scald: ["8M", "8L42"],
			sleeptalk: ["8M"],
			sludgebomb: ["8M"],
			smokescreen: ["8L12"],
			spikes: ["8E"],
			stoneedge: ["8M"],
			strength: ["8M"],
			submission: ["8L48"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			taunt: ["8M", "8L32"],
			thief: ["8M", "8L1"],
			torment: ["8M"],
			vacuumwave: ["8L1"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			wideguard: ["8L54"],
			workup: ["8M"],
			wrap: ["8L1"],
			yawn: ["8L20"],
		},
	},
	nohface: {
		learnset: {
			flail: ["8E"],
			hex: ["8E"],
			metalsound: ["8E"],
			meteormash: ["8E"],
			playrough: ["8E"],
			suckerpunch: ["8E"],
			yawn: ["8E"],
		},
	},
	kitsunoh: {
		learnset: {
			attract: ["8M"],
			bulldoze: ["8M"],
			bulletpunch: ["8L1"],
			copycat: ["8L20"],
			cut: ["8M"],
			darkpulse: ["8M"],
			defog: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			facade: ["8M"],
			fakeout: ["8L1"],
			falseswipe: ["8M"],
			flash: ["8M"],
			flashcannon: ["8M"],
			fling: ["8M"],
			gigaimpact: ["8M"],
			honeclaws: ["8L28"],
			hyperbeam: ["8M"],
			ironhead: ["8L40"],
			irontail: ["8M"],
			lick: ["8L1"],
			memento: ["8L48"],
			metalclaw: ["8L1"],
			payback: ["8M"],
			perishsong: ["8L52"],
			protect: ["8M"],
			psychup: ["8M"],
			raindance: ["8M"],
			rest: ["8M"],
			revenge: ["8L36"],
			roar: ["8M"],
			safeguard: ["8M"],
			scratch: ["8L1"],
			shadowball: ["8M"],
			shadowclaw: ["8M", "8L32"],
			shadowsneak: ["8L16"],
			shadowstrike: ["8L44"],
			sleeptalk: ["8M"],
			spite: ["8L12"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			tailwhip: ["8L1"],
			taunt: ["8M"],
			thief: ["8M"],
			torment: ["8M", "8L24"],
			trick: ["8L1"],
			trickroom: ["8M"],
			uturn: ["8M"],
			willowisp: ["8M"],
		},
	},
	monohm: {
		learnset: {
			mudslap: ["8E"],
			powdersnow: ["8E"],
		},
	},
	duohm: {
		learnset: {},
	},
	cyclohm: {
		learnset: {
			aerialace: ["8M"],
			attract: ["8M"],
			blizzard: ["8M"],
			bulldoze: ["8M"],
			charge: ["8L12"],
			chargebeam: ["8M"],
			discharge: ["8L35"],
			doublehit: ["8L1"],
			doubleteam: ["8M"],
			dracometeor: ["8T"],
			dragonbreath: ["8L20"],
			dragonclaw: ["8M"],
			dragonpulse: ["8M"],
			dragontail: ["8L28"],
			earthquake: ["8M"],
			electricterrain: ["8L1"],
			endure: ["8M"],
			facade: ["8M"],
			fireblast: ["8M"],
			flamethrower: ["8M"],
			flash: ["8M"],
			gigaimpact: ["8M"],
			growl: ["8L1"],
			hail: ["8M"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			irontail: ["8M"],
			lightscreen: ["8M"],
			lockon: ["8L56"],
			protect: ["8M"],
			raindance: ["8M", "8L40"],
			rest: ["8M"],
			roar: ["8M"],
			sandstorm: ["8M"],
			shockwave: ["8M"],
			slackoff: ["8L48"],
			sleeptalk: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			tackle: ["8L1"],
			thrash: ["8L64"],
			thunder: ["8M", "8L72"],
			thunderbolt: ["8M"],
			thundershock: ["8L1"],
			thunderwave: ["8M", "8L24"],
			torment: ["8M"],
			triattack: ["8L1"],
			trickroom: ["8M"],
			twister: ["8L1"],
			voltswitch: ["8M"],
			waterfall: ["8M"],
			waterpulse: ["8M"],
			whirlwind: ["8L16"],
			zapcannon: ["8L56"],
		},
	},
	dorsoil: {
		learnset: {
			doubleedge: ["8E"],
			fakeout: ["8E"],
			firefang: ["8E"],
			fissure: ["8E"],
			flail: ["8E"],
			mimic: ["8E"],
			sandtomb: ["8E"],
			screech: ["8E"],
			suckerpunch: ["8E"],
			thunderfang: ["8E"],
			wideguard: ["8E"],
		},
	},
	colossoil: {
		learnset: {
			attract: ["8M"],
			bite: ["8L20"],
			bodyslam: ["8L35"],
			brickbreak: ["8M"],
			bulldoze: ["8M"],
			crunch: ["8L49"],
			darkpulse: ["8M"],
			dig: ["8M"],
			doubleteam: ["8M"],
			drillrun: ["8L1"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			furyattack: ["8L1"],
			gigaimpact: ["8M"],
			highhorsepower: ["8L1"],
			hornattack: ["8L1"],
			horndrill: ["8L63"],
			hyperbeam: ["8M"],
			irontail: ["8M"],
			knockoff: ["8L25"],
			leer: ["8L1"],
			megahorn: ["8L56"],
			mudslap: ["8L1"],
			payback: ["8M"],
			peck: ["8L1"],
			protect: ["8M"],
			raindance: ["8M"],
			rapidspin: ["8L15"],
			rest: ["8M"],
			roar: ["8M"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			rocktomb: ["8M"],
			sandstorm: ["8M"],
			sandtomb: ["8L1"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			spitup: ["8L42"],
			stockpile: ["8L42"],
			stoneedge: ["8M"],
			strength: ["8M", "8L30"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			swallow: ["8L42"],
			taunt: ["8M"],
			uturn: ["8M"],
		},
	},
	protowatt: {
		learnset: {
			followme: ["8E"],
			sheercold: ["8E"],
		},
	},
	krilowatt: {
		learnset: {
			aquatail: ["8L50"],
			attract: ["8M"],
			blizzard: ["8M"],
			bubblebeam: ["8L1"],
			bulldoze: ["8M"],
			charge: ["8L1"],
			confuseray: ["8L1"],
			copycat: ["8L25"],
			cut: ["8M"],
			discharge: ["8L30"],
			doubleteam: ["8M"],
			earthquake: ["8M"],
			endure: ["8M"],
			facade: ["8M"],
			flash: ["8M"],
			fling: ["8M"],
			gigaimpact: ["8M"],
			guillotine: ["8L60"],
			hail: ["8M"],
			hyperbeam: ["8M"],
			icebeam: ["8M"],
			iceshard: ["8L1"],
			imprison: ["8L20"],
			irontail: ["8M"],
			lowsweep: ["8M"],
			magneticflux: ["8L1"],
			mindreader: ["8L35"],
			muddywater: ["8L40"],
			payback: ["8M"],
			protect: ["8M"],
			raindance: ["8M"],
			recycle: ["8M"],
			rest: ["8M"],
			scald: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			substitute: ["8M"],
			surf: ["8M"],
			swagger: ["8M"],
			thunder: ["8M", "8L55"],
			thunderbolt: ["8M"],
			thundershock: ["8L1"],
			thunderwave: ["8M"],
			torment: ["8M"],
			voltswitch: ["8M"],
			waterfall: ["8M"],
			watergun: ["8L1"],
			waterpulse: ["8M"],
			wildcharge: ["8L45"],
		},
	},
	voodoll: {
		learnset: {
			batonpass: ["8E"],
			counter: ["8E"],
			imprison: ["8E"],
			machpunch: ["8E"],
			memento: ["8E"],
			mimic: ["8E"],
		},
	},
	voodoom: {
		learnset: {
			acupressure: ["8L52"],
			astonish: ["8L1"],
			attract: ["8M"],
			aurasphere: ["8L40"],
			brickbreak: ["8M"],
			bulkup: ["8M"],
			bulldoze: ["8M"],
			charge: ["8L20"],
			closecombat: ["8L64"],
			copycat: ["8L1"],
			darkpulse: ["8M"],
			doubleteam: ["8M"],
			drainpunch: ["8M"],
			dreameater: ["8M"],
			earthquake: ["8M"],
			echoedvoice: ["8L16"],
			endure: ["8M"],
			facade: ["8M"],
			flashcannon: ["8M"],
			fling: ["8M"],
			focusblast: ["8M"],
			focuspunch: ["8M"],
			followme: ["8L1"],
			foulplay: ["8L58"],
			gigaimpact: ["8M"],
			grudge: ["8L35"],
			hex: ["8L28"],
			hyperbeam: ["8M"],
			lowsweep: ["8M"],
			nastyplot: ["8M"],
			nightslash: ["8L1"],
			painsplit: ["8L46"],
			payback: ["8M"],
			pinmissile: ["8L1"],
			protect: ["8M"],
			psychic: ["8M"],
			rest: ["8M"],
			revenge: ["8L1"],
			rockslide: ["8M"],
			rocksmash: ["8M"],
			shockwave: ["8M"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			spite: ["8L12"],
			stoneedge: ["8M"],
			strength: ["8M"],
			substitute: ["8M"],
			sunnyday: ["8M"],
			swagger: ["8M"],
			taunt: ["8M"],
			tearfullook: ["8L24"],
			thief: ["8M"],
			thunderbolt: ["8M"],
			thunderwave: ["8M"],
			torment: ["8M"],
			workup: ["8M"],
			wrap: ["8L1"],
		},
	},
};
